import React, { useState, useEffect, useRef, Component, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { withRouter, Link as Link$1 } from 'react-router-dom';
import ls from 'local-storage';
import { combineReducers } from 'redux';
import 'react-dom/server';
import ReactMarkdown from 'react-markdown';
import moment from 'moment';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Drawer from '@material-ui/core/Drawer';
import Fab from '@material-ui/core/Fab';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button$2 from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import '@material-ui/icons/HighlightOff';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Grid$2 from '@material-ui/core/Grid';
import Card$2 from '@material-ui/core/Card';
import '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent$1 from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActions';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Slider$1 from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import SendIcon from '@material-ui/icons/Send';
import CancelIcon from '@material-ui/icons/Cancel';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import '@material-ui/core/Popover';
import Menu from '@material-ui/core/Menu';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { withResizeDetector } from 'react-resize-detector';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Slide$1 from '@material-ui/core/Slide';
import QuestionAnswerIcon from '@material-ui/icons/Forum';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import Fade from 'react-reveal/Fade';
import 'react-rte';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import Slider$2 from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import path$1 from 'path';
import 'util';
import crypto$1 from 'crypto';
import fs$1 from 'fs';
import 'numeral';
import CardActionArea$1 from '@material-ui/core/CardActionArea';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import '@material-ui/core/DialogContent';
import 'react-reveal/Slide';
import 'react-reveal/makeCarousel';
import { Box as Box$1, Typography as Typography$1 } from '@material-ui/core';
import ImageGallery from 'react-image-gallery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import MUITabs from '@material-ui/core/Tabs';
import Tab$2 from '@material-ui/core/Tab';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Fade$1 from '@material-ui/core/Fade';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import '@material-ui/icons/PhotoCamera';
import '@material-ui/core/ListItemIcon';
import '@material-ui/core/ListSubheader';
import AppBar from '@material-ui/core//AppBar';
import MenuIcon from '@material-ui/icons/Menu';
import QuestionAnswerIcon$1 from '@material-ui/icons/QuestionAnswer';
import '@material-ui/icons/ShoppingCart';
import '@material-ui/icons/AccountCircle';
import '@material-ui/icons/Collections';
import '@material-ui/icons/Home';

function updateObject(oldObject, newValues) {
  return Object.assign({}, oldObject, newValues);
}

function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);else if (handlers.hasOwnProperty("*")) return handlers["*"](state, action);else return state;
  };
}

const visitorInitial = {
  isInitialized: false,
  isInitializing: false,
  isRegistered: false,
  isRegistering: false,
  data: {
    _goid: null,
    visitor_id: null
  }
}; // Actions

const ACTION = {
  initializing: "initializing",
  registering: "registering",
  receiveInitResult: "receiveInitResult",
  receiveRegisterResult: "receiveRegisterResult",
  errorInitializing: "errorInitializing",
  errorRegistering: "errorRegistering"
}; // Async Action Creators

const getVisitor = state => {
  if ('visitor' in state.alpha) return state.alpha.visitor;else return visitorInitial;
};

const init = () => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let visitor = getVisitor(getState());
    if (visitor.isInitialized || visitor.isInitializing) return Promise.resolve();
    let url = apiUrl + '/visitor/api/init/';
    let data = {
      _goid: visitor.data._goid,
      _referer: document.referrer,
      _origin: window.location.href
    }; //  alert("init: " + JSON.stringify(data))
    //  alert(process.env.REACT_APP_GOAPP_API_KEY)
    //    alert("Fetching: " + url)

    dispatch(initializing());
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': apiKey
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => dispatch(receiveInitResult(json))).catch(error => dispatch(errorInitializing(error)));
  };
};

const register = registerData => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let visitor = getVisitor(getState());
    if (visitor.isRegistered || visitor.isRegistering) return Promise.resolve();
    let url = apiUrl + '/visitor/api/register_user/';
    let data = { ...registerData,
      _goid: visitor.data._goid
    };
    dispatch(registering());
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': apiKey
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => dispatch(receiveRegisterResult(data, json))).catch(error => dispatch(errorRegistering(registerData, error)));
  };
};

const logEvent = (eventName, eventData) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let visitor = getVisitor(getState());
    if (!visitor.isRegistered) return Promise.resolve();
    let url = apiUrl + '/visitor/api/log_event/';
    let data = {
      event_name: eventName,
      event_data: eventData,
      _goid: visitor.data._goid
    }; //    alert("LogEvent: " + JSON.stringify(data, null, 2))

    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': apiKey
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => {//      alert("result: " + JSON.stringify(json))
      //      ls.set('_goid', json['_goid'])
      //      cookie.set("onboarded", true, {path: "/"});
    }).catch(error => {});
  };
}; // Synchronous Action Creators


const initializing = () => ({
  type: ACTION.initializing
});

const registering = registerData => ({
  type: ACTION.registering
});

const receiveInitResult = json => ({
  type: ACTION.receiveInitResult,
  result: json
});

const receiveRegisterResult = (registerData, json) => ({
  type: ACTION.receiveRegisterResult,
  registerData,
  result: json
});

const errorInitializing = error => ({
  type: ACTION.errorInitializing,
  error
});

const errorRegistering = (data, error) => ({
  type: ACTION.errorRegistering,
  data,
  error
}); // Visitor reducer


function _initializing(state, action) {
  return { ...state,
    isInitializing: true
  };
}

function _registering(state, action) {
  return { ...state,
    isRegistering: true
  };
}

function _errorInitializing(state, action) {
  alert(action.error);
  return { ...state,
    isInitializing: false
  };
}

function _errorRegistering(state, action) {
  alert(action.error);
  return { ...state,
    isRegistering: false
  };
}

function _receiveInitResult(state, action) {
  let _goid = action.result['_goid']; // Store _goid on local storage

  ls.set('_goid', _goid);
  return { ...state,
    isInitializing: false,
    isInitialized: true,
    data: {
      _goid: _goid
    }
  };
}

function _receiveRegisterResult(state, action) {
  return { ...state,
    isRegistering: false,
    isRegistered: true,
    data: { ...state.data,
      ...action.result
    }
  };
}

const visitorReducer = (state = null, action) => {
  if (state == null) {
    // Get userInitial from local storage, but we're still in
    // not authenticated state, authToken is still null.
    // We'll use the info to auto authenticate to auth service
    state = visitorInitial;

    let _goid = ls.get('_goid');

    if (_goid && _goid !== undefined && _goid != "undefined") state.data._goid = _goid;
  }

  const handlers = {
    [ACTION.initializing]: _initializing,
    [ACTION.registering]: _registering,
    [ACTION.receiveInitResult]: _receiveInitResult,
    [ACTION.receiveRegisterResult]: _receiveRegisterResult,
    [ACTION.errorInitializing]: _errorInitializing,
    [ACTION.errorRegistering]: _errorRegistering
  };
  if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);else return state;
};

const userInitial = {
  isAuthenticating: false,
  isLoggedIn: false,
  authToken: null,
  userInfo: null,
  isUpdatingContact: false,
  lastContactUpdate: null,
  contactInfo: null,
  companyInfo: null
}; // Actions

const ACTION$1 = {
  authenticateWithToken: "authenticateWithToken",
  completeLogout: "completeLogout",
  authenticating: "authenticating",
  receiveTokenInfo: "receiveAuthInfo",
  errorAuthenticating: "errorAuthenticating",
  updatingContact: "updatingContact",
  receiveContactInfo: "receiveContactInfo",
  errorUpdatingContact: "errorUpdatingContact",
  activateCompany: "activateCompany"
};

const getUser = state => {
  return state.alpha.user;
};

const getCompanies = state => {
  let user = getUser(state);
  if (!user.isLoggedIn || !user.contactInfo) return [];
  if ('companies' in user.contactInfo) return user.contactInfo.companies;else return [];
}; // Async Action Creators


const login$1 = (callbackUrl, removeUserInfo = false, register = false) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let user = getState().alpha.user;
    if (user.isLoggedIn || user.isAuthenticating) return Promise.resolve(); // Open login page

    let url = process.env.REACT_APP_ACCOUNT_URL + "/account/authorize/";
    let params = {
      callback: callbackUrl
    };
    if (apiKey == "000000000000") // Login as staff
      params["staff"] = 1;else params['business'] = getState().alpha.business[0].data.uid; // Try to login with previous identity

    if (user.userInfo && 'uid' in user.userInfo) {
      params['uid'] = user.userInfo.uid;
      if (removeUserInfo) // Remove userInfo from local storage, so that we don't try to login
        // if failed
        ls.remove('_userInfo');
    } // 12 Dec 2019. Add visitor info so that we can link new user to this contact


    let visitor = getVisitor(getState());
    if (visitor && visitor.data.visitor_id) params['visitor'] = visitor.data.visitor_id;
    if (register) params['register'] = 1; //    alert(JSON.stringify(params, null, 2))
    //    let params = { callback: process.env.REACT_APP_PUBLIC_URL + "/auth_callback" }
    //    let params = { callback: "http://178.128.86.10:9000/auth_callback/" }

    url = url + "?" + Object.entries(params).map(kv => kv.map(encodeURIComponent).join("=")).join("&"); // Redirect to url

    window.open(url, '_self');
  };
};

const authenticateWithToken = authToken => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (user.isAuthenticating) return Promise.resolve();
    let url = process.env.REACT_APP_ACCOUNT_URL + "/auth/token-info/";
    let data = {
      token: authToken
    }; //    alert(url)

    dispatch(authenticating());
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => {
      dispatch(receiveTokenInfo(authToken, json)); //        dispatch(fetchCart(authToken))
    }).catch(error => dispatch(errorAuthenticating(error)));
  };
};

const setActiveCompany = companyID => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (!user.isLoggedIn || !user.contactInfo) return Promise.resolve();
    let companyInfo = null;
    if ('companies' in user.contactInfo) companyInfo = user.contactInfo.companies.find(c => c['uid'] == companyID);

    if (!companyInfo) {
      alert("Invalid company: " + companyID.toString());
      return Promise.resolve();
    }

    dispatch(activateCompany(companyInfo));
  };
};

const fetchContactInfo = () => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let user = getState().alpha.user;
    if (user.isUpdatingContact) return Promise.resolve();
    let url = apiUrl + "/contact/api/contact/0/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    let authorization = {};
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    let api_key = apiKey || "000000000000";
    dispatch(updatingContact());
    return fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'X-API-Key': api_key,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveContactInfo(json))).catch(error => dispatch(errorUpdatingContact(error)));
  };
};

const updateContactInfo = data => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let url = apiUrl + "/contact/api/contact/0/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    let api_key = apiKey || "000000000000";
    dispatch(updatingContact());
    return fetch(url, {
      method: 'PUT',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': api_key,
        ...authorization
      },
      body: JSON.stringify(data)
    }).then(response => {
      return response.json().then(json => {
        if (response.ok) dispatch(receiveContactInfo(json));else dispatch(errorUpdatingContact(JSON.stringify(json, null, 2)));
      });
    }).catch(error => dispatch(errorUpdatingContact(error)));
  };
}; // Synchronous Action Creators


const authenticating = () => ({
  type: ACTION$1.authenticating
});

const receiveTokenInfo = (authToken, tokenInfo) => ({
  type: ACTION$1.receiveTokenInfo,
  authToken,
  tokenInfo
});

const errorAuthenticating = error => ({
  type: ACTION$1.errorAuthenticating,
  error
});

const updatingContact = () => ({
  type: ACTION$1.updatingContact
});

const receiveContactInfo = json => {
  // Normalize
  let contactInfo = json;
  if (!json.first_name || json.first_name === undefined) contactInfo['first_name'] = '';
  if (!json.last_name || json.last_name === undefined) contactInfo['last_name'] = '';
  return {
    type: ACTION$1.receiveContactInfo,
    contactInfo: contactInfo,
    receivedAt: Date.now()
  };
};

const errorUpdatingContact = error => ({
  type: ACTION$1.errorUpdatingContact,
  error
});

const activateCompany = companyInfo => ({
  type: ACTION$1.activateCompany,
  companyInfo
}); // User reducer


function _authenticating(state, action) {
  return updateObject(state, {
    isAuthenticating: true
  });
}

function _completeLogout(state, action) {
  ls.remove('_userInfo');
  return updateObject(state, {
    isLoggedIn: false,
    authToken: null,
    tokenInfo: {}
  });
}

function _errorAuthenticating(state, action) {
  alert(action.error);
  return { ...state,
    isAuthenticating: false
  };
}

function _receiveTokenInfo(state, action) {
  let userInfo = action.tokenInfo; //  alert(JSON.stringify(userInfo, null, 2))
  // Store userInfo on local storage

  ls.set('_userInfo', userInfo);
  return { ...state,
    isAuthenticating: false,
    isLoggedIn: true,
    authToken: action.authToken,
    userInfo: userInfo,
    isStaff: process.env.REACT_APP_GOAPP_API_KEY == "000000000000" && userInfo.is_staff
  };
}

function _updatingContact(state, action) {
  return { ...state,
    isUpdatingContact: true
  };
}

function _receiveContactInfo(state, action) {
  return { ...state,
    contactInfo: action.contactInfo,
    isUpdatingContact: false,
    lastContactUpdate: action.receivedAt
  };
}

function _errorUpdatingContact(state, action) {
  alert("Error Updating Contact."); //  alert(action.error)

  return { ...state,
    isUpdatingContact: false
  };
}

function _activateCompany(state, action) {
  //  alert("_activeCompany: " + JSON.stringify(action.companyInfo, null, 2))
  //  alert("state: " + JSON.stringify(state, null, 2))
  return { ...state,
    companyInfo: action.companyInfo
  };
}

const userReducer = (state = null, action) => {
  if (state == null) {
    // Get userInitial from local storage, but we're still in
    // not authenticated state, authToken is still null.
    // We'll use the info to auto authenticate to auth service
    state = userInitial;
    let userInfo = ls.get('_userInfo');
    if (userInfo && userInfo !== undefined) state.userInfo = userInfo;
  }

  const handlers = {
    [ACTION$1.authenticating]: _authenticating,
    [ACTION$1.errorAuthenticating]: _errorAuthenticating,
    [ACTION$1.receiveTokenInfo]: _receiveTokenInfo,
    [ACTION$1.completeLogout]: _completeLogout,
    [ACTION$1.updatingContact]: _updatingContact,
    [ACTION$1.receiveContactInfo]: _receiveContactInfo,
    [ACTION$1.errorUpdatingContact]: _errorUpdatingContact,
    [ACTION$1.activateCompany]: _activateCompany
  };
  if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);else return state;
};

const businessInfoInitial = {
  isFetching: false,
  isError: false,
  lastFetched: null,
  data: {}
}; // Actions

const ACTION$2 = {
  requestBusinessInfo: "requestBusinessInfo",
  receiveBusinessInfo: "receiveBusinessInfo",
  errorRequestBusinessInfo: "errorRequestBusinessInfo"
}; // Async action creator

const getBusinessInfo = (state, businessId = '0') => {
  if (businessId in state.alpha.business) return state.alpha.business[businessId];
  return businessInfoInitial;
};

const fetchBusinessInfo = (businessId = '0', refresh = false) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let res = getBusinessInfo(getState(), businessId);
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve(); //    let url = process.env.REACT_APP_GOAPP_API_URL + "/business/api/business/" + businessId + "/"

    let url = apiUrl + "/directory/api/business/" + businessId + "/";
    let api_key = apiKey;
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestBusinessInfo(businessId));
    return fetch(url, {
      headers: {
        'X-API-Key': api_key,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveBusinessInfo(businessId, json))).catch(error => dispatch(errorRequestBusinessInfo(businessId, error)));
  };
}; // Synchronous Action Creators for Business Info


const requestBusinessInfo = businessId => ({
  type: ACTION$2.requestBusinessInfo,
  businessId
});

const receiveBusinessInfo = (businessId, json) => {
  return {
    type: ACTION$2.receiveBusinessInfo,
    businessId,
    result: json,
    receivedAt: Date.now()
  };
};

const errorRequestBusinessInfo = (businessId, error) => ({
  type: ACTION$2.errorRequestBusinessInfo,
  businessId,
  error
}); // Reducers for Business


const businessReducer = createReducer(businessInfoInitial, {
  [ACTION$2.requestBusinessInfo]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$2.receiveBusinessInfo]: (state, action) => {
    //      alert(JSON.stringify(action, null, 2))
    return { ...state,
      isFetching: false,
      isPartial: false,
      lastFetched: action.receivedAt,
      data: action.result
    };
  },
  [ACTION$2.errorRequestBusinessInfo]: (state, action) => {
    alert(action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  }
});

function businessByIdUpdater(state, action) {
  let key = action.businessId;
  return { ...state,
    [key]: businessReducer(state[key], action)
  };
}

const businessByIdReducer = createReducer({}, {
  [ACTION$2.requestBusinessInfo]: businessByIdUpdater,
  [ACTION$2.receiveBusinessInfo]: businessByIdUpdater,
  [ACTION$2.errorRequestBusinessInfo]: businessByIdUpdater
});
const WSSTATE = {
  Idle: "Idle",
  Connecting: "Connecting",
  Connected: "Connected",
  Disconnected: "Disconnected"
};
const conversationInitial = {
  key: null,
  isFetching: false,
  isError: false,
  lastFetched: null,
  lastUpdate: null,
  // Last message update
  data: {
    new_count: 0,
    unread_count: 0,
    message_count: 0
  },
  messages: []
};
const messageInitial = {
  isSending: false,
  lastUpdate: null,
  data: {}
};
const conversationListInitial = {
  isFetching: false,
  isError: false,
  lastFetched: null,
  isStarting: false,
  newConversationKey: null,
  stats: {
    new_count: 0,
    unread_count: 0,
    message_count: 0
  },
  conversations: [],
  wsState: WSSTATE.Idle,
  activeConversationKey: -1 // 0: New conversation

}; // Actions

const ACTION$3 = {
  wsStateChanged: "wsStateChanged",
  setActiveConversationKey: "setActiveConversationKey",
  startingConversation: "startingConversation",
  receiveNewConversation: "receiveNewConversation",
  errorStartingConversation: "errorStartingConversation",
  requestConversationList: "requestConversationList",
  receiveConversationList: "receiveConversationList",
  errorRequestConversationList: "errorRequestConversationList",
  conversationDeleted: "conversationDeleted",
  requestConversation: "requestConversation",
  receiveConversation: "receiveConversation",
  errorRequestConversation: "errorRequestConversation",
  requestMessages: "requestMessages",
  receiveMessages: "receiveMessages",
  errorRequestMessages: "errorRequestMessages",
  postMessage: "postMessage",
  receivePostMessageResult: "receivePostMessageResult",
  errorPostMessage: "errorPostMessage",
  receiveNewMessage: "receiveNewMessage",
  readAllMessages: "readAllMessages",
  startTyping: "startTyping"
}; // Async action creator

const setActiveConversation = conversationKey => {
  return (dispatch, getState) => {
    dispatch(setActiveConversationKey(conversationKey));
  };
};

const fetchConversationList = (refresh = false) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let res = getState().alpha.conversationList;
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve();
    let url = apiUrl + "/conversation/api/conversation/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestConversationList());
    return fetch(url, {
      headers: {
        'X-API-Key': apiKey,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveConversationList(json))).catch(error => dispatch(errorRequestConversationList(error)));
  };
};

const getNewConversation = state => {
  if (state.alpha.conversationList.newConversationKey) return getConversation(state, state.alpha.conversationList.newConversationKey);
  return null;
};

const getConversation = (state, conversationKey) => {
  let c = state.alpha.conversationList.conversations.find(c => c.key == conversationKey);
  if (c === undefined) c = null;
  return c;
};

const getLatestConversation = state => {
  if (state.alpha.conversationList.lastFetched && state.alpha.conversationList.conversations.length) return state.alpha.conversationList.conversations[0];
  return null;
};

const startNewConversation = () => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    if (getState().alpha.conversationList.isStarting) return Promise.resolve();
    let url = apiUrl + "/conversation/api/conversation/start/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(startingConversation());
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': apiKey,
        ...authorization
      },
      body: JSON.stringify({})
    }).then(response => response.json()).then(json => dispatch(receiveNewConversation(json))).catch(error => dispatch(errorStartingConversation(error)));
  };
};

const deleteConversationIfEmpty = conversationKey => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let c = getConversation(getState(), conversationKey);
    if (c.messages.length > 0) return Promise.resolve();
    let url = apiUrl + "/conversation/api/conversation/" + c.key + "/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestMessages(conversationKey));
    return fetch(url, {
      method: 'DELETE',
      headers: {
        'X-API-Key': apiKey,
        ...authorization
      }
    }).then(response => dispatch(conversationDeleted(conversationKey))).catch(error => dispatch(errorRequestMessages(conversationKey, error)));
  };
};

const fetchConversation = (conversationKey, refresh = false, withMessages = false, partial = false) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let c = getConversation(getState(), conversationKey);
    if (!partial && c && (c.isFetching || c.lastFetched && !refresh)) return Promise.resolve();
    let url = apiUrl + "/conversation/api/conversation/" + c.key + "/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestConversation(conversationKey));
    return fetch(url, {
      headers: {
        'X-API-Key': apiKey,
        ...authorization
      }
    }).then(response => response.json()).then(json => {
      if (withMessages) {
        // Set partial to true, so that isFetching flag will not reset to false
        dispatch(receiveConversation(conversationKey, json, true));
        dispatch(fetchMessages(conversationKey, true, false));
      } else dispatch(receiveConversation(conversationKey, json, false));
    }).catch(error => dispatch(errorRequestConversation(conversationKey, error)));
  };
};

const fetchMessages = (conversationKey, refresh = false, withConversation = false, partial = false) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let c = getConversation(getState(), conversationKey);
    if (!partial && c && (c.isFetching || c.lastFetched && !refresh)) return Promise.resolve(); // 26 Nov: Try using conversation API to get messages so that we can get
    // conversation update (typing party) in one call.
    //    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/message/"

    let url = apiUrl + "/conversation/api/conversation/" + c.key + "/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    url = url + "&message_size=50"; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestMessages(conversationKey));
    return fetch(url, {
      headers: {
        'X-API-Key': apiKey,
        ...authorization
      }
    }).then(response => response.json()).then(json => {
      if (withConversation) {
        // Set partial to true, so that isFetching flag will not reset to false
        dispatch(receiveMessages(conversationKey, json, true));
        dispatch(fetchConversation(conversationKey, true, false, true));
      } else dispatch(receiveMessages(conversationKey, json, false));
    }).catch(error => dispatch(errorRequestMessages(conversationKey, error)));
  };
};

const sendMessage = (conversationKey, text, files = null) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let c = getConversation(getState(), conversationKey);
    let url = apiUrl + "/conversation/api/message/send/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    if (!text && !(files && files.length)) return Promise.resolve(); // c.lastFetched might null if user try to send message
    // while loading message contents for the first time.
    // Keep trying.
    //    if (c && c.lastFetched)

    if (c) url = url + "&conversation=" + c.data['uid'];else return Promise.resolve(); //    alert("sendMessage: " + url)
    // Create new Message object

    let message = { ...messageInitial,
      key: new Date().valueOf(),
      data: {
        body: text
      }
    }; //    alert("sendMessage: " + JSON.stringify(message, null, 2))
    //    alert("conversationKey: " + conversationKey)

    dispatch(postMessage(conversationKey, message));
    let formData = new FormData();
    formData.append('body', text);
    if (files) files.map((file, index) => {
      //      formData.append(`files${index}`, file)
      formData.append('attachments', file);
    });
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        //          'Content-Type': 'application/json',
        'X-API-Key': apiKey,
        ...authorization
      },
      //        body: JSON.stringify(data)
      body: formData
    }).then(response => response.json()).then(json => {
      dispatch(receivePostMessageResult(conversationKey, message, json)); // Refresh conversation to quickly get operator typing_parties
      // This is a temporary hack until we implement websocket for
      // realtime push
      //        dispatch(fetchConversation(conversationKey, true))
    }).catch(error => dispatch(errorPostMessage(conversationKey, message)));
  };
};

const markReadAll = conversationKey => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let c = getConversation(getState(), conversationKey); // Must not check isFetching as we often do fetching and when it's fetching
    // we don't have any chance to mark read
    //    if (c.isFetching || !c.lastFetched)
    //      return Promise.resolve()

    let url = apiUrl + "/conversation/api/message/read_all/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    url = url + "&conversation=" + c.data['uid'];
    dispatch(readAllMessages(conversationKey)); //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': apiKey,
        ...authorization
      },
      body: JSON.stringify({})
    }).then(response => response.json()).then(json => {//        alert(JSON.stringify(json, null, 2))
    });
  };
};

const startTyping = conversationKey => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let c = getConversation(getState(), conversationKey);
    let url = apiUrl + "/conversation/api/conversation/" + c.key + "/start_typing/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //url = url + "&conversation=" + c.data['uid']    

    let user = getState().alpha.user;
    dispatch({
      type: ACTION$3.startTyping,
      conversationKey
    });
    let authorization = {};
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': apiKey,
        ...authorization
      },
      body: JSON.stringify({})
    }).then(response => response.json()).then(json => {//        alert(JSON.stringify(json, null, 2))
    });
  };
}; // Synchronous Action Creators for Content Index

const setActiveConversationKey = conversationKey => ({
  type: ACTION$3.setActiveConversationKey,
  conversationKey
});

const startingConversation = () => ({
  type: ACTION$3.startingConversation
});

const receiveNewConversation = json => {
  return {
    type: ACTION$3.receiveNewConversation,
    result: json,
    receivedAt: Date.now()
  };
};

const errorStartingConversation = error => ({
  type: ACTION$3.errorStartingConversation,
  error
});

const requestConversationList = () => ({
  type: ACTION$3.requestConversationList
});

const receiveConversationList = json => {
  let result = json; //  alert("receiveConversationList")
  // alert(JSON.stringify(result, null, 2))

  return {
    type: ACTION$3.receiveConversationList,
    result: result,
    receivedAt: Date.now()
  };
};

const errorRequestConversationList = error => ({
  type: ACTION$3.errorRequestConversationList,
  error
});

const conversationDeleted = conversationKey => ({
  type: ACTION$3.conversationDeleted,
  conversationKey
});

const requestConversation = conversationKey => ({
  type: ACTION$3.requestConversation,
  conversationKey
});

const receiveConversation = (conversationKey, json, partial = false) => {
  let result = json; //  alert(JSON.stringify(json, null, 2))

  return {
    type: ACTION$3.receiveConversation,
    conversationKey,
    result: result,
    receivedAt: Date.now(),
    partial: partial
  };
};

const errorRequestConversation = (conversationKey, error) => ({
  type: ACTION$3.errorRequestConversation,
  conversationKey,
  error
});

const requestMessages = conversationKey => ({
  type: ACTION$3.requestMessages,
  conversationKey
});

const receiveMessages = (conversationKey, json, partial = false) => {
  let result = json; //  alert(JSON.stringify(json, null, 2))

  return {
    type: ACTION$3.receiveMessages,
    conversationKey,
    //    result: result,
    conversation: result,
    result: result['messages'],
    receivedAt: Date.now(),
    partial: partial
  };
};

const errorRequestMessages = (conversationKey, error) => ({
  type: ACTION$3.errorRequestMessages,
  conversationKey,
  error
});

const postMessage = (conversationKey, message) => ({
  type: ACTION$3.postMessage,
  conversationKey,
  message
});

const receivePostMessageResult = (conversationKey, message, json) => {
  let result = json;
  return {
    type: ACTION$3.receivePostMessageResult,
    conversationKey,
    message,
    result: result,
    receivedAt: Date.now()
  };
};

const errorPostMessage = (conversationKey, message, error) => ({
  type: ACTION$3.errorPostMessage,
  conversationKey,
  message
});

const readAllMessages = conversationKey => ({
  type: ACTION$3.readAllMessages,
  conversationKey
}); // Reducers for Conversation


const conversationReducer = createReducer(conversationInitial, {
  [ACTION$3.requestConversation]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$3.receiveConversation]: (state, action) => {
    return { ...state,
      isFetching: action.partial ? state.isFetching : false,
      lastFetched: action.partial ? state.lastFetched : action.receivedAt,
      data: action.result
    };
  },
  [ACTION$3.errorRequestConversation]: (state, action) => {
    alert(action.error);
    return { ...state,
      isFetchingMessages: false,
      isError: true
    };
  },
  [ACTION$3.requestMessages]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$3.receiveMessages]: (state, action) => {
    //      alert(JSON.stringify(action.result, null, 2))
    // Keep pending messages
    let pending = state.messages.reduce((all, item) => {
      if (item.isSending) return [...all, item];else return all;
    }, []);
    let messages = action.result.map(data => {
      return { ...messageInitial,
        // Same as conversation update time.
        key: data['id'],
        lastUpdate: action.receivedAt,
        data: data
      };
    });
    return { ...state,
      isFetching: action.partial ? state.isFetching : false,
      lastFetched: action.partial ? state.receivedAt : action.receivedAt,
      data: action.conversation,
      messages: [...messages, ...pending]
    };
  },
  [ACTION$3.receiveNewMessage]: (state, action) => {
    //      alert(JSON.stringify(action.result, null, 2))
    let newMessage = action.result;
    let discard = false;
    let messages = state.messages.map(message => {
      if (message.key == newMessage['id']) {
        discard = true;
        return { ...message,
          data: newMessage
        };
      } //        if (message.isSending)
      //          discard = true


      return message;
    });

    if (!discard) {
      messages.push({ ...messageInitial,
        key: newMessage['id'],
        lastUpdate: action.receivedAt,
        data: { ...newMessage,
          is_new: true
        }
      });
    }

    return { ...state,
      messages: messages,
      data: action.result.conversation
    };
  },
  [ACTION$3.readAllMessages]: (state, action) => {
    return { ...state,
      data: { ...state.data,
        new_count: 0
      }
    };
  },
  [ACTION$3.startTyping]: (state, action) => {
    return { ...state,
      data: { ...state.data,
        parties: state.data.parties.map(p => {
          //if (p.agent && p.agent.uid == action.agentUid)
          if (p.contact) return { ...p,
            typing_at: new Date()
          };else return p;
        })
      }
    };
  },
  [ACTION$3.errorRequestMessages]: (state, action) => {
    alert(action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  },
  [ACTION$3.postMessage]: (state, action) => {
    let messages = [...state.messages, { ...action.message,
      isSending: true
    }];
    return { ...state,
      messages
    };
  },
  [ACTION$3.receivePostMessageResult]: (state, action) => {
    //      alert("receivePostMessageResult: " + JSON.stringify(action.result, null, 2))
    let messages;
    let found = state.messages.find(item => item.key == action.result.id);
    if (found) messages = state.messages.reduce((p, n) => {
      if (n.key == action.message.key) return p;else return [...p, n];
    }, []);else messages = state.messages.map(item => {
      if (item.key == action.message.key) return { ...item,
        key: action.result.id,
        // Update to new key for new message
        isSending: false,
        lastUpdate: action.receivedAt,
        data: action.result
      };
      return item;
    });
    let unread_count = 1;
    if (state.data && state.data.unread_count !== undefined) unread_count = state.data.unread_count + 1;

    if (state.key == 0 && !state.lastFetched) {
      return { ...state,
        messages,
        key: action.result.conversation.uid,
        // Update with new key          
        data: { ...action.result.conversation,
          unread_count: unread_count
        },
        lastFetched: action.receivedAt
      };
    } else {
      return { ...state,
        data: { ...state.data,
          unread_count: unread_count
        },
        messages
      };
    }
  },
  [ACTION$3.errorPostMessage]: (state, action) => {
    alert("Error Post Message: " + action.error);
    return { ...state,
      isSending: false
    };
  }
});
const conversationListReducer = createReducer(conversationListInitial, {
  [ACTION$3.wsStateChanged]: (state, action) => {
    return { ...state,
      wsState: action.state
    };
  },
  [ACTION$3.setActiveConversationKey]: (state, action) => {
    return { ...state,
      activeConversationKey: action.conversationKey
    };
  },
  [ACTION$3.requestConversationList]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$3.receiveConversationList]: (state, action) => {
    // Create record for each conversation in response
    let conversations = action.result.map(data => {
      // Keep last fetched messages
      let c = state.conversations.find(c => {
        return c.key == data.uid;
      });
      let messages = c ? c.messages : [];

      if (data.last_message) {
        if (!messages.find(c => {
          return c.key == data.last_message.id;
        })) messages.push({ ...messageInitial,
          key: data.last_message.id,
          data: data.last_message
        });
      }

      return { ...conversationInitial,
        key: data.uid,
        data,
        messages
      };
    });
    let message_count = 0;
    let new_count = 0;
    let unread_count = 0;
    conversations.forEach((c, index) => {
      message_count += c.data.message_count === undefined ? 0 : c.data.message_count;
      new_count += c.data.new_count === undefined ? 0 : c.data.new_count;
      unread_count += c.data.unread_count === undefined ? 0 : c.data.unread_count;
    }); //      alert(JSON.stringify(conversations, null, 2))

    return { ...state,
      isFetching: false,
      lastFetched: action.receivedAt,
      conversations: conversations,
      stats: {
        message_count: message_count,
        new_count: new_count,
        unread_count: unread_count
      }
    };
  },
  [ACTION$3.errorRequestConversationList]: (state, action) => {
    alert("Request conversation list failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  },
  [ACTION$3.startingConversation]: (state, action) => {
    return { ...state,
      isStarting: true,
      newConversationKey: null
    };
  },
  [ACTION$3.receiveNewConversation]: (state, action) => {
    let c = { ...conversationInitial,
      key: action.result.uid,
      data: action.result
    }; //      alert("receiveNewConversation")
    //      alert(JSON.stringify(c, null, 2))

    return { ...state,
      isStarting: false,
      newConversationKey: c.key,
      conversations: [c, ...state.conversations]
    };
  },
  [ACTION$3.errorStartingConversation]: (state, action) => {
    alert(action.error);
    return { ...state,
      isStarting: false,
      isError: true
    };
  },
  [ACTION$3.conversationDeleted]: (state, action) => {
    let conversations = state.conversations.reduce((all, c) => {
      if (c.key == action.conversationKey) return all;else return [...all, c];
    }, []);
    return { ...state,
      newConversationKey: null,
      conversations
    };
  },
  '*': (state, action) => {
    if (action.type in ACTION$3) {
      //        alert(JSON.stringify(action, null, 2))
      let conversation = state.conversations.find(c => c.key == action.conversationKey);

      if (conversation) {
        let newConversation = conversationReducer(conversation, action);
        let newRecords = state.conversations.map(c => {
          if (c.key == action.conversationKey) return newConversation;
          return c;
        });
        let message_count = 0;
        let new_count = 0;
        let unread_count = 0;
        newRecords.forEach((c, index) => {
          message_count += c.data.message_count === undefined ? 0 : c.data.message_count;
          new_count += c.data.new_count === undefined ? 0 : c.data.new_count;
          unread_count += c.data.unread_count === undefined ? 0 : c.data.unread_count;
        });
        return { ...state,
          conversations: newRecords,
          stats: {
            message_count: message_count,
            new_count: new_count,
            unread_count: unread_count
          }
        };
      } else if (action.type == ACTION$3.receiveNewMessage) {
        // Not found, create the new conversation if it's receiveNewMessage
        let conversation = action.result.conversation;
        let c = { ...conversationInitial,
          key: conversation.uid,
          data: conversation,
          messages: [{ ...messageInitial,
            key: action.result.id,
            data: action.result
          }]
        }; //      alert("receiveNewConversation")
        //      alert(JSON.stringify(c, null, 2))

        return { ...state,
          conversations: [c, ...state.conversations]
        };
      }
    }

    return state;
  }
});

const wsConnect = host => ({
  type: 'WS_CONNECT',
  host
});

const wsSend = (command, data) => ({
  type: 'WS_SEND',
  command,
  data
});

const styles = theme => ({
  root: {
    paddingTop: theme.spacing(2)
  },
  list: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  avatar: {
    width: 60,
    height: 60,
    marginRight: theme.spacing.unit * 2
  },
  pageTitle: {
    color: '#000',
    fontWeight: 800,
    padding: theme.spacing.unit,
    paddingTop: theme.spacing(2),
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  sectionHeader: {
    marginBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2,
    color: '#999'
  },
  sectionFooter: {
    marginTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2
  },
  sectionDivider: {
    minHeight: theme.spacing.unit * 2
  },
  sectionBody: {
    backgroundColor: theme.palette.background.paper,
    width: '100%'
  },
  sectionContent: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
    width: '100'
  },
  sectionContentAction: {},
  bottomPadding: {
    minHeight: 100
  },
  headerChat: {
    position: 'fixed',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: 'inherit',
    background: 'white',
    zIndex: '100',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  labelChat: {
    paddingLeft: theme.spacing(2) // [theme.breakpoints.down('xs')]:{
    //   paddingLeft: 0
    // }

  },
  iconClose: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      position: 'fixed',
      right: '10px',
      top: '16px',
      zIndex: 101
    }
  },
  accountName: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'initial'
    }
  },
  mutedText: {
    color: '#777'
  }
});

const ConversationItem = ({
  classes,
  business,
  item,
  onClick
}) => {
  let title = business.name;
  let sender = "";
  let preview = "...";
  let date = "";
  let stat = ""; //  alert(JSON.stringify(item, null, 2))

  if (item.messages.length) {
    title = item.data.parties.map(p => {
      if (p.agent) {
        let name = p.agent.first_name;
        if (p.agent.last_name && p.agent.last_name !== undefined) name += " " + p.agent.last_name;
        if (p.agent.is_service_user) name += ""; //" (Bot)"
        else name += " (Agent)"; //          name += " (" + business.name + ")"

        return name;
      } else return null;
    }).reduce((p, n) => {
      if (p && n) return p + ", " + n;else if (n) return n;else return p;
    });
    if (!title && item.data.queue) title = item.data.queue.name;
    if (!title || title.length <= 0) title = "You"; //    alert(JSON.stringify(item, null, 2))

    let msg = item.messages[item.messages.length - 1];
    preview = msg.data.body;

    if (msg.data.attachments && msg.data.attachments !== undefined && msg.data.attachments.length > 0) {
      preview = "Photo";
    }

    if (preview.startsWith("{") && preview.endsWith("}")) preview = JSON.parse(preview)['text'];
    if (preview) preview = preview.replace(/(?:__|[*#])|\[(.*?)\]\(.*?\)/gm, '$1');
    if (msg.isSending) date = "Sending...";else {
      if (msg.data.sent_at) date = moment(msg.data.sent_at).fromNow(true);
      if (msg.data.sender.contact) sender = "You";
    } //    if (msg.data.agent)
    //      sender = msg.data.agent.first_name
    //    else if (msg.data.service)
    //      sender = msg.data.service.first_name
  }

  let newCount = item.data.new_count;
  if (item.data.new_count) stat = " (New)";else if (item.data.unread_count) stat = " (Not Read)";else if (item.messages.length) //    stat = " (Read)"   
    stat = "";
  return React.createElement(ListItem, {
    button: true,
    alignItems: "flex-start",
    onClick: () => onClick(item)
  }, React.createElement(ListItemAvatar, null, React.createElement(Avatar, {
    alt: "You",
    src: ""
  })), React.createElement(ListItemText, {
    primary: React.createElement(React.Fragment, null, React.createElement(Typography, {
      style: {
        color: item.data.closed_at ? '#777' : 'auto',
        fontWeight: 700
      }
    }, title)),
    secondary: React.createElement(React.Fragment, null, React.createElement(Typography, {
      component: "p",
      variant: "body2",
      className: classes.inline,
      color: item.data.closed_at ? "#777" : "textPrimary",
      noWrap: false
    }, sender && React.createElement(React.Fragment, null, " ", sender, ": "), preview), React.createElement("br", null), date, " ", stat)
  }), React.createElement(ListItemSecondaryAction, {
    style: {
      paddingRight: '8pt'
    }
  }, React.createElement(Badge, {
    color: "primary",
    badgeContent: newCount
  }, "\xA0")));
};

const ConversationList = ({
  classes,
  business,
  conversations,
  onClick
}) => React.createElement(Box, {
  className: classes.sectionBody
}, conversations.length > 0 ? React.createElement(List, {
  className: classes.list
}, conversations.length ? conversations.map(item => React.createElement(ConversationItem, {
  classes: classes,
  business: business,
  item: item,
  onClick: () => onClick(item)
})).reduce((prev, next) => [prev, React.createElement(Divider, {
  variant: "inset",
  component: "li"
}), next]) : React.createElement(React.Fragment, null)) : React.createElement(Box, {
  width: "100%",
  className: classes.sectionContent
}, React.createElement(Box, {
  flexGrow: 1,
  color: "#999"
}, React.createElement(Typography, {
  component: "div",
  variant: "body2"
}, "Tidak ada chat aktif. Klik tombol di atas untuk memulai chat."))));

const ChatHeader = ({
  classes,
  business,
  showConversation,
  wsState
}) => {
  let state = "Disconnected";
  if (wsState == WSSTATE.Connected) state = "You are online";else if (wsState == WSSTATE.Connecting) state = "Connecting...";
  return React.createElement(Box, {
    className: classes.chatHeader
  }, React.createElement(Box, {
    width: "100%",
    className: classes.sectionContent,
    display: "flex",
    flexDirection: "column"
  }, React.createElement(Box, {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }, React.createElement(Box, {
    flexGrow: 1
  }, React.createElement(Typography, {
    variant: "h6",
    className: classes.accountName
  }, React.createElement(Box, {
    fontWeight: 800,
    color: "#000"
  }, business.name)), React.createElement(Typography, {
    variant: "p",
    className: classes.accountName
  }, state)), React.createElement(Box, {
    width: "10rem"
  })), React.createElement(Box, {
    width: "100%",
    mt: 2,
    display: "flex"
  }, React.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: () => showConversation(0)
  }, "Mulai Chat Baru")), React.createElement(Box, {
    width: "100%",
    display: "flex",
    display: "none"
  }, React.createElement(Box, null, React.createElement(Avatar, {
    src: business.avatar == undefined ? null : business.avatar.image_url,
    className: classes.avatar,
    border: 1
  })), React.createElement(Box, {
    flexGrow: 1
  }, React.createElement(Typography, {
    component: "div",
    variant: "body1",
    gutterBottom: true
  }, business.name), React.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: () => showConversation(0)
  }, "Mulai Chat Baru")))));
};

const InboxView = ({
  theme,
  classes,
  history,
  business,
  lastFetched,
  wsState,
  fetchConversationList,
  isFetching,
  conversations,
  newConversation,
  openChat
}) => {
  const [hasBottomMenu, setHasBottomMenu] = useState(false);
  useEffect(() => {}); // This will be called on component init  

  useEffect(() => {
    fetchConversationList();
    return () => {};
  }, []);
  const activeList = lastFetched && conversations.filter(c => !c.data.closed_at) || [];
  const closedList = lastFetched && conversations.filter(c => c.data.closed_at) || []; // useEffect(() => {
  //   navigationContext.setLoading(isFetching)
  //   return () => {
  //     navigationContext.setLoading(false)
  //   }
  // }, [isFetching])

  let sm = useMediaQuery(theme.breakpoints.up('sm'));

  const showConversation = conversationKey => {
    openChat(conversationKey);
    /*    
        if (wsState != WSSTATE.Connected) {
          alert("Can not start chat while you are not online. Please check your internet connection.")
          return
        }
    
        setIsChat(true)
        setIsInbox(false)
        setKeyConversation(conversationKey)
    */
    //    alert('showConversation:'+ conversationKey)
    //    history.push("/chat/" + conversationKey)
    // if (sm)
    //   navigationContext.showPopupContent(
    //     <Chat conversationKey={conversationKey} openChat={(key)=>showConversation(key)} />
    //     )
    // else
    //   showPopup(
    //     <Chat conversationKey={conversationKey} openChat={(key)=>showConversation(key)} />
    //     )
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Box, {
    className: classes.pageTitle
  }), React.createElement(ChatHeader, {
    classes: classes,
    business: business,
    showConversation: showConversation,
    wsState: wsState
  }), React.createElement("div", {
    className: classes.sectionDivider
  }), React.createElement(Box, {
    className: classes.sectionHeader,
    di: true
  }, React.createElement(Typography, {
    variant: "body1"
  }, "Chat Aktif")), React.createElement(Divider, null), React.createElement(ConversationList, {
    classes: classes,
    business: business,
    conversations: activeList,
    onClick: conversation => showConversation(conversation.key)
  }), closedList.length > 0 && React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes.sectionDivider
  }), React.createElement(Box, {
    className: classes.sectionHeader,
    di: true
  }, React.createElement(Typography, {
    variant: "body1"
  }, "Riwayat Chat")), React.createElement(Divider, null), React.createElement(ConversationList, {
    classes: classes,
    business: business,
    conversations: closedList,
    onClick: conversation => showConversation(conversation.key)
  })));
};

const mapStateToProps = (state, ownProps) => {
  return { ...state.alpha.conversationList,
    business: getBusinessInfo(state).data
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchConversationList: () => {
      dispatch(fetchConversationList(true));
    }
  };
};

var Inbox = withRouter(withStyles(styles, {
  withTheme: true
})(connect(mapStateToProps, mapDispatchToProps)(InboxView)));
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var globals = createCommonjsModule(function (module, exports) {
  function insertRule(e) {
    try {
      return sheet.insertRule(e, sheet.cssRules.length);
    } catch (e) {
      console.warn("react-reveal - animation failed");
    }
  }

  function cascade(e, n, t, o, r) {
    var s = Math.log(o),
        i = Math.log(r),
        a = (i - s) / (t - n);
    return Math.exp(s + a * (e - n));
  }

  function animation(e) {
    if (!sheet) return "";
    var n = "@keyframes " + (name + counter) + "{" + e + "}",
        t = effectMap[e];
    return t ? "" + name + t : (sheet.insertRule(n, sheet.cssRules.length), effectMap[e] = counter, "" + name + counter++);
  }

  function hideAll() {
    globalHide || (exports.globalHide = globalHide = !0, window.removeEventListener("scroll", hideAll, !0), insertRule("." + namespace + " { opacity: 0; }"), window.removeEventListener("orientationchange", hideAll, !0), window.document.removeEventListener("visibilitychange", hideAll));
  }

  function config(e) {
    var n = e.ssrFadeout;
    exports.fadeOutEnabled = fadeOutEnabled = n;
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.insertRule = insertRule, exports.cascade = cascade, exports.animation = animation, exports.hideAll = hideAll, exports.default = config;

  var namespace = exports.namespace = "react-reveal",
      defaults = exports.defaults = {
    duration: 1e3,
    delay: 0,
    count: 1
  },
      ssr = exports.ssr = !0,
      observerMode = exports.observerMode = !1,
      raf = exports.raf = function (e) {
    return window.setTimeout(e, 66);
  },
      disableSsr = exports.disableSsr = function () {
    return exports.ssr = ssr = !1;
  },
      fadeOutEnabled = exports.fadeOutEnabled = !1,
      ssrFadeout = exports.ssrFadeout = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return exports.fadeOutEnabled = fadeOutEnabled = e;
  },
      globalHide = exports.globalHide = !1,
      ie10 = exports.ie10 = !1,
      collapseend = exports.collapseend = void 0,
      counter = 1,
      effectMap = {},
      sheet = !1,
      name = namespace + "-" + Math.floor(1e15 * Math.random()) + "-";

  if ("undefined" != typeof window && "nodejs" !== window.name && window.document && "undefined" != typeof navigator) {
    exports.observerMode = observerMode = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype && /\{\s*\[native code\]\s*\}/.test("" + IntersectionObserver), exports.raf = raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || raf, exports.ssr = ssr = window.document.querySelectorAll("div[data-reactroot]").length > 0, -1 !== navigator.appVersion.indexOf("MSIE 10") && (exports.ie10 = ie10 = !0), ssr && "performance" in window && "timing" in window.performance && "domContentLoadedEventEnd" in window.performance.timing && window.performance.timing.domLoading && Date.now() - window.performance.timing.domLoading < 300 && (exports.ssr = ssr = !1), ssr && window.setTimeout(disableSsr, 1500), observerMode || (exports.collapseend = collapseend = document.createEvent("Event"), collapseend.initEvent("collapseend", !0, !0));
    var element = document.createElement("style");
    document.head.appendChild(element), element.sheet && element.sheet.cssRules && element.sheet.insertRule && (sheet = element.sheet, window.addEventListener("scroll", hideAll, !0), window.addEventListener("orientationchange", hideAll, !0), window.document.addEventListener("visibilitychange", hideAll));
  }
});
unwrapExports(globals);
var globals_1 = globals.globalHide;
var globals_2 = globals.fadeOutEnabled;
var globals_3 = globals.insertRule;
var globals_4 = globals.cascade;
var globals_5 = globals.animation;
var globals_6 = globals.hideAll;
var globals_7 = globals.namespace;
var globals_8 = globals.defaults;
var globals_9 = globals.ssr;
var globals_10 = globals.observerMode;
var globals_11 = globals.raf;
var globals_12 = globals.disableSsr;
var globals_13 = globals.ssrFadeout;
var globals_14 = globals.ie10;
var globals_15 = globals.collapseend;
var RevealBase_1 = createCommonjsModule(function (module, exports) {
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function _defineProperty(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = i, e;
  }

  function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      _slicedToArray = function () {
    function e(e, t) {
      var i = [],
          s = !0,
          o = !1,
          n = void 0;

      try {
        for (var r, a = e[Symbol.iterator](); !(s = (r = a.next()).done) && (i.push(r.value), !t || i.length !== t); s = !0);
      } catch (e) {
        o = !0, n = e;
      } finally {
        try {
          !s && a.return && a.return();
        } finally {
          if (o) throw n;
        }
      }

      return i;
    }

    return function (t, i) {
      if (Array.isArray(t)) return t;
      if (Symbol.iterator in Object(t)) return e(t, i);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
      _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];

      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (e[s] = i[s]);
    }

    return e;
  },
      _createClass = function () {
    function e(e, t) {
      for (var i = 0; i < t.length; i++) {
        var s = t[i];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
      }
    }

    return function (t, i, s) {
      return i && e(t.prototype, i), s && e(t, s), t;
    };
  }(),
      _react2 = _interopRequireDefault(React),
      inOut = (0, PropTypes.shape)({
    make: PropTypes.func,
    duration: PropTypes.number.isRequired,
    delay: PropTypes.number.isRequired,
    forever: PropTypes.bool,
    count: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
    reverse: PropTypes.bool
  }),
      propTypes = {
    collapse: PropTypes.bool,
    collapseEl: PropTypes.element,
    cascade: PropTypes.bool,
    wait: PropTypes.number,
    force: PropTypes.bool,
    disabled: PropTypes.bool,
    appear: PropTypes.bool,
    enter: PropTypes.bool,
    exit: PropTypes.bool,
    fraction: PropTypes.number,
    refProp: PropTypes.string,
    innerRef: PropTypes.func,
    onReveal: PropTypes.func,
    unmountOnExit: PropTypes.bool,
    mountOnEnter: PropTypes.bool,
    inEffect: inOut.isRequired,
    outEffect: (0, PropTypes.oneOfType)([inOut, (0, PropTypes.oneOf)([!1])]).isRequired,
    ssrReveal: PropTypes.bool,
    collapseOnly: PropTypes.bool,
    ssrFadeout: PropTypes.bool
  },
      defaultProps = {
    fraction: .2,
    refProp: "ref"
  },
      contextTypes = {
    transitionGroup: PropTypes.object
  },
      RevealBase = function (e) {
    function t(e, i) {
      _classCallCheck(this, t);

      var s = _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, i));

      return s.isOn = void 0 === e.when || !!e.when, s.state = {
        collapse: e.collapse ? t.getInitialCollapseStyle(e) : void 0,
        style: {
          opacity: s.isOn && !e.ssrReveal || !e.outEffect ? void 0 : 0
        }
      }, s.savedChild = !1, s.isShown = !1, globals.observerMode ? s.handleObserve = s.handleObserve.bind(s) : (s.revealHandler = s.makeHandler(s.reveal), s.resizeHandler = s.makeHandler(s.resize)), s.saveRef = s.saveRef.bind(s), s;
    }

    return _inherits(t, e), _createClass(t, [{
      key: "saveRef",
      value: function (e) {
        this.childRef && this.childRef(e), this.props.innerRef && this.props.innerRef(e), this.el !== e && (this.el = e && "offsetHeight" in e ? e : void 0, this.observe(this.props, !0));
      }
    }, {
      key: "invisible",
      value: function () {
        this && this.el && (this.savedChild = !1, this.isShown || (this.setState({
          hasExited: !0,
          collapse: this.props.collapse ? _extends({}, this.state.collapse, {
            visibility: "hidden"
          }) : null,
          style: {
            opacity: 0
          }
        }), !globals.observerMode && this.props.collapse && window.document.dispatchEvent(globals.collapseend)));
      }
    }, {
      key: "animationEnd",
      value: function (e, t, i) {
        var s = this,
            o = i.forever,
            n = i.count,
            r = i.delay,
            a = i.duration;

        if (!o) {
          var l = function () {
            s && s.el && (s.animationEndTimeout = void 0, e.call(s));
          };

          this.animationEndTimeout = window.setTimeout(l, r + (a + (t ? a : 0) * n));
        }
      }
    }, {
      key: "getDimensionValue",
      value: function () {
        return this.el.offsetHeight + parseInt(window.getComputedStyle(this.el, null).getPropertyValue("margin-top"), 10) + parseInt(window.getComputedStyle(this.el, null).getPropertyValue("margin-bottom"), 10);
      }
    }, {
      key: "collapse",
      value: function (e, t, i) {
        var s = i.duration + (t.cascade ? i.duration : 0),
            o = this.isOn ? this.getDimensionValue() : 0,
            n = void 0,
            r = void 0;
        if (t.collapseOnly) n = i.duration / 3, r = i.delay;else {
          var a = s >> 2,
              l = a >> 1;
          n = a, r = i.delay + (this.isOn ? 0 : s - a - l), e.style.animationDuration = s - a + (this.isOn ? l : -l) + "ms", e.style.animationDelay = i.delay + (this.isOn ? a - l : 0) + "ms";
        }
        return e.collapse = {
          height: o,
          transition: "height " + n + "ms ease " + r + "ms",
          overflow: t.collapseOnly ? "hidden" : void 0
        }, e;
      }
    }, {
      key: "animate",
      value: function (e) {
        if (this && this.el && (this.unlisten(), this.isShown !== this.isOn)) {
          this.isShown = this.isOn;
          var t = !this.isOn && e.outEffect,
              i = e[t ? "outEffect" : "inEffect"],
              s = "style" in i && i.style.animationName || void 0,
              o = void 0;
          e.collapseOnly ? o = {
            hasAppeared: !0,
            hasExited: !1,
            style: {
              opacity: 1
            }
          } : ((e.outEffect || this.isOn) && i.make && (s = i.make), o = {
            hasAppeared: !0,
            hasExited: !1,
            collapse: void 0,
            style: _extends({}, i.style, {
              animationDuration: i.duration + "ms",
              animationDelay: i.delay + "ms",
              animationIterationCount: i.forever ? "infinite" : i.count,
              opacity: 1,
              animationName: s
            }),
            className: i.className
          }), this.setState(e.collapse ? this.collapse(o, e, i) : o), t ? (this.savedChild = _react2.default.cloneElement(this.getChild()), this.animationEnd(this.invisible, e.cascade, i)) : this.savedChild = !1, this.onReveal(e);
        }
      }
    }, {
      key: "onReveal",
      value: function (e) {
        e.onReveal && this.isOn && (this.onRevealTimeout && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)), e.wait ? this.onRevealTimeout = window.setTimeout(e.onReveal, e.wait) : e.onReveal());
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.unlisten(), globals.ssr && (0, globals.disableSsr)();
      }
    }, {
      key: "handleObserve",
      value: function (e, t) {
        _slicedToArray(e, 1)[0].intersectionRatio > 0 && (t.disconnect(), this.observer = null, this.reveal(this.props, !0));
      }
    }, {
      key: "observe",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

        if (this.el && globals.observerMode) {
          if (this.observer) {
            if (!t) return;
            this.observer.disconnect();
          } else if (t) return;

          this.observer = new IntersectionObserver(this.handleObserve, {
            threshold: e.fraction
          }), this.observer.observe(this.el);
        }
      }
    }, {
      key: "reveal",
      value: function (e) {
        var t = this,
            i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        globals.globalHide || (0, globals.hideAll)(), this && this.el && (e || (e = this.props), globals.ssr && (0, globals.disableSsr)(), this.isOn && this.isShown && void 0 !== e.spy ? (this.isShown = !1, this.setState({
          style: {}
        }), window.setTimeout(function () {
          return t.reveal(e);
        }, 200)) : i || this.inViewport(e) || e.force ? this.animate(e) : globals.observerMode ? this.observe(e) : this.listen());
      }
    }, {
      key: "componentDidMount",
      value: function () {
        var e = this;

        if (this.el && !this.props.disabled) {
          this.props.collapseOnly || ("make" in this.props.inEffect && this.props.inEffect.make(!1, this.props), void 0 !== this.props.when && this.props.outEffect && "make" in this.props.outEffect && this.props.outEffect.make(!0, this.props));
          var i = this.context.transitionGroup,
              s = i && !i.isMounting ? !("enter" in this.props && !1 === this.props.enter) : this.props.appear;
          return this.isOn && ((void 0 !== this.props.when || void 0 !== this.props.spy) && !s || globals.ssr && !globals.fadeOutEnabled && !this.props.ssrFadeout && this.props.outEffect && !this.props.ssrReveal && t.getTop(this.el) < window.pageYOffset + window.innerHeight) ? (this.isShown = !0, this.setState({
            hasAppeared: !0,
            collapse: this.props.collapse ? {
              height: this.getDimensionValue()
            } : this.state.collapse,
            style: {
              opacity: 1
            }
          }), void this.onReveal(this.props)) : globals.ssr && (globals.fadeOutEnabled || this.props.ssrFadeout) && this.props.outEffect && t.getTop(this.el) < window.pageYOffset + window.innerHeight ? (this.setState({
            style: {
              opacity: 0,
              transition: "opacity 1000ms 1000ms"
            }
          }), void window.setTimeout(function () {
            return e.reveal(e.props, !0);
          }, 2e3)) : void (this.isOn && (this.props.force ? this.animate(this.props) : this.reveal(this.props)));
        }
      }
    }, {
      key: "cascade",
      value: function (e) {
        var t = this,
            i = void 0;
        i = "string" == typeof e ? e.split("").map(function (e, t) {
          return _react2.default.createElement("span", {
            key: t,
            style: {
              display: "inline-block",
              whiteSpace: "pre"
            }
          }, e);
        }) : _react2.default.Children.toArray(e);
        var s = this.props[this.isOn || !this.props.outEffect ? "inEffect" : "outEffect"],
            o = s.duration,
            n = s.reverse,
            r = i.length,
            a = 2 * o;
        this.props.collapse && (a = parseInt(this.state.style.animationDuration, 10), o = a / 2);
        var l = n ? r : 0;
        return i = i.map(function (e) {
          return "object" === (void 0 === e ? "undefined" : _typeof(e)) && e ? _react2.default.cloneElement(e, {
            style: _extends({}, e.props.style, t.state.style, {
              animationDuration: Math.round((0, globals.cascade)(n ? l-- : l++, 0, r, o, a)) + "ms"
            })
          }) : e;
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function (e) {
        if (void 0 !== e.when && (this.isOn = !!e.when), e.fraction !== this.props.fraction && this.observe(e, !0), !this.isOn && e.onExited && "exit" in e && !1 === e.exit) return void e.onExited();
        e.disabled || (e.collapse && !this.props.collapse && (this.setState({
          style: {},
          collapse: t.getInitialCollapseStyle(e)
        }), this.isShown = !1), e.when === this.props.when && e.spy === this.props.spy || this.reveal(e), this.onRevealTimeout && !this.isOn && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)));
      }
    }, {
      key: "getChild",
      value: function () {
        if (this.savedChild && !this.props.disabled) return this.savedChild;

        if ("object" === _typeof(this.props.children)) {
          var e = _react2.default.Children.only(this.props.children);

          return "type" in e && "string" == typeof e.type || "ref" !== this.props.refProp ? e : _react2.default.createElement("div", null, e);
        }

        return _react2.default.createElement("div", null, this.props.children);
      }
    }, {
      key: "render",
      value: function () {
        var e = void 0;
        e = this.state.hasAppeared ? !this.props.unmountOnExit || !this.state.hasExited || this.isOn : !this.props.mountOnEnter || this.isOn;
        var t = this.getChild();
        "function" == typeof t.ref && (this.childRef = t.ref);
        var i = !1,
            s = t.props,
            o = s.style,
            n = s.className,
            r = s.children,
            a = this.props.disabled ? n : (this.props.outEffect ? globals.namespace : "") + (this.state.className ? " " + this.state.className : "") + (n ? " " + n : "") || void 0,
            l = void 0;
        "function" == typeof this.state.style.animationName && (this.state.style.animationName = this.state.style.animationName(!this.isOn, this.props)), this.props.cascade && !this.props.disabled && r && this.state.style.animationName ? (i = this.cascade(r), l = _extends({}, o, {
          opacity: 1
        })) : l = this.props.disabled ? o : _extends({}, o, this.state.style);

        var p = _extends({}, this.props.props, _defineProperty({
          className: a,
          style: l
        }, this.props.refProp, this.saveRef)),
            h = _react2.default.cloneElement(t, p, e ? i || r : void 0);

        return void 0 !== this.props.collapse ? this.props.collapseEl ? _react2.default.cloneElement(this.props.collapseEl, {
          style: _extends({}, this.props.collapseEl.style, this.props.disabled ? void 0 : this.state.collapse),
          children: h
        }) : _react2.default.createElement("div", {
          style: this.props.disabled ? void 0 : this.state.collapse,
          children: h
        }) : h;
      }
    }, {
      key: "makeHandler",
      value: function (e) {
        var t = this,
            i = function () {
          e.call(t, t.props), t.ticking = !1;
        };

        return function () {
          t.ticking || ((0, globals.raf)(i), t.ticking = !0);
        };
      }
    }, {
      key: "inViewport",
      value: function (e) {
        if (!this.el || window.document.hidden) return !1;
        var i = this.el.offsetHeight,
            s = window.pageYOffset - t.getTop(this.el),
            o = Math.min(i, window.innerHeight) * (globals.globalHide ? e.fraction : 0);
        return s > o - window.innerHeight && s < i - o;
      }
    }, {
      key: "resize",
      value: function (e) {
        this && this.el && this.isOn && this.inViewport(e) && (this.unlisten(), this.isShown = this.isOn, this.setState({
          hasExited: !this.isOn,
          hasAppeared: !0,
          collapse: void 0,
          style: {
            opacity: this.isOn || !e.outEffect ? 1 : 0
          }
        }), this.onReveal(e));
      }
    }, {
      key: "listen",
      value: function () {
        globals.observerMode || this.isListener || (this.isListener = !0, window.addEventListener("scroll", this.revealHandler, {
          passive: !0
        }), window.addEventListener("orientationchange", this.revealHandler, {
          passive: !0
        }), window.document.addEventListener("visibilitychange", this.revealHandler, {
          passive: !0
        }), window.document.addEventListener("collapseend", this.revealHandler, {
          passive: !0
        }), window.addEventListener("resize", this.resizeHandler, {
          passive: !0
        }));
      }
    }, {
      key: "unlisten",
      value: function () {
        !globals.observerMode && this.isListener && (window.removeEventListener("scroll", this.revealHandler, {
          passive: !0
        }), window.removeEventListener("orientationchange", this.revealHandler, {
          passive: !0
        }), window.document.removeEventListener("visibilitychange", this.revealHandler, {
          passive: !0
        }), window.document.removeEventListener("collapseend", this.revealHandler, {
          passive: !0
        }), window.removeEventListener("resize", this.resizeHandler, {
          passive: !0
        }), this.isListener = !1), this.onRevealTimeout && (this.onRevealTimeout = window.clearTimeout(this.onRevealTimeout)), this.animationEndTimeout && (this.animationEndTimeout = window.clearTimeout(this.animationEndTimeout));
      }
    }], [{
      key: "getInitialCollapseStyle",
      value: function (e) {
        return {
          height: 0,
          visibility: e.when ? void 0 : "hidden"
        };
      }
    }, {
      key: "getTop",
      value: function (e) {
        for (; void 0 === e.offsetTop;) e = e.parentNode;

        for (var t = e.offsetTop; e.offsetParent; t += e.offsetTop) e = e.offsetParent;

        return t;
      }
    }]), t;
  }(_react2.default.Component);

  RevealBase.propTypes = propTypes, RevealBase.defaultProps = defaultProps, RevealBase.contextTypes = contextTypes, RevealBase.displayName = "RevealBase", exports.default = RevealBase, module.exports = exports.default;
});
unwrapExports(RevealBase_1);
var wrap_1 = createCommonjsModule(function (module, exports) {
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function wrap(e, t, a, r) {
    return "in" in e && (e.when = e.in), _react2.default.Children.count(r) < 2 ? _react2.default.createElement(_RevealBase2.default, _extends({}, e, {
      inEffect: t,
      outEffect: a,
      children: r
    })) : (r = _react2.default.Children.map(r, function (r) {
      return _react2.default.createElement(_RevealBase2.default, _extends({}, e, {
        inEffect: t,
        outEffect: a,
        children: r
      }));
    }), "Fragment" in _react2.default ? _react2.default.createElement(_react2.default.Fragment, null, r) : _react2.default.createElement("span", null, r));
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }

    return e;
  };

  exports.default = wrap;

  var _react2 = _interopRequireDefault(React),
      _RevealBase2 = _interopRequireDefault(RevealBase_1);

  module.exports = exports.default;
});
unwrapExports(wrap_1);
var Zoom_1 = createCommonjsModule(function (module, exports) {
  function _interopRequireDefault(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }

  function _objectWithoutProperties(o, e) {
    var r = {};

    for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);

    return r;
  }

  function make(o, e) {
    var r = e.left,
        t = e.right,
        p = e.up,
        n = e.down,
        a = e.top,
        i = e.bottom,
        l = e.mirror,
        u = e.opposite,
        s = (r ? 1 : 0) | (t ? 2 : 0) | (a || n ? 4 : 0) | (i || p ? 8 : 0) | (l ? 16 : 0) | (u ? 32 : 0) | (o ? 64 : 0);
    if (lookup.hasOwnProperty(s)) return lookup[s];

    if (!l != !(o && u)) {
      var d = [t, r, i, a, n, p];
      r = d[0], t = d[1], a = d[2], i = d[3], p = d[4], n = d[5];
    }

    var f = r || t,
        c = a || i || p || n,
        m = f || c,
        y = void 0,
        b = void 0,
        _ = void 0,
        v = void 0,
        T = void 0;

    return m ? o ? (b = f ? (r ? "" : "-") + "42px" : "0", _ = c ? (n || a ? "-" : "") + "60px" : "0", v = f ? (t ? "" : "-") + "2000px" : "0", T = c ? (p || i ? "" : "-") + "2000px" : "0", y = "40% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d(" + b + ", " + _ + ", 0);\n        }\n        to {\n          opacity: 0;\n          transform: scale(.1) translate3d(" + v + ", " + T + ", 0);\n          transform-origin: " + (c ? "center bottom" : (r ? "left" : "right") + " center") + ";\n        }") : (b = f ? (r ? "-" : "") + "1000px" : "0", _ = c ? (n || a ? "-" : "") + "1000px" : "0", v = f ? (t ? "-" : "") + "10px" : "0", T = c ? (p || i ? "-" : "") + "60px" : "0", y = "from {\n          opacity: 0;\n          transform: scale3d(.1, .1, .1) translate3d(" + b + ", " + _ + ", 0);\n          animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n        }\n        60% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d(" + v + ", " + T + ", 0);\n          animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n        }") : y = (o ? "to" : "from") + " {opacity: 0; transform: scale3d(.1, .1, .1);} " + (o ? "from" : "to") + " { opacity: 1; transform: none;}", lookup[s] = (0, globals.animation)(y), lookup[s];
  }

  function Zoom() {
    var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : globals.defaults,
        e = o.children,
        r = (o.out, o.forever),
        t = o.timeout,
        p = o.duration,
        n = void 0 === p ? globals.defaults.duration : p,
        a = o.delay,
        i = void 0 === a ? globals.defaults.delay : a,
        l = o.count,
        u = void 0 === l ? globals.defaults.count : l,
        s = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
        d = {
      make: make,
      duration: void 0 === t ? n : t,
      delay: i,
      forever: r,
      count: u,
      style: {
        animationFillMode: "both"
      },
      reverse: s.left
    };

    return (0, _wrap2.default)(s, d, d, e);
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var _wrap2 = _interopRequireDefault(wrap_1),
      propTypes = {
    out: PropTypes.bool,
    left: PropTypes.bool,
    right: PropTypes.bool,
    top: PropTypes.bool,
    bottom: PropTypes.bool,
    mirror: PropTypes.bool,
    opposite: PropTypes.bool,
    duration: PropTypes.number,
    timeout: PropTypes.number,
    delay: PropTypes.number,
    count: PropTypes.number,
    forever: PropTypes.bool
  },
      lookup = {};

  Zoom.propTypes = propTypes, exports.default = Zoom, module.exports = exports.default;
});
var Reveal = unwrapExports(Zoom_1);
const useStyles = makeStyles(({
  palette,
  spacing
}) => {
  const radius = spacing(2.5);
  const size = spacing(6);
  const rightBgColor = palette.primary.main;
  const rightAltBgColor = palette.primary.secondary; // if you want the same as facebook messenger, use this color '#09f'

  return {
    avatar: {
      width: size,
      height: size,
      backgroundColor: '#ddd'
    },
    msg: {
      padding: spacing(1, 2),
      borderRadius: 4,
      marginBottom: 4,
      display: 'inline-block',
      wordBreak: 'break-word',
      fontFamily: // eslint-disable-next-line max-len
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
    },
    card: {
      marginBottom: 4
    },
    status: {
      padding: spacing(0, 2),
      fontSize: '.9em'
    },
    leftRow: {
      textAlign: 'left'
    },
    left: {
      borderTopRightRadius: radius,
      borderBottomRightRadius: radius,
      backgroundColor: palette.grey[100]
    },
    leftFirst: {
      borderTopLeftRadius: radius
    },
    leftLast: {
      borderBottomLeftRadius: radius
    },
    rightRow: {
      textAlign: 'right'
    },
    right: {
      borderTopLeftRadius: radius,
      borderBottomLeftRadius: radius,
      backgroundColor: rightBgColor,
      color: palette.common.white
    },
    rightAlt: {
      backgroundColor: palette.grey[500]
    },
    rightFirst: {
      borderTopRightRadius: radius
    },
    rightLast: {
      borderBottomRightRadius: radius
    }
  };
});

const ChatMessage = ({
  avatar,
  messages,
  cardComponents,
  side,
  alternate = false,
  status,
  animated
}) => {
  const classes = useStyles();

  const attachClass = index => {
    if (index === 0) {
      return classes[`${side}First`];
    }

    if (index === messages.length - 1) {
      return classes[`${side}Last`];
    }

    return '';
  };

  const altClass = index => {
    if (alternate) return classes[`${side}Alt`];else return '';
  };

  return React.createElement(Reveal, {
    duration: animated ? 500 : 0
  }, React.createElement(Grid$2, {
    container: true,
    spacing: 2,
    justify: side === 'right' ? 'flex-end' : 'flex-start'
  }, side === 'left' && avatar && React.createElement(Grid$2, {
    item: true
  }, React.createElement(Avatar, {
    className: classes.avatar,
    src: avatar
  })), React.createElement(Grid$2, {
    item: true,
    xs: 9
  }, messages.map((msg, i) => React.createElement("div", {
    className: classes[`${side}Row`]
  }, React.createElement(Typography, {
    className: `${classes.msg} ${classes[side]} ${attachClass(i)} ${altClass()}`
  }, msg))), cardComponents && React.createElement("div", null, cardComponents.map(card => React.createElement("div", {
    className: classes.card
  }, card))), status && React.createElement("div", {
    className: classes[`${side}Row`]
  }, React.createElement(Typography, {
    color: "textSecondary",
    className: classes.status
  }, status)))));
};

ChatMessage.propTypes = {
  avatar: PropTypes.string,
  messages: PropTypes.arrayOf(PropTypes.string),
  status: PropTypes.string,
  side: PropTypes.oneOf(['left', 'right'])
};
ChatMessage.defaultProps = {
  avatar: '',
  messages: [],
  side: 'left',
  status: ''
};

const styles$1 = theme => ({
  root: {},
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9

  }
});

const CardMessage = ({
  classes,
  theme,
  title,
  subtitle,
  images,
  buttons,
  onClick
}) => {
  return React.createElement(Card$2, {
    className: classes.root
  }, React.createElement(CardMedia, {
    className: classes.media,
    image: images[0].image_url,
    title: title
  }), React.createElement(CardContent$1, null, React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    component: "p"
  }, title), React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: "p"
  }, subtitle)), buttons && React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(CardActionArea, null, React.createElement(Box, {
    flex: 1,
    flexDirection: "column"
  }, buttons.map(btn => React.createElement(Button$2, {
    variant: "text",
    color: "primary",
    fullWidth: true,
    onClick: () => onClick(btn)
  }, btn.title))))));
};

var CardContent = withStyles(styles$1, {
  withTheme: true
})(CardMessage);
var reactLoading = createCommonjsModule(function (module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(typeof self !== 'undefined' ? self : commonjsGlobal, function () {
    return (
      /******/
      function (modules) {
        // webpackBootstrap

        /******/
        // The module cache

        /******/
        var installedModules = {};
        /******/

        /******/
        // The require function

        /******/

        function __webpack_require__(moduleId) {
          /******/

          /******/
          // Check if module is in cache

          /******/
          if (installedModules[moduleId]) {
            /******/
            return installedModules[moduleId].exports;
            /******/
          }
          /******/
          // Create a new module (and put it into the cache)

          /******/


          var module = installedModules[moduleId] = {
            /******/
            i: moduleId,

            /******/
            l: false,

            /******/
            exports: {}
            /******/

          };
          /******/

          /******/
          // Execute the module function

          /******/

          modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
          /******/

          /******/
          // Flag the module as loaded

          /******/

          module.l = true;
          /******/

          /******/
          // Return the exports of the module

          /******/

          return module.exports;
          /******/
        }
        /******/

        /******/

        /******/
        // expose the modules object (__webpack_modules__)

        /******/


        __webpack_require__.m = modules;
        /******/

        /******/
        // expose the module cache

        /******/

        __webpack_require__.c = installedModules;
        /******/

        /******/
        // define getter function for harmony exports

        /******/

        __webpack_require__.d = function (exports, name, getter) {
          /******/
          if (!__webpack_require__.o(exports, name)) {
            /******/
            Object.defineProperty(exports, name, {
              /******/
              configurable: false,

              /******/
              enumerable: true,

              /******/
              get: getter
              /******/

            });
            /******/
          }
          /******/

        };
        /******/

        /******/
        // getDefaultExport function for compatibility with non-harmony modules

        /******/


        __webpack_require__.n = function (module) {
          /******/
          var getter = module && module.__esModule ?
          /******/
          function getDefault() {
            return module['default'];
          } :
          /******/
          function getModuleExports() {
            return module;
          };
          /******/

          __webpack_require__.d(getter, 'a', getter);
          /******/


          return getter;
          /******/
        };
        /******/

        /******/
        // Object.prototype.hasOwnProperty.call

        /******/


        __webpack_require__.o = function (object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/

        /******/
        // __webpack_public_path__

        /******/


        __webpack_require__.p = "/";
        /******/

        /******/
        // Load entry module and return exports

        /******/

        return __webpack_require__(__webpack_require__.s = 7);
        /******/
      }(
      /************************************************************************/

      /******/
      [
      /* 0 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        /**
         * Use invariant() to assert state which your program assumes to be true.
         *
         * Provide sprintf-style format (only %s is supported) and arguments
         * to provide information about what broke and what you were
         * expecting.
         *
         * The invariant message will be stripped in production, but the invariant
         * will remain to ensure logic does not differ in production.
         */
        var validateFormat = function validateFormat(format) {};

        if (process.env.NODE_ENV !== 'production') {
          validateFormat = function validateFormat(format) {
            if (format === undefined) {
              throw new Error('invariant requires an error message argument');
            }
          };
        }

        function invariant(condition, format, a, b, c, d, e, f) {
          validateFormat(format);

          if (!condition) {
            var error;

            if (format === undefined) {
              error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
            } else {
              var args = [a, b, c, d, e, f];
              var argIndex = 0;
              error = new Error(format.replace(/%s/g, function () {
                return args[argIndex++];
              }));
              error.name = 'Invariant Violation';
            }

            error.framesToPop = 1; // we don't care about invariant's own frame

            throw error;
          }
        }

        module.exports = invariant;
        /***/
      },
      /* 1 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * 
         */
        function makeEmptyFunction(arg) {
          return function () {
            return arg;
          };
        }
        /**
         * This function accepts and discards inputs; it has no side effects. This is
         * primarily useful idiomatically for overridable function endpoints which
         * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
         */


        var emptyFunction = function emptyFunction() {};

        emptyFunction.thatReturns = makeEmptyFunction;
        emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
        emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
        emptyFunction.thatReturnsNull = makeEmptyFunction(null);

        emptyFunction.thatReturnsThis = function () {
          return this;
        };

        emptyFunction.thatReturnsArgument = function (arg) {
          return arg;
        };

        module.exports = emptyFunction;
        /***/
      },
      /* 2 */

      /***/
      function (module, exports, __webpack_require__) {
        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */

        /* eslint-disable no-unused-vars */
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;

        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
          }

          return Object(val);
        }

        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false;
            } // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118


            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

            test1[5] = 'de';

            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false;
            } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


            var test2 = {};

            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i;
            }

            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n];
            });

            if (order2.join('') !== '0123456789') {
              return false;
            } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter;
            });

            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false;
            }

            return true;
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
          }
        }

        module.exports = shouldUseNative() ? Object.assign : function (target, source) {
          var from;
          var to = toObject(target);
          var symbols;

          for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);

            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
              }
            }

            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);

              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  to[symbols[i]] = from[symbols[i]];
                }
              }
            }
          }

          return to;
        };
        /***/
      },
      /* 3 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */
        var emptyFunction = __webpack_require__(1);
        /**
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */


        var warning = emptyFunction;

        if (process.env.NODE_ENV !== 'production') {
          var printWarning = function printWarning(format) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });

            if (typeof console !== 'undefined') {
              console.error(message);
            }

            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };

          warning = function warning(condition, format) {
            if (format === undefined) {
              throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
            }

            if (format.indexOf('Failed Composite propType: ') === 0) {
              return; // Ignore CompositeComponent proptype check.
            }

            if (!condition) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
              }

              printWarning.apply(undefined, [format].concat(args));
            }
          };
        }

        module.exports = warning;
        /***/
      },
      /* 4 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        module.exports = ReactPropTypesSecret;
        /***/
      },
      /* 5 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */
        var emptyObject = {};

        if (process.env.NODE_ENV !== 'production') {
          Object.freeze(emptyObject);
        }

        module.exports = emptyObject;
        /***/
      },
      /* 6 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        if (process.env.NODE_ENV !== 'production') {
          var invariant = __webpack_require__(0);

          var warning = __webpack_require__(3);

          var ReactPropTypesSecret = __webpack_require__(4);

          var loggedTypeFailures = {};
        }
        /**
         * Assert that the values match with the type specs.
         * Error messages are memorized and will only be shown once.
         *
         * @param {object} typeSpecs Map of name to a ReactPropType
         * @param {object} values Runtime values that need to be type-checked
         * @param {string} location e.g. "prop", "context", "child context"
         * @param {string} componentName Name of the component for error messages.
         * @param {?Function} getStack Returns the component stack.
         * @private
         */


        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
          if (process.env.NODE_ENV !== 'production') {
            for (var typeSpecName in typeSpecs) {
              if (typeSpecs.hasOwnProperty(typeSpecName)) {
                var error; // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.

                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
                  error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                  error = ex;
                }

                warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);

                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error.message] = true;
                  var stack = getStack ? getStack() : '';
                  warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
                }
              }
            }
          }
        }

        module.exports = checkPropTypes;
        /***/
      },
      /* 7 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _react = __webpack_require__(8);

        var _react2 = _interopRequireDefault(_react);

        var _propTypes = __webpack_require__(11);

        var _propTypes2 = _interopRequireDefault(_propTypes);

        var _svg = __webpack_require__(14);

        var svgSources = _interopRequireWildcard(_svg);

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj.default = obj;
            return newObj;
          }
        }

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var Loading = function (_Component) {
          _inherits(Loading, _Component);

          function Loading() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Loading);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loading.__proto__ || Object.getPrototypeOf(Loading)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
              delayed: _this.props.delay > 0
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(Loading, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              var _this2 = this;

              var delay = this.props.delay;
              var delayed = this.state.delayed;

              if (delayed) {
                this.timeout = setTimeout(function () {
                  _this2.setState({
                    delayed: false
                  });
                }, delay);
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              var timeout = this.timeout;

              if (timeout) {
                clearTimeout(timeout);
              }
            }
          }, {
            key: 'render',
            value: function render() {
              var _props = this.props,
                  color = _props.color,
                  delay = _props.delay,
                  type = _props.type,
                  height = _props.height,
                  width = _props.width,
                  restProps = _objectWithoutProperties(_props, ['color', 'delay', 'type', 'height', 'width']);

              var selectedType = this.state.delayed ? 'blank' : type;
              var svg = svgSources[selectedType];
              var style = {
                fill: color,
                height: height,
                width: width
              };
              return _react2.default.createElement('div', _extends({
                style: style,
                dangerouslySetInnerHTML: {
                  __html: svg
                }
              }, restProps));
            }
          }]);

          return Loading;
        }(_react.Component);

        Loading.propTypes = {
          color: _propTypes2.default.string,
          delay: _propTypes2.default.number,
          type: _propTypes2.default.string,
          height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
          width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
        };
        Loading.defaultProps = {
          color: '#fff',
          delay: 0,
          type: 'balls',
          height: 64,
          width: 64
        };
        exports.default = Loading;
        /***/
      },
      /* 8 */

      /***/
      function (module, exports, __webpack_require__) {
        if (process.env.NODE_ENV === 'production') {
          module.exports = __webpack_require__(9);
        } else {
          module.exports = __webpack_require__(10);
        }
        /***/

      },
      /* 9 */

      /***/
      function (module, exports, __webpack_require__) {
        /** @license React v16.3.2
         * react.production.min.js
         *
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var m = __webpack_require__(2),
            n = __webpack_require__(0),
            p = __webpack_require__(5),
            q = __webpack_require__(1),
            r = "function" === typeof Symbol && Symbol["for"],
            t = r ? Symbol["for"]("react.element") : 60103,
            u = r ? Symbol["for"]("react.portal") : 60106,
            v = r ? Symbol["for"]("react.fragment") : 60107,
            w = r ? Symbol["for"]("react.strict_mode") : 60108,
            x = r ? Symbol["for"]("react.provider") : 60109,
            y = r ? Symbol["for"]("react.context") : 60110,
            z = r ? Symbol["for"]("react.async_mode") : 60111,
            A = r ? Symbol["for"]("react.forward_ref") : 60112,
            B = "function" === typeof Symbol && Symbol.iterator;

        function C(a) {
          for (var b = arguments.length - 1, e = "http://reactjs.org/docs/error-decoder.html?invariant\x3d" + a, c = 0; c < b; c++) e += "\x26args[]\x3d" + encodeURIComponent(arguments[c + 1]);

          n(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e);
        }

        var D = {
          isMounted: function () {
            return !1;
          },
          enqueueForceUpdate: function () {},
          enqueueReplaceState: function () {},
          enqueueSetState: function () {}
        };

        function E(a, b, e) {
          this.props = a;
          this.context = b;
          this.refs = p;
          this.updater = e || D;
        }

        E.prototype.isReactComponent = {};

        E.prototype.setState = function (a, b) {
          "object" !== typeof a && "function" !== typeof a && null != a ? C("85") : void 0;
          this.updater.enqueueSetState(this, a, b, "setState");
        };

        E.prototype.forceUpdate = function (a) {
          this.updater.enqueueForceUpdate(this, a, "forceUpdate");
        };

        function F() {}

        F.prototype = E.prototype;

        function G(a, b, e) {
          this.props = a;
          this.context = b;
          this.refs = p;
          this.updater = e || D;
        }

        var H = G.prototype = new F();
        H.constructor = G;
        m(H, E.prototype);
        H.isPureReactComponent = !0;
        var I = {
          current: null
        },
            J = Object.prototype.hasOwnProperty,
            K = {
          key: !0,
          ref: !0,
          __self: !0,
          __source: !0
        };

        function L(a, b, e) {
          var c = void 0,
              d = {},
              g = null,
              h = null;
          if (null != b) for (c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b) J.call(b, c) && !K.hasOwnProperty(c) && (d[c] = b[c]);
          var f = arguments.length - 2;
          if (1 === f) d.children = e;else if (1 < f) {
            for (var k = Array(f), l = 0; l < f; l++) k[l] = arguments[l + 2];

            d.children = k;
          }
          if (a && a.defaultProps) for (c in f = a.defaultProps, f) void 0 === d[c] && (d[c] = f[c]);
          return {
            $$typeof: t,
            type: a,
            key: g,
            ref: h,
            props: d,
            _owner: I.current
          };
        }

        function M(a) {
          return "object" === typeof a && null !== a && a.$$typeof === t;
        }

        function escape(a) {
          var b = {
            "\x3d": "\x3d0",
            ":": "\x3d2"
          };
          return "$" + ("" + a).replace(/[=:]/g, function (a) {
            return b[a];
          });
        }

        var N = /\/+/g,
            O = [];

        function P(a, b, e, c) {
          if (O.length) {
            var d = O.pop();
            d.result = a;
            d.keyPrefix = b;
            d.func = e;
            d.context = c;
            d.count = 0;
            return d;
          }

          return {
            result: a,
            keyPrefix: b,
            func: e,
            context: c,
            count: 0
          };
        }

        function Q(a) {
          a.result = null;
          a.keyPrefix = null;
          a.func = null;
          a.context = null;
          a.count = 0;
          10 > O.length && O.push(a);
        }

        function R(a, b, e, c) {
          var d = typeof a;
          if ("undefined" === d || "boolean" === d) a = null;
          var g = !1;
          if (null === a) g = !0;else switch (d) {
            case "string":
            case "number":
              g = !0;
              break;

            case "object":
              switch (a.$$typeof) {
                case t:
                case u:
                  g = !0;
              }

          }
          if (g) return e(c, a, "" === b ? "." + S(a, 0) : b), 1;
          g = 0;
          b = "" === b ? "." : b + ":";
          if (Array.isArray(a)) for (var h = 0; h < a.length; h++) {
            d = a[h];
            var f = b + S(d, h);
            g += R(d, f, e, c);
          } else if (null === a || "undefined" === typeof a ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), h = 0; !(d = a.next()).done;) d = d.value, f = b + S(d, h++), g += R(d, f, e, c);else "object" === d && (e = "" + a, C("31", "[object Object]" === e ? "object with keys {" + Object.keys(a).join(", ") + "}" : e, ""));
          return g;
        }

        function S(a, b) {
          return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
        }

        function T(a, b) {
          a.func.call(a.context, b, a.count++);
        }

        function U(a, b, e) {
          var c = a.result,
              d = a.keyPrefix;
          a = a.func.call(a.context, b, a.count++);
          Array.isArray(a) ? V(a, c, e, q.thatReturnsArgument) : null != a && (M(a) && (b = d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(N, "$\x26/") + "/") + e, a = {
            $$typeof: t,
            type: a.type,
            key: b,
            ref: a.ref,
            props: a.props,
            _owner: a._owner
          }), c.push(a));
        }

        function V(a, b, e, c, d) {
          var g = "";
          null != e && (g = ("" + e).replace(N, "$\x26/") + "/");
          b = P(b, g, c, d);
          null == a || R(a, "", U, b);
          Q(b);
        }

        var W = {
          Children: {
            map: function (a, b, e) {
              if (null == a) return a;
              var c = [];
              V(a, c, null, b, e);
              return c;
            },
            forEach: function (a, b, e) {
              if (null == a) return a;
              b = P(null, null, b, e);
              null == a || R(a, "", T, b);
              Q(b);
            },
            count: function (a) {
              return null == a ? 0 : R(a, "", q.thatReturnsNull, null);
            },
            toArray: function (a) {
              var b = [];
              V(a, b, null, q.thatReturnsArgument);
              return b;
            },
            only: function (a) {
              M(a) ? void 0 : C("143");
              return a;
            }
          },
          createRef: function () {
            return {
              current: null
            };
          },
          Component: E,
          PureComponent: G,
          createContext: function (a, b) {
            void 0 === b && (b = null);
            a = {
              $$typeof: y,
              _calculateChangedBits: b,
              _defaultValue: a,
              _currentValue: a,
              _changedBits: 0,
              Provider: null,
              Consumer: null
            };
            a.Provider = {
              $$typeof: x,
              _context: a
            };
            return a.Consumer = a;
          },
          forwardRef: function (a) {
            return {
              $$typeof: A,
              render: a
            };
          },
          Fragment: v,
          StrictMode: w,
          unstable_AsyncMode: z,
          createElement: L,
          cloneElement: function (a, b, e) {
            null === a || void 0 === a ? C("267", a) : void 0;
            var c = void 0,
                d = m({}, a.props),
                g = a.key,
                h = a.ref,
                f = a._owner;

            if (null != b) {
              void 0 !== b.ref && (h = b.ref, f = I.current);
              void 0 !== b.key && (g = "" + b.key);
              var k = void 0;
              a.type && a.type.defaultProps && (k = a.type.defaultProps);

              for (c in b) J.call(b, c) && !K.hasOwnProperty(c) && (d[c] = void 0 === b[c] && void 0 !== k ? k[c] : b[c]);
            }

            c = arguments.length - 2;
            if (1 === c) d.children = e;else if (1 < c) {
              k = Array(c);

              for (var l = 0; l < c; l++) k[l] = arguments[l + 2];

              d.children = k;
            }
            return {
              $$typeof: t,
              type: a.type,
              key: g,
              ref: h,
              props: d,
              _owner: f
            };
          },
          createFactory: function (a) {
            var b = L.bind(null, a);
            b.type = a;
            return b;
          },
          isValidElement: M,
          version: "16.3.2",
          __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
            ReactCurrentOwner: I,
            assign: m
          }
        },
            X = Object.freeze({
          default: W
        }),
            Y = X && W || X;
        module.exports = Y["default"] ? Y["default"] : Y;
        /***/
      },
      /* 10 */

      /***/
      function (module, exports, __webpack_require__) {
        /** @license React v16.3.2
         * react.development.js
         *
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        if (process.env.NODE_ENV !== "production") {
          (function () {
            var _assign = __webpack_require__(2);

            var invariant = __webpack_require__(0);

            var emptyObject = __webpack_require__(5);

            var warning = __webpack_require__(3);

            var emptyFunction = __webpack_require__(1);

            var checkPropTypes = __webpack_require__(6); // TODO: this is special because it gets imported during build.


            var ReactVersion = '16.3.2'; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
            // nor polyfill, then a plain number is used for performance.

            var hasSymbol = typeof Symbol === 'function' && Symbol['for'];
            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol['for']('react.element') : 0xeac7;
            var REACT_CALL_TYPE = hasSymbol ? Symbol['for']('react.call') : 0xeac8;
            var REACT_RETURN_TYPE = hasSymbol ? Symbol['for']('react.return') : 0xeac9;
            var REACT_PORTAL_TYPE = hasSymbol ? Symbol['for']('react.portal') : 0xeaca;
            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol['for']('react.fragment') : 0xeacb;
            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol['for']('react.strict_mode') : 0xeacc;
            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol['for']('react.provider') : 0xeacd;
            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol['for']('react.context') : 0xeace;
            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol['for']('react.async_mode') : 0xeacf;
            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol['for']('react.forward_ref') : 0xead0;
            var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
            var FAUX_ITERATOR_SYMBOL = '@@iterator';

            function getIteratorFn(maybeIterable) {
              if (maybeIterable === null || typeof maybeIterable === 'undefined') {
                return null;
              }

              var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

              if (typeof maybeIterator === 'function') {
                return maybeIterator;
              }

              return null;
            } // Relying on the `invariant()` implementation lets us
            // have preserve the format and params in the www builds.

            /**
             * Forked from fbjs/warning:
             * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
             *
             * Only change is we use console.warn instead of console.error,
             * and do nothing when 'console' is not supported.
             * This really simplifies the code.
             * ---
             * Similar to invariant but only logs a warning if the condition is not met.
             * This can be used to log issues in development environments in critical
             * paths. Removing the logging code for production environments will keep the
             * same logic and follow the same code paths.
             */


            var lowPriorityWarning = function () {};

            {
              var printWarning = function (format) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = arguments[_key];
                }

                var argIndex = 0;
                var message = 'Warning: ' + format.replace(/%s/g, function () {
                  return args[argIndex++];
                });

                if (typeof console !== 'undefined') {
                  console.warn(message);
                }

                try {
                  // --- Welcome to debugging React ---
                  // This error was thrown as a convenience so that you can use this stack
                  // to find the callsite that caused this warning to fire.
                  throw new Error(message);
                } catch (x) {}
              };

              lowPriorityWarning = function (condition, format) {
                if (format === undefined) {
                  throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
                }

                if (!condition) {
                  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                    args[_key2 - 2] = arguments[_key2];
                  }

                  printWarning.apply(undefined, [format].concat(args));
                }
              };
            }
            var lowPriorityWarning$1 = lowPriorityWarning;
            var didWarnStateUpdateForUnmountedComponent = {};

            function warnNoop(publicInstance, callerName) {
              {
                var _constructor = publicInstance.constructor;
                var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
                var warningKey = componentName + '.' + callerName;

                if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
                  return;
                }

                warning(false, "Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
                didWarnStateUpdateForUnmountedComponent[warningKey] = true;
              }
            }
            /**
             * This is the abstract API for an update queue.
             */


            var ReactNoopUpdateQueue = {
              /**
               * Checks whether or not this composite component is mounted.
               * @param {ReactClass} publicInstance The instance we want to test.
               * @return {boolean} True if mounted, false otherwise.
               * @protected
               * @final
               */
              isMounted: function (publicInstance) {
                return false;
              },

              /**
               * Forces an update. This should only be invoked when it is known with
               * certainty that we are **not** in a DOM transaction.
               *
               * You may want to call this when you know that some deeper aspect of the
               * component's state has changed but `setState` was not called.
               *
               * This will not invoke `shouldComponentUpdate`, but it will invoke
               * `componentWillUpdate` and `componentDidUpdate`.
               *
               * @param {ReactClass} publicInstance The instance that should rerender.
               * @param {?function} callback Called after component is updated.
               * @param {?string} callerName name of the calling function in the public API.
               * @internal
               */
              enqueueForceUpdate: function (publicInstance, callback, callerName) {
                warnNoop(publicInstance, 'forceUpdate');
              },

              /**
               * Replaces all of the state. Always use this or `setState` to mutate state.
               * You should treat `this.state` as immutable.
               *
               * There is no guarantee that `this.state` will be immediately updated, so
               * accessing `this.state` after calling this method may return the old value.
               *
               * @param {ReactClass} publicInstance The instance that should rerender.
               * @param {object} completeState Next state.
               * @param {?function} callback Called after component is updated.
               * @param {?string} callerName name of the calling function in the public API.
               * @internal
               */
              enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
                warnNoop(publicInstance, 'replaceState');
              },

              /**
               * Sets a subset of the state. This only exists because _pendingState is
               * internal. This provides a merging strategy that is not available to deep
               * properties which is confusing. TODO: Expose pendingState or don't use it
               * during the merge.
               *
               * @param {ReactClass} publicInstance The instance that should rerender.
               * @param {object} partialState Next partial state to be merged with state.
               * @param {?function} callback Called after component is updated.
               * @param {?string} Name of the calling function in the public API.
               * @internal
               */
              enqueueSetState: function (publicInstance, partialState, callback, callerName) {
                warnNoop(publicInstance, 'setState');
              }
            };
            /**
             * Base class helpers for the updating state of a component.
             */

            function Component(props, context, updater) {
              this.props = props;
              this.context = context;
              this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
              // renderer.

              this.updater = updater || ReactNoopUpdateQueue;
            }

            Component.prototype.isReactComponent = {};
            /**
             * Sets a subset of the state. Always use this to mutate
             * state. You should treat `this.state` as immutable.
             *
             * There is no guarantee that `this.state` will be immediately updated, so
             * accessing `this.state` after calling this method may return the old value.
             *
             * There is no guarantee that calls to `setState` will run synchronously,
             * as they may eventually be batched together.  You can provide an optional
             * callback that will be executed when the call to setState is actually
             * completed.
             *
             * When a function is provided to setState, it will be called at some point in
             * the future (not synchronously). It will be called with the up to date
             * component arguments (state, props, context). These values can be different
             * from this.* because your function may be called after receiveProps but before
             * shouldComponentUpdate, and this new state, props, and context will not yet be
             * assigned to this.
             *
             * @param {object|function} partialState Next partial state or function to
             *        produce next partial state to be merged with current state.
             * @param {?function} callback Called after state is updated.
             * @final
             * @protected
             */

            Component.prototype.setState = function (partialState, callback) {
              !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : void 0;
              this.updater.enqueueSetState(this, partialState, callback, 'setState');
            };
            /**
             * Forces an update. This should only be invoked when it is known with
             * certainty that we are **not** in a DOM transaction.
             *
             * You may want to call this when you know that some deeper aspect of the
             * component's state has changed but `setState` was not called.
             *
             * This will not invoke `shouldComponentUpdate`, but it will invoke
             * `componentWillUpdate` and `componentDidUpdate`.
             *
             * @param {?function} callback Called after update is complete.
             * @final
             * @protected
             */


            Component.prototype.forceUpdate = function (callback) {
              this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
            };
            /**
             * Deprecated APIs. These APIs used to exist on classic React classes but since
             * we would like to deprecate them, we're not going to move them over to this
             * modern base class. Instead, we define a getter that warns if it's accessed.
             */


            {
              var deprecatedAPIs = {
                isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
                replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
              };

              var defineDeprecationWarning = function (methodName, info) {
                Object.defineProperty(Component.prototype, methodName, {
                  get: function () {
                    lowPriorityWarning$1(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                    return undefined;
                  }
                });
              };

              for (var fnName in deprecatedAPIs) {
                if (deprecatedAPIs.hasOwnProperty(fnName)) {
                  defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
                }
              }
            }

            function ComponentDummy() {}

            ComponentDummy.prototype = Component.prototype;
            /**
             * Convenience component with default shallow equality check for sCU.
             */

            function PureComponent(props, context, updater) {
              this.props = props;
              this.context = context;
              this.refs = emptyObject;
              this.updater = updater || ReactNoopUpdateQueue;
            }

            var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
            pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

            _assign(pureComponentPrototype, Component.prototype);

            pureComponentPrototype.isPureReactComponent = true; // an immutable object with a single mutable value

            function createRef() {
              var refObject = {
                current: null
              };
              {
                Object.seal(refObject);
              }
              return refObject;
            }
            /**
             * Keeps track of the current owner.
             *
             * The current owner is the component who should own any components that are
             * currently being constructed.
             */


            var ReactCurrentOwner = {
              /**
               * @internal
               * @type {ReactComponent}
               */
              current: null
            };
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            var RESERVED_PROPS = {
              key: true,
              ref: true,
              __self: true,
              __source: true
            };
            var specialPropKeyWarningShown = void 0;
            var specialPropRefWarningShown = void 0;

            function hasValidRef(config) {
              {
                if (hasOwnProperty.call(config, 'ref')) {
                  var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

                  if (getter && getter.isReactWarning) {
                    return false;
                  }
                }
              }
              return config.ref !== undefined;
            }

            function hasValidKey(config) {
              {
                if (hasOwnProperty.call(config, 'key')) {
                  var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

                  if (getter && getter.isReactWarning) {
                    return false;
                  }
                }
              }
              return config.key !== undefined;
            }

            function defineKeyPropWarningGetter(props, displayName) {
              var warnAboutAccessingKey = function () {
                if (!specialPropKeyWarningShown) {
                  specialPropKeyWarningShown = true;
                  warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
                }
              };

              warnAboutAccessingKey.isReactWarning = true;
              Object.defineProperty(props, 'key', {
                get: warnAboutAccessingKey,
                configurable: true
              });
            }

            function defineRefPropWarningGetter(props, displayName) {
              var warnAboutAccessingRef = function () {
                if (!specialPropRefWarningShown) {
                  specialPropRefWarningShown = true;
                  warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
                }
              };

              warnAboutAccessingRef.isReactWarning = true;
              Object.defineProperty(props, 'ref', {
                get: warnAboutAccessingRef,
                configurable: true
              });
            }
            /**
             * Factory method to create a new React element. This no longer adheres to
             * the class pattern, so do not use new to call it. Also, no instanceof check
             * will work. Instead test $$typeof field against Symbol.for('react.element') to check
             * if something is a React Element.
             *
             * @param {*} type
             * @param {*} key
             * @param {string|object} ref
             * @param {*} self A *temporary* helper to detect places where `this` is
             * different from the `owner` when React.createElement is called, so that we
             * can warn. We want to get rid of owner and replace string `ref`s with arrow
             * functions, and as long as `this` and owner are the same, there will be no
             * change in behavior.
             * @param {*} source An annotation object (added by a transpiler or otherwise)
             * indicating filename, line number, and/or other information.
             * @param {*} owner
             * @param {*} props
             * @internal
             */


            var ReactElement = function (type, key, ref, self, source, owner, props) {
              var element = {
                // This tag allows us to uniquely identify this as a React Element
                $$typeof: REACT_ELEMENT_TYPE,
                // Built-in properties that belong on the element
                type: type,
                key: key,
                ref: ref,
                props: props,
                // Record the component responsible for creating this element.
                _owner: owner
              };
              {
                // The validation flag is currently mutative. We put it on
                // an external backing store so that we can freeze the whole object.
                // This can be replaced with a WeakMap once they are implemented in
                // commonly used development environments.
                element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
                // the validation flag non-enumerable (where possible, which should
                // include every environment we run tests in), so the test framework
                // ignores it.

                Object.defineProperty(element._store, 'validated', {
                  configurable: false,
                  enumerable: false,
                  writable: true,
                  value: false
                }); // self and source are DEV only properties.

                Object.defineProperty(element, '_self', {
                  configurable: false,
                  enumerable: false,
                  writable: false,
                  value: self
                }); // Two elements created in two different places should be considered
                // equal for testing purposes and therefore we hide it from enumeration.

                Object.defineProperty(element, '_source', {
                  configurable: false,
                  enumerable: false,
                  writable: false,
                  value: source
                });

                if (Object.freeze) {
                  Object.freeze(element.props);
                  Object.freeze(element);
                }
              }
              return element;
            };
            /**
             * Create and return a new ReactElement of the given type.
             * See https://reactjs.org/docs/react-api.html#createelement
             */


            function createElement(type, config, children) {
              var propName = void 0; // Reserved names are extracted

              var props = {};
              var key = null;
              var ref = null;
              var self = null;
              var source = null;

              if (config != null) {
                if (hasValidRef(config)) {
                  ref = config.ref;
                }

                if (hasValidKey(config)) {
                  key = '' + config.key;
                }

                self = config.__self === undefined ? null : config.__self;
                source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

                for (propName in config) {
                  if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                    props[propName] = config[propName];
                  }
                }
              } // Children can be more than one argument, and those are transferred onto
              // the newly allocated props object.


              var childrenLength = arguments.length - 2;

              if (childrenLength === 1) {
                props.children = children;
              } else if (childrenLength > 1) {
                var childArray = Array(childrenLength);

                for (var i = 0; i < childrenLength; i++) {
                  childArray[i] = arguments[i + 2];
                }

                {
                  if (Object.freeze) {
                    Object.freeze(childArray);
                  }
                }
                props.children = childArray;
              } // Resolve default props


              if (type && type.defaultProps) {
                var defaultProps = type.defaultProps;

                for (propName in defaultProps) {
                  if (props[propName] === undefined) {
                    props[propName] = defaultProps[propName];
                  }
                }
              }

              {
                if (key || ref) {
                  if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
                    var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

                    if (key) {
                      defineKeyPropWarningGetter(props, displayName);
                    }

                    if (ref) {
                      defineRefPropWarningGetter(props, displayName);
                    }
                  }
                }
              }
              return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
            }
            /**
             * Return a function that produces ReactElements of a given type.
             * See https://reactjs.org/docs/react-api.html#createfactory
             */


            function cloneAndReplaceKey(oldElement, newKey) {
              var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
              return newElement;
            }
            /**
             * Clone and return a new ReactElement using element as the starting point.
             * See https://reactjs.org/docs/react-api.html#cloneelement
             */


            function cloneElement(element, config, children) {
              !!(element === null || element === undefined) ? invariant(false, 'React.cloneElement(...): The argument must be a React element, but you passed %s.', element) : void 0;
              var propName = void 0; // Original props are copied

              var props = _assign({}, element.props); // Reserved names are extracted


              var key = element.key;
              var ref = element.ref; // Self is preserved since the owner is preserved.

              var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
              // transpiler, and the original source is probably a better indicator of the
              // true owner.

              var source = element._source; // Owner will be preserved, unless ref is overridden

              var owner = element._owner;

              if (config != null) {
                if (hasValidRef(config)) {
                  // Silently steal the ref from the parent.
                  ref = config.ref;
                  owner = ReactCurrentOwner.current;
                }

                if (hasValidKey(config)) {
                  key = '' + config.key;
                } // Remaining properties override existing props


                var defaultProps = void 0;

                if (element.type && element.type.defaultProps) {
                  defaultProps = element.type.defaultProps;
                }

                for (propName in config) {
                  if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                    if (config[propName] === undefined && defaultProps !== undefined) {
                      // Resolve default props
                      props[propName] = defaultProps[propName];
                    } else {
                      props[propName] = config[propName];
                    }
                  }
                }
              } // Children can be more than one argument, and those are transferred onto
              // the newly allocated props object.


              var childrenLength = arguments.length - 2;

              if (childrenLength === 1) {
                props.children = children;
              } else if (childrenLength > 1) {
                var childArray = Array(childrenLength);

                for (var i = 0; i < childrenLength; i++) {
                  childArray[i] = arguments[i + 2];
                }

                props.children = childArray;
              }

              return ReactElement(element.type, key, ref, self, source, owner, props);
            }
            /**
             * Verifies the object is a ReactElement.
             * See https://reactjs.org/docs/react-api.html#isvalidelement
             * @param {?object} object
             * @return {boolean} True if `object` is a valid component.
             * @final
             */


            function isValidElement(object) {
              return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            }

            var ReactDebugCurrentFrame = {};
            {
              // Component that is being worked on
              ReactDebugCurrentFrame.getCurrentStack = null;

              ReactDebugCurrentFrame.getStackAddendum = function () {
                var impl = ReactDebugCurrentFrame.getCurrentStack;

                if (impl) {
                  return impl();
                }

                return null;
              };
            }
            var SEPARATOR = '.';
            var SUBSEPARATOR = ':';
            /**
             * Escape and wrap key so it is safe to use as a reactid
             *
             * @param {string} key to be escaped.
             * @return {string} the escaped key.
             */

            function escape(key) {
              var escapeRegex = /[=:]/g;
              var escaperLookup = {
                '=': '=0',
                ':': '=2'
              };
              var escapedString = ('' + key).replace(escapeRegex, function (match) {
                return escaperLookup[match];
              });
              return '$' + escapedString;
            }
            /**
             * TODO: Test that a single child and an array with one item have the same key
             * pattern.
             */


            var didWarnAboutMaps = false;
            var userProvidedKeyEscapeRegex = /\/+/g;

            function escapeUserProvidedKey(text) {
              return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
            }

            var POOL_SIZE = 10;
            var traverseContextPool = [];

            function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
              if (traverseContextPool.length) {
                var traverseContext = traverseContextPool.pop();
                traverseContext.result = mapResult;
                traverseContext.keyPrefix = keyPrefix;
                traverseContext.func = mapFunction;
                traverseContext.context = mapContext;
                traverseContext.count = 0;
                return traverseContext;
              } else {
                return {
                  result: mapResult,
                  keyPrefix: keyPrefix,
                  func: mapFunction,
                  context: mapContext,
                  count: 0
                };
              }
            }

            function releaseTraverseContext(traverseContext) {
              traverseContext.result = null;
              traverseContext.keyPrefix = null;
              traverseContext.func = null;
              traverseContext.context = null;
              traverseContext.count = 0;

              if (traverseContextPool.length < POOL_SIZE) {
                traverseContextPool.push(traverseContext);
              }
            }
            /**
             * @param {?*} children Children tree container.
             * @param {!string} nameSoFar Name of the key path so far.
             * @param {!function} callback Callback to invoke with each child found.
             * @param {?*} traverseContext Used to pass information throughout the traversal
             * process.
             * @return {!number} The number of children in this subtree.
             */


            function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
              var type = typeof children;

              if (type === 'undefined' || type === 'boolean') {
                // All of the above are perceived as null.
                children = null;
              }

              var invokeCallback = false;

              if (children === null) {
                invokeCallback = true;
              } else {
                switch (type) {
                  case 'string':
                  case 'number':
                    invokeCallback = true;
                    break;

                  case 'object':
                    switch (children.$$typeof) {
                      case REACT_ELEMENT_TYPE:
                      case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                    }

                }
              }

              if (invokeCallback) {
                callback(traverseContext, children, // If it's the only child, treat the name as if it was wrapped in an array
                // so that it's consistent if the number of children grows.
                nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
                return 1;
              }

              var child = void 0;
              var nextName = void 0;
              var subtreeCount = 0; // Count of children found in the current subtree.

              var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

              if (Array.isArray(children)) {
                for (var i = 0; i < children.length; i++) {
                  child = children[i];
                  nextName = nextNamePrefix + getComponentKey(child, i);
                  subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                }
              } else {
                var iteratorFn = getIteratorFn(children);

                if (typeof iteratorFn === 'function') {
                  {
                    // Warn about using Maps as children
                    if (iteratorFn === children.entries) {
                      !didWarnAboutMaps ? warning(false, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.%s', ReactDebugCurrentFrame.getStackAddendum()) : void 0;
                      didWarnAboutMaps = true;
                    }
                  }
                  var iterator = iteratorFn.call(children);
                  var step = void 0;
                  var ii = 0;

                  while (!(step = iterator.next()).done) {
                    child = step.value;
                    nextName = nextNamePrefix + getComponentKey(child, ii++);
                    subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                  }
                } else if (type === 'object') {
                  var addendum = '';
                  {
                    addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
                  }
                  var childrenString = '' + children;
                  invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum);
                }
              }

              return subtreeCount;
            }
            /**
             * Traverses children that are typically specified as `props.children`, but
             * might also be specified through attributes:
             *
             * - `traverseAllChildren(this.props.children, ...)`
             * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
             *
             * The `traverseContext` is an optional argument that is passed through the
             * entire traversal. It can be used to store accumulations or anything else that
             * the callback might find relevant.
             *
             * @param {?*} children Children tree object.
             * @param {!function} callback To invoke upon traversing each child.
             * @param {?*} traverseContext Context for traversal.
             * @return {!number} The number of children in this subtree.
             */


            function traverseAllChildren(children, callback, traverseContext) {
              if (children == null) {
                return 0;
              }

              return traverseAllChildrenImpl(children, '', callback, traverseContext);
            }
            /**
             * Generate a key string that identifies a component within a set.
             *
             * @param {*} component A component that could contain a manual key.
             * @param {number} index Index that is used if a manual key is not provided.
             * @return {string}
             */


            function getComponentKey(component, index) {
              // Do some typechecking here since we call this blindly. We want to ensure
              // that we don't block potential future ES APIs.
              if (typeof component === 'object' && component !== null && component.key != null) {
                // Explicit key
                return escape(component.key);
              } // Implicit key determined by the index in the set


              return index.toString(36);
            }

            function forEachSingleChild(bookKeeping, child, name) {
              var func = bookKeeping.func,
                  context = bookKeeping.context;
              func.call(context, child, bookKeeping.count++);
            }
            /**
             * Iterates through children that are typically specified as `props.children`.
             *
             * See https://reactjs.org/docs/react-api.html#react.children.foreach
             *
             * The provided forEachFunc(child, index) will be called for each
             * leaf child.
             *
             * @param {?*} children Children tree container.
             * @param {function(*, int)} forEachFunc
             * @param {*} forEachContext Context for forEachContext.
             */


            function forEachChildren(children, forEachFunc, forEachContext) {
              if (children == null) {
                return children;
              }

              var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
              traverseAllChildren(children, forEachSingleChild, traverseContext);
              releaseTraverseContext(traverseContext);
            }

            function mapSingleChildIntoContext(bookKeeping, child, childKey) {
              var result = bookKeeping.result,
                  keyPrefix = bookKeeping.keyPrefix,
                  func = bookKeeping.func,
                  context = bookKeeping.context;
              var mappedChild = func.call(context, child, bookKeeping.count++);

              if (Array.isArray(mappedChild)) {
                mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
              } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                  mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
                  // traverseAllChildren used to do for objects as children
                  keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
                }

                result.push(mappedChild);
              }
            }

            function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
              var escapedPrefix = '';

              if (prefix != null) {
                escapedPrefix = escapeUserProvidedKey(prefix) + '/';
              }

              var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
              traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
              releaseTraverseContext(traverseContext);
            }
            /**
             * Maps children that are typically specified as `props.children`.
             *
             * See https://reactjs.org/docs/react-api.html#react.children.map
             *
             * The provided mapFunction(child, key, index) will be called for each
             * leaf child.
             *
             * @param {?*} children Children tree container.
             * @param {function(*, int)} func The map function.
             * @param {*} context Context for mapFunction.
             * @return {object} Object containing the ordered map of results.
             */


            function mapChildren(children, func, context) {
              if (children == null) {
                return children;
              }

              var result = [];
              mapIntoWithKeyPrefixInternal(children, result, null, func, context);
              return result;
            }
            /**
             * Count the number of children that are typically specified as
             * `props.children`.
             *
             * See https://reactjs.org/docs/react-api.html#react.children.count
             *
             * @param {?*} children Children tree container.
             * @return {number} The number of children.
             */


            function countChildren(children, context) {
              return traverseAllChildren(children, emptyFunction.thatReturnsNull, null);
            }
            /**
             * Flatten a children object (typically specified as `props.children`) and
             * return an array with appropriately re-keyed children.
             *
             * See https://reactjs.org/docs/react-api.html#react.children.toarray
             */


            function toArray(children) {
              var result = [];
              mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
              return result;
            }
            /**
             * Returns the first child in a collection of children and verifies that there
             * is only one child in the collection.
             *
             * See https://reactjs.org/docs/react-api.html#react.children.only
             *
             * The current implementation of this function assumes that a single child gets
             * passed without a wrapper, but the purpose of this helper function is to
             * abstract away the particular structure of children.
             *
             * @param {?object} children Child collection structure.
             * @return {ReactElement} The first and only `ReactElement` contained in the
             * structure.
             */


            function onlyChild(children) {
              !isValidElement(children) ? invariant(false, 'React.Children.only expected to receive a single React element child.') : void 0;
              return children;
            }

            function createContext(defaultValue, calculateChangedBits) {
              if (calculateChangedBits === undefined) {
                calculateChangedBits = null;
              } else {
                {
                  !(calculateChangedBits === null || typeof calculateChangedBits === 'function') ? warning(false, 'createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits) : void 0;
                }
              }

              var context = {
                $$typeof: REACT_CONTEXT_TYPE,
                _calculateChangedBits: calculateChangedBits,
                _defaultValue: defaultValue,
                _currentValue: defaultValue,
                _changedBits: 0,
                // These are circular
                Provider: null,
                Consumer: null
              };
              context.Provider = {
                $$typeof: REACT_PROVIDER_TYPE,
                _context: context
              };
              context.Consumer = context;
              {
                context._currentRenderer = null;
              }
              return context;
            }

            function forwardRef(render) {
              {
                !(typeof render === 'function') ? warning(false, 'forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render) : void 0;
              }
              return {
                $$typeof: REACT_FORWARD_REF_TYPE,
                render: render
              };
            }

            var describeComponentFrame = function (name, source, ownerName) {
              return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
            };

            function isValidElementType(type) {
              return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
              type === REACT_FRAGMENT_TYPE || type === REACT_ASYNC_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
            }

            function getComponentName(fiber) {
              var type = fiber.type;

              if (typeof type === 'function') {
                return type.displayName || type.name;
              }

              if (typeof type === 'string') {
                return type;
              }

              switch (type) {
                case REACT_FRAGMENT_TYPE:
                  return 'ReactFragment';

                case REACT_PORTAL_TYPE:
                  return 'ReactPortal';

                case REACT_CALL_TYPE:
                  return 'ReactCall';

                case REACT_RETURN_TYPE:
                  return 'ReactReturn';
              }

              if (typeof type === 'object' && type !== null) {
                switch (type.$$typeof) {
                  case REACT_FORWARD_REF_TYPE:
                    var functionName = type.render.displayName || type.render.name || '';
                    return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
                }
              }

              return null;
            }
            /**
             * ReactElementValidator provides a wrapper around a element factory
             * which validates the props passed to the element. This is intended to be
             * used only in DEV and could be replaced by a static type checker for languages
             * that support it.
             */


            var currentlyValidatingElement = void 0;
            var propTypesMisspellWarningShown = void 0;

            var getDisplayName = function () {};

            var getStackAddendum = function () {};

            {
              currentlyValidatingElement = null;
              propTypesMisspellWarningShown = false;

              getDisplayName = function (element) {
                if (element == null) {
                  return '#empty';
                } else if (typeof element === 'string' || typeof element === 'number') {
                  return '#text';
                } else if (typeof element.type === 'string') {
                  return element.type;
                } else if (element.type === REACT_FRAGMENT_TYPE) {
                  return 'React.Fragment';
                } else {
                  return element.type.displayName || element.type.name || 'Unknown';
                }
              };

              getStackAddendum = function () {
                var stack = '';

                if (currentlyValidatingElement) {
                  var name = getDisplayName(currentlyValidatingElement);
                  var owner = currentlyValidatingElement._owner;
                  stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner));
                }

                stack += ReactDebugCurrentFrame.getStackAddendum() || '';
                return stack;
              };
            }

            function getDeclarationErrorAddendum() {
              if (ReactCurrentOwner.current) {
                var name = getComponentName(ReactCurrentOwner.current);

                if (name) {
                  return '\n\nCheck the render method of `' + name + '`.';
                }
              }

              return '';
            }

            function getSourceInfoErrorAddendum(elementProps) {
              if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
                var source = elementProps.__source;
                var fileName = source.fileName.replace(/^.*[\\\/]/, '');
                var lineNumber = source.lineNumber;
                return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
              }

              return '';
            }
            /**
             * Warn if there's no key explicitly set on dynamic arrays of children or
             * object keys are not valid. This allows us to keep track of children between
             * updates.
             */


            var ownerHasKeyUseWarning = {};

            function getCurrentComponentErrorInfo(parentType) {
              var info = getDeclarationErrorAddendum();

              if (!info) {
                var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

                if (parentName) {
                  info = '\n\nCheck the top-level render call using <' + parentName + '>.';
                }
              }

              return info;
            }
            /**
             * Warn if the element doesn't have an explicit key assigned to it.
             * This element is in an array. The array could grow and shrink or be
             * reordered. All children that haven't already been validated are required to
             * have a "key" property assigned to it. Error statuses are cached so a warning
             * will only be shown once.
             *
             * @internal
             * @param {ReactElement} element Element that requires a key.
             * @param {*} parentType element's parent's type.
             */


            function validateExplicitKey(element, parentType) {
              if (!element._store || element._store.validated || element.key != null) {
                return;
              }

              element._store.validated = true;
              var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

              if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
                return;
              }

              ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
              // property, it may be the creator of the child that's responsible for
              // assigning it a key.

              var childOwner = '';

              if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
                // Give the component that originally created this child.
                childOwner = ' It was passed a child from ' + getComponentName(element._owner) + '.';
              }

              currentlyValidatingElement = element;
              {
                warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, getStackAddendum());
              }
              currentlyValidatingElement = null;
            }
            /**
             * Ensure that every element either is passed in a static location, in an
             * array with an explicit keys property defined, or in an object literal
             * with valid key property.
             *
             * @internal
             * @param {ReactNode} node Statically passed child of any type.
             * @param {*} parentType node's parent's type.
             */


            function validateChildKeys(node, parentType) {
              if (typeof node !== 'object') {
                return;
              }

              if (Array.isArray(node)) {
                for (var i = 0; i < node.length; i++) {
                  var child = node[i];

                  if (isValidElement(child)) {
                    validateExplicitKey(child, parentType);
                  }
                }
              } else if (isValidElement(node)) {
                // This element was passed in a valid location.
                if (node._store) {
                  node._store.validated = true;
                }
              } else if (node) {
                var iteratorFn = getIteratorFn(node);

                if (typeof iteratorFn === 'function') {
                  // Entry iterators used to provide implicit keys,
                  // but now we print a separate warning for them later.
                  if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step = void 0;

                    while (!(step = iterator.next()).done) {
                      if (isValidElement(step.value)) {
                        validateExplicitKey(step.value, parentType);
                      }
                    }
                  }
                }
              }
            }
            /**
             * Given an element, validate that its props follow the propTypes definition,
             * provided by the type.
             *
             * @param {ReactElement} element
             */


            function validatePropTypes(element) {
              var componentClass = element.type;

              if (typeof componentClass !== 'function') {
                return;
              }

              var name = componentClass.displayName || componentClass.name;
              var propTypes = componentClass.propTypes;

              if (propTypes) {
                currentlyValidatingElement = element;
                checkPropTypes(propTypes, element.props, 'prop', name, getStackAddendum);
                currentlyValidatingElement = null;
              } else if (componentClass.PropTypes !== undefined && !propTypesMisspellWarningShown) {
                propTypesMisspellWarningShown = true;
                warning(false, 'Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
              }

              if (typeof componentClass.getDefaultProps === 'function') {
                !componentClass.getDefaultProps.isReactClassApproved ? warning(false, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
              }
            }
            /**
             * Given a fragment, validate that it can only be provided with fragment props
             * @param {ReactElement} fragment
             */


            function validateFragmentProps(fragment) {
              currentlyValidatingElement = fragment;
              var keys = Object.keys(fragment.props);

              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];

                if (key !== 'children' && key !== 'key') {
                  warning(false, 'Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.%s', key, getStackAddendum());
                  break;
                }
              }

              if (fragment.ref !== null) {
                warning(false, 'Invalid attribute `ref` supplied to `React.Fragment`.%s', getStackAddendum());
              }

              currentlyValidatingElement = null;
            }

            function createElementWithValidation(type, props, children) {
              var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
              // succeed and there will likely be errors in render.

              if (!validType) {
                var info = '';

                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                  info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
                }

                var sourceInfo = getSourceInfoErrorAddendum(props);

                if (sourceInfo) {
                  info += sourceInfo;
                } else {
                  info += getDeclarationErrorAddendum();
                }

                info += getStackAddendum() || '';
                var typeString = void 0;

                if (type === null) {
                  typeString = 'null';
                } else if (Array.isArray(type)) {
                  typeString = 'array';
                } else {
                  typeString = typeof type;
                }

                warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
              }

              var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
              // TODO: Drop this when these are no longer allowed as the type argument.

              if (element == null) {
                return element;
              } // Skip key warning if the type isn't valid since our key validation logic
              // doesn't expect a non-string/function type and can throw confusing errors.
              // We don't want exception behavior to differ between dev and prod.
              // (Rendering will throw with a helpful message and as soon as the type is
              // fixed, the key warnings will appear.)


              if (validType) {
                for (var i = 2; i < arguments.length; i++) {
                  validateChildKeys(arguments[i], type);
                }
              }

              if (type === REACT_FRAGMENT_TYPE) {
                validateFragmentProps(element);
              } else {
                validatePropTypes(element);
              }

              return element;
            }

            function createFactoryWithValidation(type) {
              var validatedFactory = createElementWithValidation.bind(null, type);
              validatedFactory.type = type; // Legacy hook: remove it

              {
                Object.defineProperty(validatedFactory, 'type', {
                  enumerable: false,
                  get: function () {
                    lowPriorityWarning$1(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
                    Object.defineProperty(this, 'type', {
                      value: type
                    });
                    return type;
                  }
                });
              }
              return validatedFactory;
            }

            function cloneElementWithValidation(element, props, children) {
              var newElement = cloneElement.apply(this, arguments);

              for (var i = 2; i < arguments.length; i++) {
                validateChildKeys(arguments[i], newElement.type);
              }

              validatePropTypes(newElement);
              return newElement;
            }

            var React = {
              Children: {
                map: mapChildren,
                forEach: forEachChildren,
                count: countChildren,
                toArray: toArray,
                only: onlyChild
              },
              createRef: createRef,
              Component: Component,
              PureComponent: PureComponent,
              createContext: createContext,
              forwardRef: forwardRef,
              Fragment: REACT_FRAGMENT_TYPE,
              StrictMode: REACT_STRICT_MODE_TYPE,
              unstable_AsyncMode: REACT_ASYNC_MODE_TYPE,
              createElement: createElementWithValidation,
              cloneElement: cloneElementWithValidation,
              createFactory: createFactoryWithValidation,
              isValidElement: isValidElement,
              version: ReactVersion,
              __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
                ReactCurrentOwner: ReactCurrentOwner,
                // Used by renderers to avoid bundling object-assign twice in UMD bundles:
                assign: _assign
              }
            };
            {
              _assign(React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, {
                // These should not be included in production.
                ReactDebugCurrentFrame: ReactDebugCurrentFrame,
                // Shim for React DOM 16.0.0 which still destructured (but not used) this.
                // TODO: remove in React 17.0.
                ReactComponentTreeHook: {}
              });
            }
            var React$2 = Object.freeze({
              default: React
            });
            var React$3 = React$2 && React || React$2; // TODO: decide on the top-level export form.
            // This is hacky but makes it work with both Rollup and Jest.

            var react = React$3['default'] ? React$3['default'] : React$3;
            module.exports = react;
          })();
        }
        /***/

      },
      /* 11 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        if (process.env.NODE_ENV !== 'production') {
          var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

          var isValidElement = function (object) {
            return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
          }; // By explicitly using `prop-types` you are opting into new development behavior.
          // http://fb.me/prop-types-in-prod


          var throwOnDirectAccess = true;
          module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(13)();
        }
        /***/

      },
      /* 12 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var emptyFunction = __webpack_require__(1);

        var invariant = __webpack_require__(0);

        var warning = __webpack_require__(3);

        var assign = __webpack_require__(2);

        var ReactPropTypesSecret = __webpack_require__(4);

        var checkPropTypes = __webpack_require__(6);

        module.exports = function (isValidElement, throwOnDirectAccess) {
          /* global Symbol */
          var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
          var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

          /**
           * Returns the iterator method function contained on the iterable object.
           *
           * Be sure to invoke the function with the iterable as context:
           *
           *     var iteratorFn = getIteratorFn(myIterable);
           *     if (iteratorFn) {
           *       var iterator = iteratorFn.call(myIterable);
           *       ...
           *     }
           *
           * @param {?object} maybeIterable
           * @return {?function}
           */

          function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

            if (typeof iteratorFn === 'function') {
              return iteratorFn;
            }
          }
          /**
           * Collection of methods that allow declaration and validation of props that are
           * supplied to React components. Example usage:
           *
           *   var Props = require('ReactPropTypes');
           *   var MyArticle = React.createClass({
           *     propTypes: {
           *       // An optional string prop named "description".
           *       description: Props.string,
           *
           *       // A required enum prop named "category".
           *       category: Props.oneOf(['News','Photos']).isRequired,
           *
           *       // A prop named "dialog" that requires an instance of Dialog.
           *       dialog: Props.instanceOf(Dialog).isRequired
           *     },
           *     render: function() { ... }
           *   });
           *
           * A more formal specification of how these methods are used:
           *
           *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
           *   decl := ReactPropTypes.{type}(.isRequired)?
           *
           * Each and every declaration produces a function with the same signature. This
           * allows the creation of custom validation functions. For example:
           *
           *  var MyLink = React.createClass({
           *    propTypes: {
           *      // An optional string or URI prop named "href".
           *      href: function(props, propName, componentName) {
           *        var propValue = props[propName];
           *        if (propValue != null && typeof propValue !== 'string' &&
           *            !(propValue instanceof URI)) {
           *          return new Error(
           *            'Expected a string or an URI for ' + propName + ' in ' +
           *            componentName
           *          );
           *        }
           *      }
           *    },
           *    render: function() {...}
           *  });
           *
           * @internal
           */


          var ANONYMOUS = '<<anonymous>>'; // Important!
          // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

          var ReactPropTypes = {
            array: createPrimitiveTypeChecker('array'),
            bool: createPrimitiveTypeChecker('boolean'),
            func: createPrimitiveTypeChecker('function'),
            number: createPrimitiveTypeChecker('number'),
            object: createPrimitiveTypeChecker('object'),
            string: createPrimitiveTypeChecker('string'),
            symbol: createPrimitiveTypeChecker('symbol'),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
          };
          /**
           * inlined Object.is polyfill to avoid requiring consumers ship their own
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
           */

          /*eslint-disable no-self-compare*/

          function is(x, y) {
            // SameValue algorithm
            if (x === y) {
              // Steps 1-5, 7-10
              // Steps 6.b-6.e: +0 != -0
              return x !== 0 || 1 / x === 1 / y;
            } else {
              // Step 6.a: NaN == NaN
              return x !== x && y !== y;
            }
          }
          /*eslint-enable no-self-compare*/

          /**
           * We use an Error-like object for backward compatibility as people may call
           * PropTypes directly and inspect their output. However, we don't use real
           * Errors anymore. We don't inspect their stack anyway, and creating them
           * is prohibitively expensive if they are created too often, such as what
           * happens in oneOfType() for any type before the one that matched.
           */


          function PropTypeError(message) {
            this.message = message;
            this.stack = '';
          } // Make `instanceof Error` still work for returned errors.


          PropTypeError.prototype = Error.prototype;

          function createChainableTypeChecker(validate) {
            if (process.env.NODE_ENV !== 'production') {
              var manualPropTypeCallCache = {};
              var manualPropTypeWarningCount = 0;
            }

            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
              componentName = componentName || ANONYMOUS;
              propFullName = propFullName || propName;

              if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                  // New behavior only for users of `prop-types` package
                  invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
                  // Old behavior for people using React.PropTypes
                  var cacheKey = componentName + ':' + propName;

                  if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                  manualPropTypeWarningCount < 3) {
                    warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName);
                    manualPropTypeCallCache[cacheKey] = true;
                    manualPropTypeWarningCount++;
                  }
                }
              }

              if (props[propName] == null) {
                if (isRequired) {
                  if (props[propName] === null) {
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                  }

                  return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }

                return null;
              } else {
                return validate(props, propName, componentName, location, propFullName);
              }
            }

            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
          }

          function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunction.thatReturnsNull);
          }

          function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
              }

              var propValue = props[propName];

              if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
              }

              for (var i = 0; i < propValue.length; i++) {
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

                if (error instanceof Error) {
                  return error;
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
              if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) {
              process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
              return emptyFunction.thatReturnsNull;
            }

            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              for (var i = 0; i < expectedValues.length; i++) {
                if (is(propValue, expectedValues[i])) {
                  return null;
                }
              }

              var valuesString = JSON.stringify(expectedValues);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
            }

            return createChainableTypeChecker(validate);
          }

          function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
              }

              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
              }

              for (var key in propValue) {
                if (propValue.hasOwnProperty(key)) {
                  var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                  if (error instanceof Error) {
                    return error;
                  }
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) {
              process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
              return emptyFunction.thatReturnsNull;
            }

            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];

              if (typeof checker !== 'function') {
                warning(false, 'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received %s at index %s.', getPostfixForTypeWarning(checker), i);
                return emptyFunction.thatReturnsNull;
              }
            }

            function validate(props, propName, componentName, location, propFullName) {
              for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                var checker = arrayOfTypeCheckers[i];

                if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                  return null;
                }
              }

              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
            }

            return createChainableTypeChecker(validate);
          }

          function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              if (!isNode(props[propName])) {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              }

              for (var key in shapeTypes) {
                var checker = shapeTypes[key];

                if (!checker) {
                  continue;
                }

                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                if (error) {
                  return error;
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              } // We need to check all keys in case some are required but missing from
              // props.


              var allKeys = assign({}, props[propName], shapeTypes);

              for (var key in allKeys) {
                var checker = shapeTypes[key];

                if (!checker) {
                  return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                }

                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                if (error) {
                  return error;
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function isNode(propValue) {
            switch (typeof propValue) {
              case 'number':
              case 'string':
              case 'undefined':
                return true;

              case 'boolean':
                return !propValue;

              case 'object':
                if (Array.isArray(propValue)) {
                  return propValue.every(isNode);
                }

                if (propValue === null || isValidElement(propValue)) {
                  return true;
                }

                var iteratorFn = getIteratorFn(propValue);

                if (iteratorFn) {
                  var iterator = iteratorFn.call(propValue);
                  var step;

                  if (iteratorFn !== propValue.entries) {
                    while (!(step = iterator.next()).done) {
                      if (!isNode(step.value)) {
                        return false;
                      }
                    }
                  } else {
                    // Iterator will provide entry [k,v] tuples rather than values.
                    while (!(step = iterator.next()).done) {
                      var entry = step.value;

                      if (entry) {
                        if (!isNode(entry[1])) {
                          return false;
                        }
                      }
                    }
                  }
                } else {
                  return false;
                }

                return true;

              default:
                return false;
            }
          }

          function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === 'symbol') {
              return true;
            } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


            if (propValue['@@toStringTag'] === 'Symbol') {
              return true;
            } // Fallback for non-spec compliant Symbols which are polyfilled.


            if (typeof Symbol === 'function' && propValue instanceof Symbol) {
              return true;
            }

            return false;
          } // Equivalent of `typeof` but with special handling for array and regexp.


          function getPropType(propValue) {
            var propType = typeof propValue;

            if (Array.isArray(propValue)) {
              return 'array';
            }

            if (propValue instanceof RegExp) {
              // Old webkits (at least until Android 4.0) return 'function' rather than
              // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
              // passes PropTypes.object.
              return 'object';
            }

            if (isSymbol(propType, propValue)) {
              return 'symbol';
            }

            return propType;
          } // This handles more types than `getPropType`. Only used for error messages.
          // See `createPrimitiveTypeChecker`.


          function getPreciseType(propValue) {
            if (typeof propValue === 'undefined' || propValue === null) {
              return '' + propValue;
            }

            var propType = getPropType(propValue);

            if (propType === 'object') {
              if (propValue instanceof Date) {
                return 'date';
              } else if (propValue instanceof RegExp) {
                return 'regexp';
              }
            }

            return propType;
          } // Returns a string that is postfixed to a warning about an invalid type.
          // For example, "undefined" or "of type array"


          function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);

            switch (type) {
              case 'array':
              case 'object':
                return 'an ' + type;

              case 'boolean':
              case 'date':
              case 'regexp':
                return 'a ' + type;

              default:
                return type;
            }
          } // Returns class name of the object, if any.


          function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) {
              return ANONYMOUS;
            }

            return propValue.constructor.name;
          }

          ReactPropTypes.checkPropTypes = checkPropTypes;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };
        /***/

      },
      /* 13 */

      /***/
      function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var emptyFunction = __webpack_require__(1);

        var invariant = __webpack_require__(0);

        var ReactPropTypesSecret = __webpack_require__(4);

        module.exports = function () {
          function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret) {
              // It is still safe when called from React.
              return;
            }

            invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          }

          shim.isRequired = shim;

          function getShim() {
            return shim;
          } // Important!
          // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


          var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim
          };
          ReactPropTypes.checkPropTypes = emptyFunction;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };
        /***/

      },
      /* 14 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _blank = __webpack_require__(15);

        Object.defineProperty(exports, 'blank', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_blank).default;
          }
        });

        var _loadingBalls = __webpack_require__(16);

        Object.defineProperty(exports, 'balls', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingBalls).default;
          }
        });

        var _loadingBars = __webpack_require__(17);

        Object.defineProperty(exports, 'bars', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingBars).default;
          }
        });

        var _loadingBubbles = __webpack_require__(18);

        Object.defineProperty(exports, 'bubbles', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingBubbles).default;
          }
        });

        var _loadingCubes = __webpack_require__(19);

        Object.defineProperty(exports, 'cubes', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingCubes).default;
          }
        });

        var _loadingCylon = __webpack_require__(20);

        Object.defineProperty(exports, 'cylon', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingCylon).default;
          }
        });

        var _loadingSpin = __webpack_require__(21);

        Object.defineProperty(exports, 'spin', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingSpin).default;
          }
        });

        var _loadingSpinningBubbles = __webpack_require__(22);

        Object.defineProperty(exports, 'spinningBubbles', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingSpinningBubbles).default;
          }
        });

        var _loadingSpokes = __webpack_require__(23);

        Object.defineProperty(exports, 'spokes', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_loadingSpokes).default;
          }
        });

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /***/

      },
      /* 15 */

      /***/
      function (module, exports) {
        module.exports = "<svg class=\"icon-blank\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"></svg>\n";
        /***/
      },
      /* 16 */

      /***/
      function (module, exports) {
        module.exports = "<svg class=\"icon-loading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(-8 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"-8 0; 2 0; 2 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.25;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(2 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"2 0; 12 0; 12 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.35;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(12 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"12 0; 22 0; 22 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.45;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(24 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"22 0; 32 0; 32 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.55;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n</svg>\n";
        /***/
      },
      /* 17 */

      /***/
      function (module, exports) {
        module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(2)\" d=\"M0 12 V20 H4 V12z\"> \n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(8)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.2\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(14)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.4\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path transform=\"translate(20)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.6\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path transform=\"translate(26)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.8\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n</svg>\n";
        /***/
      },
      /* 18 */

      /***/
      function (module, exports) {
        module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <circle transform=\"translate(8 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"translate(16 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.3\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"translate(24 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.6\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n</svg>\n";
        /***/
      },
      /* 19 */

      /***/
      function (module, exports) {
        module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(-8 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"-8 0; 2 0; 2 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.25;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(2 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"2 0; 12 0; 12 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.35;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(12 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"12 0; 22 0; 22 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.45;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(24 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"22 0; 32 0; 32 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.55;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n</svg>\n";
        /***/
      },
      /* 20 */

      /***/
      function (module, exports) {
        module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path opacity=\"0.5\" transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0.1s\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path opacity=\"0.25\" transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0.2s\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n</svg>\n";
        /***/
      },
      /* 21 */

      /***/
      function (module, exports) {
        module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path opacity=\".25\" d=\"M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4\"/>\n  <path d=\"M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z\">\n    <animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 16 16\" to=\"360 16 16\" dur=\"0.8s\" repeatCount=\"indefinite\" />\n  </path>\n</svg>\n";
        /***/
      },
      /* 22 */

      /***/
      function (module, exports) {
        module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <circle cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(45 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.125s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(90 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.25s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(135 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.375s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(180 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(225 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.625s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(270 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.75s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(315 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.875s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(180 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n</svg>\n";
        /***/
      },
      /* 23 */

      /***/
      function (module, exports) {
        module.exports = "<svg id=\"loading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(0 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(45 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.125s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(90 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.25s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(135 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.375s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(180 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(225 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.675s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(270 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.75s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(315 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.875s\"/>\n  </path>\n</svg>\n";
        /***/
      }
      /******/
      ])
    );
  });
});
var ReactLoading = unwrapExports(reactLoading);

const styles$2 = theme => ({
  root: {
    padding: theme.spacing(2)
  },
  textField: {},
  formControl: {
    // Text field has top spacing. Let's add it
    // to other control
    marginTop: theme.spacing(2)
  }
});

const FormInput = ({
  classes,
  theme,
  formFields,
  saveForm,
  initial = {}
}) => {
  if (!initial || initial === undefined) initial = {};
  const [formValues, setFormValues] = useState(initial);
  const [errorTexts, setErrorTexts] = useState({});

  const isValid = (val, required = true, type = null) => {
    if (!val || val == undefined) val = "";else val = val.trim();
    if (required && val.length == 0) return false;
    if (val.length > 0) if (type == 'email') {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(val).toLowerCase())) return false;
    }
    return true;
  };

  const validateAndSave = () => {
    let errors = {};
    formFields.forEach(ff => {
      if (!isValid(formValues[ff.field_name], true, ff.validation)) errors[ff.field_name] = "Invalid";
    });

    if (Object.keys(errors).length > 0) {
      setErrorTexts(errors);
      alert("Please check some invalid input.");
    } else saveForm(formValues);
  };

  const onValueChanged = name => event => {
    setFormValues({ ...formValues,
      [name]: event.target.value
    });
  };

  let controls = formFields.map(ff => {
    if (ff.input_type == 'text') {
      return React.createElement(TextField, {
        label: ff.label,
        value: formValues[ff.field_name],
        error: ff.field_name in errorTexts ? true : false,
        onChange: onValueChanged(ff.field_name),
        className: classes.textField,
        margin: "normal",
        fullWidth: true
      });
    } else if (ff.input_type == 'option') {
      return React.createElement(FormControl, {
        fullWidth: true,
        className: classes.formControl
      }, React.createElement(InputLabel, {
        id: "demo-simple-select-label"
      }, ff.label), React.createElement(Select, {
        value: formValues[ff.field_name],
        onChange: onValueChanged(ff.field_name)
      }, ff.options.map(o => React.createElement(MenuItem, {
        value: o.value
      }, o.text))));
    } else if (ff.input_type == 'radio') {
      return React.createElement(FormControl, {
        component: "fieldset",
        className: classes.formControl
      }, React.createElement(FormLabel, {
        component: "legend"
      }, ff.label), React.createElement(RadioGroup, {
        name: ff.field_name,
        value: formValues[ff.field_name],
        onChange: onValueChanged(ff.field_name),
        row: true
      }, ff.options.map(o => React.createElement(FormControlLabel, {
        control: React.createElement(Radio, {
          color: "primary"
        }),
        value: o.value,
        label: o.text
      }))));
    }
  });
  return React.createElement(Paper, {
    className: classes.root
  }, controls, React.createElement(Box, {
    mt: 2
  }), React.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    onClick: validateAndSave
  }, "Submit"));
};

var FormInput$1 = withStyles(styles$2, {
  withTheme: true
})(FormInput);

const styles$3 = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
  },
  header: {
    zIndex: 1300,
    position: 'sticky',
    top: '0'
  },
  footer: {
    display: 'block',
    position: 'sticky',
    bottom: '0'
  },
  chatHeader: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing.unit * 2
  },
  chatHeaderContent: {
    paddingLeft: theme.spacing.unit * 6,
    paddingBottom: theme.spacing.unit * 2
  },
  avatar: {
    width: 50,
    height: 50,
    backgroundColor: '#ddd'
  },
  headerTitle: {
    fontWeight: 800
  },
  headerSubTitle: {},
  chatInfo: {
    color: '#999'
  },
  messageTop: {
    //    minHeight: '70vh',
    //    [theme.breakpoints.up('sm')]: {
    //      minHeight: '80vh'
    //    }
    minHeight: '50vh',
    [theme.breakpoints.up('sm')]: {
      //      minHeight: '30vh'
      minHeight: '40vh'
    }
  },
  messageList: {
    width: '100%',
    //    maxWidth: 500,
    padding: theme.spacing.unit * 2,
    backgroundColor: '#eee'
  },
  inline: {
    display: 'inline'
  },
  componentBar: {
    margin: 0
  },
  composeBar: {
    //    marginTop: theme.spacing.unit * 2,
    //    marginBottom: theme.spacing.unit * 2,
    display: 'block' //    position: 'fixed',
    //    bottom: 0

  },
  composeBarPaper: {
    display: 'flex',
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    margin: 'auto',
    //    maxWidth: 500,
    alignItems: 'center'
  },
  filesPreviewPaper: {
    display: 'flex',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2)
  },
  composeInput: {
    //    padding: `${theme.spacing.unit * 2}`,
    paddingLeft: theme.spacing.unit * 1,
    paddingRight: 0,
    //theme.spacing.unit * 1.5,
    paddingTop: theme.spacing.unit * 0,
    paddingBottom: theme.spacing.unit * 0,
    width: '100%'
  },
  composeIcon: {
    padding: theme.spacing.unit
  },
  composeSendIcon: {
    padding: theme.spacing.unit
  },
  displayNone: {
    display: 'none'
  },
  attachFileZone: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    marginBottom: theme.spacing.unit
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  previewImageDiv: {
    width: '100%',
    borderColor: '#eeeeee',
    borderWidth: 1
  },
  muted: {
    color: '#999'
  },
  sliderPrevButton: {
    top: '50%',
    display: 'block',
    position: 'absolute',
    transform: 'translate(0, -50%)',
    left: 0,
    zIndex: 1,
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '50%'
  },
  sliderNextButton: {
    top: '50%',
    display: 'block',
    position: 'absolute',
    transform: 'translate(0, -50%)',
    right: 0,
    zIndex: 1,
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '50%'
  },
  iconChevron: {
    fontSize: '2rem',
    color: 'white'
  }
});

const FilePreview = ({
  classes,
  file
}) => {
  const [image, setImage] = useState(null);
  useEffect(() => {
    let reader = new FileReader();

    reader.onload = e => {
      setImage(e.target.result);
    };

    reader.readAsDataURL(file);
  }, file);
  return React.createElement("div", {
    className: classes.previewImageDiv
  }, React.createElement("img", {
    src: image,
    className: classes.previewImage
  }));
};
/*
const AttachFileZone = ({ classes, onCancel, sendFiles }) => {
  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files
  }, [])
  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({onDrop})
  
  const [ files, setFiles ] = useState([])
  
  useEffect(() => {
    if (acceptedFiles)
      setFiles([...files, ...acceptedFiles])
  }, [acceptedFiles])
  
  return (
    <div>
      <div {...getRootProps()} className={ classes.attachFileZone }>
        <input {...getInputProps()} />
        { isDragActive ?
          <p>Drop the files here ...</p>
          :
          <Grid container spacing={1}>
            { files.map(file => (
              <Grid item xs={3}>              
                <FilePreview classes={classes} file={file} />
              </Grid>
              ))
            }
            <Grid item xs={3}>              
              <p>Add file</p>
            </Grid>
          </Grid>          
        }
      </div>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Button variant="contained" color="primary" size="medium" aria-label="" className={classes.mainButton} fullWidth onClick={()=>sendFiles(files)}>
            Kirim
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button variant="outlined" color="secondary" size="medium" aria-label="" className={classes.mainButton} fullWidth onClick={onCancel}>
            Batal
          </Button>
        </Grid>
      </Grid>
      
    </div>
  )
}
*/


const ComposeBar = ({
  classes,
  sendMessage,
  defaultValue,
  disabled,
  onChange
}) => {
  const [message, setMessage] = useState({
    body: ""
  });
  const [files, setFiles] = useState([]);

  const handleChange = name => event => {
    setMessage({ ...message,
      [name]: event.target.value
    });
    if (onChange) onChange(message);
  };

  const handleKeyDown = event => {
    if (event.keyCode == 13) send();
  };

  const send = () => {
    sendMessage(message.body, files);
    clear();
  };

  const clear = () => {
    setMessage({ ...message,
      body: ""
    });
    setFiles([]);
  };

  useEffect(() => {
    if (defaultValue) setMessage({ ...message,
      body: defaultValue
    });
  }, [defaultValue]);

  const addFiles = ({
    target
  }) => {
    let newFiles = [];

    for (let i = 0; i < target.files.length; i++) {
      let file = target.files[i];
      newFiles.push(file);
    }

    setFiles([...files, ...newFiles]);
  };

  return React.createElement(Box, {
    className: classes.composeBar
  }, files.length ? React.createElement(Paper, {
    className: classes.filesPreviewPaper,
    elevation: 0
  }, React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, files.map(file => React.createElement(Grid$2, {
    item: true,
    xs: 3
  }, React.createElement(FilePreview, {
    classes: classes,
    file: file
  }))))) : React.createElement(React.Fragment, null), React.createElement(Paper, {
    className: classes.composeBarPaper,
    elevation: 0
  }, React.createElement(Input, {
    placeholder: "Tulis pesan anda",
    className: classes.composeInput,
    margin: "normal",
    variant: "filled",
    disableUnderline: true,
    value: message.body,
    onChange: handleChange("body"),
    onKeyDown: handleKeyDown,
    disabled: disabled
  }), !disabled && React.createElement(React.Fragment, null, React.createElement("input", {
    accept: "image/*",
    className: classes.input,
    style: {
      display: 'none'
    },
    id: "attachFileChat",
    multiple: true,
    onChange: addFiles,
    type: "file",
    disable: disabled
  }), React.createElement("label", {
    htmlFor: "attachFileChat"
  }, React.createElement(IconButton, {
    size: "medium",
    component: "span",
    className: classes.composeSendIcon
  }, React.createElement(AddAPhotoIcon, null))), React.createElement(IconButton, {
    size: "medium",
    className: classNames(classes.composeSendIcon, {
      [classes.displayNone]: !message.body && !(files && files.length)
    }),
    onClick: () => send()
  }, React.createElement(SendIcon, null)))));
};

const OptionInputBar = ({
  theme,
  classes,
  sendMessage,
  helperText,
  options
}) => {
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  return React.createElement(Box, {
    className: classes.composeBar
  }, React.createElement(Paper, {
    className: classes.composeBarPaper,
    elevation: 0
  }, smUp ? React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    width: "100%",
    flexWrap: "wrap",
    ml: 1,
    mr: 1
  }, React.createElement(Box, {
    mb: 1,
    width: "100%"
  }, React.createElement(Typography, {
    variant: "body2",
    className: classes.muted
  }, helperText)), options.map(option => React.createElement(Box, {
    mt: 1,
    mr: 1
  }, React.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize
    },
    onClick: () => sendMessage(JSON.stringify({
      value: option.value,
      text: option.text
    }))
  }, option.text)))) : React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    ml: 1,
    mr: 1
  }, React.createElement(Box, {
    mb: 1
  }, React.createElement(Typography, {
    variant: "body2",
    className: classes.muted
  }, helperText)), options.map(option => React.createElement(Box, {
    mt: 1,
    flexGrow: 1,
    width: "100%"
  }, React.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize
    },
    onClick: () => sendMessage(JSON.stringify({
      value: option.value,
      text: option.text
    }))
  }, option.text))))));
};

const InlineOptionInputBar = ({
  theme,
  classes,
  sendMessage,
  helperText,
  options,
  animated
}) => {
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  return React.createElement(Box, {
    mt: 1,
    ml: 3
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    flexWrap: "wrap",
    ml: 1,
    mr: 1
  }, options.map(option => React.createElement(Box, {
    mt: 1,
    mr: 1
  }, React.createElement(Reveal, {
    duration: animated ? 500 : 0
  }, React.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize,
      backgroundColor: 'white'
    },
    onClick: () => sendMessage(JSON.stringify({
      value: option.value,
      text: option.text
    }))
  }, option.text))))));
};

const FormInputBar = props => {
  return React.createElement(Box, {
    mt: 1,
    ml: 3
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    flexWrap: "wrap",
    ml: 1,
    mr: 1
  }, React.createElement(FormInput$1, props)));
};

const ChatHeader$1 = ({
  classes,
  business,
  conversation,
  openChat,
  wsState
}) => {
  // When displayed inside popup, we need to get popup width, so that
  // the header div can have fixed position and width.
  // On mobile, we can just use 100%, but not popup is not full width.
  let headerWidth = '100%';
  let headerStyle = {
    //    display: 'block',
    //    position: 'fixed',
    //    top: '0'
    width: headerWidth
  };
  let title = business.name;
  title = conversation.data.parties.map(p => {
    if (p.agent) {
      let name = p.agent.first_name;
      if (p.agent.last_name && p.agent.last_name !== undefined) name += " " + p.agent.last_name;
      if (p.agent.is_service_user) name += ""; //" (Bot)"
      else name += " (Agent)"; //          name += " (" + business.name + ")"

      return name;
    } else return null;
  }).reduce((p, n) => {
    if (p && n) return p + ", " + n;else if (n) return n;else return p;
  });
  if (!title && conversation.data.queue) title = conversation.data.queue.name;
  if (!title || title.length <= 0) title = "You";
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const hideMenu = () => {
    setMenuAnchorEl(null);
  };

  return React.createElement("div", {
    className: classes.chatHeader,
    style: headerStyle
  }, React.createElement(Box, {
    container: true,
    className: classes.chatHeaderContent,
    display: "flex",
    direction: "row"
  }, React.createElement(Box, {
    mr: 1
  }, React.createElement(Avatar, {
    src: business.avatar == undefined ? null : business.avatar.image_url,
    className: classes.avatar,
    border: 1
  })), React.createElement(Box, {
    flexGrow: 1
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, React.createElement(Typography, {
    className: classes.headerTitle,
    variant: "body1",
    align: "left"
  }, business.name), false), React.createElement(Typography, {
    className: classes.headerSubTitle,
    variant: "body2",
    align: "left"
  }, title))), React.createElement(Divider, null), React.createElement(Menu, {
    id: menuAnchorEl ? 'chat-menu-popover' : undefined,
    open: Boolean(menuAnchorEl),
    anchorEl: menuAnchorEl,
    onClose: hideMenu,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, React.createElement(MenuItem, {
    onClick: () => openChat(0)
  }, React.createElement(AddIcon, null), React.createElement(Box, {
    mr: 1
  }), "Start New Chat")), wsState != WSSTATE.Connected && React.createElement(Box, {
    style: {
      position: 'absolute',
      top: '0',
      width: headerWidth,
      textAlign: 'center'
    }
  }, React.createElement(Typography, {
    style: {
      fontSize: '.9em',
      backgroundColor: '#f00',
      color: '#fff'
    }
  }, wsState)));
};

const MessageItem = ({
  classes,
  theme,
  user,
  item,
  showResponseTemplate = false,
  openLink,
  sendMessage,
  businessAvatar
}) => {
  let sender = "";
  let messages = [];
  let date = "";
  let side = "left";
  let alternate = false;

  if (item.isSending) {
    sender = "You";
    side = "right";
  } else if (user && user.isStaff) {
    if (item.data.sender.agent && user && user.isStaff && item.data.sender.agent.uid == user.userInfo.uid) {
      sender = "You";
      side = "right";
    } else if (item.data.sender.agent) {
      sender = item.data.sender.agent.first_name;
      if (item.data.sender.agent.last_name) sender += " " + item.data.sender.agent.last_name;

      if (user.isStaff) {
        // Another Staff
        side = "right";
        alternate = true;
      }
    } else {
      sender = item.data.sender.contact.first_name;
      if (item.data.sender.contact.last_name) sender += " " + item.data.sender.contact.last_name;
      side = "left";
    }
  } else {
    if (item.data.sender.agent) {
      sender = item.data.sender.agent.first_name;
      if (item.data.sender.agent.last_name) sender += " " + item.data.sender.agent.last_name;
      side = "left";
    } else {
      sender = "You";
      side = "right";
    }
  }
  /*
    if (!item.isSending && item.data.sender.agent) {
      sender = item.data.sender.agent.first_name
      side = "left"
      if (businessAvatar)
        avatar = businessAvatar
    }
  */


  let animated = item.data.is_new ? true : false;

  const onCardButtonClick = item => button => {
    if (button.button_type && button.button_type == 'callback') {
      let data = { ...button
      }; // alert(JSON.stringify(data, null, 2))

      sendMessage(JSON.stringify(data));
    } else if (button.link_to) openLink(button.link_to);
  };

  let actionComponent = null;
  let cardComponents = null;
  const renderers = {
    paragraph: props => React.createElement(Typography, {
      gutterBottom: true,
      className: classes.paragraph,
      variant: "body2"
    }, " ", props.children, " ")
  };
  let nextItem = item;

  while (nextItem) {
    let body = nextItem.data.body;

    if (body.startsWith("{") && body.endsWith("}")) {
      let data = JSON.parse(body);
      body = data['text'];
    }

    if (messages.length == 0) {
      messages.push(React.createElement("div", null, React.createElement(Typography, {
        variant: "body2",
        style: {
          fontWeight: 800,
          opacity: 0.3
        }
      }, sender), React.createElement(ReactMarkdown, {
        source: body,
        renderers: renderers
      })));
    } else messages.push(React.createElement(ReactMarkdown, {
      source: body,
      renderers: renderers
    }));

    if (nextItem.data.attachments && nextItem.data.attachments !== undefined && nextItem.data.attachments.length > 0) {
      messages.push(...nextItem.data.attachments.map(att => React.createElement("img", {
        src: att.image_url,
        className: classes.previewImage
      })));
    }

    if (!nextItem.next) break;
    nextItem = nextItem.next;
  }

  if (nextItem.data.body && nextItem.data.body != undefined) {
    let body = nextItem.data.body;

    if (body.startsWith("{") && body.endsWith("}")) {
      let data = JSON.parse(body);
      let cardData = data['card'];

      if (cardData) {
        cardComponents = [React.createElement(CardContent, {
          title: cardData['title'],
          subtitle: cardData['subtitle'],
          images: cardData['images'],
          buttons: cardData['buttons'],
          onClick: onCardButtonClick()
        })];
      }

      let cardListData = data['card_list'];

      if (cardListData) {
        cardComponents = cardListData.map(item => React.createElement(CardContent, {
          title: item['title'],
          subtitle: item['subtitle'],
          images: item['images'],
          buttons: item['buttons'],
          onClick: onCardButtonClick()
        }));
      }

      if (showResponseTemplate) {
        let inputType = data['input_type'];

        if (inputType == 'option') {
          actionComponent = React.createElement(InlineOptionInputBar, {
            theme: theme,
            classes: classes,
            options: data['options'],
            helperText: data['helper_text'],
            sendMessage: sendMessage,
            animated: animated
          });
        } else if (inputType == 'form') {
          actionComponent = React.createElement(FormInputBar, {
            formFields: data['form_fields'],
            saveForm: values => {
              let text = data['form_fields'].map(ff => {
                let val = values[ff.field_name];
                if (!val) val = "";else if (ff.input_type == 'option' || ff.input_type == 'radio') val = ff.options.find(o => o.value == val).text;
                return `${ff.label}: ${val}`;
              }).reduce((p, n) => p + ", " + n);
              sendMessage(JSON.stringify({
                form_values: values,
                text: text
              }));
            }
          });
        }
      }
    } //    alert(renderToString(<ReactMarkdown source={body} renderers={renderers}/>))
    //    let body = item.data.body.replace(/(\[.*?\]\()(.+?)(\))/g, "<a href='$2'>$1</a>")
    //    messages.push(<>{ body }</>)

  }

  if (nextItem.isSending) date = "Sending...";else if (nextItem.data.sent_at) {
    date = moment(nextItem.data.sent_at).fromNow(true);

    if (nextItem.data.sender && nextItem.data.sender.contact) {
      if (nextItem.data.read_at !== undefined && nextItem.data.read_at) date += " . read";else date += " . not read";
    }
  }

  function SliderPrevArrow(props) {
    const {
      className,
      style,
      onClick
    } = props;
    return React.createElement(Box, {
      className: classes.sliderPrevButton,
      onClick: onClick
    }, React.createElement(ChevronLeftIcon, {
      className: classes.iconChevron
    }));
  }

  function SliderNextArrow(props) {
    const {
      className,
      style,
      onClick
    } = props;
    return React.createElement(Box, {
      className: classes.sliderNextButton,
      onClick: onClick
    }, React.createElement(ChevronRightIcon, {
      className: classes.iconChevron
    }));
  }

  return React.createElement(React.Fragment, null, React.createElement(ChatMessage, {
    side: side,
    alternate: alternate,
    avatar: null,
    messages: messages,
    status: date,
    animated: animated
  }), cardComponents && false && React.createElement(Box, {
    mt: 2,
    mb: 2
  }, React.createElement(CarouselProvider, {
    naturalSlideWidth: 100,
    naturalSlideHeight: 125,
    totalSlides: cardComponents.length
  }, React.createElement(Slider, null, cardComponents.map((card, index) => React.createElement(Slide, {
    index: index
  }, card))), React.createElement(ButtonNext, {
    className: classes.chevronNext
  }, React.createElement(ChevronRightIcon, {
    className: classes.iconChevron
  })), React.createElement(Box, {
    className: classes.chevronPrev
  }, React.createElement(ButtonBack, null, React.createElement(ChevronLeftIcon, {
    className: classes.iconChevron
  }))))), cardComponents && false && React.createElement(Box, {
    mt: 2,
    mb: 2
  }, React.createElement(Carousel, {
    itemWidth: 240,
    centered: true,
    arrowLeft: React.createElement(Box, {
      className: classes.chevronPrev
    }, React.createElement(ChevronLeftIcon, {
      className: classes.iconChevron
    })),
    arrowRight: React.createElement(Box, {
      className: classes.chevronNext
    }, React.createElement(ChevronRightIcon, {
      className: classes.iconChevron
    })),
    addArrowClickHandler: true
  }, cardComponents.map((card, index) => React.createElement("div", {
    style: {
      margin: 8
    }
  }, card)))), cardComponents && true && React.createElement(Box, {
    mt: 2,
    mb: 2
  }, React.createElement(Slider$1, {
    className: "center",
    arrows: true,
    slidesToShow: 1.3,
    infinite: false,
    prevArrow: React.createElement(SliderPrevArrow, null),
    nextArrow: React.createElement(SliderNextArrow, null)
  }, cardComponents.map((card, index) => React.createElement("div", null, React.createElement(Box, {
    style: {
      padding: '0px 8px'
    }
  }, card))))), actionComponent && React.createElement(React.Fragment, null, actionComponent));
};

const MessageList = ({
  classes,
  theme,
  business,
  user,
  messages,
  parties,
  initialMessage,
  footerMessage,
  openLink,
  sendMessage,
  containerHeight = 0
}) => {
  const bottomDiv = useRef(); //  const listDiv = useRef()

  const [topPadding, setTopPadding] = useState(-1);

  const scrollToBottom = () => {
    //    alert("Scroll to bottom")
    //		listDiv.current.scrollTop = listDiv.current.scrollHeight;
    //bottomDiv.current.scrollIntoView({ behavior: "smooth" })
    // Do not smooth scroll on first load
    bottomDiv.current.scrollIntoView();
  }; // Scroll to bottom when message is added or typing parties changed


  let messagesLength = messages.length + (parties.filter(item => item['typing_at'] ? true : false).length << 8) + (footerMessage ? 1 : 0);
  useEffect(() => {
    scrollToBottom();
  }, [messagesLength, topPadding]);
  let groupedMessages = [];

  if (messages.length > 0) {
    groupedMessages = messages.reduce((p, n) => {
      let body = n.data.body;
      let hasComponent = false;

      if (body.startsWith("{") && body.endsWith("}")) {
        let data = JSON.parse(body);
        if (data['card_list'] || data['card'] || data['input_type']) hasComponent = true;
      }

      n.hasComponent = hasComponent;
      n.next = null; // reset

      if (p.length > 0 && !n.isSending) {
        let lastItem = p[p.length - 1];

        while (lastItem.next) lastItem = lastItem.next;

        let sent_interval = moment(n.data.sent_at).diff(moment(lastItem.data.sent_at));

        if (!lastItem.isSending) {
          if (n.data.sender.agent && lastItem.data.sender.agent && n.data.sender.agent.uid == lastItem.data.sender.agent.uid || n.data.sender.contact && lastItem.data.sender.contact) {
            if (!lastItem.hasComponent && sent_interval <= 30000) {
              lastItem.next = n;
              return p;
            }
          }
        }
      }

      return [...p, n];
    }, []);
  }

  let businessAvatar = business.avatar == undefined ? null : business.avatar.image_url;
  let typing_at = null;
  parties.forEach(p => {
    if (p.agent && p.typing_at) typing_at = moment(p.typing_at).toDate();
  });
  const [typingTimeout, setTypingTimeout] = useState();
  useEffect(() => {
    if (typing_at && !typingTimeout) {
      const interval = new Date().getTime() - typing_at.getTime();

      if (interval < 10000) {
        if (typingTimeout) clearTimeout(typingTimeout);
        setTypingTimeout(setTimeout(() => {
          //alert('timeout')
          setTypingTimeout(null);
        }, 10000 - interval));
      }
    }
  }, [typing_at]);
  return React.createElement("div", {
    className: classes.messageList
  }, React.createElement("div", {
    className: classes.messageTop,
    style: {
      minHeight: containerHeight - 40
    }
  }), React.createElement(Typography, {
    variant: "body1",
    className: classes.chatInfo,
    gutterBottom: true
  }, initialMessage), React.createElement("div", null, groupedMessages.length > 0 && groupedMessages.map((item, index) => React.createElement(MessageItem, {
    classes: classes,
    theme: theme,
    item: item,
    user: user,
    showResponseTemplate: index == groupedMessages.length - 1 ? true : false,
    sendMessage: sendMessage,
    openLink: openLink,
    businessAvatar: businessAvatar
  })), parties.map(item => item.agent && item['typing_at'] && new Date() - moment(item['typing_at']).toDate() < 10000 ? React.createElement(ChatMessage, {
    side: "left",
    avatar: businessAvatar,
    messages: [React.createElement(Box, {
      style: {
        height: 32,
        position: 'relative',
        top: -16
      }
    }, React.createElement(ReactLoading, {
      type: "bubbles",
      color: "#555",
      width: 64,
      height: 64
    }))]
  }) : React.createElement(React.Fragment, null))), footerMessage && React.createElement(Typography, {
    variant: "body2",
    className: classes.chatInfo,
    style: {
      padding: theme.spacing(2),
      textAlign: 'center'
    }
  }, footerMessage), React.createElement("div", {
    ref: bottomDiv
  }));
};

const ChatMessagesView = ({
  height,
  theme,
  classes,
  history,
  headerComponent = ChatHeader$1,
  renderHeader,
  business,
  user,
  conversationKey,
  conversation,
  fetchMessages,
  sendMessage,
  markReadAll,
  startTyping,
  deleteConversationIfEmpty,
  fetchContactInfo,
  updateContactInfo,
  openChat,
  onHide,
  wsState
}) => {
  useEffect(() => {
    //    const intervalID = setInterval(() => {
    //      fetchConversation()
    //      }, 2000)
    return () => {
      // Delete conversation if it's empty.
      deleteConversationIfEmpty();
    };
  }, []);
  useEffect(() => {
    let timeoutID = null;

    if (conversation.data.new_count > 0) {
      timeoutID = setTimeout(() => {
        markReadAll();
      }, 50);
    }

    return () => {
      if (timeoutID) clearTimeout(timeoutID);
    };
  }, [conversation.data.new_count]);
  const [firstFetch, setFirstFetch] = useState(true);
  useEffect(() => {
    // Refetch on first open or when connected
    if (wsState == WSSTATE.Connected) fetchMessages();
  }, [wsState, conversationKey]);

  const checkOnlineAndSendMessage = (message, files = null) => {
    if (wsState != WSSTATE.Connected) {
      alert("Can not send message because you are not online. Please check your internet connection and try again!");
      return;
    }

    sendMessage(message, files);
  };

  const openLink = linkTo => {
    if (linkTo.startsWith("mailto:")) {
      window.location.href = linkTo;
      return;
    }

    let link = "";
    if (linkTo.startsWith("/")) link = linkTo;else link = "/" + linkTo;
    if (link == "/home") link = "/";
    history.push(link);
    onHide();
  };

  let typing_at = null;
  conversation.data.parties.forEach(p => {
    if (p.contact && p.typing_at) typing_at = moment(p.typing_at).toDate();
  }); // Check last message

  let component = null;
  let defaultValue = null;
  let footerMessage = null;
  if (conversation.data.closed_at) footerMessage = "This chat has been ended.";

  if (conversation.data.accept_reply) {
    let disableSendMessage = false;
    if (conversation.data.closed_at) disableSendMessage = true;

    if (conversation.messages.length) {
      let lastMessage = conversation.messages[conversation.messages.length - 1];
      let body = lastMessage.data.body;

      if (body.startsWith("{") && body.endsWith("}")) {
        let data = JSON.parse(body);
        let inputType = data['input_type'];
        if ('default' in data) defaultValue = data['default'];

        if (inputType == 'option') {
          component = React.createElement(OptionInputBar, {
            theme: theme,
            classes: classes,
            options: data['options'],
            helperText: data['helper_text'],
            sendMessage: checkOnlineAndSendMessage
          }); // Moved to message list

          component = null;
        }

        if (data['disable_send_message']) disableSendMessage = true;
      }
    }

    if (!component) component = React.createElement(ComposeBar, {
      theme: theme,
      classes: classes,
      sendMessage: checkOnlineAndSendMessage,
      defaultValue: defaultValue,
      disabled: disableSendMessage,
      onChange: () => {
        if (!typing_at || new Date().getTime() - typing_at.getTime() >= 5000) startTyping();
      }
    });
  }

  let header = null;
  if (renderHeader) header = renderHeader(conversation);else if (headerComponent) header = React.createElement(headerComponent, {
    theme,
    classes,
    business,
    conversation,
    openChat,
    wsState
  });
  return React.createElement("div", {
    className: classes.root
  }, header && React.createElement("div", {
    className: classes.header
  }, header), React.createElement(MessageList, {
    classes: classes,
    theme: theme,
    business: business,
    user: user,
    messages: conversation.messages,
    parties: conversation.data.parties,
    sendMessage: checkOnlineAndSendMessage,
    openLink: openLink,
    containerHeight: height,
    footerMessage: footerMessage
  }), React.createElement(Divider, null), React.createElement("div", {
    className: classes.footer
  }, component));
};

const NewChatView = ({
  classes,
  business,
  openChat,
  isStarting,
  conversationKey,
  conversation,
  startNewConversation,
  wsStart,
  wsState
}) => {
  const [hasStarted, setHasStarted] = React.useState(false); // Initialize new conversation.    

  useEffect(() => {
    if (conversationKey == 0) {
      if (conversation && hasStarted) {
        // Send start command to websocket
        wsStart(); // Reopen chat with new conversation key

        openChat(conversation.key);
      } else {
        // Try to start a new convrsation
        startNewConversation();
        setHasStarted(true);
      }
    } else if (conversationKey == -1) {
      if (conversation) openChat(conversation.key);else openChat(0);
    }
  }, [conversation, conversationKey]);
  return React.createElement("div", {
    className: classes.root,
    style: {
      minHeight: 100
    }
  }, React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItem: "center"
  }, isStarting ? React.createElement(Typography, {
    variant: "body1"
  }, "Starting...") : React.createElement(Typography, {
    variant: "body1"
  }, "Please wait...")));
};

const ChatView = props => {
  const {
    conversationKey
  } = props; // This can be null when loading chat before conversation list fetched

  if (conversationKey > 0 && !props.conversation) return React.createElement(React.Fragment, null, "\xA0");
  if (conversationKey <= 0) return React.createElement(NewChatView, props);else return React.createElement(ChatMessagesView, props);
};

function conversationKeyFromProps(props) {
  let key = 0;
  if (props.conversationKey) key = props.conversationKey;else if (props.match) key = props.match.params.key;
  return key;
}

const mapStateToProps$1 = (state, ownProps) => {
  let key = conversationKeyFromProps(ownProps);
  let c = null;
  let isStarting = false;

  if (key == 0) {
    c = getNewConversation(state);
    isStarting = state.alpha.conversationList.isStarting;
  } else if (key == -1) {
    c = getLatestConversation(state);

    if (!c) {
      c = getNewConversation(state);
      isStarting = state.alpha.conversationList.isStarting;
    }
  } else c = getConversation(state, key);

  return {
    conversationKey: key,
    conversation: c,
    iStarting: isStarting,
    business: getBusinessInfo(state, '0').data,
    user: getUser(state),
    wsState: state.alpha.conversationList.wsState
  };
};

const mapDispatchToProps$1 = (dispatch, ownProps) => {
  let key = conversationKeyFromProps(ownProps);
  return {
    startNewConversation: () => {
      dispatch(startNewConversation());
    },
    deleteConversationIfEmpty: () => {
      dispatch(deleteConversationIfEmpty(key));
    },
    wsStart: () => {
      dispatch(wsSend('start', null));
    },
    fetchMessages: () => {
      dispatch(fetchMessages(key, true, false));
    },
    sendMessage: (message, files = null) => {
      dispatch(sendMessage(key, message, files));
    },
    markReadAll: () => {
      dispatch(markReadAll(key));
    },
    startTyping: () => {
      dispatch(startTyping(key));
    },
    fetchContactInfo: () => {
      dispatch(fetchContactInfo());
    },
    updateContactInfo: data => {
      dispatch(updateContactInfo(data));
    }
  };
};

var Chat = withResizeDetector(withStyles(styles$3, {
  withTheme: true
})(connect(mapStateToProps$1, mapDispatchToProps$1)(ChatView)));

const styles$4 = theme => ({
  root: {},
  floatingChatButton: {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2)
  },
  windowFrame: {
    /*
    '&::after':{
      bottom: '85px',
      right: '20px',
      width: 0,
      height: 0,
      content: "''",
      borderTop: 'solid 20px white',
      borderLeft: 'solid 25px transparent',
      marginLeft: '0px',
      position: 'fixed',
      borderRight: 'solid 25px transparent',
    },
    */
    zIndex: 1250,
    // Above Drawer, below Modal
    position: 'fixed',
    bottom: '100px',
    right: '20px',
    width: '400px',
    minHeight: '250px',
    maxHeight: '704px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 5px 40px',
    opacity: 1,
    height: 'calc(100% - 120px)',
    borderRadius: '8px',
    overflowX: 'hidden',
    background: 'white',
    [theme.breakpoints.down('xs')]: {
      // paddingTop: theme.spacing(5),
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      height: '100%',
      borderRadius: '0px',
      // overflowY: 'auto',
      background: 'white'
    }
  },
  headerChat: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  labelChat: {
    paddingLeft: theme.spacing(2)
  },
  header: {
    zIndex: 1301,
    position: 'sticky',
    top: '0'
  },
  iconClose: {
    display: 'block',
    cursor: 'pointer',
    position: 'absolute',
    right: '16px',
    top: '26px',
    color: '#aaa'
  },
  iconBack: {
    display: 'block',
    cursor: 'pointer',
    position: 'absolute',
    left: '16px',
    top: '26px',
    color: '#aaa'
  },
  noDecoration: {
    textDecoration: 'none'
  }
});

const ChatWindow = ({
  theme,
  classes,
  history,
  business,
  wsState,
  activeConversationKey,
  setActiveConversation,
  fetchConversationList,
  isFetching,
  lastFetched,
  conversations,
  stats,
  showFloatingChatButton,
  startChatOnEmpty = true,
  isOpen,
  onShow,
  onHide
}) => {
  const [conversationKey, setConversationKey] = useState(startChatOnEmpty ? -2 : -1);
  const topDiv = useRef(); // This will be called on component init  

  useEffect(() => {
    fetchConversationList();
    return () => {};
  }, []);
  /*
  useEffect(() => {
    if (conversationKey != activeConversationKey)
      setConversationKey(activeConversationKey)
  }, [activeConversationKey])
  */

  useEffect(() => {
    if (conversationKey == -1 && topDiv.current) // Scroll to top
      topDiv.current.scrollIntoView();
  }, [conversationKey]);
  useEffect(() => {
    // Auto start new chat
    if (conversationKey == -2 && lastFetched && isOpen && wsState == WSSTATE.Connected && conversations.length <= 0) setConversationKey(0);
  }, [conversationKey, lastFetched, isOpen, wsState]);
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let windowStyle = {};

  if (smUp) {
    if (showFloatingChatButton) {
      windowStyle = {
        top: 'auto',
        bottom: '100px'
      };
    } else {
      windowStyle = {
        top: '100px',
        bottom: 'auto'
      };
    }
  }

  let chatIcon = React.createElement(QuestionAnswerIcon, null);
  if (stats && stats.new_count && stats.new_count > 0) chatIcon = React.createElement(Badge, {
    badgeContent: stats.new_count,
    color: "secondary"
  }, chatIcon);

  const showConversation = key => {
    if (wsState != WSSTATE.Connected) {
      alert("Can not start chat while you are not online. Please check your internet connection.");
      return;
    }
    /*
    if (key != activeConversationKey)
      setActiveConversation(key)
    else
      setConversationKey(key)
    */


    setConversationKey(key);
  };

  const hideConversation = () => {
    setConversationKey(-1);
  };

  return React.createElement("div", {
    className: classes.root
  }, showFloatingChatButton && React.createElement("div", {
    className: classes.floatingChatButton
  }, isOpen ? React.createElement(Fab, {
    color: "primary",
    "aria-label": "add",
    onClick: onHide
  }, React.createElement(CloseIcon, null)) : React.createElement(Fab, {
    color: "primary",
    "aria-label": "add",
    onClick: onShow
  }, chatIcon)), isOpen && React.createElement(ClickAwayListener, null, React.createElement(Slide$1, {
    direction: "left",
    in: isOpen,
    mountOnEnter: true,
    unmountOnExit: true
  }, React.createElement("div", {
    className: classes.windowFrame,
    style: windowStyle
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement("div", {
    className: classes.iconClose,
    onClick: onHide
  }, React.createElement(CloseIcon, {
    style: {
      fontSize: '2rem'
    }
  })), conversationKey >= 0 && React.createElement("div", {
    className: classes.iconBack,
    onClick: hideConversation
  }, React.createElement(ArrowBackIosIcon, {
    style: {
      fontSize: '2rem'
    }
  }))), React.createElement("div", {
    ref: topDiv
  }), conversationKey >= 0 ? React.createElement(Chat, {
    conversationKey: conversationKey,
    openChat: showConversation,
    closeChat: hideConversation,
    onHide: onHide,
    history: history
  }) : React.createElement(Inbox, {
    openChat: showConversation,
    onHide: onHide
  })))));
};

const mapStateToProps$2 = (state, ownProps) => {
  return { ...state.alpha.conversationList,
    business: getBusinessInfo(state).data
  };
};

const mapDispatchToProps$2 = (dispatch, ownProps) => {
  return {
    fetchConversationList: () => {
      dispatch(fetchConversationList(true));
    },
    setActiveConversation: key => {
      dispatch(setActiveConversation(key));
    }
  };
};

var ChatWindow$1 = withRouter(withStyles(styles$4, {
  withTheme: true
})(connect(mapStateToProps$2, mapDispatchToProps$2)(ChatWindow)));

const styles$5 = theme => ({
  root: {},
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  floatingChat: {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: 2
  },
  frameChat: {
    '&::after': {
      bottom: '85px',
      right: '20px',
      width: 0,
      height: 0,
      content: "''",
      borderTop: 'solid 20px white',
      borderLeft: 'solid 25px transparent',
      marginLeft: '0px',
      position: 'fixed',
      borderRight: 'solid 25px transparent'
    },
    zIndex: '1000',
    position: 'fixed',
    bottom: '100px',
    right: '20px',
    width: '376px',
    minHeight: '250px',
    maxHeight: '704px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 5px 40px',
    opacity: 1,
    height: 'calc(100% - 120px)',
    borderRadius: '8px',
    overflowX: 'hidden',
    background: 'white',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(5),
      zIndex: '1000',
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      height: '100%',
      borderRadius: '0px',
      // overflowY: 'auto',
      background: 'white'
    }
  },
  headerChat: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  labelChat: {
    paddingLeft: theme.spacing(2)
  },
  iconClose: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      position: 'fixed',
      right: '10px',
      top: '10px'
    }
  },
  noDecoration: {
    textDecoration: 'none'
  }
});

const AppBase = props => {
  const {
    classes,
    business,
    history,
    user,
    companies,
    visitor,
    wsState,
    params
  } = props;
  const {
    showFloatingChatButton = true,
    startChatOnEmpty = true
  } = props;
  const {
    fetchBusinessInfo,
    fetchConversationList,
    fetchProductsCount,
    login,
    authenticateWithToken,
    setActiveCompany,
    fetchContactInfo,
    init,
    register
  } = props;
  const {
    apiKey = process.env.REACT_APP_GOAPP_API_KEY,
    apiUrl = process.env.REACT_APP_GOAPP_API_URL
  } = props;

  const getWSHost = () => {
    let host = apiUrl + "/ws/conversation/";
    host = host.replace("http://", "ws://");
    host = host.replace("https://", "wss://");
    host += "?";
    if (visitor.data.visitor_id) host += "&visitor=" + visitor.data.visitor_id;
    if (user.isLoggedIn) host += "&token=" + user.authToken;
    host += "&api_key=" + apiKey;
    return host;
  };

  const [isOnline, setIsOnline] = useState(false); // Add support for staff app with special API Key
  // For staff app we fetch business info after user login

  const isStaffApp = apiKey == "000000000000";
  useEffect(() => {
    if (!isStaffApp) fetchBusinessInfo();
    window.addEventListener('online', e => {
      setIsOnline(true);
    });
    window.addEventListener('offline', e => {
      setIsOnline(false);
    });
    return () => {//      clearInterval(conversationTimerID)
    };
  }, []);
  useEffect(() => {
    //    alert("WebSocket state: " + wsState)
    if (wsState == WSSTATE.Disconnected) {
      let timeout = 250;
      if (!isOnline) timeout = 3000;
      setTimeout(() => {
        //        alert(getWSHost())
        props.wsConnect(getWSHost());
      }, timeout);
    } else if (wsState == WSSTATE.Connected) {
      // Refresh conversation list on re-connect.
      fetchConversationList(true);
    }
  }, [wsState]); // Floating chat state

  const [isChatWindowOpen, setChatWindowOpen] = useState(false);

  const showChatWindow = show => {
    setChatWindowOpen(show);
  };

  useEffect(() => {
    if (!business.lastFetched && !isStaffApp) // Wait
      return;

    if (params.get('reset') == 1) {
      ls.remove('_goid');
      ls.remove('_userInfo'); // Reload app

      window.open(process.env.REACT_APP_PUBLIC_URL, "_self");
      return;
    } // Check token from callback URL


    let authToken = params.get('auth_token');

    if (authToken && !user.isLoggedIn) {
      let authSuccess = params.get('auth_success');
      authenticateWithToken(authToken);
      params.delete('auth_token');
      params.delete('auth_success'); // Update url
      // Note: Should use history.replace so that path with token not pushed
      // to history, but it doesn't work.

      history.push({
        pathname: history.location.pathname,
        search: params.toString()
      });
    } else if (user.isAuthenticating) ;else if (user.userInfo && !user.isLoggedIn) {
      if (!user.isAuthenticating) // Try to login automatically
        login();
    } else if (isStaffApp) {
      if (user.isLoggedIn) {
        if (!business.lastFetched) fetchBusinessInfo();else {
          if (wsState == WSSTATE.Idle) props.wsConnect(getWSHost());
        }
      }
    } else if (!visitor.isInitialized) {
      init();
    } else if (!visitor.isRegistered) {
      let registerData = {};
      if (user.isLoggedIn) registerData = {
        external_app: 'alpha.apps.directory',
        external_model: 'user',
        external_id: user.userInfo.uid,
        first_name: user.userInfo.first_name,
        last_name: user.userInfo.last_name,
        email: user.userInfo.email,
        mobile_no: user.userInfo.mobile_no
      };else registerData = {};
      register(registerData);
    } else if (user.isUpdatingContact) ;else if (!user.lastContactUpdate) {
      // Fetch contact info.
      fetchContactInfo();
    } else {
      /*
      if (!conversationTimerID || conversationTimerID == undefined) {
        // First chat
        fetchConversationList(true)
        
        let conversationTimerID = setInterval(() => {
      //          alert("timer timeout")
          fetchConversationList(true)
          }, 15000)
        setConversationTimerID(conversationTimerID)
      }
      */
      // Connect to conversation ws
      if (wsState == WSSTATE.Idle) {
        props.wsConnect(getWSHost());
      }
      /*
            if (!hasFetchProductsCount) {
              fetchProductsCount()
              setHasFetchProductsCount(true)
            }      
      */


      if (user.isLoggedIn && !user.companyInfo && companies.length > 0) setActiveCompany(companies[0].uid);
    } //    alert(this.props.location)
    //    if (this.props.location !== prevProps.location) {
    //      visitor_log_event('View Page', { 'url': this.props.location })
    //    }

  }); // Show page

  if (isStaffApp) {
    if (user.isAuthenticating || business.isFetching) {
      let message = "...";
      if (business.isFetching) message = "One second...";else if (user.isAuthenticating) message = "Authenticating...";
      return React.createElement("div", {
        className: classes.root
      }, React.createElement("div", {
        className: classes.wrapper
      }, message));
    } else {
      const {
        mainComponent,
        mainProps
      } = props;
      let component = React.createElement(mainComponent, { ...mainProps,
        showChat: () => setChatWindowOpen(true)
      });
      return React.createElement("div", {
        className: classes.root
      }, component);
    }
  } else {
    if (business.lastFetched && !user.isAuthenticating && visitor.isRegistered && user.lastContactUpdate) {
      const {
        mainComponent,
        mainProps
      } = props;
      let component = React.createElement(mainComponent, { ...mainProps,
        showChat: () => setChatWindowOpen(true)
      });
      return React.createElement("div", {
        className: classes.root
      }, component, React.createElement(ChatWindow$1, {
        showFloatingChatButton: showFloatingChatButton,
        startChatOnEmpty: startChatOnEmpty,
        isOpen: isChatWindowOpen,
        onHide: () => showChatWindow(false),
        onShow: () => showChatWindow(true)
      }));
    } else {
      // Show loading messages
      let message = "...";
      if (business.isFetching) message = "Initializing...";else if (user.isAuthenticating) message = "Authenticating...";else if (visitor.isInitializing || visitor.isRegistering) message = "Almost done...";else if (user.isUpdatingContact) message = "One second...";
      return React.createElement("div", {
        className: classes.root
      }, React.createElement("div", {
        className: classes.wrapper
      }, message));
    }
  }
};

const mapStateToProps$3 = (state, ownProps) => {
  let urlParams = new URLSearchParams(ownProps.location.search);
  return {
    user: getUser(state),
    companies: getCompanies(state),
    visitor: state.alpha.visitor,
    business: getBusinessInfo(state, '0'),
    params: urlParams,
    wsState: state.alpha.conversationList.wsState,
    chat: false
  };
};

const mapDispatchToProps$3 = (dispatch, ownProps) => {
  //  let callbackUrl = process.env.REACT_APP_PUBLIC_URL + ownProps.location.path
  let callbackUrl = window.location.href; //  alert(callbackUrl)

  return {
    fetchBusinessInfo: () => {
      dispatch(fetchBusinessInfo('0'));
    },
    login: () => {
      dispatch(login$1(callbackUrl, true));
    },
    authenticateWithToken: authToken => {
      dispatch(authenticateWithToken(authToken));
    },
    fetchContactInfo: () => {
      dispatch(fetchContactInfo());
    },
    setActiveCompany: companyID => {
      dispatch(setActiveCompany(companyID));
    },
    init: () => {
      dispatch(init());
    },
    register: registerData => {
      dispatch(register(registerData));
    },
    fetchProductsCount: () => {
      dispatch(fetchProductIndex('default', null));
    },
    fetchConversationList: refresh => {
      dispatch(fetchConversationList(refresh));
    },
    wsConnect: host => {
      dispatch(wsConnect(host));
    }
  };
};

const App = withRouter(withStyles(styles$5, {
  withTheme: true
})(connect(mapStateToProps$3, mapDispatchToProps$3)(AppBase)));

const contentRecordInitial = {
  isFetching: false,
  isPartial: false,
  isError: false,
  lastFetched: null,
  data: {}
};
const contentIndexInitial = {
  isFetching: false,
  isError: false,
  lastFetched: null,
  data: {
    records: null
  }
}; // Actions

const ACTION$4 = {
  requestContentIndex: "requestContentIndex",
  receiveContentIndex: "receiveContentIndex",
  errorRequestContentIndex: "errorRequestContentIndex",
  requestContentRecord: "requestContentRecord",
  receiveContentRecord: "receiveContentRecord",
  errorRequestContentRecord: "errorRequestContentRecord",
  modifyContentRecord: "modifyContentRecord",
  errorModifyContentRecord: "errorModifyContentRecord"
}; // Async action creator

const getContentIndex = (state, modelKey, indexKey = 'default') => {
  if (modelKey in state.alpha.content) {
    if (indexKey in state.alpha.content[modelKey].indexes) return state.alpha.content[modelKey].indexes[indexKey];
  }

  return contentIndexInitial;
};

const fetchContentIndex = (modelKey, indexKey, params = null, refresh = false) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let res = getContentIndex(getState(), modelKey, indexKey);
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve();
    if (!indexKey) indexKey = "default";
    let url = apiUrl + "/content/api/content/";
    if (modelKey && modelKey != "all") url += "?model=" + modelKey;
    let api_key = apiKey;
    if (params) url += Object.keys(params).map(key => "&" + key + "=" + params[key]).join(""); //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestContentIndex(modelKey, indexKey, params));
    return fetch(url, {
      headers: {
        'X-API-Key': api_key,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveContentIndex(modelKey, indexKey, params, json))).catch(error => dispatch(errorRequestContentIndex(modelKey, indexKey, params, error)));
  };
};

const getContentRecord = (state, modelKey, recordKey) => {
  if (modelKey in state.alpha.content) {
    if (recordKey in state.alpha.content[modelKey].records) return state.alpha.content[modelKey].records[recordKey];
  }

  return contentRecordInitial;
};

const fetchContentRecord = (modelKey, recordKey, refresh = false, params = null) => {
  return (dispatch, getState, args) => {
    const {
      apiKey = process.env.REACT_APP_GOAPP_API_KEY,
      apiUrl = process.env.REACT_APP_GOAPP_API_URL
    } = args || {};
    let res = getContentRecord(getState(), modelKey, recordKey);
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve();
    let url = apiUrl + "/content/api/content/" + recordKey + "/?model=" + modelKey;
    let api_key = apiKey;
    if (params) url += Object.keys(params).map(key => "&" + key + "=" + params[key]).join("");
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestContentRecord(modelKey, recordKey, params));
    return fetch(url, {
      headers: {
        'X-API-Key': api_key,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveContentRecord(modelKey, recordKey, params, json))).catch(error => dispatch(errorRequestContentRecord(modelKey, recordKey, params, error)));
  };
};


const requestContentIndex = (modelKey, indexKey, params) => ({
  type: ACTION$4.requestContentIndex,
  modelKey,
  indexKey,
  params
});

const receiveContentIndex = (modelKey, indexKey, params, json) => {
  let result = {
    count: json.length,
    records: json
  }; //  alert("receiveContentIndex")
  //  alert(JSON.stringify(result, null, 2))

  return {
    type: ACTION$4.receiveContentIndex,
    modelKey,
    indexKey,
    result: result,
    receivedAt: Date.now()
  };
};

const errorRequestContentIndex = (modelKey, indexKey, params, error) => ({
  type: ACTION$4.errorRequestContentIndex,
  modelKey,
  indexKey,
  params,
  error
});

const requestContentRecord = (modelKey, contentKey, params) => ({
  type: ACTION$4.requestContentRecord,
  modelKey,
  contentKey,
  params
});

const receiveContentRecord = (modelKey, contentKey, params, json) => {
  let result = json; //  alert(JSON.stringify(json, null, 2))

  return {
    type: ACTION$4.receiveContentRecord,
    modelKey,
    contentKey,
    result: result,
    receivedAt: Date.now()
  };
};

const errorRequestContentRecord = (modelKey, contentKey, params, error) => ({
  type: ACTION$4.errorRequestContentRecord,
  modelKey,
  contentKey,
  params,
  error
});


const contentIndexReducer = createReducer(contentIndexInitial, {
  [ACTION$4.requestContentIndex]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$4.receiveContentIndex]: (state, action) => {
    return { ...state,
      isFetching: false,
      isPartial: false,
      lastFetched: action.receivedAt,
      data: action.result
    };
  },
  [ACTION$4.errorRequestContentIndex]: (state, action) => {
    alert("Request content index failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  }
});

function contentIndexByKeyUpdater(state, action) {
  let key = action.indexKey;
  return { ...state,
    [key]: contentIndexReducer(state[key], action)
  };
}

const contentIndexByKeyReducer = createReducer({}, {
  [ACTION$4.requestContentIndex]: contentIndexByKeyUpdater,
  [ACTION$4.receiveContentIndex]: contentIndexByKeyUpdater,
  [ACTION$4.errorReceiveContentIndex]: contentIndexByKeyUpdater
}); // Reducers for Content Record

const contentRecordReducer = createReducer(contentRecordInitial, {
  [ACTION$4.requestContentRecord]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$4.modifyContentRecord]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$4.receiveContentRecord]: (state, action) => {
    return { ...state,
      isFetching: false,
      isPartial: false,
      lastFetched: action.receivedAt,
      data: action.result
    };
  },
  [ACTION$4.errorRequestContentRecord]: (state, action) => {
    alert("Request content record failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  },
  [ACTION$4.errorModifyContentRecord]: (state, action) => {
    alert("Request content record failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  }
});

function contentRecordByKeyUpdater(state, action) {
  let key = action.contentKey;
  return { ...state,
    [key]: contentRecordReducer(state[key], action)
  };
}

const contentRecordByKeyReducer = createReducer({}, {
  [ACTION$4.requestContentRecord]: contentRecordByKeyUpdater,
  [ACTION$4.modifyContentRecord]: contentRecordByKeyUpdater,
  [ACTION$4.receiveContentRecord]: contentRecordByKeyUpdater,
  [ACTION$4.errorRequestContentRecord]: contentRecordByKeyUpdater,
  [ACTION$4.errorModifyContentRecord]: contentRecordByKeyUpdater
}); // Combine all content reducer

const contentReducer = combineReducers({
  indexes: contentIndexByKeyReducer,
  records: contentRecordByKeyReducer
}); // Content model by key reducer

function contentModelReducer(state = {}, action) {
  if (action.type in ACTION$4) {
    let modelKey = action.modelKey;
    let newState = { ...state,
      [modelKey]: contentReducer(state[modelKey], action)
    }; //    alert(JSON.stringify(newState, null, 2))

    return newState;
  }

  return state;
}

const alphaReducer = combineReducers({
  business: businessByIdReducer,
  user: userReducer,
  visitor: visitorReducer,
  content: contentModelReducer,
  conversationList: conversationListReducer
});

const drawerWidth = 240;

const styles$6 = theme => {
  return {
    root: {//    width: '100%',
      //    display: 'flex',
      //    justifyContent: 'center'
      //    backgroundColor: '#f5f5f5'
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    toolbar: {
      paddingRight: 24 // keep right padding when drawer closed

    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      ...theme.mixins.toolbar
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      backgroundColor: "#fff",
      color: "#000"
    },
    appBarHidden: {
      display: 'none'
    },
    menuButton: {//    marginLeft: 12,
      //    marginRight: 12,
    },
    menuButtonHidden: {
      display: 'none'
    },
    linearProgress: {
      position: 'fixed',
      height: 2,
      overflow: 'hidden',
      width: '100%',
      zIndex: 1250 // Above Drawer (1200)

    },
    title: {
      flexGrow: 1,
      fontWeight: 800,
      paddingLeft: theme.spacing.unit * 2
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: theme.spacing.unit * 7,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing.unit * 9
      }
    },
    appBarSpacer: theme.mixins.toolbar,
    bottomBarSpacer: {
      height: theme.mixins.toolbar.height
    },
    content: {
      //    padding: theme.spacing.unit * 2,
      flexGrow: 1,
      //    height: '100vh',
      overflow: 'auto',
      width: '100%' //    maxWidth: 480

    },
    chartContainer: {
      marginLeft: -22
    },
    tableContainer: {
      height: 320
    },
    h5: {
      marginBottom: theme.spacing.unit * 2
    },
    bottomNavBarMenu: {
      width: '100%',
      position: 'fixed',
      bottom: 60 + 8,
      textAlign: 'center',
      'z-index': 1050 // Below appbar (1100)

    },
    bottomNavBar: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        display: 'none'
      }
    },
    sideContent: {
      width: 400 //    paddingTop: theme.spacing(4)

    },
    sideContentCloseButton: {
      position: 'fixed',
      top: theme.spacing.unit,
      right: theme.spacing.unit,
      'z-index': 1350
    },
    popupContentCloseButton: {
      position: 'fixed',
      top: theme.spacing.unit,
      right: theme.spacing.unit,
      'z-index': 1350
    },
    poweredBy: {
      color: '#aaa',
      fontSize: 12,
      padding: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3)
      }
    }
  };
};

const NavigationContext = React.createContext({});

class ScrollToTopView extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.props.location.search) {
        let sp = new URLSearchParams(this.props.location.search);
        if (sp.get('popup') == 1) return;
      }

      if (prevProps.location.search) {
        let sp = new URLSearchParams(prevProps.location.search);
        if (sp.get('popup') == 1) return;
      }

      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }

}

const ScrollToTop = withRouter(ScrollToTopView);

const NavigationController = ({
  theme,
  classes,
  header,
  footer,
  bottomNavBar,
  children
}) => {
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  let maxWidth = 0;
  if (lgUp) maxWidth = 760;else if (mdUp) maxWidth = 720;else if (smUp) maxWidth = 680;
  const [appBarHidden, setAppBarHidden] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [sideContent, setSideContent] = useState(null);
  const [popupContent, setPopupContent] = useState(null);
  const [bottomNavBarMenu, setBottomNavBarMenu] = useState(null);
  const navigationContext = {
    showTitle: text => {},
    showAppBar: c => setAppBarHidden(!c),
    hasBottomNavBar: bottomNavBar && !smUp ? true : false,
    showBottomNavBarMenu: setBottomNavBarMenu,
    setLoading: setLoading,
    showSideContent: setSideContent,
    showPopupContent: (content, onHide = null) => {
      if (content) setPopupContent({
        content,
        header,
        footer,
        onHide
      });else setPopupContent(null);
    },
    popupContentWidth: maxWidth
  };
  let sideContentVisible = sideContent ? true : false;
  let popupContentVisible = popupContent ? true : false;

  const closePopup = () => {
    if (popupContent && popupContent.onHide) popupContent.onHide();else setPopupContent(null);
  };

  let popupContentStyle;
  if (maxWidth > 0) popupContentStyle = {
    width: maxWidth
  };else popupContentStyle = {
    width: '100%'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: navigationContext
  }, /*#__PURE__*/React.createElement(ScrollToTop, null, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement("main", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.appBarSpacer, appBarHidden && classes.appBarHidden)
  }), children, footer, /*#__PURE__*/React.createElement(Box, {
    style: {
      visibility: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.poweredBy
  }, /*#__PURE__*/React.createElement(Link, {
    href: "https://www.goapp.co.id",
    color: "inherit",
    target: "_blank"
  }, "Powered by GOAPP")))), bottomNavBar && /*#__PURE__*/React.createElement("div", {
    className: classes.bottomBarSpacer
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.sideContentCloseButton,
    display: sideContentVisible ? "block" : "none"
  }, /*#__PURE__*/React.createElement(Button$2, {
    size: "large",
    className: classes.sideContentCloseButton,
    onClick: () => navigationContext.showSideContent(null)
  }, /*#__PURE__*/React.createElement(CancelIcon, null))), smUp ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    anchor: "bottom",
    scroll: "paper",
    open: popupContentVisible,
    onClose: closePopup,
    maxWidth: false
  }, popupContent && /*#__PURE__*/React.createElement("div", {
    style: popupContentStyle
  }, popupContent.content))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: classes.popupContentCloseButton,
    display: popupContentVisible ? "block" : "none"
  }, /*#__PURE__*/React.createElement(Button$2, {
    size: "large",
    className: classes.popupContentCloseButton,
    onClick: closePopup
  }, /*#__PURE__*/React.createElement(CancelIcon, null))), /*#__PURE__*/React.createElement(Drawer, {
    anchor: "bottom",
    open: popupContentVisible,
    onClose: closePopup
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentDiv,
    style: popupContentStyle
  }, popupContent && popupContent.content))), /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: sideContentVisible,
    onClose: () => navigationContext.showSideContent(null)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sideContent
  }, sideContent)), header, bottomNavBarMenu && /*#__PURE__*/React.createElement("div", {
    className: classes.bottomNavBarMenu
  }, bottomNavBarMenu), /*#__PURE__*/React.createElement("div", {
    className: classes.bottomNavBar
  }, bottomNavBar), /*#__PURE__*/React.createElement("div", {
    className: classes.linearProgress,
    style: isLoading ? {} : {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement(LinearProgress, null))))));
};

var NavigationController$1 = withRouter(withStyles(styles$6, {
  withTheme: true
})(NavigationController));

const styles$7 = theme => ({
  root: {},
  imagesSlider: {},
  imageDiv: {},
  image: {
    width: '100%',
    objectFit: 'cover',
    overflow: 'hidden'
  }
});

const Image = ({
  classes,
  image,
  aspectRatio = 0
}) => {
  if (aspectRatio != 0) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        height: 'auto',
        position: 'relative',
        paddingBottom: `${100 / aspectRatio}%`
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement("img", {
      style: {
        flexShrink: 0,
        minWidth: '100%',
        minHeight: '100%'
      },
      src: image.image_url
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.imageDiv
  }, /*#__PURE__*/React.createElement("img", {
    src: image.image_url,
    className: classes.image
  }));
};

const ImagesSlider = ({
  classes,
  images,
  slidesToShow = 1,
  aspectRatio = 0
}) => {
  const settings = {
    className: classes.imagesSlider,
    infinite: true,
    dots: true,
    arrows: false,
    //    slidesPerRow: 1,
    //    centerPadding: "0px",
    //    centerMode: false,
    slidesToScroll: 1,
    slidesToShow: slidesToShow,
    //    swipeToSlide: true,
    afterChange: function (index) {
      console.log(`Slider Changed to: ${index + 1}, background: #222; color: #bada55`);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, images.length == 1 && slidesToShow == 1 ? /*#__PURE__*/React.createElement(Image, {
    classes: classes,
    image: images[0],
    aspectRatio: aspectRatio
  }) : /*#__PURE__*/React.createElement(Slider$1, settings, images.map(image => /*#__PURE__*/React.createElement(Image, {
    classes: classes,
    image: image,
    aspectRatio: aspectRatio
  }))));
};

var ImagesSlider$1 = withStyles(styles$7, {
  withTheme: true
})(ImagesSlider);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const styles$8 = theme => ({
  listItem: {
    marginTop: theme.spacing(1)
  },
  heading: {
    marginTop: '.5em',
    marginBottom: '.5em'
  },
  paragraph: {
    marginBottom: '.8em',
    overflowWrap: 'break-word'
  },
  strong: {
    fontWeight: 800
  }
});

const options = {
  overrides: {
    h1: {
      component: props => /*#__PURE__*/React.createElement(Typography, _extends({
        gutterBottom: true,
        variant: "h1"
      }, props))
    },
    h2: {
      component: props => /*#__PURE__*/React.createElement(Typography, _extends({
        gutterBottom: true,
        variant: "h2"
      }, props))
    },
    h3: {
      component: props => /*#__PURE__*/React.createElement(Typography, _extends({
        gutterBottom: true,
        variant: "subtitle1"
      }, props))
    },
    h4: {
      component: props => /*#__PURE__*/React.createElement(Typography, _extends({
        gutterBottom: true,
        variant: "caption",
        paragraph: true
      }, props))
    },
    p: {
      component: props => /*#__PURE__*/React.createElement(Typography, _extends({
        paragraph: true
      }, props))
    },
    li: {
      component: withStyles(styles$8)(({
        classes,
        ...props
      }) => /*#__PURE__*/React.createElement("li", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement(Typography, _extends({
        component: "span"
      }, props))))
    }
  }
};

const Markdown = props => {
  let {
    classes,
    dark = false,
    color,
    variant = 'body'
  } = props;
  let headingStyles = {};
  let paragraphStyles = {};
  let strongStyles = {};
  styles$8['color'] = color || 'black';
  headingStyles['color'] = color || 'black';
  paragraphStyles['color'] = color || 'black';
  strongStyles['color'] = color || 'black'; //  let { products, fetchProductRecord, openLink } = props

  const renderLink = props => {
    let children = props.children;

    if (children.length == 0) {
      const iconStyle = {};

      if (props.href) {
        if (props.href.indexOf("linkedin.c") >= 0) {
          children = /*#__PURE__*/React.createElement("a", {
            href: props.href
          }, /*#__PURE__*/React.createElement(LinkedInIcon, {
            style: iconStyle,
            color: "primary"
          }));
        } else if (props.href.indexOf("facebook.") >= 0) {
          children = /*#__PURE__*/React.createElement("a", {
            href: props.href
          }, /*#__PURE__*/React.createElement(FacebookIcon, {
            style: iconStyle,
            color: "primary"
          }));
        } else if (props.href.indexOf("twitter.") >= 0) {
          children = /*#__PURE__*/React.createElement("a", {
            href: props.href
          }, /*#__PURE__*/React.createElement(TwitterIcon, {
            style: iconStyle,
            color: "primary"
          }));
        } else if (props.href.indexOf("instagram.") >= 0) {
          children = /*#__PURE__*/React.createElement("a", {
            href: props.href
          }, /*#__PURE__*/React.createElement(InstagramIcon, {
            style: iconStyle,
            color: "primary"
          }));
        } else if (props.href.indexOf("youtube.") >= 0) {
          children = /*#__PURE__*/React.createElement("a", {
            href: props.href
          }, /*#__PURE__*/React.createElement(YouTubeIcon, {
            style: iconStyle,
            color: "primary"
          }));
        }
      }
      /*
      if (props.href.startsWith("product/")) {
        let productKeys = props.href.substring("product/".length).split(",")
          
        let result = []
        productKeys.forEach((key) => {
          fetchProductRecord(key)
             if (key in products) {
            let p = products[key]
            if (p.lastFetched)
              result.push(p)
          }
        })
          
        return (
            <Grid container spacing={1}>
            {            
              result.map((product) =>
              <Grid item xs={6}>
                <ProductCard product={product.data}
                  onClick={() => openLink("product/" + product.data.key ) }
                />
              </Grid>
              )
            }
            </Grid>
          )
      }
      */

    }

    return /*#__PURE__*/React.createElement(Link, {
      href: props.href,
      color: "primary"
    }, children);
  };

  const renderers = {
    heading: props => {
      if (variant == 'body') {
        let level = Math.min(props.level, 4);
        let fontSize = "1.0rem";
        if (level == 1) fontSize = "1.5rem";else if (level == 2) fontSize = "1.3rem";else if (level == 3) fontSize = "1.15rem";
        let styles = { ...headingStyles,
          fontSize: fontSize,
          lineHeight: '1.4em',
          marginTop: '1.2em',
          marginBottom: '.7em',
          fontWeight: 700
        };
        return /*#__PURE__*/React.createElement(Typography, {
          gutterBottom: true,
          className: classes.heading,
          style: styles,
          component: 'h' + (level + 1),
          variant: 'h' + (level + 2)
        }, " ", props.children, " ");
      } else return /*#__PURE__*/React.createElement(Typography, {
        gutterBottom: true,
        className: classes.heading,
        style: headingStyles,
        variant: 'h' + props.level
      }, " ", props.children, " ");
    },
    paragraph: props => /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      className: classes.paragraph,
      style: paragraphStyles,
      variant: "body1"
    }, " ", props.children, " "),
    listItem: props => /*#__PURE__*/React.createElement("li", {
      className: classes.paragraph,
      style: paragraphStyles
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, " ", props.children, " ")),
    strong: props => /*#__PURE__*/React.createElement(Typography, {
      display: "inline",
      variant: "inherit",
      className: classes.strong,
      style: strongStyles
    }, props.children, " "),
    link: renderLink
  };
  return /*#__PURE__*/React.createElement(ReactMarkdown, _extends({
    options: options
  }, props, {
    renderers: renderers
  }));
};

const mapStateToProps$4 = (state, ownProps) => {
  return {// products: state.alpha.catalog.records
  };
};

const mapDispatchToProps$4 = (dispatch, ownProps) => {
  return {
    /*
    fetchProductRecord: (key) => {
      dispatch(fetchProductRecord(key))
    },    
    */
  };
};

var Markdown$1 = withStyles(styles$8)(connect(mapStateToProps$4, mapDispatchToProps$4)(Markdown));

const styles$9 = theme => ({
  root: {
    textTransform: 'none'
  }
});

const Button = ({
  classes,
  theme,
  style,
  color,
  children,
  ...props
}) => {
  let btnStyle = {};
  let btnVariant = 'contained';
  let btnSize = 'large';
  let btnColor = 'primary';

  if (style) {
    if (style.includes("small")) btnSize = 'small';else if (style.includes('large') || style.includes('big')) btnSize = "large";
    if (style.includes('outline')) btnVariant = 'outlined';else if (style.includes('text')) btnVariant = 'text';
  }

  return /*#__PURE__*/React.createElement(Button$2, _extends({
    style: btnStyle,
    variant: btnVariant,
    color: btnColor,
    size: btnSize,
    className: classes.btnStyle
  }, props), children);
};

var Button$1 = withStyles(styles$9, {
  withTheme: true
})(Button);

const styles$a = theme => ({
  root: {},
  selectionOverlay: {
    position: 'absolute'
  }
});

const SelectionBox = ({
  classes,
  theme,
  control,
  myControl,
  children,
  width,
  height,
  selected,
  disabled = false,
  level = 0,
  onBeginEditItem,
  onSelect
}) => {
  let selectionOverlayStyle = {};

  if (selected) {
    selectionOverlayStyle['border'] = "3px solid blue";
    selectionOverlayStyle['borderColor'] = theme.palette.primary.main; //    selectionOverlayStyle['pointer-events'] = 'none'
  }

  selectionOverlayStyle = { ...selectionOverlayStyle,
    width,
    height,
    zIndex: 1000 + level
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, !disabled && /*#__PURE__*/React.createElement("div", {
    className: classes.selectionOverlay,
    style: selectionOverlayStyle,
    onClick: () => {
      // Be careful! Don't call onSelect is already selected,
      // otherwise it will be called every time 'control' receive
      // click event
      if (!selected && onSelect) onSelect();
    }
  }, selected && control), children);
};

var SelectionBox$1 = withResizeDetector(withStyles(styles$a, {
  withTheme: true
})(SelectionBox));

const styles$b = theme => ({
  root: {
    width: '320px',
    position: 'absolute',
    marginTop: '10px',
    right: '10px'
  },
  tabRoot: {
    width: '320px'
  },
  selectInput: {
    width: '100%'
  },
  //   tabPanelRoot:{
  //     mincontent_width: '100px'
  //   },
  textLabel: {
    marginBottom: theme.spacing(2)
  },
  buttonGroup: {
    width: '100%'
  },
  menuButton: {
    position: 'absolute',
    right: '10px',
    top: theme.spacing(1),
    padding: 0,
    margin: 0
  }
});

const TextEditor = ({
  classes,
  theme,
  sectionData,
  onMoveUp,
  onMoveDown,
  onDelete,
  onEdit,
  onUpdate,
  onCompleted
}) => {
  console.log("TEXT Editor", sectionData);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) ;
      } // Bind the event listener


      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  let initial = {
    title: sectionData.title ? sectionData.title : null,
    subtitle: sectionData.subtitle ? sectionData.subtitle : null,
    body: sectionData.body ? sectionData.body : null,
    button_title: sectionData.button_title ? sectionData.button_title : null,
    link_to: sectionData.link_to ? sectionData.link_to : null,
    button_style: sectionData.button_style ? sectionData.button_style : 'fill'
  };
  let selectedPath = sectionData.selectedItemPath.replace(/[0-9]\//g, '');
  const [formData, setFormData] = useState(initial);

  const handleChangeForm = name => (event, newValue) => {
    let eventValue = event.target.value;
    let valueNew = newValue ? newValue.props ? newValue.props.value : newValue : newValue;
    setFormData({ ...formData,
      [name]: valueNew ? valueNew : eventValue
    });

    if (name !== 'text_alignment' && name !== 'color' && name !== 'item_size' && name !== 'item_image_position' && name !== "item_text_alignment" && name !== 'vertical_alignment' && name !== 'horizontal_alignment' && name !== 'button_style') {
      sectionData[name] = valueNew ? valueNew : eventValue;
    } else {
      if (sectionData[name] !== undefined) {
        sectionData[name]['value'] = valueNew ? valueNew : eventValue;
      } else {
        sectionData[name] = {
          value: valueNew ? valueNew : eventValue,
          name: valueNew ? valueNew : eventValue
        };
      }
    }

    onUpdate();
  };

  const capitalize = str => {
    var splitStr = str.toLowerCase().split('_');

    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }

    return splitStr.join(' ');
  };

  const [value, setValue] = React.useState(0);

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  const defaultButtonStyle = [{
    name: 'Large Fill',
    value: 'large-fill'
  }, {
    name: 'Large Outline',
    value: 'large-outline'
  }, {
    name: 'Large Text',
    value: 'large-text'
  }, {
    name: 'Medium Fill',
    value: 'fill'
  }, {
    name: 'Medium Outline',
    value: 'outline'
  }, {
    name: 'Medium Text',
    value: 'text'
  }, {
    name: 'Small Fill',
    value: 'small-fill'
  }, {
    name: 'Small Outline',
    value: 'small-outline'
  }, {
    name: 'Small Text',
    value: 'small-text'
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 8,
    style: {
      height: '400px'
    }
  }, sectionData.selectedItemPath !== undefined && /*#__PURE__*/React.createElement(Box, {
    style: {
      padding: '16px',
      paddingTop: '32px'
    }
  }, sectionData.selectedItemPath === 'button_title' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    mb: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.textLabel
  }, "Button Style"), /*#__PURE__*/React.createElement(Select, {
    labelId: "demo-simple-select-placeholder-label-label",
    id: "demo-simple-select-placeholder-label",
    value: formValue('button_style'),
    onChange: handleChangeForm('button_style'),
    displayEmpty: true,
    className: classes.selectInput
  }, defaultButtonStyle.map(item => /*#__PURE__*/React.createElement(MenuItem, {
    value: item.value
  }, item.name)))), /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    mb: 1
  }, /*#__PURE__*/React.createElement(TextField, {
    style: {
      marginTop: '8px'
    },
    id: "standard-full-width",
    label: "Link to",
    placeholder: "Link to",
    fullWidth: true,
    multiline: true,
    rowsMax: "10",
    value: formValue('link_to'),
    onChange: handleChangeForm('link_to'),
    InputProps: {
      disableUnderline: true
    },
    InputLabelProps: {
      shrink: true
    }
  }))), /*#__PURE__*/React.createElement(TextField, {
    id: "standard-full-width",
    label: capitalize(selectedPath),
    placeholder: capitalize(selectedPath),
    fullWidth: true,
    multiline: true,
    rowsMax: "10",
    value: formValue(selectedPath),
    onChange: handleChangeForm(selectedPath),
    InputProps: {
      disableUnderline: true
    },
    InputLabelProps: {
      shrink: true
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: onCompleted
  }, /*#__PURE__*/React.createElement(DoneIcon, null)))));
};

var TextEditor$1 = withStyles(styles$b, {
  withTheme: true
})(TextEditor);

const styles$c = theme => ({
  root: {
    width: '100%',
    padding: '0px'
  },
  toolbar: {},
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  menuButton: {
    marginRight: 0
  }
});

const SectionEditText = props => {
  const {
    classes,
    theme,
    sectionData,
    onMoveUp,
    onMoveDown,
    onDelete,
    onEdit,
    onCancel
  } = props;
  console.log("SECTION", sectionData);
  const pageEditContext = useContext(PageEditContext);
  const {
    onBeginEditItem,
    onEndEditItem
  } = pageEditContext;
  let sectionControl = [];
  sectionControl['position'] = 'absolute';
  sectionControl['background'] = 'white';
  sectionControl['right'] = '10px';
  sectionControl['top'] = '0px';
  sectionControl['width'] = 'fit-content';
  const [showProperty, setShowProperty] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: sectionControl
  }, onEdit && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: () => {
      onBeginEditItem( /*#__PURE__*/React.createElement(TextEditor$1, {
        sectionData: sectionData,
        onUpdate: () => {
          onEdit({ ...sectionData
          });
        },
        onCompleted: onEndEditItem
      })); // onEdit({...sectionData}); setShowProperty(true)
    }
  }, /*#__PURE__*/React.createElement(EditIcon, null)), showProperty && /*#__PURE__*/React.createElement(TextEditor$1, {
    sectionData: sectionData,
    onUpdate: () => {
      onEdit({ ...sectionData
      });
    },
    onCompleted: () => setShowProperty(false)
  }));
};

var SectionEditText$1 = withStyles(styles$c, {
  withTheme: true
})(SectionEditText);

const styles$d = theme => ({
  root: {
    width: '300px',
    position: 'absolute',
    marginTop: '10px',
    right: '10px'
  },
  tabRoot: {
    width: '300px'
  },
  selectInput: {
    width: '100%'
  },
  //   tabPanelRoot:{
  //     mincontent_width: '100px'
  //   },
  textLabel: {
    marginBottom: theme.spacing(2)
  },
  buttonGroup: {
    width: '100%'
  },
  menuButton: {
    position: 'absolute',
    right: '10px',
    top: theme.spacing(1),
    padding: 0,
    margin: 0
  },
  input: {
    display: 'none'
  },
  btnChoose: {
    width: '100%',
    height: '250px',
    marginBottom: theme.spacing(2)
  }
});

const ImageUpload = ({
  classes,
  theme,
  sectionData,
  onMoveUp,
  onMoveDown,
  onDelete,
  onEdit,
  onUpdate,
  onCompleted,
  uploadMediaContent
}) => {
  const [loading, setLoading] = React.useState(false);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) ;
      } // Bind the event listener


      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  function ValueLabelComponent(props) {
    const {
      children,
      open,
      value
    } = props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      open: open,
      enterTouchDelay: 0,
      placement: "top",
      title: value
    }, children);
  }

  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired
  };
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  let initial = {
    images: sectionData.images ? sectionData.images : [],
    background_images: sectionData.subtitle ? sectionData.background_images : [],
    image_width: sectionData.image_width ? sectionData.image_width : 100
  };
  let selectedPath = sectionData.selectedItemPath ? sectionData.selectedItemPath.replace(/[0-9]\//g, '') : 'background_images';
  const [formData, setFormData] = useState(initial);
  const [imagePreview, setPreviewImage] = useState(null);
  const [dataUpload, setDataUpload] = useState(null);

  const handleChangeForm = name => (event, newValue) => {
    if (name !== 'image_width') {
      setPreviewImage(URL.createObjectURL(event.target.files[0]));
      let data = {
        title: '',
        media: event.target.files,
        name: name
      };
      setDataUpload(data);
    } else {
      setFormData({ ...formData,
        [name]: newValue
      });
      sectionData[name] = newValue;
      onUpdate();
    }
  };

  const uploadImages = data => {
    setLoading(true);
    let resultUpload = uploadMediaContent(data);
    Promise.resolve(resultUpload).then(function (value) {
      let itemData = [];
      itemData.push(value);
      setFormData({ ...formData,
        [data.name]: itemData
      });
      sectionData[data.name] = itemData;
      setLoading(false);
      onCompleted();
      onUpdate();
    });
  };

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 8,
    style: {
      height: selectedPath === 'images' && formValue('images').length > 0 ? '420px' : '350px'
    }
  }, selectedPath !== undefined && /*#__PURE__*/React.createElement(Box, {
    style: {
      padding: '16px',
      paddingTop: '32px'
    }
  }, selectedPath === 'images' && formValue('images').length > 0 && /*#__PURE__*/React.createElement(Box, {
    mb: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.textLabel
  }, "Image Width"), /*#__PURE__*/React.createElement(Slider$2, {
    ValueLabelComponent: ValueLabelComponent,
    "aria-label": "custom thumb label",
    onChange: handleChangeForm('image_width'),
    defaultValue: formValue('image_width')
  })), !imagePreview ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    accept: "image/*",
    className: classes.input,
    id: "icon-button-file",
    type: "file",
    onChange: handleChangeForm(selectedPath)
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-button-file"
  }, /*#__PURE__*/React.createElement(Button$2, {
    color: "primary",
    variant: "outlined",
    "aria-label": "upload picture",
    component: "span",
    className: classes.btnChoose
  }, "Choose File"))) : /*#__PURE__*/React.createElement(Box, {
    className: classes.btnChoose
  }, /*#__PURE__*/React.createElement("img", {
    src: imagePreview,
    width: "100%"
  })), /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 24
  }), /*#__PURE__*/React.createElement(Button$2, {
    color: "primary",
    variant: "contained",
    style: {
      width: '100%'
    },
    disabled: loading,
    onClick: () => uploadImages(dataUpload)
  }, "Upload")))));
};

var ImageUpload$1 = withStyles(styles$d, {
  withTheme: true
})(ImageUpload);

const styles$e = theme => ({
  root: {
    width: '100%',
    padding: '0px'
  },
  toolbar: {},
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  menuButton: {
    marginRight: 0
  }
});

const SectionImageUpload = props => {
  const {
    classes,
    theme,
    sectionData,
    onMoveUp,
    onMoveDown,
    onDelete,
    onEdit,
    onCancel
  } = props;
  const pageEditContext = useContext(PageEditContext);
  const {
    onBeginEditItem,
    onEndEditItem,
    uploadMediaContent
  } = pageEditContext;
  let sectionControl = [];
  sectionControl['position'] = 'absolute';
  sectionControl['background'] = 'white';
  sectionControl['right'] = '10px';
  sectionControl['top'] = '0px';
  sectionControl['width'] = 'fit-content';
  const [showProperty, setShowProperty] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: sectionControl
  }, onEdit && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: () => {
      onBeginEditItem( /*#__PURE__*/React.createElement(ImageUpload$1, {
        sectionData: sectionData,
        onUpdate: () => {
          onEdit({ ...sectionData
          });
        },
        onCompleted: onEndEditItem,
        uploadMediaContent: uploadMediaContent
      })); // onEdit({...sectionData}); setShowProperty(true)
    }
  }, /*#__PURE__*/React.createElement(EditIcon, null)), showProperty && /*#__PURE__*/React.createElement(ImageUpload$1, {
    sectionData: sectionData,
    onUpdate: () => {
      onEdit({ ...sectionData
      });
    },
    onCompleted: () => setShowProperty(false),
    uploadMediaContent: uploadMediaContent
  }));
};

var SectionImageUpload$1 = withStyles(styles$e, {
  withTheme: true
})(SectionImageUpload);

const styles$f = theme => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  btnStyle: {
    textTransform: 'none',
    fontSize: theme.typography.h6.fontSize
  },
  btnTitle: {
    zIndex: 1
  },
  editorStyle: {
    background: 'transparent',
    border: 'none'
  }
});

const TitleContentBlock = props => {
  const {
    classes,
    theme,
    openLink,
    children,
    title,
    subtitle,
    body,
    images,
    color,
    color_type,
    image_width,
    image_position,
    text_alignment,
    button_title,
    button_style,
    link_to,
    item_spacing,
    item_text_alignment,
    itemIndex
  } = props;
  const pageEditContext = useContext(PageEditContext);
  const {
    editMode,
    canEdit,
    selectionLevel,
    selectedItemPath,
    onSelectItem,
    onUpdateSection
  } = pageEditContext;
  let indexItem = itemIndex !== undefined ? itemIndex : '';
  let initialState = {
    selectedItemPath: selectedItemPath || undefined,
    itemIndex: indexItem,
    title: title || null,
    subtitle: subtitle || null,
    body: body || null,
    button_title: button_title || null,
    link_to: link_to || null,
    images: images || [],
    image_width: image_width || 100
  };
  const [newSectionsData, setNewSectionsData] = useState(initialState);
  let editControl = null;
  let controlUpload = null;
  const [formData, setFormData] = useState(newSectionsData);
  let imageUrl = null;
  let imageStyle = [];
  let itemStyle = [];
  const selectedItem = selectedItemPath;
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));

  if (images && images !== undefined && images.length > 0) {
    imageStyle['width'] = image_width ? image_width + '%' : '100%';
    imageUrl = images[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  if (text_alignment === 'left') {
    itemStyle['alignItems'] = 'flex-start';
  } else if (text_alignment === 'right') {
    itemStyle['alignItems'] = 'flex-end';
  } else {
    itemStyle['alignItems'] = 'center';
  }

  const handleChangeForm = (name, value) => {
    setFormData({ ...formData,
      [name]: value
    });
  };

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  if (selectedItem) {
    editControl = /*#__PURE__*/React.createElement(SectionEditText$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        setNewSectionsData(newSectionData);
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
        onUpdateSection(newSectionData);
      }
    });
    controlUpload = /*#__PURE__*/React.createElement(SectionImageUpload$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        setNewSectionsData(newSectionData);
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
        onUpdateSection(newSectionData);
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.item,
    style: itemStyle
  }, // React reveal will prevent selection. Do not add Fade when in edit mode
  canEdit ? /*#__PURE__*/React.createElement(Box, {
    align: text_alignment,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == 'title',
    onSelect: () => onSelectItem('title'),
    control: editControl,
    level: selectionLevel + 2
  }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('title'),
    variant: "hero",
    color: color
  }) : /*#__PURE__*/React.createElement(Typography, {
    component: "span"
  }, "[Add Title]")) : /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('title'),
    variant: "hero",
    color: color
  }))), /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == 'subtitle',
    onSelect: () => onSelectItem('subtitle'),
    control: editControl,
    level: selectionLevel + 1
  }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('subtitle'),
    variant: "hero",
    color: color
  }) : /*#__PURE__*/React.createElement(Typography, {
    component: "span"
  }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(React.Fragment, null, subtitle && /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('subtitle'),
    variant: "hero",
    color: color
  }))), /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    mb: 4
  }, /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == 'images',
    onSelect: () => onSelectItem('images'),
    control: controlUpload,
    level: selectionLevel + 1
  }, imageUrl ? /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: classes.imageCenter,
    style: imageStyle
  }) : /*#__PURE__*/React.createElement(Typography, {
    component: "span"
  }, "[Add Image]"))), /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == 'body',
    onSelect: () => onSelectItem('body'),
    control: editControl,
    level: selectionLevel + 0
  }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('body'),
    variant: "body",
    color: color
  }) : /*#__PURE__*/React.createElement(Typography, {
    component: "span"
  }, "[Add Body]")) : /*#__PURE__*/React.createElement(React.Fragment, null, body && /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('body'),
    variant: "body",
    color: color
  })))) : /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement(Box, {
    align: text_alignment,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, title && /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('title'),
    variant: "hero",
    color: color
  })), /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, subtitle && /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('subtitle'),
    variant: "hero",
    color: color
  })), imageUrl && /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    mb: 4
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: classes.imageCenter,
    style: imageStyle
  })), /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, body && /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('body'),
    variant: "body",
    color: color
  })))), children && /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, Array.isArray(children) ? /*#__PURE__*/React.createElement(React.Fragment, null, children.map(c => c)) : /*#__PURE__*/React.createElement(React.Fragment, null, children)), link_to && link_to !== undefined && button_title !== undefined &&
  /*#__PURE__*/
  // <Fade>     
  React.createElement(Box, {
    align: text_alignment,
    mt: 4,
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == 'button_title',
    onSelect: () => onSelectItem('button_title'),
    control: editControl,
    level: selectionLevel + 0
  }, /*#__PURE__*/React.createElement(Button$1, {
    style: button_style,
    className: classes.btnTitle,
    onClick: () => openLink(formValue('link_to'))
  }, formValue('button_title') ? formValue('button_title') : 'Button')) : /*#__PURE__*/React.createElement(Button$1, {
    style: button_style,
    className: classes.btnTitle,
    onClick: () => openLink(formValue('link_to'))
  }, formValue('button_title'))) // </Fade>
  , link_to === undefined && canEdit && /*#__PURE__*/React.createElement(Box, {
    align: text_alignment,
    mt: 4,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == 'button_title',
    onSelect: () => onSelectItem('button_title'),
    control: editControl,
    level: selectionLevel - 1
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "span"
  }, "[Add Button]"))));
};

var TitleContentBlock$1 = withStyles(styles$f, {
  withTheme: true
})(TitleContentBlock);

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var utils = createCommonjsModule$1(function (module, exports) {
    exports.isInteger = num => {
        if (typeof num === 'number') {
            return Number.isInteger(num);
        }
        if (typeof num === 'string' && num.trim() !== '') {
            return Number.isInteger(Number(num));
        }
        return false;
    };
    /**
     * Find a node of the given type
     */
    exports.find = (node, type) => node.nodes.find(node => node.type === type);
    /**
     * Find a node of the given type
     */
    exports.exceedsLimit = (min, max, step = 1, limit) => {
        if (limit === false)
            return false;
        if (!exports.isInteger(min) || !exports.isInteger(max))
            return false;
        return ((Number(max) - Number(min)) / Number(step)) >= limit;
    };
    /**
     * Escape the given node with '\\' before node.value
     */
    exports.escapeNode = (block, n = 0, type) => {
        let node = block.nodes[n];
        if (!node)
            return;
        if ((type && node.type === type) || node.type === 'open' || node.type === 'close') {
            if (node.escaped !== true) {
                node.value = '\\' + node.value;
                node.escaped = true;
            }
        }
    };
    /**
     * Returns true if the given brace node should be enclosed in literal braces
     */
    exports.encloseBrace = node => {
        if (node.type !== 'brace')
            return false;
        if ((node.commas >> 0 + node.ranges >> 0) === 0) {
            node.invalid = true;
            return true;
        }
        return false;
    };
    /**
     * Returns true if a brace node is invalid.
     */
    exports.isInvalidBrace = block => {
        if (block.type !== 'brace')
            return false;
        if (block.invalid === true || block.dollar)
            return true;
        if ((block.commas >> 0 + block.ranges >> 0) === 0) {
            block.invalid = true;
            return true;
        }
        if (block.open !== true || block.close !== true) {
            block.invalid = true;
            return true;
        }
        return false;
    };
    /**
     * Returns true if a node is an open or close node
     */
    exports.isOpenOrClose = node => {
        if (node.type === 'open' || node.type === 'close') {
            return true;
        }
        return node.open === true || node.close === true;
    };
    /**
     * Reduce an array of text nodes.
     */
    exports.reduce = nodes => nodes.reduce((acc, node) => {
        if (node.type === 'text')
            acc.push(node.value);
        if (node.type === 'range')
            node.type = 'text';
        return acc;
    }, []);
    /**
     * Flatten an array
     */
    exports.flatten = (...args) => {
        const result = [];
        const flat = arr => {
            for (let i = 0; i < arr.length; i++) {
                let ele = arr[i];
                Array.isArray(ele) ? flat(ele) : ele !== void 0 && result.push(ele);
            }
            return result;
        };
        flat(args);
        return result;
    };
});
var utils_1 = utils.isInteger;
var utils_2 = utils.find;
var utils_3 = utils.exceedsLimit;
var utils_4 = utils.escapeNode;
var utils_5 = utils.encloseBrace;
var utils_6 = utils.isInvalidBrace;
var utils_7 = utils.isOpenOrClose;
var utils_8 = utils.reduce;
var utils_9 = utils.flatten;

const WIN_SLASH = '\\\\/';
const WIN_NO_SLASH = `[^${WIN_SLASH}]`;
/**
 * Posix glob regex
 */
const DOT_LITERAL = '\\.';
const PLUS_LITERAL = '\\+';
const QMARK_LITERAL = '\\?';
const SLASH_LITERAL = '\\/';
const ONE_CHAR = '(?=.)';
const QMARK = '[^/]';
const END_ANCHOR = `(?:${SLASH_LITERAL}|$)`;
const START_ANCHOR = `(?:^|${SLASH_LITERAL})`;
const DOTS_SLASH = `${DOT_LITERAL}{1,2}${END_ANCHOR}`;
const NO_DOT = `(?!${DOT_LITERAL})`;
const NO_DOTS = `(?!${START_ANCHOR}${DOTS_SLASH})`;
const NO_DOT_SLASH = `(?!${DOT_LITERAL}{0,1}${END_ANCHOR})`;
const NO_DOTS_SLASH = `(?!${DOTS_SLASH})`;
const QMARK_NO_DOT = `[^.${SLASH_LITERAL}]`;
const STAR = `${QMARK}*?`;
const POSIX_CHARS = {
    DOT_LITERAL,
    PLUS_LITERAL,
    QMARK_LITERAL,
    SLASH_LITERAL,
    ONE_CHAR,
    QMARK,
    END_ANCHOR,
    DOTS_SLASH,
    NO_DOT,
    NO_DOTS,
    NO_DOT_SLASH,
    NO_DOTS_SLASH,
    QMARK_NO_DOT,
    STAR,
    START_ANCHOR
};
/**
 * Windows glob regex
 */
const WINDOWS_CHARS = Object.assign({}, POSIX_CHARS, { SLASH_LITERAL: `[${WIN_SLASH}]`, QMARK: WIN_NO_SLASH, STAR: `${WIN_NO_SLASH}*?`, DOTS_SLASH: `${DOT_LITERAL}{1,2}(?:[${WIN_SLASH}]|$)`, NO_DOT: `(?!${DOT_LITERAL})`, NO_DOTS: `(?!(?:^|[${WIN_SLASH}])${DOT_LITERAL}{1,2}(?:[${WIN_SLASH}]|$))`, NO_DOT_SLASH: `(?!${DOT_LITERAL}{0,1}(?:[${WIN_SLASH}]|$))`, NO_DOTS_SLASH: `(?!${DOT_LITERAL}{1,2}(?:[${WIN_SLASH}]|$))`, QMARK_NO_DOT: `[^.${WIN_SLASH}]`, START_ANCHOR: `(?:^|[${WIN_SLASH}])`, END_ANCHOR: `(?:[${WIN_SLASH}]|$)` });
/**
 * POSIX Bracket Regex
 */
const POSIX_REGEX_SOURCE = {
    alnum: 'a-zA-Z0-9',
    alpha: 'a-zA-Z',
    ascii: '\\x00-\\x7F',
    blank: ' \\t',
    cntrl: '\\x00-\\x1F\\x7F',
    digit: '0-9',
    graph: '\\x21-\\x7E',
    lower: 'a-z',
    print: '\\x20-\\x7E ',
    punct: '\\-!"#$%&\'()\\*+,./:;<=>?@[\\]^_`{|}~',
    space: ' \\t\\r\\n\\v\\f',
    upper: 'A-Z',
    word: 'A-Za-z0-9_',
    xdigit: 'A-Fa-f0-9'
};
var constants$1 = {
    MAX_LENGTH: 1024 * 64,
    POSIX_REGEX_SOURCE,
    // regular expressions
    REGEX_BACKSLASH: /\\(?![*+?^${}(|)[\]])/g,
    REGEX_NON_SPECIAL_CHAR: /^[^@![\].,$*+?^{}()|\\/]+/,
    REGEX_SPECIAL_CHARS: /[-*+?.^${}(|)[\]]/,
    REGEX_SPECIAL_CHARS_BACKREF: /(\\?)((\W)(\3*))/g,
    REGEX_SPECIAL_CHARS_GLOBAL: /([-*+?.^${}(|)[\]])/g,
    REGEX_REMOVE_BACKSLASH: /(?:\[.*?[^\\]\]|\\(?=.))/g,
    // Replace globs with equivalent patterns to reduce parsing time.
    REPLACEMENTS: {
        '***': '*',
        '**/**': '**',
        '**/**/**': '**'
    },
    // Digits
    CHAR_0: 48,
    CHAR_9: 57,
    // Alphabet chars.
    CHAR_UPPERCASE_A: 65,
    CHAR_LOWERCASE_A: 97,
    CHAR_UPPERCASE_Z: 90,
    CHAR_LOWERCASE_Z: 122,
    CHAR_LEFT_PARENTHESES: 40,
    CHAR_RIGHT_PARENTHESES: 41,
    CHAR_ASTERISK: 42,
    // Non-alphabetic chars.
    CHAR_AMPERSAND: 38,
    CHAR_AT: 64,
    CHAR_BACKWARD_SLASH: 92,
    CHAR_CARRIAGE_RETURN: 13,
    CHAR_CIRCUMFLEX_ACCENT: 94,
    CHAR_COLON: 58,
    CHAR_COMMA: 44,
    CHAR_DOT: 46,
    CHAR_DOUBLE_QUOTE: 34,
    CHAR_EQUAL: 61,
    CHAR_EXCLAMATION_MARK: 33,
    CHAR_FORM_FEED: 12,
    CHAR_FORWARD_SLASH: 47,
    CHAR_GRAVE_ACCENT: 96,
    CHAR_HASH: 35,
    CHAR_HYPHEN_MINUS: 45,
    CHAR_LEFT_ANGLE_BRACKET: 60,
    CHAR_LEFT_CURLY_BRACE: 123,
    CHAR_LEFT_SQUARE_BRACKET: 91,
    CHAR_LINE_FEED: 10,
    CHAR_NO_BREAK_SPACE: 160,
    CHAR_PERCENT: 37,
    CHAR_PLUS: 43,
    CHAR_QUESTION_MARK: 63,
    CHAR_RIGHT_ANGLE_BRACKET: 62,
    CHAR_RIGHT_CURLY_BRACE: 125,
    CHAR_RIGHT_SQUARE_BRACKET: 93,
    CHAR_SEMICOLON: 59,
    CHAR_SINGLE_QUOTE: 39,
    CHAR_SPACE: 32,
    CHAR_TAB: 9,
    CHAR_UNDERSCORE: 95,
    CHAR_VERTICAL_LINE: 124,
    CHAR_ZERO_WIDTH_NOBREAK_SPACE: 65279,
    SEP: path$1.sep,
    /**
     * Create EXTGLOB_CHARS
     */
    extglobChars(chars) {
        return {
            '!': { type: 'negate', open: '(?:(?!(?:', close: `))${chars.STAR})` },
            '?': { type: 'qmark', open: '(?:', close: ')?' },
            '+': { type: 'plus', open: '(?:', close: ')+' },
            '*': { type: 'star', open: '(?:', close: ')*' },
            '@': { type: 'at', open: '(?:', close: ')' }
        };
    },
    /**
     * Create GLOB_CHARS
     */
    globChars(win32) {
        return win32 === true ? WINDOWS_CHARS : POSIX_CHARS;
    }
};

var utils$1 = createCommonjsModule$1(function (module, exports) {
    const win32 = process.platform === 'win32';
    const { REGEX_SPECIAL_CHARS, REGEX_SPECIAL_CHARS_GLOBAL, REGEX_REMOVE_BACKSLASH } = constants$1;
    exports.isObject = val => val !== null && typeof val === 'object' && !Array.isArray(val);
    exports.hasRegexChars = str => REGEX_SPECIAL_CHARS.test(str);
    exports.isRegexChar = str => str.length === 1 && exports.hasRegexChars(str);
    exports.escapeRegex = str => str.replace(REGEX_SPECIAL_CHARS_GLOBAL, '\\$1');
    exports.toPosixSlashes = str => str.replace(/\\/g, '/');
    exports.removeBackslashes = str => {
        return str.replace(REGEX_REMOVE_BACKSLASH, match => {
            return match === '\\' ? '' : match;
        });
    };
    exports.supportsLookbehinds = () => {
        let segs = process.version.slice(1).split('.');
        if (segs.length === 3 && +segs[0] >= 9 || (+segs[0] === 8 && +segs[1] >= 10)) {
            return true;
        }
        return false;
    };
    exports.isWindows = options => {
        if (options && typeof options.windows === 'boolean') {
            return options.windows;
        }
        return win32 === true || path$1.sep === '\\';
    };
    exports.escapeLast = (input, char, lastIdx) => {
        let idx = input.lastIndexOf(char, lastIdx);
        if (idx === -1)
            return input;
        if (input[idx - 1] === '\\')
            return exports.escapeLast(input, char, idx - 1);
        return input.slice(0, idx) + '\\' + input.slice(idx);
    };
});
var utils_1$1 = utils$1.isObject;
var utils_2$1 = utils$1.hasRegexChars;
var utils_3$1 = utils$1.isRegexChar;
var utils_4$1 = utils$1.escapeRegex;
var utils_5$1 = utils$1.toPosixSlashes;
var utils_6$1 = utils$1.removeBackslashes;
var utils_7$1 = utils$1.supportsLookbehinds;
var utils_8$1 = utils$1.isWindows;
var utils_9$1 = utils$1.escapeLast;

const reservedWords = 'break case class catch const continue debugger default delete do else export extends finally for function if import in instanceof let new return super switch this throw try typeof var void while with yield enum await implements package protected static interface private public';
const builtins = 'arguments Infinity NaN undefined null true false eval uneval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Symbol Error EvalError InternalError RangeError ReferenceError SyntaxError TypeError URIError Number Math Date String RegExp Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array Map Set WeakMap WeakSet SIMD ArrayBuffer DataView JSON Promise Generator GeneratorFunction Reflect Proxy Intl';
const forbiddenIdentifiers = new Set(`${reservedWords} ${builtins}`.split(' '));
forbiddenIdentifiers.add('');

/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */
function Mime() {
  this._types = Object.create(null);
  this._extensions = Object.create(null);

  for (var i = 0; i < arguments.length; i++) {
    this.define(arguments[i]);
  }

  this.define = this.define.bind(this);
  this.getType = this.getType.bind(this);
  this.getExtension = this.getExtension.bind(this);
}

/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */
Mime.prototype.define = function(typeMap, force) {
  for (var type in typeMap) {
    var extensions = typeMap[type].map(function(t) {return t.toLowerCase()});
    type = type.toLowerCase();

    for (var i = 0; i < extensions.length; i++) {
      var ext = extensions[i];

      // '*' prefix = not the preferred type for this extension.  So fixup the
      // extension, and skip it.
      if (ext[0] == '*') {
        continue;
      }

      if (!force && (ext in this._types)) {
        throw new Error(
          'Attempt to change mapping for "' + ext +
          '" extension from "' + this._types[ext] + '" to "' + type +
          '". Pass `force=true` to allow this, otherwise remove "' + ext +
          '" from the list of extensions for "' + type + '".'
        );
      }

      this._types[ext] = type;
    }

    // Use first extension as default
    if (force || !this._extensions[type]) {
      var ext = extensions[0];
      this._extensions[type] = (ext[0] != '*') ? ext : ext.substr(1);
    }
  }
};

/**
 * Lookup a mime type based on extension
 */
Mime.prototype.getType = function(path) {
  path = String(path);
  var last = path.replace(/^.*[/\\]/, '').toLowerCase();
  var ext = last.replace(/^.*\./, '').toLowerCase();

  var hasPath = last.length < path.length;
  var hasDot = ext.length < last.length - 1;

  return (hasDot || !hasPath) && this._types[ext] || null;
};

/**
 * Return file extension associated with a mime type
 */
Mime.prototype.getExtension = function(type) {
  type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
  return type && this._extensions[type.toLowerCase()] || null;
};

var Mime_1 = Mime;

var standard = {"application/andrew-inset":["ez"],"application/applixware":["aw"],"application/atom+xml":["atom"],"application/atomcat+xml":["atomcat"],"application/atomsvc+xml":["atomsvc"],"application/bdoc":["bdoc"],"application/ccxml+xml":["ccxml"],"application/cdmi-capability":["cdmia"],"application/cdmi-container":["cdmic"],"application/cdmi-domain":["cdmid"],"application/cdmi-object":["cdmio"],"application/cdmi-queue":["cdmiq"],"application/cu-seeme":["cu"],"application/dash+xml":["mpd"],"application/davmount+xml":["davmount"],"application/docbook+xml":["dbk"],"application/dssc+der":["dssc"],"application/dssc+xml":["xdssc"],"application/ecmascript":["ecma","es"],"application/emma+xml":["emma"],"application/epub+zip":["epub"],"application/exi":["exi"],"application/font-tdpfr":["pfr"],"application/geo+json":["geojson"],"application/gml+xml":["gml"],"application/gpx+xml":["gpx"],"application/gxf":["gxf"],"application/gzip":["gz"],"application/hjson":["hjson"],"application/hyperstudio":["stk"],"application/inkml+xml":["ink","inkml"],"application/ipfix":["ipfix"],"application/java-archive":["jar","war","ear"],"application/java-serialized-object":["ser"],"application/java-vm":["class"],"application/javascript":["js","mjs"],"application/json":["json","map"],"application/json5":["json5"],"application/jsonml+json":["jsonml"],"application/ld+json":["jsonld"],"application/lost+xml":["lostxml"],"application/mac-binhex40":["hqx"],"application/mac-compactpro":["cpt"],"application/mads+xml":["mads"],"application/manifest+json":["webmanifest"],"application/marc":["mrc"],"application/marcxml+xml":["mrcx"],"application/mathematica":["ma","nb","mb"],"application/mathml+xml":["mathml"],"application/mbox":["mbox"],"application/mediaservercontrol+xml":["mscml"],"application/metalink+xml":["metalink"],"application/metalink4+xml":["meta4"],"application/mets+xml":["mets"],"application/mods+xml":["mods"],"application/mp21":["m21","mp21"],"application/mp4":["mp4s","m4p"],"application/msword":["doc","dot"],"application/mxf":["mxf"],"application/n-quads":["nq"],"application/n-triples":["nt"],"application/octet-stream":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"],"application/oda":["oda"],"application/oebps-package+xml":["opf"],"application/ogg":["ogx"],"application/omdoc+xml":["omdoc"],"application/onenote":["onetoc","onetoc2","onetmp","onepkg"],"application/oxps":["oxps"],"application/patch-ops-error+xml":["xer"],"application/pdf":["pdf"],"application/pgp-encrypted":["pgp"],"application/pgp-signature":["asc","sig"],"application/pics-rules":["prf"],"application/pkcs10":["p10"],"application/pkcs7-mime":["p7m","p7c"],"application/pkcs7-signature":["p7s"],"application/pkcs8":["p8"],"application/pkix-attr-cert":["ac"],"application/pkix-cert":["cer"],"application/pkix-crl":["crl"],"application/pkix-pkipath":["pkipath"],"application/pkixcmp":["pki"],"application/pls+xml":["pls"],"application/postscript":["ai","eps","ps"],"application/pskc+xml":["pskcxml"],"application/raml+yaml":["raml"],"application/rdf+xml":["rdf","owl"],"application/reginfo+xml":["rif"],"application/relax-ng-compact-syntax":["rnc"],"application/resource-lists+xml":["rl"],"application/resource-lists-diff+xml":["rld"],"application/rls-services+xml":["rs"],"application/rpki-ghostbusters":["gbr"],"application/rpki-manifest":["mft"],"application/rpki-roa":["roa"],"application/rsd+xml":["rsd"],"application/rss+xml":["rss"],"application/rtf":["rtf"],"application/sbml+xml":["sbml"],"application/scvp-cv-request":["scq"],"application/scvp-cv-response":["scs"],"application/scvp-vp-request":["spq"],"application/scvp-vp-response":["spp"],"application/sdp":["sdp"],"application/set-payment-initiation":["setpay"],"application/set-registration-initiation":["setreg"],"application/shf+xml":["shf"],"application/sieve":["siv","sieve"],"application/smil+xml":["smi","smil"],"application/sparql-query":["rq"],"application/sparql-results+xml":["srx"],"application/srgs":["gram"],"application/srgs+xml":["grxml"],"application/sru+xml":["sru"],"application/ssdl+xml":["ssdl"],"application/ssml+xml":["ssml"],"application/tei+xml":["tei","teicorpus"],"application/thraud+xml":["tfi"],"application/timestamped-data":["tsd"],"application/voicexml+xml":["vxml"],"application/wasm":["wasm"],"application/widget":["wgt"],"application/winhlp":["hlp"],"application/wsdl+xml":["wsdl"],"application/wspolicy+xml":["wspolicy"],"application/xaml+xml":["xaml"],"application/xcap-diff+xml":["xdf"],"application/xenc+xml":["xenc"],"application/xhtml+xml":["xhtml","xht"],"application/xml":["xml","xsl","xsd","rng"],"application/xml-dtd":["dtd"],"application/xop+xml":["xop"],"application/xproc+xml":["xpl"],"application/xslt+xml":["xslt"],"application/xspf+xml":["xspf"],"application/xv+xml":["mxml","xhvml","xvml","xvm"],"application/yang":["yang"],"application/yin+xml":["yin"],"application/zip":["zip"],"audio/3gpp":["*3gpp"],"audio/adpcm":["adp"],"audio/basic":["au","snd"],"audio/midi":["mid","midi","kar","rmi"],"audio/mp3":["*mp3"],"audio/mp4":["m4a","mp4a"],"audio/mpeg":["mpga","mp2","mp2a","mp3","m2a","m3a"],"audio/ogg":["oga","ogg","spx"],"audio/s3m":["s3m"],"audio/silk":["sil"],"audio/wav":["wav"],"audio/wave":["*wav"],"audio/webm":["weba"],"audio/xm":["xm"],"font/collection":["ttc"],"font/otf":["otf"],"font/ttf":["ttf"],"font/woff":["woff"],"font/woff2":["woff2"],"image/aces":["exr"],"image/apng":["apng"],"image/bmp":["bmp"],"image/cgm":["cgm"],"image/dicom-rle":["drle"],"image/emf":["emf"],"image/fits":["fits"],"image/g3fax":["g3"],"image/gif":["gif"],"image/heic":["heic"],"image/heic-sequence":["heics"],"image/heif":["heif"],"image/heif-sequence":["heifs"],"image/ief":["ief"],"image/jls":["jls"],"image/jp2":["jp2","jpg2"],"image/jpeg":["jpeg","jpg","jpe"],"image/jpm":["jpm"],"image/jpx":["jpx","jpf"],"image/jxr":["jxr"],"image/ktx":["ktx"],"image/png":["png"],"image/sgi":["sgi"],"image/svg+xml":["svg","svgz"],"image/t38":["t38"],"image/tiff":["tif","tiff"],"image/tiff-fx":["tfx"],"image/webp":["webp"],"image/wmf":["wmf"],"message/disposition-notification":["disposition-notification"],"message/global":["u8msg"],"message/global-delivery-status":["u8dsn"],"message/global-disposition-notification":["u8mdn"],"message/global-headers":["u8hdr"],"message/rfc822":["eml","mime"],"model/3mf":["3mf"],"model/gltf+json":["gltf"],"model/gltf-binary":["glb"],"model/iges":["igs","iges"],"model/mesh":["msh","mesh","silo"],"model/stl":["stl"],"model/vrml":["wrl","vrml"],"model/x3d+binary":["*x3db","x3dbz"],"model/x3d+fastinfoset":["x3db"],"model/x3d+vrml":["*x3dv","x3dvz"],"model/x3d+xml":["x3d","x3dz"],"model/x3d-vrml":["x3dv"],"text/cache-manifest":["appcache","manifest"],"text/calendar":["ics","ifb"],"text/coffeescript":["coffee","litcoffee"],"text/css":["css"],"text/csv":["csv"],"text/html":["html","htm","shtml"],"text/jade":["jade"],"text/jsx":["jsx"],"text/less":["less"],"text/markdown":["markdown","md"],"text/mathml":["mml"],"text/mdx":["mdx"],"text/n3":["n3"],"text/plain":["txt","text","conf","def","list","log","in","ini"],"text/richtext":["rtx"],"text/rtf":["*rtf"],"text/sgml":["sgml","sgm"],"text/shex":["shex"],"text/slim":["slim","slm"],"text/stylus":["stylus","styl"],"text/tab-separated-values":["tsv"],"text/troff":["t","tr","roff","man","me","ms"],"text/turtle":["ttl"],"text/uri-list":["uri","uris","urls"],"text/vcard":["vcard"],"text/vtt":["vtt"],"text/xml":["*xml"],"text/yaml":["yaml","yml"],"video/3gpp":["3gp","3gpp"],"video/3gpp2":["3g2"],"video/h261":["h261"],"video/h263":["h263"],"video/h264":["h264"],"video/jpeg":["jpgv"],"video/jpm":["*jpm","jpgm"],"video/mj2":["mj2","mjp2"],"video/mp2t":["ts"],"video/mp4":["mp4","mp4v","mpg4"],"video/mpeg":["mpeg","mpg","mpe","m1v","m2v"],"video/ogg":["ogv"],"video/quicktime":["qt","mov"],"video/webm":["webm"]};

var other = {"application/prs.cww":["cww"],"application/vnd.3gpp.pic-bw-large":["plb"],"application/vnd.3gpp.pic-bw-small":["psb"],"application/vnd.3gpp.pic-bw-var":["pvb"],"application/vnd.3gpp2.tcap":["tcap"],"application/vnd.3m.post-it-notes":["pwn"],"application/vnd.accpac.simply.aso":["aso"],"application/vnd.accpac.simply.imp":["imp"],"application/vnd.acucobol":["acu"],"application/vnd.acucorp":["atc","acutc"],"application/vnd.adobe.air-application-installer-package+zip":["air"],"application/vnd.adobe.formscentral.fcdt":["fcdt"],"application/vnd.adobe.fxp":["fxp","fxpl"],"application/vnd.adobe.xdp+xml":["xdp"],"application/vnd.adobe.xfdf":["xfdf"],"application/vnd.ahead.space":["ahead"],"application/vnd.airzip.filesecure.azf":["azf"],"application/vnd.airzip.filesecure.azs":["azs"],"application/vnd.amazon.ebook":["azw"],"application/vnd.americandynamics.acc":["acc"],"application/vnd.amiga.ami":["ami"],"application/vnd.android.package-archive":["apk"],"application/vnd.anser-web-certificate-issue-initiation":["cii"],"application/vnd.anser-web-funds-transfer-initiation":["fti"],"application/vnd.antix.game-component":["atx"],"application/vnd.apple.installer+xml":["mpkg"],"application/vnd.apple.keynote":["keynote"],"application/vnd.apple.mpegurl":["m3u8"],"application/vnd.apple.numbers":["numbers"],"application/vnd.apple.pages":["pages"],"application/vnd.apple.pkpass":["pkpass"],"application/vnd.aristanetworks.swi":["swi"],"application/vnd.astraea-software.iota":["iota"],"application/vnd.audiograph":["aep"],"application/vnd.blueice.multipass":["mpm"],"application/vnd.bmi":["bmi"],"application/vnd.businessobjects":["rep"],"application/vnd.chemdraw+xml":["cdxml"],"application/vnd.chipnuts.karaoke-mmd":["mmd"],"application/vnd.cinderella":["cdy"],"application/vnd.citationstyles.style+xml":["csl"],"application/vnd.claymore":["cla"],"application/vnd.cloanto.rp9":["rp9"],"application/vnd.clonk.c4group":["c4g","c4d","c4f","c4p","c4u"],"application/vnd.cluetrust.cartomobile-config":["c11amc"],"application/vnd.cluetrust.cartomobile-config-pkg":["c11amz"],"application/vnd.commonspace":["csp"],"application/vnd.contact.cmsg":["cdbcmsg"],"application/vnd.cosmocaller":["cmc"],"application/vnd.crick.clicker":["clkx"],"application/vnd.crick.clicker.keyboard":["clkk"],"application/vnd.crick.clicker.palette":["clkp"],"application/vnd.crick.clicker.template":["clkt"],"application/vnd.crick.clicker.wordbank":["clkw"],"application/vnd.criticaltools.wbs+xml":["wbs"],"application/vnd.ctc-posml":["pml"],"application/vnd.cups-ppd":["ppd"],"application/vnd.curl.car":["car"],"application/vnd.curl.pcurl":["pcurl"],"application/vnd.dart":["dart"],"application/vnd.data-vision.rdz":["rdz"],"application/vnd.dece.data":["uvf","uvvf","uvd","uvvd"],"application/vnd.dece.ttml+xml":["uvt","uvvt"],"application/vnd.dece.unspecified":["uvx","uvvx"],"application/vnd.dece.zip":["uvz","uvvz"],"application/vnd.denovo.fcselayout-link":["fe_launch"],"application/vnd.dna":["dna"],"application/vnd.dolby.mlp":["mlp"],"application/vnd.dpgraph":["dpg"],"application/vnd.dreamfactory":["dfac"],"application/vnd.ds-keypoint":["kpxx"],"application/vnd.dvb.ait":["ait"],"application/vnd.dvb.service":["svc"],"application/vnd.dynageo":["geo"],"application/vnd.ecowin.chart":["mag"],"application/vnd.enliven":["nml"],"application/vnd.epson.esf":["esf"],"application/vnd.epson.msf":["msf"],"application/vnd.epson.quickanime":["qam"],"application/vnd.epson.salt":["slt"],"application/vnd.epson.ssf":["ssf"],"application/vnd.eszigno3+xml":["es3","et3"],"application/vnd.ezpix-album":["ez2"],"application/vnd.ezpix-package":["ez3"],"application/vnd.fdf":["fdf"],"application/vnd.fdsn.mseed":["mseed"],"application/vnd.fdsn.seed":["seed","dataless"],"application/vnd.flographit":["gph"],"application/vnd.fluxtime.clip":["ftc"],"application/vnd.framemaker":["fm","frame","maker","book"],"application/vnd.frogans.fnc":["fnc"],"application/vnd.frogans.ltf":["ltf"],"application/vnd.fsc.weblaunch":["fsc"],"application/vnd.fujitsu.oasys":["oas"],"application/vnd.fujitsu.oasys2":["oa2"],"application/vnd.fujitsu.oasys3":["oa3"],"application/vnd.fujitsu.oasysgp":["fg5"],"application/vnd.fujitsu.oasysprs":["bh2"],"application/vnd.fujixerox.ddd":["ddd"],"application/vnd.fujixerox.docuworks":["xdw"],"application/vnd.fujixerox.docuworks.binder":["xbd"],"application/vnd.fuzzysheet":["fzs"],"application/vnd.genomatix.tuxedo":["txd"],"application/vnd.geogebra.file":["ggb"],"application/vnd.geogebra.tool":["ggt"],"application/vnd.geometry-explorer":["gex","gre"],"application/vnd.geonext":["gxt"],"application/vnd.geoplan":["g2w"],"application/vnd.geospace":["g3w"],"application/vnd.gmx":["gmx"],"application/vnd.google-apps.document":["gdoc"],"application/vnd.google-apps.presentation":["gslides"],"application/vnd.google-apps.spreadsheet":["gsheet"],"application/vnd.google-earth.kml+xml":["kml"],"application/vnd.google-earth.kmz":["kmz"],"application/vnd.grafeq":["gqf","gqs"],"application/vnd.groove-account":["gac"],"application/vnd.groove-help":["ghf"],"application/vnd.groove-identity-message":["gim"],"application/vnd.groove-injector":["grv"],"application/vnd.groove-tool-message":["gtm"],"application/vnd.groove-tool-template":["tpl"],"application/vnd.groove-vcard":["vcg"],"application/vnd.hal+xml":["hal"],"application/vnd.handheld-entertainment+xml":["zmm"],"application/vnd.hbci":["hbci"],"application/vnd.hhe.lesson-player":["les"],"application/vnd.hp-hpgl":["hpgl"],"application/vnd.hp-hpid":["hpid"],"application/vnd.hp-hps":["hps"],"application/vnd.hp-jlyt":["jlt"],"application/vnd.hp-pcl":["pcl"],"application/vnd.hp-pclxl":["pclxl"],"application/vnd.hydrostatix.sof-data":["sfd-hdstx"],"application/vnd.ibm.minipay":["mpy"],"application/vnd.ibm.modcap":["afp","listafp","list3820"],"application/vnd.ibm.rights-management":["irm"],"application/vnd.ibm.secure-container":["sc"],"application/vnd.iccprofile":["icc","icm"],"application/vnd.igloader":["igl"],"application/vnd.immervision-ivp":["ivp"],"application/vnd.immervision-ivu":["ivu"],"application/vnd.insors.igm":["igm"],"application/vnd.intercon.formnet":["xpw","xpx"],"application/vnd.intergeo":["i2g"],"application/vnd.intu.qbo":["qbo"],"application/vnd.intu.qfx":["qfx"],"application/vnd.ipunplugged.rcprofile":["rcprofile"],"application/vnd.irepository.package+xml":["irp"],"application/vnd.is-xpr":["xpr"],"application/vnd.isac.fcs":["fcs"],"application/vnd.jam":["jam"],"application/vnd.jcp.javame.midlet-rms":["rms"],"application/vnd.jisp":["jisp"],"application/vnd.joost.joda-archive":["joda"],"application/vnd.kahootz":["ktz","ktr"],"application/vnd.kde.karbon":["karbon"],"application/vnd.kde.kchart":["chrt"],"application/vnd.kde.kformula":["kfo"],"application/vnd.kde.kivio":["flw"],"application/vnd.kde.kontour":["kon"],"application/vnd.kde.kpresenter":["kpr","kpt"],"application/vnd.kde.kspread":["ksp"],"application/vnd.kde.kword":["kwd","kwt"],"application/vnd.kenameaapp":["htke"],"application/vnd.kidspiration":["kia"],"application/vnd.kinar":["kne","knp"],"application/vnd.koan":["skp","skd","skt","skm"],"application/vnd.kodak-descriptor":["sse"],"application/vnd.las.las+xml":["lasxml"],"application/vnd.llamagraphics.life-balance.desktop":["lbd"],"application/vnd.llamagraphics.life-balance.exchange+xml":["lbe"],"application/vnd.lotus-1-2-3":["123"],"application/vnd.lotus-approach":["apr"],"application/vnd.lotus-freelance":["pre"],"application/vnd.lotus-notes":["nsf"],"application/vnd.lotus-organizer":["org"],"application/vnd.lotus-screencam":["scm"],"application/vnd.lotus-wordpro":["lwp"],"application/vnd.macports.portpkg":["portpkg"],"application/vnd.mcd":["mcd"],"application/vnd.medcalcdata":["mc1"],"application/vnd.mediastation.cdkey":["cdkey"],"application/vnd.mfer":["mwf"],"application/vnd.mfmp":["mfm"],"application/vnd.micrografx.flo":["flo"],"application/vnd.micrografx.igx":["igx"],"application/vnd.mif":["mif"],"application/vnd.mobius.daf":["daf"],"application/vnd.mobius.dis":["dis"],"application/vnd.mobius.mbk":["mbk"],"application/vnd.mobius.mqy":["mqy"],"application/vnd.mobius.msl":["msl"],"application/vnd.mobius.plc":["plc"],"application/vnd.mobius.txf":["txf"],"application/vnd.mophun.application":["mpn"],"application/vnd.mophun.certificate":["mpc"],"application/vnd.mozilla.xul+xml":["xul"],"application/vnd.ms-artgalry":["cil"],"application/vnd.ms-cab-compressed":["cab"],"application/vnd.ms-excel":["xls","xlm","xla","xlc","xlt","xlw"],"application/vnd.ms-excel.addin.macroenabled.12":["xlam"],"application/vnd.ms-excel.sheet.binary.macroenabled.12":["xlsb"],"application/vnd.ms-excel.sheet.macroenabled.12":["xlsm"],"application/vnd.ms-excel.template.macroenabled.12":["xltm"],"application/vnd.ms-fontobject":["eot"],"application/vnd.ms-htmlhelp":["chm"],"application/vnd.ms-ims":["ims"],"application/vnd.ms-lrm":["lrm"],"application/vnd.ms-officetheme":["thmx"],"application/vnd.ms-outlook":["msg"],"application/vnd.ms-pki.seccat":["cat"],"application/vnd.ms-pki.stl":["*stl"],"application/vnd.ms-powerpoint":["ppt","pps","pot"],"application/vnd.ms-powerpoint.addin.macroenabled.12":["ppam"],"application/vnd.ms-powerpoint.presentation.macroenabled.12":["pptm"],"application/vnd.ms-powerpoint.slide.macroenabled.12":["sldm"],"application/vnd.ms-powerpoint.slideshow.macroenabled.12":["ppsm"],"application/vnd.ms-powerpoint.template.macroenabled.12":["potm"],"application/vnd.ms-project":["mpp","mpt"],"application/vnd.ms-word.document.macroenabled.12":["docm"],"application/vnd.ms-word.template.macroenabled.12":["dotm"],"application/vnd.ms-works":["wps","wks","wcm","wdb"],"application/vnd.ms-wpl":["wpl"],"application/vnd.ms-xpsdocument":["xps"],"application/vnd.mseq":["mseq"],"application/vnd.musician":["mus"],"application/vnd.muvee.style":["msty"],"application/vnd.mynfc":["taglet"],"application/vnd.neurolanguage.nlu":["nlu"],"application/vnd.nitf":["ntf","nitf"],"application/vnd.noblenet-directory":["nnd"],"application/vnd.noblenet-sealer":["nns"],"application/vnd.noblenet-web":["nnw"],"application/vnd.nokia.n-gage.data":["ngdat"],"application/vnd.nokia.n-gage.symbian.install":["n-gage"],"application/vnd.nokia.radio-preset":["rpst"],"application/vnd.nokia.radio-presets":["rpss"],"application/vnd.novadigm.edm":["edm"],"application/vnd.novadigm.edx":["edx"],"application/vnd.novadigm.ext":["ext"],"application/vnd.oasis.opendocument.chart":["odc"],"application/vnd.oasis.opendocument.chart-template":["otc"],"application/vnd.oasis.opendocument.database":["odb"],"application/vnd.oasis.opendocument.formula":["odf"],"application/vnd.oasis.opendocument.formula-template":["odft"],"application/vnd.oasis.opendocument.graphics":["odg"],"application/vnd.oasis.opendocument.graphics-template":["otg"],"application/vnd.oasis.opendocument.image":["odi"],"application/vnd.oasis.opendocument.image-template":["oti"],"application/vnd.oasis.opendocument.presentation":["odp"],"application/vnd.oasis.opendocument.presentation-template":["otp"],"application/vnd.oasis.opendocument.spreadsheet":["ods"],"application/vnd.oasis.opendocument.spreadsheet-template":["ots"],"application/vnd.oasis.opendocument.text":["odt"],"application/vnd.oasis.opendocument.text-master":["odm"],"application/vnd.oasis.opendocument.text-template":["ott"],"application/vnd.oasis.opendocument.text-web":["oth"],"application/vnd.olpc-sugar":["xo"],"application/vnd.oma.dd2+xml":["dd2"],"application/vnd.openofficeorg.extension":["oxt"],"application/vnd.openxmlformats-officedocument.presentationml.presentation":["pptx"],"application/vnd.openxmlformats-officedocument.presentationml.slide":["sldx"],"application/vnd.openxmlformats-officedocument.presentationml.slideshow":["ppsx"],"application/vnd.openxmlformats-officedocument.presentationml.template":["potx"],"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":["xlsx"],"application/vnd.openxmlformats-officedocument.spreadsheetml.template":["xltx"],"application/vnd.openxmlformats-officedocument.wordprocessingml.document":["docx"],"application/vnd.openxmlformats-officedocument.wordprocessingml.template":["dotx"],"application/vnd.osgeo.mapguide.package":["mgp"],"application/vnd.osgi.dp":["dp"],"application/vnd.osgi.subsystem":["esa"],"application/vnd.palm":["pdb","pqa","oprc"],"application/vnd.pawaafile":["paw"],"application/vnd.pg.format":["str"],"application/vnd.pg.osasli":["ei6"],"application/vnd.picsel":["efif"],"application/vnd.pmi.widget":["wg"],"application/vnd.pocketlearn":["plf"],"application/vnd.powerbuilder6":["pbd"],"application/vnd.previewsystems.box":["box"],"application/vnd.proteus.magazine":["mgz"],"application/vnd.publishare-delta-tree":["qps"],"application/vnd.pvi.ptid1":["ptid"],"application/vnd.quark.quarkxpress":["qxd","qxt","qwd","qwt","qxl","qxb"],"application/vnd.realvnc.bed":["bed"],"application/vnd.recordare.musicxml":["mxl"],"application/vnd.recordare.musicxml+xml":["musicxml"],"application/vnd.rig.cryptonote":["cryptonote"],"application/vnd.rim.cod":["cod"],"application/vnd.rn-realmedia":["rm"],"application/vnd.rn-realmedia-vbr":["rmvb"],"application/vnd.route66.link66+xml":["link66"],"application/vnd.sailingtracker.track":["st"],"application/vnd.seemail":["see"],"application/vnd.sema":["sema"],"application/vnd.semd":["semd"],"application/vnd.semf":["semf"],"application/vnd.shana.informed.formdata":["ifm"],"application/vnd.shana.informed.formtemplate":["itp"],"application/vnd.shana.informed.interchange":["iif"],"application/vnd.shana.informed.package":["ipk"],"application/vnd.simtech-mindmapper":["twd","twds"],"application/vnd.smaf":["mmf"],"application/vnd.smart.teacher":["teacher"],"application/vnd.solent.sdkm+xml":["sdkm","sdkd"],"application/vnd.spotfire.dxp":["dxp"],"application/vnd.spotfire.sfs":["sfs"],"application/vnd.stardivision.calc":["sdc"],"application/vnd.stardivision.draw":["sda"],"application/vnd.stardivision.impress":["sdd"],"application/vnd.stardivision.math":["smf"],"application/vnd.stardivision.writer":["sdw","vor"],"application/vnd.stardivision.writer-global":["sgl"],"application/vnd.stepmania.package":["smzip"],"application/vnd.stepmania.stepchart":["sm"],"application/vnd.sun.wadl+xml":["wadl"],"application/vnd.sun.xml.calc":["sxc"],"application/vnd.sun.xml.calc.template":["stc"],"application/vnd.sun.xml.draw":["sxd"],"application/vnd.sun.xml.draw.template":["std"],"application/vnd.sun.xml.impress":["sxi"],"application/vnd.sun.xml.impress.template":["sti"],"application/vnd.sun.xml.math":["sxm"],"application/vnd.sun.xml.writer":["sxw"],"application/vnd.sun.xml.writer.global":["sxg"],"application/vnd.sun.xml.writer.template":["stw"],"application/vnd.sus-calendar":["sus","susp"],"application/vnd.svd":["svd"],"application/vnd.symbian.install":["sis","sisx"],"application/vnd.syncml+xml":["xsm"],"application/vnd.syncml.dm+wbxml":["bdm"],"application/vnd.syncml.dm+xml":["xdm"],"application/vnd.tao.intent-module-archive":["tao"],"application/vnd.tcpdump.pcap":["pcap","cap","dmp"],"application/vnd.tmobile-livetv":["tmo"],"application/vnd.trid.tpt":["tpt"],"application/vnd.triscape.mxs":["mxs"],"application/vnd.trueapp":["tra"],"application/vnd.ufdl":["ufd","ufdl"],"application/vnd.uiq.theme":["utz"],"application/vnd.umajin":["umj"],"application/vnd.unity":["unityweb"],"application/vnd.uoml+xml":["uoml"],"application/vnd.vcx":["vcx"],"application/vnd.visio":["vsd","vst","vss","vsw"],"application/vnd.visionary":["vis"],"application/vnd.vsf":["vsf"],"application/vnd.wap.wbxml":["wbxml"],"application/vnd.wap.wmlc":["wmlc"],"application/vnd.wap.wmlscriptc":["wmlsc"],"application/vnd.webturbo":["wtb"],"application/vnd.wolfram.player":["nbp"],"application/vnd.wordperfect":["wpd"],"application/vnd.wqd":["wqd"],"application/vnd.wt.stf":["stf"],"application/vnd.xara":["xar"],"application/vnd.xfdl":["xfdl"],"application/vnd.yamaha.hv-dic":["hvd"],"application/vnd.yamaha.hv-script":["hvs"],"application/vnd.yamaha.hv-voice":["hvp"],"application/vnd.yamaha.openscoreformat":["osf"],"application/vnd.yamaha.openscoreformat.osfpvg+xml":["osfpvg"],"application/vnd.yamaha.smaf-audio":["saf"],"application/vnd.yamaha.smaf-phrase":["spf"],"application/vnd.yellowriver-custom-menu":["cmp"],"application/vnd.zul":["zir","zirz"],"application/vnd.zzazz.deck+xml":["zaz"],"application/x-7z-compressed":["7z"],"application/x-abiword":["abw"],"application/x-ace-compressed":["ace"],"application/x-apple-diskimage":["*dmg"],"application/x-arj":["arj"],"application/x-authorware-bin":["aab","x32","u32","vox"],"application/x-authorware-map":["aam"],"application/x-authorware-seg":["aas"],"application/x-bcpio":["bcpio"],"application/x-bdoc":["*bdoc"],"application/x-bittorrent":["torrent"],"application/x-blorb":["blb","blorb"],"application/x-bzip":["bz"],"application/x-bzip2":["bz2","boz"],"application/x-cbr":["cbr","cba","cbt","cbz","cb7"],"application/x-cdlink":["vcd"],"application/x-cfs-compressed":["cfs"],"application/x-chat":["chat"],"application/x-chess-pgn":["pgn"],"application/x-chrome-extension":["crx"],"application/x-cocoa":["cco"],"application/x-conference":["nsc"],"application/x-cpio":["cpio"],"application/x-csh":["csh"],"application/x-debian-package":["*deb","udeb"],"application/x-dgc-compressed":["dgc"],"application/x-director":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"],"application/x-doom":["wad"],"application/x-dtbncx+xml":["ncx"],"application/x-dtbook+xml":["dtb"],"application/x-dtbresource+xml":["res"],"application/x-dvi":["dvi"],"application/x-envoy":["evy"],"application/x-eva":["eva"],"application/x-font-bdf":["bdf"],"application/x-font-ghostscript":["gsf"],"application/x-font-linux-psf":["psf"],"application/x-font-pcf":["pcf"],"application/x-font-snf":["snf"],"application/x-font-type1":["pfa","pfb","pfm","afm"],"application/x-freearc":["arc"],"application/x-futuresplash":["spl"],"application/x-gca-compressed":["gca"],"application/x-glulx":["ulx"],"application/x-gnumeric":["gnumeric"],"application/x-gramps-xml":["gramps"],"application/x-gtar":["gtar"],"application/x-hdf":["hdf"],"application/x-httpd-php":["php"],"application/x-install-instructions":["install"],"application/x-iso9660-image":["*iso"],"application/x-java-archive-diff":["jardiff"],"application/x-java-jnlp-file":["jnlp"],"application/x-latex":["latex"],"application/x-lua-bytecode":["luac"],"application/x-lzh-compressed":["lzh","lha"],"application/x-makeself":["run"],"application/x-mie":["mie"],"application/x-mobipocket-ebook":["prc","mobi"],"application/x-ms-application":["application"],"application/x-ms-shortcut":["lnk"],"application/x-ms-wmd":["wmd"],"application/x-ms-wmz":["wmz"],"application/x-ms-xbap":["xbap"],"application/x-msaccess":["mdb"],"application/x-msbinder":["obd"],"application/x-mscardfile":["crd"],"application/x-msclip":["clp"],"application/x-msdos-program":["*exe"],"application/x-msdownload":["*exe","*dll","com","bat","*msi"],"application/x-msmediaview":["mvb","m13","m14"],"application/x-msmetafile":["*wmf","*wmz","*emf","emz"],"application/x-msmoney":["mny"],"application/x-mspublisher":["pub"],"application/x-msschedule":["scd"],"application/x-msterminal":["trm"],"application/x-mswrite":["wri"],"application/x-netcdf":["nc","cdf"],"application/x-ns-proxy-autoconfig":["pac"],"application/x-nzb":["nzb"],"application/x-perl":["pl","pm"],"application/x-pilot":["*prc","*pdb"],"application/x-pkcs12":["p12","pfx"],"application/x-pkcs7-certificates":["p7b","spc"],"application/x-pkcs7-certreqresp":["p7r"],"application/x-rar-compressed":["rar"],"application/x-redhat-package-manager":["rpm"],"application/x-research-info-systems":["ris"],"application/x-sea":["sea"],"application/x-sh":["sh"],"application/x-shar":["shar"],"application/x-shockwave-flash":["swf"],"application/x-silverlight-app":["xap"],"application/x-sql":["sql"],"application/x-stuffit":["sit"],"application/x-stuffitx":["sitx"],"application/x-subrip":["srt"],"application/x-sv4cpio":["sv4cpio"],"application/x-sv4crc":["sv4crc"],"application/x-t3vm-image":["t3"],"application/x-tads":["gam"],"application/x-tar":["tar"],"application/x-tcl":["tcl","tk"],"application/x-tex":["tex"],"application/x-tex-tfm":["tfm"],"application/x-texinfo":["texinfo","texi"],"application/x-tgif":["obj"],"application/x-ustar":["ustar"],"application/x-virtualbox-hdd":["hdd"],"application/x-virtualbox-ova":["ova"],"application/x-virtualbox-ovf":["ovf"],"application/x-virtualbox-vbox":["vbox"],"application/x-virtualbox-vbox-extpack":["vbox-extpack"],"application/x-virtualbox-vdi":["vdi"],"application/x-virtualbox-vhd":["vhd"],"application/x-virtualbox-vmdk":["vmdk"],"application/x-wais-source":["src"],"application/x-web-app-manifest+json":["webapp"],"application/x-x509-ca-cert":["der","crt","pem"],"application/x-xfig":["fig"],"application/x-xliff+xml":["xlf"],"application/x-xpinstall":["xpi"],"application/x-xz":["xz"],"application/x-zmachine":["z1","z2","z3","z4","z5","z6","z7","z8"],"audio/vnd.dece.audio":["uva","uvva"],"audio/vnd.digital-winds":["eol"],"audio/vnd.dra":["dra"],"audio/vnd.dts":["dts"],"audio/vnd.dts.hd":["dtshd"],"audio/vnd.lucent.voice":["lvp"],"audio/vnd.ms-playready.media.pya":["pya"],"audio/vnd.nuera.ecelp4800":["ecelp4800"],"audio/vnd.nuera.ecelp7470":["ecelp7470"],"audio/vnd.nuera.ecelp9600":["ecelp9600"],"audio/vnd.rip":["rip"],"audio/x-aac":["aac"],"audio/x-aiff":["aif","aiff","aifc"],"audio/x-caf":["caf"],"audio/x-flac":["flac"],"audio/x-m4a":["*m4a"],"audio/x-matroska":["mka"],"audio/x-mpegurl":["m3u"],"audio/x-ms-wax":["wax"],"audio/x-ms-wma":["wma"],"audio/x-pn-realaudio":["ram","ra"],"audio/x-pn-realaudio-plugin":["rmp"],"audio/x-realaudio":["*ra"],"audio/x-wav":["*wav"],"chemical/x-cdx":["cdx"],"chemical/x-cif":["cif"],"chemical/x-cmdf":["cmdf"],"chemical/x-cml":["cml"],"chemical/x-csml":["csml"],"chemical/x-xyz":["xyz"],"image/prs.btif":["btif"],"image/prs.pti":["pti"],"image/vnd.adobe.photoshop":["psd"],"image/vnd.airzip.accelerator.azv":["azv"],"image/vnd.dece.graphic":["uvi","uvvi","uvg","uvvg"],"image/vnd.djvu":["djvu","djv"],"image/vnd.dvb.subtitle":["*sub"],"image/vnd.dwg":["dwg"],"image/vnd.dxf":["dxf"],"image/vnd.fastbidsheet":["fbs"],"image/vnd.fpx":["fpx"],"image/vnd.fst":["fst"],"image/vnd.fujixerox.edmics-mmr":["mmr"],"image/vnd.fujixerox.edmics-rlc":["rlc"],"image/vnd.microsoft.icon":["ico"],"image/vnd.ms-modi":["mdi"],"image/vnd.ms-photo":["wdp"],"image/vnd.net-fpx":["npx"],"image/vnd.tencent.tap":["tap"],"image/vnd.valve.source.texture":["vtf"],"image/vnd.wap.wbmp":["wbmp"],"image/vnd.xiff":["xif"],"image/vnd.zbrush.pcx":["pcx"],"image/x-3ds":["3ds"],"image/x-cmu-raster":["ras"],"image/x-cmx":["cmx"],"image/x-freehand":["fh","fhc","fh4","fh5","fh7"],"image/x-icon":["*ico"],"image/x-jng":["jng"],"image/x-mrsid-image":["sid"],"image/x-ms-bmp":["*bmp"],"image/x-pcx":["*pcx"],"image/x-pict":["pic","pct"],"image/x-portable-anymap":["pnm"],"image/x-portable-bitmap":["pbm"],"image/x-portable-graymap":["pgm"],"image/x-portable-pixmap":["ppm"],"image/x-rgb":["rgb"],"image/x-tga":["tga"],"image/x-xbitmap":["xbm"],"image/x-xpixmap":["xpm"],"image/x-xwindowdump":["xwd"],"message/vnd.wfa.wsc":["wsc"],"model/vnd.collada+xml":["dae"],"model/vnd.dwf":["dwf"],"model/vnd.gdl":["gdl"],"model/vnd.gtw":["gtw"],"model/vnd.mts":["mts"],"model/vnd.opengex":["ogex"],"model/vnd.parasolid.transmit.binary":["x_b"],"model/vnd.parasolid.transmit.text":["x_t"],"model/vnd.usdz+zip":["usdz"],"model/vnd.valve.source.compiled-map":["bsp"],"model/vnd.vtu":["vtu"],"text/prs.lines.tag":["dsc"],"text/vnd.curl":["curl"],"text/vnd.curl.dcurl":["dcurl"],"text/vnd.curl.mcurl":["mcurl"],"text/vnd.curl.scurl":["scurl"],"text/vnd.dvb.subtitle":["sub"],"text/vnd.fly":["fly"],"text/vnd.fmi.flexstor":["flx"],"text/vnd.graphviz":["gv"],"text/vnd.in3d.3dml":["3dml"],"text/vnd.in3d.spot":["spot"],"text/vnd.sun.j2me.app-descriptor":["jad"],"text/vnd.wap.wml":["wml"],"text/vnd.wap.wmlscript":["wmls"],"text/x-asm":["s","asm"],"text/x-c":["c","cc","cxx","cpp","h","hh","dic"],"text/x-component":["htc"],"text/x-fortran":["f","for","f77","f90"],"text/x-handlebars-template":["hbs"],"text/x-java-source":["java"],"text/x-lua":["lua"],"text/x-markdown":["mkd"],"text/x-nfo":["nfo"],"text/x-opml":["opml"],"text/x-org":["*org"],"text/x-pascal":["p","pas"],"text/x-processing":["pde"],"text/x-sass":["sass"],"text/x-scss":["scss"],"text/x-setext":["etx"],"text/x-sfv":["sfv"],"text/x-suse-ymp":["ymp"],"text/x-uuencode":["uu"],"text/x-vcalendar":["vcs"],"text/x-vcard":["vcf"],"video/vnd.dece.hd":["uvh","uvvh"],"video/vnd.dece.mobile":["uvm","uvvm"],"video/vnd.dece.pd":["uvp","uvvp"],"video/vnd.dece.sd":["uvs","uvvs"],"video/vnd.dece.video":["uvv","uvvv"],"video/vnd.dvb.file":["dvb"],"video/vnd.fvt":["fvt"],"video/vnd.mpegurl":["mxu","m4u"],"video/vnd.ms-playready.media.pyv":["pyv"],"video/vnd.uvvu.mp4":["uvu","uvvu"],"video/vnd.vivo":["viv"],"video/x-f4v":["f4v"],"video/x-fli":["fli"],"video/x-flv":["flv"],"video/x-m4v":["m4v"],"video/x-matroska":["mkv","mk3d","mks"],"video/x-mng":["mng"],"video/x-ms-asf":["asf","asx"],"video/x-ms-vob":["vob"],"video/x-ms-wm":["wm"],"video/x-ms-wmv":["wmv"],"video/x-ms-wmx":["wmx"],"video/x-ms-wvx":["wvx"],"video/x-msvideo":["avi"],"video/x-sgi-movie":["movie"],"video/x-smv":["smv"],"x-conference/x-cooltalk":["ice"]};

var mime = new Mime_1(standard, other);

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }


var mime$1 = _interopDefault(mime);
var crypto = _interopDefault(crypto$1);
var path = _interopDefault(path$1);
var fs = _interopDefault(fs$1);

const styles$g = theme => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  imageCenter: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    cursor: 'pointer'
  },
  imageCardCenter: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  imageCard: {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    width: '100%'
  },
  boxItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      paddingBottom: '10%'
    }
  },
  boxItemCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {}
  },
  boxItemRight: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      paddingBottom: '10%'
    }
  },
  boxCard: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignItems: 'center',
    padding: '2%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: 0
    }
  },
  boxCardCenter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: 0
    }
  },
  imageIcon: {
    backgroundColor: 'silver',
    display: 'inline-block',
    height: 0,
    // paddingBottom: '100%',
    // width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

const Card = props => {
  const {
    openLink
  } = props;
  const {
    classes,
    title,
    theme,
    subtitle,
    body,
    images,
    color,
    variant,
    image_width,
    image_ratio,
    image_position,
    positionImage,
    image_alternate_position,
    item_size,
    text_alignment,
    link_to,
    button_title,
    button_style,
    item_spacing,
    onClick,
    itemIndex
  } = props;
  /*
  if (item_size == 'xl' && image_position == 'bottom') {
    return (
      <TitleContentBlock
        {...props}
      />
    )
  }
  */

  const internalOnClick = () => {
    if (link_to) openLink(link_to);else if (onClick) onClick();
  };

  const pageEditContext = useContext(PageEditContext);
  const {
    editMode,
    canEdit,
    selectionLevel,
    selectedItemPath,
    onSelectItem,
    onUpdateSection,
    onUpdateItemValue
  } = pageEditContext;
  let selectedItem = selectedItemPath;
  let imageUrl = null;
  let editControl = null;
  let controlUpload = null;
  let indexItem = itemIndex !== undefined ? itemIndex : '';
  let initialState = {
    title: title || null,
    subtitle: subtitle || null,
    body: body || null,
    button_title: button_title || null,
    link_to: link_to || undefined,
    selectedItemPath: selectedItemPath || undefined,
    itemIndex: indexItem,
    images: images || undefined
  };
  const [formData, setFormData] = useState(initialState);

  const handleChangeForm = (name, value) => {
    setFormData({ ...formData,
      [name]: value
    });
  };

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  if (selectedItem) {
    editControl = /*#__PURE__*/React.createElement(SectionEditText$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        // setNewSectionsData(newSectionData)
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
        onUpdateItemValue(newSectionData, indexItem);
      }
    });
    controlUpload = /*#__PURE__*/React.createElement(SectionImageUpload$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        // setNewSectionsData(newSectionData)
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
        onUpdateItemValue(newSectionData, indexItem);
      }
    });
  }

  const [imageWidth, setWidth] = useState(0);
  const [imageHeight, setHeight] = useState(0);

  if (formValue('images') && formValue('images') !== undefined && formValue('images').length > 0) {
    imageUrl = formValue('images')[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  let imageStyle = [];
  let imageEditStyle = [];
  let itemStyle = [];
  let itemStyleEdit = [];
  let image_height = 100;
  if (image_ratio) image_height = Math.round(100 / image_ratio);
  imageStyle['width'] = image_width + '%' || '100%';
  imageStyle['paddingBottom'] = image_height + '%';
  imageStyle['background'] = 'url("' + imageUrl + '")';
  imageStyle['backgroundPosition'] = 'center';
  imageStyle['backgroundRepeat'] = 'no-repeat';
  imageStyle['backgroundSize'] = 'contain';

  if (text_alignment == 'left') {
    itemStyle['alignItems'] = 'flex-start';
    itemStyle['textAlign'] = 'left';
    itemStyleEdit['alignItems'] = 'initial';
    itemStyleEdit['textAlign'] = 'left';
  } else if (text_alignment == 'right') {
    itemStyle['alignItems'] = 'flex-end';
    itemStyle['textAlign'] = 'right';
    itemStyleEdit['alignItems'] = 'initial';
    itemStyleEdit['textAlign'] = 'right';
  } else {
    itemStyle['alignItems'] = 'center';
    itemStyle['textAlign'] = 'center';
    itemStyleEdit['alignItems'] = 'initial';
    itemStyleEdit['textAlign'] = 'center';
  }

  imageEditStyle['width'] = image_width + '%' || '100%';

  const EditableCard = ({
    editMode,
    children
  }) => {
    if (editMode) {
      return children;
    } else {
      return children; // Temporarily disabled for Sieva
    }
  }; // itemStyle['padding'] = item_spacing+'%'


  if (image_position === 'right') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditableCard, _extends({}, props, {
      editMode: editMode
    }), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxItemRight
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCard,
      style: {
        textAlign: text_alignment
      }
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == (indexItem !== '' ? indexItem + '/title' : 'title'),
      onSelect: () => onSelectItem(indexItem !== '' ? indexItem + '/title' : 'title'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('title'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Title]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: title,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'subtitle',
      onSelect: () => onSelectItem('subtitle'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('subtitle'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: subtitle,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'body',
      onSelect: () => onSelectItem('body'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('body'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Body]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: body,
      color: color,
      theme: theme
    })), link_to && button_title && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      className: classes.btnTitle,
      onClick: internalOnClick
    }, button_title)), link_to === undefined && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3,
      style: {
        width: '100%'
      }
    }, canEdit && /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel - 1
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Button]")))), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCard
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'images',
      onSelect: () => onSelectItem('images'),
      control: controlUpload,
      level: selectionLevel + 1
    }, imageUrl ? /*#__PURE__*/React.createElement(Box, {
      className: classes.imageCenter
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageEditStyle
    })) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Image]")) : /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
      className: classes.imageCenter,
      onClick: internalOnClick
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageEditStyle
    })))))));
  } else if (image_position === 'left') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditableCard, _extends({}, props, {
      editMode: editMode
    }), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxItem
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCard
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'images',
      onSelect: () => onSelectItem('images'),
      control: controlUpload,
      level: selectionLevel + 1
    }, imageUrl ? /*#__PURE__*/React.createElement(Box, {
      className: classes.imageCenter
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageEditStyle
    })) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Image]")) : /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
      className: classes.imageCenter,
      onClick: internalOnClick
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageEditStyle
    })))), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCard,
      style: {
        textAlign: text_alignment
      }
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'title',
      onSelect: () => onSelectItem('title'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('title'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Title]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: title,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'subtitle',
      onSelect: () => onSelectItem('subtitle'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('subtitle'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: subtitle,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'body',
      onSelect: () => onSelectItem('body'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('body'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Body]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: body,
      color: color,
      theme: theme
    })), link_to && button_title && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel + 2
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      className: classes.btnTitle,
      onClick: internalOnClick
    }, button_title)) : /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      className: classes.btnTitle,
      onClick: internalOnClick
    }, button_title)), link_to === undefined && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 4,
      style: {
        width: '100%'
      }
    }, canEdit && /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel - 1
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Button]")))))));
  } else if (image_position === 'bottom') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditableCard, _extends({}, props, {
      editMode: editMode
    }), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxItemCenter
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCardCenter,
      style: canEdit ? itemStyleEdit : itemStyle
    }, (canEdit || title) && /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'title',
      onSelect: () => onSelectItem('title'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('title'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Title]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: title,
      color: color,
      theme: theme
    })), (canEdit || subtitle) && /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'subtitle',
      onSelect: () => onSelectItem('subtitle'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('subtitle'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: subtitle,
      color: color,
      theme: theme
    })), (canEdit || body) && /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'body',
      onSelect: () => onSelectItem('body'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('body'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Body]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: body,
      color: color,
      theme: theme
    })), link_to && button_title && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      className: classes.btnTitle,
      onClick: internalOnClick
    }, button_title)), link_to === undefined && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3,
      style: {
        width: '100%'
      }
    }, canEdit && /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel - 1
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Button]"))))), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCardCenter,
      style: canEdit ? itemStyleEdit : itemStyle
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'images',
      onSelect: () => onSelectItem('images'),
      control: controlUpload,
      level: selectionLevel + 1
    }, imageUrl ? /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      style: imageEditStyle,
      className: classes.imageCard
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Image]")) : /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
      mt: 2,
      className: classes.imageIcon,
      style: imageStyle,
      onClick: internalOnClick
    }))))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditableCard, _extends({}, props, {
      editMode: editMode
    }), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxItemCenter
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCardCenter,
      style: canEdit ? itemStyleEdit : itemStyle
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'images',
      onSelect: () => onSelectItem('images'),
      control: controlUpload,
      level: selectionLevel + 1
    }, imageUrl ? /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      style: imageEditStyle,
      className: classes.imageCard
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Image]")) : /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
      mb: 2,
      className: classes.imageIcon,
      style: imageStyle,
      onClick: internalOnClick
    }))), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCardCenter,
      style: canEdit ? itemStyleEdit : itemStyle
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'title',
      onSelect: () => onSelectItem('title'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('title'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Title]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: title,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'subtitle',
      onSelect: () => onSelectItem('subtitle'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('subtitle'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: subtitle,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'body',
      onSelect: () => onSelectItem('body'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('body'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Body]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: body,
      color: color,
      theme: theme
    })), link_to && button_title && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      className: classes.btnTitle,
      onClick: internalOnClick
    }, button_title)), link_to === undefined && /*#__PURE__*/React.createElement(Box, {
      align: text_alignment,
      mt: 3,
      style: {
        width: '100%'
      }
    }, canEdit && /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel - 1
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Button]"))))))));
  }
};

var Card$1 = withStyles(styles$g, {
  withTheme: true
})(Card);

const styles$h = theme => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  imageCenter: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  imageCard: {
    maxHeight: '100%',
    // maxWidth:'100%',
    objectFit: 'contain'
  },
  relativePosition: {
    position: 'relative'
  },
  imageRight: {
    position: 'absolute',
    left: '-20%',
    width: '120%'
  },
  imageLeft: {
    position: 'absolute',
    width: '120%'
  },
  cardText: {
    zIndex: 1,
    height: '75vh'
  },
  detailCard: {
    padding: '10%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    // zIndex: 1,
    background: '#f0f0f0'
  },
  boxItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse'
    }
  },
  boxItemLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  boxCollage: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '5%',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  }
});

const Collage = props => {
  const {
    openLink
  } = props;
  const {
    classes,
    title,
    theme,
    subtitle,
    body,
    images,
    color,
    variant,
    image_width,
    item_spacing,
    image_position,
    positionImage,
    image_alternate_position,
    item_size,
    text_alignment,
    link_to,
    button_title,
    button_style,
    itemIndex
  } = props;
  let editControl = null;
  let controlUpload = null;
  const pageEditContext = useContext(PageEditContext);
  const {
    editMode,
    canEdit,
    selectionLevel,
    selectedItemPath,
    onSelectItem,
    onUpdateSection,
    onUpdateItemValue
  } = pageEditContext;
  let indexItem = itemIndex !== undefined ? itemIndex : '';
  const selectedItem = selectedItemPath;
  let initialState = {
    title: title || null,
    subtitle: subtitle || null,
    body: body || null,
    button_title: button_title || null,
    link_to: link_to || null,
    selectedItemPath: selectedItemPath || undefined,
    itemIndex: indexItem,
    images: images || undefined
  };
  const [formData, setFormData] = useState(initialState);

  const handleChangeForm = (name, value) => {
    setFormData({ ...formData,
      [name]: value
    });
  };

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  if (selectedItem) {
    editControl = /*#__PURE__*/React.createElement(SectionEditText$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        // setNewSectionsData(newSectionData)
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
        onUpdateItemValue(newSectionData, indexItem);
      }
    });
    controlUpload = /*#__PURE__*/React.createElement(SectionImageUpload$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        // setNewSectionsData(newSectionData)
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
        onUpdateItemValue(newSectionData, indexItem);
      }
    });
  }

  let imageUrl = null;

  if (formValue('images') && formValue('images') !== undefined && formValue('images').length > 0) {
    imageUrl = formValue('images')[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let imageBox = [];
  let imageBoxEdit = [];
  let detailText = [];
  let imageMobileStyle = [];

  if (!editMode) {
    detailText['zIndex'] = 1;
  }

  if (smUp) {
    // if(item_spacing){
    //   imageBox['position'] = 'inherit'
    //   imageMobileStyle['width'] = (image_width+item_spacing)+'%' || '125%'
    //   if(positionImage === 'right'){
    //     imageBox['left'] = (item_spacing*-1)+'%'
    //   }
    // }else{
    imageBox['position'] = 'inherit';
    imageBoxEdit['position'] = 'relative';
    imageMobileStyle['width'] = '125%';

    if (positionImage === 'right') {
      imageBox['left'] = '-25%';
      imageBoxEdit['left'] = '-25%';
    } // }

  } else {
    // if(item_spacing){
    //   imageBox['width'] = (image_width+item_spacing)+'%' || '100%'
    //   if(positionImage === 'right'){
    //     imageBox['margin-left'] = item_spacing+'%'
    //     detailText['margin-top'] = (item_spacing*-1)+'%'
    //   }else{
    //     imageBox['margin-left'] =(item_spacing*-1)+'%'
    //     detailText['margin-top'] = (item_spacing*-1)+'%'
    //   }
    // }else{
    imageBox['width'] = '100%';
    imageBoxEdit['width'] = '100%';

    if (positionImage === 'right') {
      imageBox['margin-left'] = '20%';
      imageBoxEdit['margin-left'] = '20%';
      detailText['margin-top'] = '-20%';
      detailText['margin-right'] = '10%';
      imageMobileStyle['width'] = '90%';
    } else {
      // imageStyle['margin-left'] = '-20%'
      detailText['margin-top'] = '-20%';
      detailText['margin-left'] = '10%';
      imageMobileStyle['width'] = '90%';
    } // }

  }

  const EditableCollage = ({
    editMode,
    children
  }) => {
    if (editMode) {
      return children;
    } else {
      // Tempoararily disabled. It cause flashing on Sieva project
      return children;
    }
  }; // if(item_size === 'xl'){


  if (positionImage === 'left') {
    return /*#__PURE__*/React.createElement(EditableCollage, _extends({}, props, {
      editMode: editMode
    }), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxItemLeft
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCollage
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'images',
      onSelect: () => onSelectItem('images'),
      control: controlUpload,
      level: selectionLevel + 1
    }, imageUrl ? /*#__PURE__*/React.createElement(Box, {
      style: imageBox
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageMobileStyle
    })) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Image]")) : /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
      style: imageBox
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageMobileStyle
    })))), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCollage
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.detailCard,
      style: detailText
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'title',
      onSelect: () => onSelectItem('title'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('title'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Title]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: title,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'subtitle',
      onSelect: () => onSelectItem('subtitle'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('subtitle'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: subtitle,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'body',
      onSelect: () => onSelectItem('body'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('body'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Body]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: body,
      color: color,
      theme: theme
    })), link_to && link_to !== undefined && /*#__PURE__*/React.createElement(Box, {
      align: "center",
      mt: 4
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      onClick: () => openLink(link_to)
    }, button_title)), link_to === undefined && canEdit && /*#__PURE__*/React.createElement(Box, {
      align: "center",
      mt: 3,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel - 1
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Button]")))))));
  } else {
    return /*#__PURE__*/React.createElement(EditableCollage, _extends({}, props, {
      editMode: editMode
    }), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxItem
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCollage
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.detailCard,
      style: detailText
    }, /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'title',
      onSelect: () => onSelectItem('title'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('title') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('title'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Title]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: title,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'subtitle',
      onSelect: () => onSelectItem('subtitle'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('subtitle') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('subtitle'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Subtitle]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: subtitle,
      color: color,
      theme: theme
    })), /*#__PURE__*/React.createElement(Box, {
      style: {
        width: '100%'
      }
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'body',
      onSelect: () => onSelectItem('body'),
      control: editControl,
      level: selectionLevel + 2
    }, formValue('body') ? /*#__PURE__*/React.createElement(Markdown$1, {
      source: formValue('body'),
      variant: "body",
      color: color
    }) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Body]")) : /*#__PURE__*/React.createElement(Markdown$1, {
      source: body,
      color: color,
      theme: theme
    })), link_to && link_to !== undefined && /*#__PURE__*/React.createElement(Box, {
      align: "center",
      mt: 4
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: button_style,
      onClick: () => openLink(link_to)
    }, button_title)), link_to === undefined && canEdit && /*#__PURE__*/React.createElement(Box, {
      align: "center",
      mt: 3,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'button_title',
      onSelect: () => onSelectItem('button_title'),
      control: editControl,
      level: selectionLevel - 1
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Button]"))))), /*#__PURE__*/React.createElement(Box, {
      className: classes.boxCollage
    }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
      selected: selectedItem == 'images',
      onSelect: () => onSelectItem('images'),
      control: controlUpload,
      level: selectionLevel + 1
    }, imageUrl ? /*#__PURE__*/React.createElement(Box, {
      style: imageBoxEdit
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageMobileStyle
    })) : /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, "[Add Image]")) : /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
      style: imageBox
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      className: classes.imageCard,
      style: imageMobileStyle
    }))))));
  } // }

};

var Collage$1 = withStyles(styles$h, {
  withTheme: true
})(Collage);

const variantMaps = {
  Card: Card$1,
  Collage: Collage$1
};

const ImageContentBlock = props => {
  const {
    variant
  } = props;
  let comp;
  if (variant in variantMaps) comp = variantMaps[variant];else comp = variantMaps['Card'];
  return React.createElement(comp, { ...props
  });
};

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$2(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var circle = createCommonjsModule$2(function (module, exports) {
var __extends = (commonjsGlobal$1 && commonjsGlobal$1.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });

var react_1 = React;
var radius = 175;
var diameter = Math.round(Math.PI * radius * 2);
var getOffset = function (val) {
    if (val === void 0) { val = 0; }
    return Math.round((100 - val) / 100 * diameter);
};
var Circle = (function (_super) {
    __extends(Circle, _super);
    function Circle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Circle.prototype, "text", {
        get: function () {
            var _a = this.props, progress = _a.progress, showPercentage = _a.showPercentage, textColor = _a.textColor, textStyle = _a.textStyle, percentSpacing = _a.percentSpacing, showPercentageSymbol = _a.showPercentageSymbol;
            if (!showPercentage)
                return;
            return (React.createElement("text", { style: textStyle, fill: textColor, x: "50%", y: "50%", dx: "-25", textAnchor: "middle" },
                progress,
                showPercentageSymbol && React.createElement("tspan", { dx: percentSpacing }, "%")));
        },
        enumerable: true,
        configurable: true
    });
    Circle.prototype.render = function () {
        var text = this.text;
        var _a = this.props, progress = _a.progress, size = _a.size, bgColor = _a.bgColor, progressColor = _a.progressColor, lineWidth = _a.lineWidth, animate = _a.animate, animationDuration = _a.animationDuration, roundedStroke = _a.roundedStroke, responsive = _a.responsive, onAnimationEnd = _a.onAnimationEnd;
        var strokeDashoffset = getOffset(progress);
        var transition = animate ? "stroke-dashoffset " + animationDuration + " ease-out" : null;
        var strokeLinecap = roundedStroke ? 'round' : 'butt';
        var svgSize = responsive ? '100%' : size;
        return (React.createElement("svg", { width: svgSize, height: svgSize, viewBox: "-25 -25 400 400" },
            React.createElement("circle", { stroke: bgColor, cx: "175", cy: "175", r: "175", strokeWidth: lineWidth, fill: "none" }),
            React.createElement("circle", { stroke: progressColor, transform: "rotate(-90 175 175)", cx: "175", cy: "175", r: "175", strokeDasharray: "1100", strokeWidth: lineWidth, strokeDashoffset: "1100", strokeLinecap: strokeLinecap, fill: "none", style: { strokeDashoffset: strokeDashoffset, transition: transition }, onTransitionEnd: onAnimationEnd }),
            text));
    };
    Circle.defaultProps = {
        progress: 0,
        animate: true,
        animationDuration: '1s',
        showPercentage: true,
        showPercentageSymbol: true,
        progressColor: 'rgb(76, 154, 255)',
        bgColor: '#ecedf0',
        textColor: '#6b778c',
        size: '100',
        lineWidth: '25',
        percentSpacing: 10,
        textStyle: { font: 'bold 4rem Helvetica, Arial, sans-serif' }
    };
    return Circle;
}(react_1.Component));
exports.Circle = Circle;
});

unwrapExports$1(circle);
var circle_1 = circle.Circle;

var dist = createCommonjsModule$2(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = circle.Circle;
__export(circle);
});

var Circle = unwrapExports$1(dist);

const styles$i = theme => ({
  item: {
    display: 'flex',
    flexDirection: 'column' // alignItems: 'center',
    //    padding: theme.spacing(0, 3),

  },
  btnStyle: {
    textTransform: 'none',
    fontSize: theme.typography.h6.fontSize
  },
  btnTitle: {
    zIndex: 1
  },
  noPadding: {
    padding: 0
  }
});

const SocialMediaContentBlock = ({
  classes,
  theme,
  openLink,
  children,
  title,
  subtitle,
  body,
  images,
  color,
  color_type,
  image_width,
  image_position,
  text_alignment,
  button_title,
  button_style,
  link_to,
  item_spacing
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Box, {
    align: text_alignment
  }, link_to !== undefined && /*#__PURE__*/React.createElement("a", {
    href: link_to,
    color: "inherit"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.noPadding
  }, link_to.includes('facebook') && /*#__PURE__*/React.createElement(FacebookIcon, null), link_to.includes('twitter') && /*#__PURE__*/React.createElement(TwitterIcon, null), link_to.includes('linkedin') && /*#__PURE__*/React.createElement(LinkedInIcon, null), link_to.includes('instagram') && /*#__PURE__*/React.createElement(InstagramIcon, null)))));
};

var SocialMediaContentBlock$1 = withStyles(styles$i, {
  withTheme: true
})(SocialMediaContentBlock);

const styles$j = theme => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  btnStyle: {
    textTransform: 'none',
    fontSize: theme.typography.h6.fontSize
  },
  btnTitle: {
    zIndex: 1
  }
});

const ProgressContentBlock = props => {
  const {
    classes,
    theme,
    openLink,
    children,
    title,
    subtitle,
    body,
    images,
    color,
    color_type,
    image_width,
    image_position,
    text_alignment,
    button_title,
    button_style,
    link_to,
    item_spacing,
    editMode = false,
    canEdit,
    selectedItemPath,
    onSelectItem,
    itemIndex
  } = props;
  let indexItem = itemIndex !== undefined ? itemIndex : '';
  let imageUrl = null;
  let imageStyle = [];
  let itemStyle = [];
  let editControl = null;
  let initialState = {
    title: title || null,
    subtitle: subtitle || null,
    body: body || null,
    button_title: button_title || null,
    link_to: link_to || null,
    selectedItemPath: selectedItemPath || undefined,
    itemIndex: indexItem
  };
  const [formData, setFormData] = useState(initialState);
  const selectedItem = selectedItemPath;

  const handleChangeForm = (name, value) => {
    setFormData({ ...formData,
      [name]: value
    });
  };

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  if (selectedItem) {
    editControl = /*#__PURE__*/React.createElement(SectionEditText$1, {
      sectionData: initialState,
      onEdit: newSectionData => {
        // setNewSectionsData(newSectionData)
        handleChangeForm(selectedItem.replace(/[0-9]\//g, ''), newSectionData[selectedItem.replace(/[0-9]\//g, '')]);
      }
    });
  }

  let smUp = useMediaQuery(theme.breakpoints.up('sm'));

  if (images && images !== undefined && images.length > 0) {
    imageStyle['width'] = image_width ? image_width + '%' : '100%';
    imageUrl = images[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  if (text_alignment === 'left') {
    itemStyle['alignItems'] = 'flex-start';
  } else if (text_alignment === 'right') {
    itemStyle['alignItems'] = 'flex-end';
  } else {
    itemStyle['alignItems'] = 'center';
  } // if(smUp){
  //   itemStyle['padding'] = '0 '+item_spacing+'%'
  // }else{
  //   itemStyle['padding'] = item_spacing+'% 0'
  // }


  let percentage = title ? title.match(/\d/g).join("") : 100;
  let textColor;
  let progressColor;
  let backgroundColor;
  let size;

  if (color === '#fff') {
    textColor = '#eee';
    backgroundColor = '#333';
    progressColor = '#eee';
  } else if (color === '#000') {
    textColor = '#000';
    backgroundColor = '#ddd';
    progressColor = '#000';
  } else {
    textColor = '#fff';
    backgroundColor = '#333';
    progressColor = '#fff';
  }

  if (smUp) {
    size = '200';
  } else {
    size = '100';
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.item,
    style: itemStyle
  }, /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement(Box, {
    align: text_alignment
  }, title && /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == (indexItem !== '' ? indexItem + '/title' : 'title'),
    onClick: () => onSelectItem(indexItem !== '' ? indexItem + '/title' : 'title'),
    control: editControl,
    level: 2
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('title') ? formValue('title') : "Write Here...",
    variant: "body",
    color: color
  })) : /*#__PURE__*/React.createElement(Circle, {
    progress: percentage,
    responsive: false,
    animate: true,
    roundedStroke: false,
    size: size,
    progressColor: progressColor,
    bgColor: backgroundColor,
    textColor: textColor,
    lineWidth: '30',
    textStyle: {
      font: 'bold 5rem Helvetica, Arial, sans-serif'
    }
  })) // <Markdown source={ title } variant='body' color={color}/>
  , /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == (indexItem !== '' ? indexItem + '/subtitle' : 'subtitle'),
    onClick: () => onSelectItem(indexItem !== '' ? indexItem + '/subtitle' : 'subtitle'),
    control: editControl,
    level: 2
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('subtitle') ? formValue('subtitle') : "Write Here...",
    variant: "body",
    color: color
  })) : /*#__PURE__*/React.createElement(Markdown$1, {
    source: subtitle,
    variant: "body",
    color: color
  })), /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, canEdit ? /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItem == (indexItem !== '' ? indexItem + '/body' : 'body'),
    onClick: () => onSelectItem(indexItem !== '' ? indexItem + '/body' : 'body'),
    control: editControl,
    level: 2
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: formValue('body') ? formValue('body') : "Write Here...",
    variant: "body",
    color: color
  })) : /*#__PURE__*/React.createElement(Markdown$1, {
    source: body,
    variant: "body",
    color: color
  })), imageUrl && /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: classes.imageCenter,
    style: imageStyle
  })))), children && /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, Array.isArray(children) ? /*#__PURE__*/React.createElement(React.Fragment, null, children.map(c => c)) : /*#__PURE__*/React.createElement(React.Fragment, null, children)), link_to && link_to !== undefined && /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    mt: 4
  }, /*#__PURE__*/React.createElement(Button$1, {
    style: button_style,
    className: classes.btnTitle,
    onClick: () => openLink(link_to)
  }, button_title))));
};

var ProgressContentBlock$1 = withStyles(styles$j, {
  withTheme: true
})(ProgressContentBlock);

const styles$k = theme => ({
  storyCard: {
    flexGrow: 1,
    width: '100%'
  },
  storyPaper: {
    padding: 0,
    margin: 'auto',
    maxWidth: 500
  },
  storyMedia: {
    width: '100%',
    padding: 0
  },
  storyContent: {
    width: '100%',
    padding: theme.spacing.unit * 2
  },
  storyCategory: {
    color: '#aaa',
    fontWeight: 800,
    textTransform: 'uppercase'
  },
  storyTitle: {
    fontWeight: 800
  },
  storyLead: {},
  storyLikes: {
    color: '#888',
    fontWeight: 400
  },
  storyDate: {
    color: '#aaa',
    fontSize: '.75rem'
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%'
  }
});

const BlogItem = ({
  classes,
  title,
  lead_paragraph,
  created_at,
  total_view,
  images,
  category,
  onClick
}) => {
  let publishDate = moment(created_at).fromNow(true);
  let likes = "0 Views";
  if (total_view !== undefined) likes = total_view + " Views"; // + " - 0 Comments"

  return /*#__PURE__*/React.createElement(Card$2, {
    className: classes.storyCard,
    elevation: 16
  }, /*#__PURE__*/React.createElement(CardActionArea$1, {
    onClick: onClick
  }, images && images !== undefined && images.length == 999 && /*#__PURE__*/React.createElement(CardMedia, {
    component: "img",
    className: classes.storyImage,
    image: images[0]['image_url']
  }), images && images !== undefined && images.length > 0 && /*#__PURE__*/React.createElement(ImagesSlider$1, {
    images: images,
    imageAspectRatio: 1
  }), /*#__PURE__*/React.createElement(CardContent$1, {
    className: classes.storyContent
  }, /*#__PURE__*/React.createElement(Grid$2, {
    container: true
  }, category && category !== undefined && /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.storyCategory,
    variant: "body2"
  }, category.name)), publishDate && /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 4,
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.storyDate,
    variant: "body2",
    align: "right"
  }, publishDate))), title && title !== undefined && /*#__PURE__*/React.createElement(Typography, {
    className: classes.storyTitle,
    variant: "h5"
  }, title), lead_paragraph !== undefined && lead_paragraph && /*#__PURE__*/React.createElement(Typography, {
    className: classes.storyLead,
    variant: "h5"
  }, lead_paragraph), likes && /*#__PURE__*/React.createElement(Typography, {
    className: classes.storyLikes,
    variant: "body2",
    style: {
      display: 'inline-block'
    }
  }, likes))));
};

BlogItem.propTypes = {
  classes: PropTypes.object.isRequired
};
var BlogItem$1 = withStyles(styles$k)(BlogItem);

const contentBlockMaps = {
  TitleContentBlock: TitleContentBlock$1,
  ImageContentBlock: ImageContentBlock,
  ProgressContentBlock: ProgressContentBlock$1,
  SocialMediaContentBlock: SocialMediaContentBlock$1,
  BlogItem: BlogItem$1
};

const styles$l = theme => ({
  root: {
    //    backgroundColor: theme.palette.common.white,
    //    color: theme.palette.common.white,
    //    color: theme.palette.common.black, 
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {//      minHeight: 500,
      //      maxHeight: 1300,
    }
  },
  container: {
    // marginTop: theme.spacing(6),
    //    marginBottom: theme.spacing(14),
    // marginBottom: theme.spacing(6),
    display: 'block',
    flexDirection: 'column',
    alignItems: 'center'
  },
  backdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    //    backgroundColor: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    opacity: 0.4,
    zIndex: -1
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    zIndex: -2
  },
  arrowDown: {
    position: 'absolute',
    bottom: theme.spacing(4)
  }
});

function Layout(props) {
  const {
    backgroundClassName,
    backgroundStyle,
    fullHeight,
    dark = false,
    children,
    classes,
    theme,
    sectionWidth
  } = props;
  let backdropStyle = {};
  let rootStyle = {};
  let containerStyle = {};
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));

  if (backgroundStyle['color'] === 'dark') {
    if ('backgroundImage' in backgroundStyle) {
      backdropStyle['backgroundColor'] = theme.sectionPalette.dark.background;
      backdropStyle['opacity'] = backgroundStyle['overlayOpacity'] / 100;
    } else {
      rootStyle['color'] = theme.sectionPalette.dark.contrastText;
      rootStyle['backgroundColor'] = theme.sectionPalette.dark.background;
      rootStyle['opacity'] = 1;
    }
  } else if (backgroundStyle['color'] === 'accent') {
    if ('backgroundImage' in backgroundStyle) {
      backdropStyle['backgroundColor'] = theme.sectionPalette.accent.background;
      backdropStyle['opacity'] = backgroundStyle['overlayOpacity'] / 100;
    } else {
      rootStyle['color'] = theme.sectionPalette.accent.contrastText;
      rootStyle['backgroundColor'] = theme.sectionPalette.accent.background;
      rootStyle['opacity'] = 1;
    }
  } else if (backgroundStyle['color'] === 'light') {
    if ('backgroundImage' in backgroundStyle) {
      backdropStyle['backgroundColor'] = theme.sectionPalette.light.background;
      backdropStyle['opacity'] = backgroundStyle['overlayOpacity'] / 100;
    } else {
      rootStyle['color'] = theme.sectionPalette.light.contrastText;
      rootStyle['backgroundColor'] = theme.sectionPalette.light.background;
      rootStyle['opacity'] = 1;
    }
  } else if (backgroundStyle['color'] === 'white') {
    if ('backgroundImage' in backgroundStyle) {
      backdropStyle['backgroundColor'] = theme.sectionPalette.white.background;
      backdropStyle['opacity'] = backgroundStyle['overlayOpacity'] / 100;
    } else {
      rootStyle['color'] = theme.sectionPalette.white.contrastText;
      rootStyle['backgroundColor'] = theme.sectionPalette.white.background;
      rootStyle['opacity'] = 1;
    }
  } else {
    if ('backgroundImage' in backgroundStyle) {
      backdropStyle['backgroundColor'] = theme.sectionPalette.black.background;
      backdropStyle['opacity'] = backgroundStyle['overlayOpacity'] / 100;
    } else {
      rootStyle['color'] = theme.sectionPalette.black.contrastText;
      rootStyle['backgroundColor'] = theme.sectionPalette.black.background;
      rootStyle['opacity'] = 1;
    }
  } // if (fullHeight)
  //   rootStyle['minHeight'] = '100vh'


  rootStyle['minHeight'] = backgroundStyle['sectionHeight'] + 'vh';
  containerStyle['marginTop'] = backgroundStyle['marginHeight'] + 'pt';
  containerStyle['marginBottom'] = backgroundStyle['marginHeight'] + 'pt';

  if (backgroundStyle['sectionWidth'] === 'inset') {
    rootStyle['margin'] = '5%';
  } else if (backgroundStyle['sectionWidth'] === 'full_text') {
    if (mdUp) {
      containerStyle['paddingLeft'] = 180;
      containerStyle['paddingRight'] = 180;
    }
  }

  if (backgroundStyle['verticalAlignment'] === 'top') {
    rootStyle['alignItems'] = 'flex-start';
  } else if (backgroundStyle['verticalAlignment'] === 'bottom') {
    rootStyle['alignItems'] = 'flex-end';
  } else {
    rootStyle['alignItems'] = 'center';
  }

  if (backgroundStyle['horizontalAlignment'] === 'left') {
    rootStyle['justifyContent'] = 'flex-start';
  } else if (backgroundStyle['horizontalAlignment'] === 'right') {
    rootStyle['justifyContent'] = 'flex-end';
  } else {
    rootStyle['justifyContent'] = 'center';
  } // containerStyle['padding'] = 0


  return /*#__PURE__*/React.createElement("section", {
    id: props.id,
    className: classes.root,
    style: rootStyle
  }, /*#__PURE__*/React.createElement(Container, {
    className: classes.container,
    style: containerStyle
  }, children, /*#__PURE__*/React.createElement("div", {
    className: classes.backdrop,
    style: backdropStyle
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.background, backgroundClassName),
    style: backgroundStyle
  })));
}

Layout.propTypes = {
  backgroundClassName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired
};
var Layout$1 = withStyles(styles$l, {
  withTheme: true
})(Layout);

//  'https://images.unsplash.com/photo-1534854638093-bada1813ca19?auto=format&fit=crop&w=1400&q=80'

const styles$m = theme => ({
  background: {
    //    backgroundImage: `url(${backgroundImage})`,
    //    backgroundColor: '#7fc7d9', // Average color of the background image.
    backgroundPosition: 'center'
  },
  imageSide: {
    width: '100%'
  },
  imageCenter: {
    width: '100%' //    [theme.breakpoints.up('sm')]: {
    //      width: '50%',
    //    },
    //    [theme.breakpoints.down('sm')]: {    
    //      marginLeft: theme.spacing(-2),
    //      width: 'calc(100% + 32px)'
    //    }

  },
  button: {
    minWidth: 200
  },
  h5: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(10)
    }
  },
  more: {
    marginTop: theme.spacing(2)
  },
  imageDiv: {
    width: '54%'
  },
  spacingDiv: {
    width: '6%'
  },
  contentDiv: {
    width: '40%'
  }
});

const Section = props => {
  const {
    theme,
    classes,
    key,
    sectionIndex,
    openLink,
    createContentBlock,
    children,
    isCarouselItem
  } = props;
  const pageEditContext = useContext(PageEditContext); // Section attributes

  const {
    color,
    section_height,
    content_width,
    vertical_alignment,
    horizontal_alignment,
    section_width,
    overlay_opacity,
    background_images,
    item_spacing
  } = props; // Default section content. Will be send to TitleContentBlock

  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let textColor;

  if (color === 'dark') {
    textColor = theme.sectionPalette.dark.contrastText;
  } else if (color === 'accent') {
    textColor = theme.sectionPalette.accent.contrastText;
  } else if (color === 'light') {
    textColor = theme.sectionPalette.light.contrastText;
  } else if (color === 'white') {
    textColor = theme.sectionPalette.white.contrastText;
  } else {
    textColor = theme.sectionPalette.black.contrastText;
  }

  const contentData = {
    title: props.title,
    subtitle: props.subtitle,
    body: props.body,
    images: props.images,
    link_to: props.link_to,
    button_title: props.button_title,
    button_style: props.button_style,
    text_alignment: props.text_alignment,
    animation: props.animation,
    image_position: props.image_position,
    image_width: props.image_width,
    colorType: props.color || 'white',
    color: textColor,
    item_spacing: item_spacing
  };
  let containerStyle = {
    'display': 'flex'
  };
  if (horizontal_alignment && horizontal_alignment == 'left') containerStyle['justifyContent'] = 'flex-start';else if (horizontal_alignment && horizontal_alignment == 'right') containerStyle['justifyContent'] = 'flex-end';else containerStyle['justifyContent'] = 'center';

  if (!smUp) {
    // Add additional padding for Carousel
    if (isCarouselItem) {
      containerStyle['paddingLeft'] = theme.spacing(2);
      containerStyle['paddingRight'] = theme.spacing(2);
    }
  }

  let contentStyle = {};

  if (content_width && content_width > 0) {
    if (smUp) contentStyle['width'] = `${content_width}%`;else contentStyle['width'] = '100%'; // contentStyle['width'] = `${Math.max(Math.min(content_width * 1.5, 100), 60)}%`
  } else contentStyle['width'] = '100%'; //  if(selectedItemPath){
  //    contentStyle['zIndex'] = 1000
  //  }


  let backgroundStyle = {};
  let backgroundImageUrl = null;

  if (background_images && background_images !== undefined && background_images.length > 0) {
    backgroundImageUrl = background_images[0].image_url;
    if (backgroundImageUrl.startsWith("/")) backgroundImageUrl = "http://178.128.86.10:8000" + backgroundImageUrl;
    backgroundStyle['backgroundImage'] = `url(${backgroundImageUrl})`;
  }

  backgroundStyle['color'] = color || 'white';
  backgroundStyle['marginHeight'] = 100 * section_height / 100 || 100 * (66 / 100);
  backgroundStyle['sectionHeight'] = section_height || 66;
  backgroundStyle['contentWidth'] = content_width || '100%';
  backgroundStyle['verticalAlignment'] = vertical_alignment || 'center';
  backgroundStyle['horizontalAlignment'] = horizontal_alignment || 'center';
  backgroundStyle['sectionWidth'] = section_width || 'full_bleed';
  backgroundStyle['overlayOpacity'] = overlay_opacity || 20;
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));
  return /*#__PURE__*/React.createElement(Layout$1, {
    id: 'section-' + (sectionIndex + 1),
    backgroundClassName: classes.background,
    dark: color == 'dark',
    fullHeight: sectionIndex == 0 ? true : false,
    backgroundStyle: backgroundStyle
  }, backgroundImageUrl &&
  /*#__PURE__*/

  /* Increase the network loading priority of the background image. */
  React.createElement("img", {
    style: {
      display: 'none'
    },
    src: backgroundImageUrl,
    alt: ""
  }), sectionIndex == 0 && /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }), /*#__PURE__*/React.createElement("div", {
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: contentStyle
  }, /*#__PURE__*/React.createElement(TitleContentBlock$1, _extends({}, contentData, {
    openLink: openLink
  }), children && /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    mb: 2
  }, Array.isArray(children) ? /*#__PURE__*/React.createElement(React.Fragment, null, children.map(c => c)) : /*#__PURE__*/React.createElement(React.Fragment, null, children))))));
};

Section.propTypes = {
  classes: PropTypes.object.isRequired
};
var Section$1 = withStyles(styles$m, {
  withTheme: true
})(Section);

const TitleSection = props => {
  return /*#__PURE__*/React.createElement(Section$1, props);
};

const styles$n = theme => ({
  chevronPrev: {
    position: 'absolute',
    top: '50%',
    left: 0,
    zIndex: 10,
    // background: 'white',
    // borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(0),
      width: '36px',
      height: '36px',
      background: '#00000066'
    },
    cursor: 'pointer'
  },
  chevronNext: {
    position: 'absolute',
    top: '50%',
    right: 0,
    zIndex: 10,
    // background: 'white',
    // borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(0),
      width: '36px',
      height: '36px',
      background: '#00000066'
    },
    cursor: 'pointer'
  },
  iconChevron: {
    fontSize: '2.5rem',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem'
    }
  },
  carouselDots: {
    position: 'absolute',
    bottom: theme.spacing(3),
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  boxHeaderGallery: {
    // background: '#000000b3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '5%'
  },
  iconCloseGallery: {
    position: 'absolute',
    right: 0,
    top: '8px',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      right: theme.spacing(1)
    }
  }
});

const Gallery = props => {
  const {
    position,
    children,
    classes,
    items,
    activeIndex,
    closeGallery
  } = props;
  const [current, setCurrent] = useState(activeIndex);

  const nextCarousel = () => {
    let index = current;

    if (index === items.length - 1) {
      setCurrent(0);
    } else {
      setCurrent(++index);
    }
  };

  const prevCarousel = () => {
    let index = current;

    if (index === 0) {
      setCurrent(items.length - 1);
    } else {
      setCurrent(--index);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextCarousel();
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);
  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.boxHeaderGallery
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body1"
  }, current + 1, " of ", items.length), /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.iconCloseGallery,
    onClick: closeGallery
  })), /*#__PURE__*/React.createElement(Box$1, {
    style: {
      overflow: 'hidden'
    }
  }, items.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, null, current === index && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: '5%',
      width: '100%',
      opacity: 1.0,
      height: '95%'
    }
  }, /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(` + (item.images.length > 0 ? item.images[0].image_url : '') + `)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      height: '100%'
    }
  }))))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.chevronNext
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: classes.iconChevron,
    onClick: nextCarousel
  })), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.chevronPrev
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: classes.iconChevron,
    onClick: prevCarousel
  })))));
};

var Gallery$1 = withStyles(styles$n)(Gallery);

const styles$o = theme => ({
  root: {
    width: '100%',
    padding: '0px'
  },
  toolbar: {},
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  menuButtonLeft: {
    position: 'absolute',
    left: '-35px',
    color: theme.sectionPalette.accent.background,
    // background: 'white',
    top: '100px'
  },
  menuButtonRight: {
    position: 'absolute',
    right: '-20px',
    color: theme.sectionPalette.accent.background,
    // background: 'white',
    top: '100px'
  },
  menuButtonRemove: {
    position: 'absolute',
    right: '-20px',
    top: '-35px',
    color: '#ff1744' // background: 'white',

  }
});

const SectionEditItem = props => {
  const {
    classes,
    theme,
    sectionData,
    onMoveUp,
    onMoveDown,
    onDelete,
    onAdd,
    onEdit,
    onCancel
  } = props;
  const pageEditContext = useContext(PageEditContext);
  const {
    onBeginEditItem,
    onEndEditItem,
    selectedItemIndex
  } = pageEditContext;

  const deleteItem = index => {
    sectionData.splice(index, 1);
    onDelete(sectionData);
  };

  const addItem = index => {
    if (sectionData.length - 1 === index) {
      sectionData.push({});
      onAdd(sectionData);
    } else {
      sectionData.splice(index, 0, {});
      onAdd(sectionData);
    }
  };

  let sectionControl = [];
  sectionControl['position'] = 'relative';
  sectionControl['display'] = 'flex';
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: sectionControl
  }, onAdd && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButtonLeft,
    color: "primary",
    onClick: () => addItem(selectedItemIndex)
  }, /*#__PURE__*/React.createElement(AddCircleIcon, null)), /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButtonRight,
    color: "primary",
    onClick: () => addItem(selectedItemIndex + 1)
  }, /*#__PURE__*/React.createElement(AddCircleIcon, null))), onDelete && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButtonRemove,
    color: "red",
    onClick: () => deleteItem(selectedItemIndex)
  }, /*#__PURE__*/React.createElement(CancelIcon, null)));
};

var SectionEditItem$1 = withStyles(styles$o, {
  withTheme: true
})(SectionEditItem);

const styles$p = theme => ({
  root: {
    paddingLeft: theme.spacing(-1),
    display: 'flex',
    overflow: 'hidden'
  },
  container: {},
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  }
});

function useTraceUpdate(props) {
  const prev = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v];
      }

      return ps;
    }, {});

    if (Object.keys(changedProps).length > 0) {
      console.log('Changed props:', changedProps);
    }

    prev.current = props;
  });
}

const Grid = props => {
  const {
    theme,
    classes,
    color,
    item_size,
    item_count,
    items,
    item_image_position,
    item_image_alternate_position,
    item_spacing,
    item_justify = 'center',
    item_text_alignment,
    horizontal_alignment,
    max_row_count = 0,
    createItemBlock
  } = props;
  console.log("Props", props);
  useTraceUpdate(props);
  const pageEditContext = useContext(PageEditContext);
  const {
    editMode,
    canEdit,
    selectedItemPath,
    selectionLevel,
    onSelectItem,
    onUpdateItems
  } = pageEditContext; // Split to selected section index and child path

  let editItemIndex = -1;
  let selectedChildItemPath = null;

  if (selectedItemPath) {
    let pos = selectedItemPath.indexOf("/");
    if (pos == -1) editItemIndex = parseInt(selectedItemPath);else {
      editItemIndex = parseInt(selectedItemPath.substring(0, pos));
      selectedChildItemPath = selectedItemPath.substring(pos + 1);
    }
  }
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'));
  let spacing;
  let itemsPerRow;

  if (item_size == 'xs') {
    if (xlUp) {
      itemsPerRow = 6;
      spacing = 3;
    } else if (lgUp) {
      itemsPerRow = 6;
      spacing = 3;
    } else if (mdUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (smUp) {
      itemsPerRow = 4;
      spacing = 2;
    } else {
      itemsPerRow = 3;
      spacing = 1;
    }
  } else if (item_size == 's') {
    if (xlUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (lgUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (mdUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (smUp) {
      itemsPerRow = 3;
      spacing = 2;
    } else {
      itemsPerRow = 2;
      spacing = 1;
    }
  } else if (item_size == 'l') {
    if (xlUp) {
      itemsPerRow = 2;
      spacing = 8;
    } else if (lgUp) {
      itemsPerRow = 2;
      spacing = 6;
    } else if (mdUp) {
      itemsPerRow = 2;
      spacing = 4;
    } else if (smUp) {
      itemsPerRow = 1;
      spacing = 4;
    } else {
      itemsPerRow = 1;
      spacing = 2;
    }
  } else if (item_size == 'xl') {
    if (xlUp) {
      itemsPerRow = 1;
      spacing = 8;
    } else if (lgUp) {
      itemsPerRow = 1;
      spacing = 6;
    } else if (mdUp) {
      itemsPerRow = 1;
      spacing = 4;
    } else if (smUp) {
      itemsPerRow = 1;
      spacing = 4;
    } else {
      itemsPerRow = 1;
      spacing = 2;
    }
  } else {
    if (xlUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (lgUp) {
      itemsPerRow = 3;
      spacing = 3;
    } else if (mdUp) {
      itemsPerRow = 3;
      spacing = 3;
    } else if (smUp) {
      itemsPerRow = 2;
      spacing = 2;
    } else {
      itemsPerRow = 2;
      spacing = 1;
    }
  }

  let filteredItems = items ? items : [];

  if (filteredItems.length) {
    if (max_row_count > 0) {
      let rowCount = Math.ceil(items.length / itemsPerRow);
      if (rowCount > max_row_count) filteredItems = items.slice(0, max_row_count * itemsPerRow);
    }

    filteredItems = filteredItems.map((item, index) => {
      item['itemIndex'] = index;
      if (index % 2 === 1) item['positionImage'] = item_image_alternate_position;else item['positionImage'] = item_image_position;
      return item;
    });
  }
  /*
  const [newItems, setNewItems] = useState([])
  
  useEffect(() => {
      console.log("NEW", newItems)
      setNewItems(filteredItems)
  }, [items])
  */


  let itemStyle = [];
  let editControl = null;
  let itemJustify = null;

  if (canEdit) {
    editControl = /*#__PURE__*/React.createElement(SectionEditItem$1, {
      sectionData: newItems,
      onAdd: newItem => {
        //setNewItems(newItem)
        onSelectItem(null);
        onUpdateItems(newItem);
      },
      onDelete: newItem => {
        //setNewItems(newItem)
        onSelectItem(null);
        onUpdateItems(newItem);
      }
    });
  }

  if (horizontal_alignment === 'left') {
    itemJustify = 'flex-start';
  } else if (horizontal_alignment === 'right') {
    itemJustify = 'flex-end';
  } else {
    itemJustify = 'center';
  } // This will add left and right spacing as well
  //  itemStyle['padding'] = item_spacing+'%'


  return /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    justify: itemJustify,
    spacing: spacing
  }, filteredItems !== undefined && filteredItems.map((item, index) => /*#__PURE__*/React.createElement(Grid$2, {
    key: index.toString(),
    item: true,
    xs: 12 / itemsPerRow,
    style: itemStyle
  }, canEdit ? /*#__PURE__*/React.createElement(PageEditContext.Provider, {
    value: { ...pageEditContext,
      selectedItemPath: selectedChildItemPath,
      canEdit: editItemIndex == index ? true : false,
      selectionLevel: selectionLevel + 1,
      selectedItemIndex: editItemIndex,
      onSelectItem: path => onSelectItem(path ? editItemIndex.toString() + "/" + path : editItemIndex.toString())
    }
  }, /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: editItemIndex == index && !selectedChildItemPath,
    control: editControl,
    onSelect: () => onSelectItem(index.toString()),
    level: selectionLevel
  }, createItemBlock(item, index))) : /*#__PURE__*/React.createElement(React.Fragment, null, createItemBlock(item, index)))), filteredItems.length === 0 && /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    },
    align: "center"
  }, canEdit && /*#__PURE__*/React.createElement(SelectionBox$1, {
    selected: selectedItemPath == 'grid' // control={ editControl }
    ,
    onSelect: () => {
      onSelectItem('grid');
      /*setNewItems([{title:'title'}]);*/

      onUpdateItems([{
        title: 'title'
      }]);
    },
    level: selectionLevel
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "span"
  }, "[Add First Item]"))));
};

Grid.propTypes = {
  classes: PropTypes.object.isRequired
};
var Grid$1 = withStyles(styles$p, {
  withTheme: true
})(Grid);

const styles$q = theme => ({
  root: {
    flexGrow: 1
  },
  backgroundNext: {
    background: 'linear-gradient(to left, rgba(35,31,32,1) 0%,rgba(35,31,32,0) 100%) !important'
  }
});

const NextArrow = props => {
  const {
    className,
    style,
    onClick
  } = props;

  if (props.type !== 'course') {
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: { ...style,
        display: "block",
        right: 0,
        width: '70px'
      },
      onClick: onClick
    }, /*#__PURE__*/React.createElement(ArrowForwardIosIcon, {
      style: {
        fill: '#ffffff8a',
        fontSize: '5rem'
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: { ...style,
        display: "block",
        right: 0,
        width: '60px',
        paddingRight: '10px'
      },
      onClick: onClick
    }, /*#__PURE__*/React.createElement(ArrowForwardIosIcon, {
      style: {
        fill: '#ffffff8a',
        fontSize: '4rem'
      }
    }));
  }
};

const mapStateToProps$5 = (state, ownProps) => {
  return {};
};

const mapDispatchToProps$5 = (dispatch, ownProps) => {
  return {};
};

var NextArrow$1 = connect(mapStateToProps$5, mapDispatchToProps$5)(withStyles(styles$q)(NextArrow));

const styles$r = theme => ({
  root: {
    flexGrow: 1
  }
});

const PrevArrow = props => {
  const {
    className,
    style,
    onClick
  } = props;

  if (props.type !== 'course') {
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: { ...style,
        display: "block",
        left: '10px',
        zIndex: 1,
        width: '50px'
      },
      onClick: onClick
    }, /*#__PURE__*/React.createElement(ArrowBackIosIcon, {
      style: {
        fill: '#ffffff8a',
        fontSize: '5rem'
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: { ...style,
        display: "block",
        left: '10px',
        zIndex: 1,
        width: '80px',
        paddingRight: '60px'
      },
      onClick: onClick
    }, /*#__PURE__*/React.createElement(ArrowBackIosIcon, {
      style: {
        fill: '#ffffff8a',
        fontSize: '4rem'
      }
    }));
  }
};

const mapStateToProps$6 = (state, ownProps) => {
  return {};
};

const mapDispatchToProps$6 = (dispatch, ownProps) => {
  return {};
};

var PrevArrow$1 = connect(mapStateToProps$6, mapDispatchToProps$6)(withStyles(styles$r)(PrevArrow));

const styles$s = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  carouselItem: {
    // padding: "0 80px",
    maxWidth: 1280,
    margin: "0 auto",
    zIndex: 0,
    // marginTop: theme.spacing(3),
    [theme.breakpoints.between('md', 'sm')]: {
      marginTop: theme.spacing(3),
      padding: 0
    },
    [theme.breakpoints.down('xs')]: {
      // marginRight: theme.spacing(1) * -2,
      // marginLeft: theme.spacing(1) * -2,
      marginBottom: theme.spacing(3)
    }
  }
});

const Carousel$1 = props => {
  const {
    theme,
    classes,
    color,
    item_size = 'medium',
    item_count,
    item_component_type,
    createContentBlock,
    items,
    activeKey,
    item_text_alignment
  } = props;
  let removeNotFullRow = false;
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'));
  let itemsPerRow;
  let variableWidth;
  let slidesPerRow;
  let dots = false;
  let arrows = true;

  if (item_size == 'xs') {
    if (xlUp) {
      itemsPerRow = 6;
      variableWidth = false;
      slidesPerRow = 2;
      dots = true;
      arrows = false;
    } else if (lgUp) {
      itemsPerRow = 6;
      variableWidth = false;
      slidesPerRow = 2;
      dots = true;
      arrows = false;
    } else if (mdUp) {
      itemsPerRow = 4;
      variableWidth = false;
      slidesPerRow = 2;
      dots = true;
      arrows = false;
    } else if (smUp) {
      itemsPerRow = 3;
      variableWidth = false;
      slidesPerRow = 2;
      dots = true;
      arrows = false;
    } else {
      itemsPerRow = 2;
      variableWidth = false;
      slidesPerRow = 2;
      dots = true;
      arrows = false;
    }
  } else if (item_size == 's') {
    if (xlUp) {
      itemsPerRow = 6;
      variableWidth = false;
      slidesPerRow = 2;
    } else if (lgUp) {
      itemsPerRow = 5;
      variableWidth = false;
      slidesPerRow = 2;
    } else if (mdUp) {
      itemsPerRow = 4;
      variableWidth = false;
      slidesPerRow = 2;
    } else if (smUp) {
      itemsPerRow = 3;
      variableWidth = false;
      slidesPerRow = 2;
    } else {
      itemsPerRow = 2;
      variableWidth = false;
      slidesPerRow = 2;
    }
  } else if (item_size == 'l') {
    if (xlUp) {
      itemsPerRow = 2;
      slidesPerRow = 1;
    } else if (lgUp) {
      itemsPerRow = 2;
      slidesPerRow = 1;
    } else if (mdUp) {
      itemsPerRow = 2;
      variableWidth = false;
      slidesPerRow = 1;
    } else if (smUp) {
      itemsPerRow = 2;
      variableWidth = false;
      slidesPerRow = 1;
    } else {
      itemsPerRow = 1;
      variableWidth = false;
      slidesPerRow = 1;
    }
  } else if (item_size == 'xl') {
    if (xlUp) {
      itemsPerRow = 1;
      variableWidth = false;
      slidesPerRow = 1;
    } else if (lgUp) {
      itemsPerRow = 1;
      variableWidth = false;
      slidesPerRow = 1;
    } else if (mdUp) {
      itemsPerRow = 1;
      variableWidth = false;
      slidesPerRow = 1;
    } else if (smUp) {
      itemsPerRow = 1;
      variableWidth = false;
      slidesPerRow = 1;
    } else {
      itemsPerRow = 1;
      variableWidth = false;
      slidesPerRow = 1;
    }
  } else {
    if (mdUp) {
      itemsPerRow = 3;
      variableWidth = false;
      slidesPerRow = 1;
    } else if (smUp) {
      itemsPerRow = 3;
      variableWidth = false;
      slidesPerRow = 1;
    } else {
      itemsPerRow = 2;
      variableWidth = false;
      slidesPerRow = 1;
    }
  }

  let itemAttributes = {};

  const createItemBlock = itemData => {
    itemAttributes = {
      itemKey: itemData.key,
      itemsPerRow: itemsPerRow,
      activeKey: activeKey,
      item_text_alignment: item_text_alignment
    };
    return createContentBlock(item_component_type, itemData, 0, itemAttributes);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: itemsPerRow,
    arrows: true,
    // slidesToScroll: itemScroll,
    autoplay: true,
    autoplaySpeed: 5000,
    variableWidth: variableWidth,
    // centerMode: centerMode,
    initialIndex: 0,
    pauseOnHover: false,
    nextArrow: /*#__PURE__*/React.createElement(NextArrow$1, {
      type: "course"
    }),
    prevArrow: /*#__PURE__*/React.createElement(PrevArrow$1, {
      type: "course"
    }),
    responsive: [{
      breakpoint: 600,
      settings: {
        // slidesToShow: 1,
        // slidesToScroll: 2,
        arrows: arrows,
        rows: 1,
        slidesPerRow: slidesPerRow,
        dots: dots,
        centerMode: true,
        infinite: true,
        centerPadding: "-5px",
        slidesToShow: slidesPerRow
      }
    }]
  };
  let filteredItems = items;

  if (items !== undefined && removeNotFullRow) {
    let rowCount = Math.floor(items.length / itemsPerRow);
    if (rowCount <= 0) filteredItems = items;else filteredItems = items.slice(0, rowCount * itemsPerRow);
  }

  return /*#__PURE__*/React.createElement(Slider$1, _extends({}, settings, {
    className: classes.carouselItem
  }), filteredItems !== undefined && filteredItems.map((item, index) => createItemBlock(item)));
};

Carousel$1.propTypes = {
  classes: PropTypes.object.isRequired
};
var Carousel$2 = withStyles(styles$s, {
  withTheme: true
})(Carousel$1);

const styles$t = theme => ({
  root: {
    width: '100%',
    flex: 1,
    flexDirection: 'column'
  },
  tabs: {},
  content: {
    paddingTop: theme.spacing(2)
  }
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const Tab = props => {
  const {
    theme,
    classes,
    color,
    item_size,
    item_count,
    items,
    item_image_position,
    item_image_alternate_position,
    item_spacing,
    item_justify = 'center',
    max_row_count = 0,
    createItemBlock,
    editMode = false,
    canEdit,
    selectedItemPath,
    onSelectItem
  } = props;
  const [activeTab, setActiveTab] = useState('0');
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let variant = "standard";

  if (smUp) ; else {
    if (items.length > 3) variant = "scrollable";else {
      variant = "fullWidth";
    }
  } // This will add left and right spacing as well
  //  itemStyle['padding'] = item_spacing+'%'


  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tabs
  }, /*#__PURE__*/React.createElement(MUITabs, {
    value: activeTab,
    onChange: (event, tab) => setActiveTab(tab),
    indicatorColor: "primary",
    textColor: "primary",
    variant: variant,
    scrollButtons: "on",
    centered: true
  }, items.map((item, index) => /*#__PURE__*/React.createElement(Tab$2, _extends({
    value: index.toString(),
    label: item.label || item.title || item.name
  }, a11yProps(index)))))), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, createItemBlock(items[parseInt(activeTab)], parseInt(activeTab))));
};

Tab.propTypes = {
  classes: PropTypes.object.isRequired
};
var Tab$1 = withStyles(styles$t, {
  withTheme: true
})(Tab);

const styles$u = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden'
  },
  imageCenter: {
    width: '100%' //    [theme.breakpoints.down('sm')]: {    
    //      marginLeft: theme.spacing(-2),
    //      width: 'calc(100% + 32px)'
    //    }

  }
});

const ExpansionList = props => {
  const {
    theme,
    classes,
    variant,
    color_mode,
    items,
    item_size,
    removeNotFullRow = false,
    renderItem = null,
    openLink
  } = props;
  const [expanded, setExpanded] = useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'));
  let spacing;
  let itemsPerRow;

  if (item_size == 'xs') {
    if (xlUp) {
      itemsPerRow = 6;
      spacing = 3;
    } else if (lgUp) {
      itemsPerRow = 6;
      spacing = 3;
    } else if (mdUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (smUp) {
      itemsPerRow = 4;
      spacing = 2;
    } else {
      itemsPerRow = 3;
      spacing = 1;
    }
  } else if (item_size == 's') {
    if (xlUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (lgUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (mdUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (smUp) {
      itemsPerRow = 3;
      spacing = 2;
    } else {
      itemsPerRow = 2;
      spacing = 1;
    }
  } else if (item_size == 'l') {
    if (xlUp) {
      itemsPerRow = 2;
      spacing = 8;
    } else if (lgUp) {
      itemsPerRow = 2;
      spacing = 6;
    } else if (mdUp) {
      itemsPerRow = 2;
      spacing = 4;
    } else if (smUp) {
      itemsPerRow = 1;
      spacing = 4;
    } else {
      itemsPerRow = 1;
      spacing = 2;
    }
  } else if (item_size == 'xl') {
    if (xlUp) {
      itemsPerRow = 1;
      spacing = 8;
    } else if (lgUp) {
      itemsPerRow = 1;
      spacing = 6;
    } else if (mdUp) {
      itemsPerRow = 1;
      spacing = 4;
    } else if (smUp) {
      itemsPerRow = 1;
      spacing = 4;
    } else {
      itemsPerRow = 1;
      spacing = 2;
    }
  } else {
    if (xlUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (lgUp) {
      itemsPerRow = 4;
      spacing = 3;
    } else if (mdUp) {
      itemsPerRow = 3;
      spacing = 3;
    } else if (smUp) {
      itemsPerRow = 2;
      spacing = 2;
    } else {
      itemsPerRow = 2;
      spacing = 1;
    }
  }

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: spacing
  }, items !== undefined && items.map((item, index) => /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12 / itemsPerRow
  }, /*#__PURE__*/React.createElement(ExpansionPanel, {
    expanded: expanded === 'panel-' + index,
    onChange: handleChange('panel-' + index),
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: item.label || item.title || item.name,
    dark: color_mode == 'dark'
  })), /*#__PURE__*/React.createElement(ExpansionPanelDetails, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: item.body,
    dark: color_mode == 'dark'
  }), item.link_to && item.link_to !== undefined && /*#__PURE__*/React.createElement(Box, {
    align: "left",
    mt: 3
  }, /*#__PURE__*/React.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize
    },
    onClick: () => openLink(item.link_to)
  }, item.link_title))))))))));
};

ExpansionList.propTypes = {
  classes: PropTypes.object.isRequired
};
var ExpansionList$1 = withStyles(styles$u, {
  withTheme: true
})(ExpansionList);

const styles$v = theme => ({
  root: {
    paddingLeft: theme.spacing(-1),
    display: 'flex',
    overflow: 'hidden'
  },
  container: {},
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  }
});

const ItemMain = ({
  classes,
  item,
  selected = false
}) => {
  const imageUrl = item.images && item.images.length > 0 && item.images[0].image_url;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      // border: "solid 1px #ddd",
      width: "100%",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    style: {
      width: "100%",
      height: "100%",
      objectFit: 'contain'
    }
  }), item.title && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 4,
      paddingBottom: 4,
      backgroundColor: 'rgba(200, 200, 200, 0.9)'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      fontWeight: 700
    }
  }, item.title)));
};

const ItemCard = ({
  classes,
  item,
  selected = false,
  position = 'right',
  onClick
}) => {
  const imageUrl = item.images && item.images.length > 0 && item.images[0].image_url;
  let style = {};

  if (selected) ; else {
    style['opacity'] = 0.4;
  }

  if (position === "bottom") {
    style["height"] = "80px";
    return /*#__PURE__*/React.createElement("div", {
      style: style,
      onClick: onClick
    }, /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      style: {
        width: "auto",
        height: "100%"
      }
    }));
  } else return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    style: {
      width: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      height: "auto"
    }
  }));
};

const GridGallery = props => {
  const {
    theme,
    classes,
    color,
    item_size,
    item_count,
    items,
    item_image_position,
    item_image_alternate_position,
    item_spacing,
    item_justify = 'center',
    item_text_alignment,
    horizontal_alignment,
    max_row_count = 0,
    createItemBlock
  } = props;
  const {
    thumbnailPosition = 'right'
  } = props;
  const [selectedItem, setSelectedItem] = useState(0);
  useEffect(() => {
    setSelectedItem(0);
  }, [items]);
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  if (!smUp) return /*#__PURE__*/React.createElement(Grid$2, props); // let filteredItems = items ? items : []

  if (thumbnailPosition === "bottom") return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1,
      height: "65vh",
      position: "relative",
      // border: "solid 1px #ddd",
      backgroundColor: "#f8f8f8",
      padding: 0
    }
  }, items && selectedItem < items.length && /*#__PURE__*/React.createElement(ItemMain, {
    classes: classes,
    item: items[selectedItem]
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 12,
      flexShrink: 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      flexShrink: 0,
      flexGrow: 0,
      height: "80px",
      position: "relative",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      overflowX: "auto"
    }
  }, items && items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: 8
    }
  }, /*#__PURE__*/React.createElement(ItemCard, {
    item: item,
    theme: theme,
    classes: classes,
    selected: selectedItem == index,
    position: thumbnailPosition,
    onClick: () => setSelectedItem(index)
  })))));else return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      height: "65vh",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1,
      height: "100%",
      position: "relative",
      // border: "solid 1px #ddd",
      backgroundColor: "#f8f8f8",
      padding: 0
    }
  }, items && selectedItem < items.length && /*#__PURE__*/React.createElement(ItemMain, {
    classes: classes,
    item: items[selectedItem]
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 12,
      flexShrink: 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "20%",
      flexShrink: 0,
      flexGrow: 0,
      height: "100%",
      position: "relative",
      // display: "flex",
      flexDirection: "column",
      alignItems: "center",
      overflowY: "auto"
    }
  }, items && items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 8
    }
  }, /*#__PURE__*/React.createElement(ItemCard, {
    item: item,
    theme: theme,
    classes: classes,
    selected: selectedItem == index,
    position: thumbnailPosition,
    onClick: () => setSelectedItem(index)
  })))));
};

GridGallery.propTypes = {
  classes: PropTypes.object.isRequired
};
const GridGalleryDefault = withStyles(styles$v, {
  withTheme: true
})(GridGallery);
const GridGalleryBottom = props => /*#__PURE__*/React.createElement(GridGalleryDefault, _extends({
  thumbnailPosition: "bottom"
}, props));

const listVariantMaps = {
  Grid: Grid$1,
  Slideshow: Carousel$2,
  SlideshowLeft: Carousel$2,
  Tab: Tab$1,
  Expansion: ExpansionList$1,
  GridGallery: GridGalleryDefault,
  GridGalleryBottom: GridGalleryBottom
};

const styles$w = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  dialogGallery: {
    height: '100vh',
    [theme.breakpoints.down('xs')]: {// height: '40vh'
    }
  }
});

const ListSection = props => {
  const {
    theme,
    classes,
    openLink,
    variant,
    color,
    item_size,
    item_variant,
    item_count,
    items,
    item_spacing,
    onItemClick,
    removeNotFullRow = false,
    editMode,
    canEdit,
    selectedItemPath,
    onSelectItem,
    selectionLevel
  } = props;
  const {
    item_component_type,
    createContentBlock
  } = props;
  const [openGallery, setOpenGallery] = React.useState(false);
  const [positions, setPositions] = React.useState(0);

  const internalOnItemClick = (item, index) => {
    if (onItemClick) onItemClick(item, index);else handleClickOpenGallery(index);
  };

  const handleClickOpenGallery = position => {
    setPositions(position);
    setOpenGallery(true);
  };

  const handleCloseGallery = () => {
    setOpenGallery(false);
  };

  let textColor;

  if (color === 'dark') {
    textColor = theme.sectionPalette.dark.contrastText;
  } else if (color === 'accent') {
    textColor = theme.sectionPalette.accent.contrastText;
  } else if (color === 'light') {
    textColor = theme.sectionPalette.light.contrastText;
  } else if (color === 'white') {
    textColor = theme.sectionPalette.white.contrastText;
  } else {
    textColor = theme.sectionPalette.black.contrastText;
  } // let imagesWidth = []
  // const [images,setImages] = useState([])
  // useEffect(() => {
  //   items.map((item,index) => {
  //     if (item.images && item.images.length > 0) {
  //       let image = new Image();
  //       image.src = item.images[0].image_url || ''
  //       // image.width = 
  //       image.onload = function() {
  //           let dimension = {
  //               width: image.width,
  //               height: image.height
  //           };
  //       };
  //     }
  //   })
  // }, [])


  const itemAttributes = {
    variant: props.item_variant,
    button_style: props.item_button_style,
    item_size: props.item_size,
    item_justify: props.item_justify,
    text_alignment: props.item_text_alignment,
    animation: props.item_animation,
    image_position: props.item_image_position,
    image_alternate_position: props.item_image_alternate_position,
    image_width: props.item_image_width,
    image_ratio: props.item_image_ratio ? parseFloat(props.item_image_ratio) : 1.0,
    color: textColor,
    colorType: props.color || 'white',
    index: props.itemIndex,
    item_spacing: props.item_spacing,
    openGallery: openGallery,
    editMode: editMode,
    canEdit: canEdit,
    selectedItemPath: selectedItemPath,
    onSelectItem: onSelectItem,
    selectionLevel: selectionLevel + 1,
    setOpenGallery: handleClickOpenGallery // selected={index === selected_index ? true : false}
    // selected_index: ,
    // selected:

  };

  const createItemBlock = (itemData, index) => {
    return createContentBlock(item_component_type, itemData, 0, { ...itemAttributes,
      onClick: () => internalOnItemClick(itemData, index)
    });
  };

  let comp;
  if (variant in listVariantMaps) comp = listVariantMaps[variant];else comp = listVariantMaps['Grid'];
  let container = React.createElement(comp, { ...props,
    item_size: item_size,
    item_count: item_count,
    items: items,
    item_spacing: item_spacing,
    openLink: openLink,
    createItemBlock: createItemBlock
  });
  return /*#__PURE__*/React.createElement(Section$1, props, container, openGallery && /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: true,
    onClose: handleCloseGallery
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      width: "100%",
      backgroundColor: "rgba(255, 255, 255, .5)",
      height: 48,
      zIndex: 2000
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 700
    }
  }, "Gallery View")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(Button$2, {
    onClick: handleCloseGallery,
    variant: "contained",
    color: "primary",
    size: "small"
  }, "Close"), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 16
    }
  }))), /*#__PURE__*/React.createElement(ImageGallery, {
    items: items.filter(item => item.images.length > 0).map(item => ({
      original: item.images[0].image_url,
      thumbnail: item.images[0].image_url
    })),
    useBrowserFullscreen: false,
    showFullscreenButton: false
  })));
};

ListSection.propTypes = {
  classes: PropTypes.object.isRequired
};
var ListSection$1 = withStyles(styles$w, {
  withTheme: true
})(ListSection);

const styles$x = theme => ({});

const BlogFeed = props => {
  const {
    classes,
    theme,
    blogList,
    fetchBlogList,
    openLink
  } = props;
  useEffect(() => {
    fetchBlogList();
  }, []);
  let items = [];

  if (blogList.lastFetched) {
    items = blogList.data.records;
  }

  return /*#__PURE__*/React.createElement(ListSection$1, _extends({}, props, {
    onItemClick: item => openLink('blog/post/' + item.key),
    removeNotFullRow: true,
    items: items,
    max_row_count: 1
  }));
};

BlogFeed.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps$7 = (state, ownProps) => {
  return {
    blogList: getContentIndex(state, 'blog')
  };
};

const mapDispatchToProps$7 = (dispatch, ownProps) => {
  return {
    fetchBlogList: (refresh = false) => {
      dispatch(fetchContentIndex('blog'));
    }
  };
};

var BlogFeed$1 = withStyles(styles$x, {
  withTheme: true
})(connect(mapStateToProps$7, mapDispatchToProps$7)(BlogFeed));

const styles$y = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden'
  },
  // Must use custom background div or it will overlap with section backdrop/image
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: -3
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  carouselItem: {
    position: 'absolute',
    width: '100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    height: '100vh',
    [theme.breakpoints.between('md', 'sm')]: {
      marginTop: theme.spacing(3),
      padding: 0
    },
    [theme.breakpoints.down('xs')]: {
      // marginRight: theme.spacing(1) * -2,
      // marginLeft: theme.spacing(1) * -2,
      marginBottom: theme.spacing(3)
    }
  },
  relativeCarouselActive: {
    position: 'relative',
    height: '100%',
    display: 'block'
  },
  relativeCarousel: {
    position: 'relative',
    height: '100%',
    display: 'none'
  },
  fullHeight: {
    position: 'absolute',
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    background: 'white'
  },
  textCarousel: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100vh'
  },
  detailText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column'
  },
  chevronPrev: {
    position: 'absolute',
    top: '50%',
    left: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(0)
    },
    cursor: 'pointer'
  },
  chevronNext: {
    position: 'absolute',
    top: '50%',
    right: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(0)
    },
    cursor: 'pointer'
  },
  iconChevron: {
    fontSize: '4rem',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem'
    }
  },
  opacityAnimate: {
    opacity: 0.125
  },
  carouselDots: {
    position: 'absolute',
    bottom: theme.spacing(3),
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  dotsItem: {
    backgroundColor: 'black',
    border: '3px solid white',
    borderRadius: '50%',
    display: 'inline-block',
    height: '10px',
    width: '10px',
    margin: theme.spacing(0.4),
    cursor: 'pointer'
  },
  dotsItemActive: {
    backgroundColor: 'white',
    border: '3px solid black',
    borderRadius: '50%',
    display: 'inline-block',
    height: '10px',
    width: '10px',
    margin: theme.spacing(0.4),
    cursor: 'pointer'
  }
});

const CarouselSection = props => {
  const {
    theme,
    classes,
    key,
    sectionIndex,
    openLink,
    color,
    createContentBlock,
    item_spacing,
    children
  } = props;
  const {
    items
  } = props;
  const sectionProp = {
    section_height: props.section_height,
    section_width: props.section_width,
    content_width: props.content_width,
    vertical_alignment: props.vertical_alignment,
    horizontal_alignment: props.horizontal_alignment,
    overlay_opacity: props.overlay_opacity,
    color: props.color,
    text_alignment: props.text_alignment,
    button_style: props.button_style,
    item_spacing: item_spacing
  };
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let backgroundColor = theme.sectionPalette.white.background;
  if (color == 'light') backgroundColor = theme.sectionPalette.light.background;else if (color == 'dark') backgroundColor = theme.sectionPalette.dark.background;else if (color == 'accent') backgroundColor = theme.sectionPalette.accent.background;else if (color == 'black') backgroundColor = theme.sectionPalette.black.background;
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);

  const nextCarousel = () => {
    let index = activeIndex;

    if (index === items.length - 1) {
      setVisible(true);
      setActiveIndex(0);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    } else {
      setVisible(true);
      setActiveIndex(++index);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    }
  };

  const prevCarousel = () => {
    let index = activeIndex;

    if (index === 0) {
      setVisible(true);
      setActiveIndex(items.length - 1);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    } else {
      setVisible(true);
      setActiveIndex(--index);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextCarousel();
    }, 5000);
    return () => clearInterval(interval);
  }, [activeIndex]);
  /*
  const itemProp = {
    title: items[activeIndex].title,
    subtitle: items[activeIndex].subtitle,
    body: items[activeIndex].body,
    link_to: items[activeIndex].link_to,
    button_title: items[activeIndex].button_title,
    background_images: items[activeIndex].images,
  }
  */

  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100vh'
    }
  }, items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: '100%',
      opacity: 1.0
    }
  }, /*#__PURE__*/React.createElement(Fade$1, {
    in: activeIndex == index ? true : false,
    timeout: 1000
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Section$1, _extends({
    openLink: openLink,
    createContentBlock: createContentBlock,
    sectionIndex: sectionIndex
  }, sectionProp, {
    title: item.title,
    subtitle: item.subtitle,
    body: item.body,
    link_to: item.link_to,
    button_title: item.button_title,
    background_images: item.images
  })))))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: classes.chevronNext,
    onClick: nextCarousel
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: classes.iconChevron
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.chevronPrev,
    onClick: prevCarousel
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: classes.iconChevron
  }))), /*#__PURE__*/React.createElement(Box, {
    className: classes.carouselDots
  }, items.map((item, index) => /*#__PURE__*/React.createElement("span", {
    className: activeIndex === index ? classes.dotsItemActive : classes.dotsItem,
    onClick: () => setActiveIndex(index)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.background,
    style: {
      backgroundColor: backgroundColor
    }
  }));
};

CarouselSection.propTypes = {
  classes: PropTypes.object.isRequired
};
var CarouselSection$1 = withStyles(styles$y, {
  withTheme: true
})(CarouselSection);

const styles$z = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  signUpBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "white",
    padding: theme.spacing(3),
    shadow: theme.shadows[5],
    borderRadius: theme.shape.borderRadius
  },
  signUpForm: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      width: "300px"
    }
  },
  signUpFormField: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: "100%"
    }
  },
  signUpButton: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3)
    }
  }
});

const LaunchingSection = props => {
  const {
    theme,
    classes,
    openLink,
    variant,
    color,
    subtitle,
    body,
    text_alignment
  } = props;
  const {
    user,
    fetchContactInfo,
    updateContactInfo
  } = props;
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const hasContactInfo = user.contactInfo && user.contactInfo.first_name ? true : false;
  let textColor;

  if (color === 'dark') {
    textColor = theme.sectionPalette.dark.contrastText;
  } else if (color === 'accent') {
    textColor = theme.sectionPalette.accent.contrastText;
  } else if (color === 'light') {
    textColor = theme.sectionPalette.light.contrastText;
  } else if (color === 'white') {
    textColor = theme.sectionPalette.white.contrastText;
  } else {
    textColor = theme.sectionPalette.black.contrastText;
  }

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const onInputChange = name => event => {
    setFormData({ ...formData,
      [name]: event.target.value
    });
  };

  const onSave = () => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let errors = {};
    if (!formData.first_name) errors["first_name"] = "Please enter your name";
    if (!formData.email || !emailRegex.test(formData.email)) errors["email"] = "Please enter a valid email";
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      alert(errors[Object.keys(errors)[0]]);
      return;
    } // Update contact


    updateContactInfo(formData);
  };

  return /*#__PURE__*/React.createElement(Section$1, _extends({}, props, {
    subtitle: "",
    body: ""
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.signUpBox
  }, hasContactInfo ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 700
    },
    variant: "body1"
  }, "Thank you for subscribing! We'll email you when it's ready.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 700
    },
    variant: "body2"
  }, subtitle)), /*#__PURE__*/React.createElement(Box, {
    className: classes.signUpForm
  }, user.isUpdatingContact ? /*#__PURE__*/React.createElement(CircularProgress, {
    size: 24
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    label: "Your Name",
    size: "15",
    className: classes.signUpFormField,
    value: formData["first_name"],
    onChange: onInputChange("first_name"),
    error: formErrors["first_name"]
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "email",
    label: "Email",
    size: "15",
    className: classes.signUpFormField,
    value: formData["email"],
    onChange: onInputChange("email"),
    error: formErrors["email"]
  }), /*#__PURE__*/React.createElement(Button$2, {
    color: "primary",
    variant: "contained",
    size: "large",
    className: classes.signUpButton,
    onClick: onSave
  }, "Send")))))), /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    mb: 4,
    style: {
      width: '100%'
    },
    align: text_alignment
  }, body && /*#__PURE__*/React.createElement(Markdown$1, {
    source: body,
    variant: "body",
    color: textColor
  })));
};

const mapStateToProps$8 = (state, ownProps) => {
  return {
    user: getUser(state)
  };
};

const mapDispatchToProps$8 = (dispatch, ownProps) => {
  return {
    fetchContactInfo: () => {
      dispatch(fetchContactInfo());
    },
    updateContactInfo: data => {
      dispatch(updateContactInfo(data));
    }
  };
};

var LaunchingSection$1 = withStyles(styles$z, {
  withTheme: true
})(connect(mapStateToProps$8, mapDispatchToProps$8)(LaunchingSection));

const sectionMaps = {
  TitleSection: TitleSection,
  ListSection: ListSection$1,
  BlogFeed: BlogFeed$1,
  ExpansionList: ExpansionList$1,
  CarouselSection: CarouselSection$1,
  LaunchingSection: LaunchingSection$1
};

const styles$A = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden'
  },
  // Must use custom background div or it will overlap with section backdrop/image
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: -3
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' //    padding: theme.spacing(0, 3),

  },
  carouselItem: {
    position: 'absolute',
    width: '100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    height: '100vh',
    [theme.breakpoints.between('md', 'sm')]: {
      marginTop: theme.spacing(3),
      padding: 0
    },
    [theme.breakpoints.down('xs')]: {
      // marginRight: theme.spacing(1) * -2,
      // marginLeft: theme.spacing(1) * -2,
      marginBottom: theme.spacing(3)
    }
  },
  relativeCarouselActive: {
    position: 'relative',
    height: '100%',
    display: 'block'
  },
  relativeCarousel: {
    position: 'relative',
    height: '100%',
    display: 'none'
  },
  fullHeight: {
    position: 'absolute',
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    background: 'white'
  },
  textCarousel: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100vh'
  },
  detailText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column'
  },
  chevronPrev: {
    position: 'absolute',
    top: '50%',
    left: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(0)
    },
    cursor: 'pointer'
  },
  chevronNext: {
    position: 'absolute',
    top: '50%',
    right: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(0)
    },
    cursor: 'pointer'
  },
  iconChevron: {
    fontSize: '4rem',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem'
    }
  },
  opacityAnimate: {
    opacity: 0.125
  },
  carouselDots: {
    position: 'absolute',
    bottom: theme.spacing(3),
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  dotsItem: {
    backgroundColor: 'black',
    border: '3px solid white',
    borderRadius: '50%',
    display: 'inline-block',
    height: '10px',
    width: '10px',
    margin: theme.spacing(0.4),
    cursor: 'pointer'
  },
  dotsItemActive: {
    backgroundColor: 'white',
    border: '3px solid black',
    borderRadius: '50%',
    display: 'inline-block',
    height: '10px',
    width: '10px',
    margin: theme.spacing(0.4),
    cursor: 'pointer'
  }
});

const CarouselSectionList = props => {
  const {
    theme,
    classes,
    sectionList,
    createSection,
    editMode = false,
    canEdit,
    selectedItemPath,
    onSelectItem,
    openLink
  } = props;
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let backgroundColor = theme.sectionPalette.white.background;
  backgroundColor = theme.sectionPalette.light.background;
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);

  const nextCarousel = () => {
    let index = activeIndex;

    if (index === sectionList.length - 1) {
      setVisible(true);
      setActiveIndex(0);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    } else {
      setVisible(true);
      setActiveIndex(++index);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    }
  };

  const prevCarousel = () => {
    let index = activeIndex;

    if (index === 0) {
      setVisible(true);
      setActiveIndex(sectionList.length - 1);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    } else {
      setVisible(true);
      setActiveIndex(--index);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    }
  };

  useEffect(() => {
    if (!editMode) {
      const interval = setInterval(() => {
        nextCarousel();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [activeIndex]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100vh'
    }
  }, sectionList.map((sectionData, index) => /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: '100%',
      opacity: 1.0
    }
  }, /*#__PURE__*/React.createElement(Fade$1, {
    in: activeIndex == index ? true : false,
    timeout: 1000
  }, /*#__PURE__*/React.createElement(Box, {
    onClick: sectionData.link_to !== undefined && sectionData.button_title === undefined ? () => openLink(sectionData.link_to) : ''
  }, createSection(sectionData, index, {
    isCarouselItem: true
  }))))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: classes.chevronNext,
    onClick: nextCarousel
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: classes.iconChevron
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.chevronPrev,
    onClick: prevCarousel
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: classes.iconChevron
  }))), /*#__PURE__*/React.createElement(Box, {
    className: classes.carouselDots
  }, sectionList.map((item, index) => /*#__PURE__*/React.createElement("span", {
    className: activeIndex === index ? classes.dotsItemActive : classes.dotsItem,
    onClick: () => setActiveIndex(index)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.background,
    style: {
      backgroundColor: backgroundColor
    }
  }));
};

CarouselSectionList.propTypes = {
  classes: PropTypes.object.isRequired
};
var CarouselSectionList$1 = withStyles(styles$A, {
  withTheme: true
})(CarouselSectionList);

const styles$B = theme => ({
  root: {
    width: '320px',
    position: 'absolute',
    marginTop: '10px',
    right: '10px'
  },
  tabRoot: {
    width: '320px'
  },
  selectInput: {
    width: '100%'
  },
  //   tabPanelRoot:{
  //     mincontent_width: '100px'
  //   },
  textLabel: {
    marginBottom: theme.spacing(2)
  },
  buttonGroup: {
    width: '100%'
  },
  cardMedia: {
    width: '80px',
    height: '80px',
    marginRight: theme.spacing(2)
  },
  media: {
    width: '80px',
    height: '80px'
  },
  boxUploadMedia: {
    display: 'flex',
    flexDirection: 'row'
  },
  input: {
    display: 'none'
  }
});

const SectionPropertyForm = ({
  classes,
  theme,
  sectionData,
  onMoveUp,
  onMoveDown,
  onDelete,
  onEdit,
  onUpdate,
  uploadMediaContent
}) => {
  const [openUploader, setOpenUploader] = useState(false);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) ;
      } // Bind the event listener


      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  let tabRoot = {};

  function ValueLabelComponent(props) {
    const {
      children,
      open,
      value
    } = props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      open: open,
      enterTouchDelay: 0,
      placement: "top",
      title: value
    }, children);
  }

  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired
  };

  if (sectionData.component !== undefined && sectionData.component !== 'ListSection' && !sectionData.component.includes("ListSection")) {
    tabRoot['minWidth'] = '150px';
  } else {
    tabRoot['minWidth'] = '100px';
  }

  let initial = {
    title: sectionData.title ? sectionData.title : null,
    subtitle: sectionData.subtitle ? sectionData.subtitle : null,
    body: sectionData.body ? sectionData.body : null,
    background_images: sectionData.background_images ? sectionData.background_images : [],
    images: sectionData.images ? sectionData.images : [],
    image_width: sectionData.image_width ? sectionData.image_width : 100,
    horizontal_alignment: sectionData.horizontal_alignment ? sectionData.horizontal_alignment.value : 'center',
    vertical_alignment: sectionData.vertical_alignment ? sectionData.vertical_alignment.value : 'center',
    section_height: sectionData.section_height || 66,
    content_width: sectionData.content_width || 100,
    text_alignment: sectionData.text_alignment ? sectionData.text_alignment.value : 'center',
    color: sectionData.color ? sectionData.color.value : 'white',
    overlay_opacity: sectionData.overlay_opacity || 50,
    variant: sectionData.variant || 'Grid',
    item_variant: sectionData.item_variant || 'Card',
    item_size: sectionData.item_size ? sectionData.item_size.value : 'm',
    item_image_width: sectionData.item_image_width || 30,
    item_image_position: sectionData.item_image_position ? sectionData.item_image_position.value : 'top',
    item_text_alignment: sectionData.item_text_alignment ? sectionData.item_text_alignment.value : 'center'
  };
  const [formData, setFormData] = useState(initial);

  const handleChangeForm = name => (event, newValue) => {
    let eventValue = event.target.value;
    let valueNew = newValue ? newValue.props ? newValue.props.value : newValue : newValue;

    if (name !== 'background_images' && name !== 'item_variant') {
      setFormData({ ...formData,
        [name]: valueNew ? valueNew : eventValue
      });
    } else if (name === 'item_variant') {
      if (valueNew !== 'Collage') {
        setFormData({ ...formData,
          [name]: valueNew ? valueNew : eventValue
        });
      } else {
        setFormData({ ...formData,
          [name]: valueNew ? valueNew : eventValue,
          ['item_size']: 'xl'
        });
      }
    } else {
      return;
    }

    if (name !== 'text_alignment' && name !== 'color' && name !== 'item_size' && name !== 'item_image_position' && name !== "item_text_alignment" && name !== 'vertical_alignment' && name !== 'horizontal_alignment' && name !== 'item_variant') {
      sectionData[name] = valueNew ? valueNew : eventValue;
    } else if (name === 'item_variant') {
      if (valueNew !== 'Collage') {
        sectionData[name] = valueNew ? valueNew : eventValue;
      } else {
        sectionData[name] = valueNew;
        sectionData['item_size']['value'] = 'xl';
      }
    } else {
      if (sectionData[name] !== undefined) {
        sectionData[name]['value'] = valueNew ? valueNew : eventValue;
      } else {
        sectionData[name] = {
          value: valueNew ? valueNew : eventValue,
          name: valueNew ? valueNew : eventValue
        };
      }
    }

    onUpdate();
  };

  function TabPanel(props) {
    const {
      children,
      value,
      index,
      ...other
    } = props;
    return /*#__PURE__*/React.createElement(Typography, _extends({
      component: "div",
      role: "tabpanel",
      hidden: value !== index,
      id: `full-content_width-tabpanel-${index}`,
      "aria-labelledby": `full-content_width-tab-${index}`
    }, other), value === index && /*#__PURE__*/React.createElement(Box, {
      p: 3
    }, children));
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  };

  function a11yProps(index) {
    return {
      id: `full-content_width-tab-${index}`,
      'aria-controls': `full-content_width-tabpanel-${index}`
    };
  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const defaultHorizontalAlignment = [{
    name: 'Left',
    value: 'left'
  }, {
    name: 'Middle',
    value: 'center'
  }, {
    name: 'Right',
    value: 'right'
  }];
  const defaultVerticalAlignment = [{
    name: 'Top',
    value: 'top'
  }, {
    name: 'Center',
    value: 'center'
  }, {
    name: 'Bottom',
    value: 'bottom'
  }];
  const defaultTextAlignment = [{
    name: 'Left',
    value: 'left'
  }, {
    name: 'Middle',
    value: 'center'
  }, {
    name: 'Right',
    value: 'right'
  }];
  const defaultColor = [{
    name: 'Light',
    value: 'light'
  }, {
    name: 'Dark',
    value: 'dark'
  }, {
    name: 'Accent',
    value: 'accent'
  }, {
    name: 'Black',
    value: 'black'
  }, {
    name: 'White',
    value: 'white'
  }];
  const defaultListVariant = [{
    name: 'Card',
    value: 'Card'
  }, {
    name: 'Collage',
    value: 'Collage'
  }];
  const defaultVariant = [{
    name: 'Grid',
    value: 'Grid'
  }, {
    name: 'Tab',
    value: 'Tab'
  }, {
    name: 'Expansion',
    value: 'Expansion'
  }];
  const defaulItemSize = [{
    name: 'XS',
    value: 'xs'
  }, {
    name: 'S',
    value: 's'
  }, {
    name: 'M',
    value: 'm'
  }, {
    name: 'L',
    value: 'l'
  }, {
    name: 'XL',
    value: 'xl'
  }];
  const defaulImagePosition = [{
    name: 'Top',
    value: 'top'
  }, {
    name: 'Left',
    value: 'left'
  }, {
    name: 'Right',
    value: 'right'
  }, {
    name: 'Bottom',
    value: 'bottom'
  }];

  const formValue = fieldName => {
    if (formData && formData !== undefined && fieldName in formData) return formData[fieldName];else return null;
  };

  const SectionPropertyField = ({
    name,
    type,
    itemKey,
    options
  }) => {
    if (type === 'slider') {
      return /*#__PURE__*/React.createElement(Box, {
        mt: 1,
        mb: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        className: classes.textLabel
      }, name), /*#__PURE__*/React.createElement(Slider$2, {
        ValueLabelComponent: ValueLabelComponent,
        "aria-label": "custom thumb label",
        onChange: handleChangeForm(itemKey),
        defaultValue: formValue(itemKey)
      }));
    } else if (type === 'option') {
      return /*#__PURE__*/React.createElement(Box, {
        mt: 1,
        mb: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        className: classes.textLabel
      }, name), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
        className: classes.buttonGroup,
        size: "small",
        value: formValue(itemKey),
        exclusive: true,
        onChange: handleChangeForm(itemKey)
      }, options.map((item, index) => /*#__PURE__*/React.createElement(ToggleButton, {
        className: classes.buttonGroup,
        key: index + 1,
        value: item.value
      }, item.name))));
    } else if (type === 'dropdown') {
      return /*#__PURE__*/React.createElement(Box, {
        mt: 1,
        mb: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        className: classes.textLabel
      }, name), /*#__PURE__*/React.createElement(Select, {
        labelId: "demo-simple-select-placeholder-label-label",
        id: "demo-simple-select-placeholder-label",
        value: formValue(itemKey),
        onChange: handleChangeForm(itemKey),
        displayEmpty: true,
        className: classes.selectInput
      }, options.map(item => /*#__PURE__*/React.createElement(MenuItem, {
        value: item.value
      }, item.name))));
    } else if (type === 'images') {
      return /*#__PURE__*/React.createElement(Box, {
        mt: 1,
        mb: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        className: classes.textLabel
      }, name), /*#__PURE__*/React.createElement(Box, {
        className: classes.boxUploadMedia
      }, formValue(itemKey).length > 0 && formValue(itemKey).map(item => /*#__PURE__*/React.createElement(Card$2, {
        className: classes.cardMedia
      }, /*#__PURE__*/React.createElement(CardMedia, {
        className: classes.media,
        image: item.image_url,
        title: item.title
      }))), /*#__PURE__*/React.createElement("label", {
        htmlFor: "icon-button-file"
      }, /*#__PURE__*/React.createElement(Button$2, {
        color: "primary",
        variant: "outlined",
        "aria-label": "upload picture",
        component: "span",
        onClick: () => setOpenUploader(true)
      }, "Change Background"))));
    } else {
      return '';
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 8
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MUITabs, {
    value: value,
    onChange: handleChange,
    indicatorColor: "primary",
    textColor: "primary",
    variant: "fullWidth",
    centered: true
  }, /*#__PURE__*/React.createElement(Tab$2, _extends({
    style: tabRoot,
    label: "Layout"
  }, a11yProps(0))), /*#__PURE__*/React.createElement(Tab$2, _extends({
    style: tabRoot,
    label: "Background"
  }, a11yProps(1))), sectionData.component && (sectionData.component == 'ListSection' || sectionData.component.includes("ListSection")) && /*#__PURE__*/React.createElement(Tab$2, _extends({
    style: tabRoot,
    label: "List"
  }, a11yProps(2)))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 0,
    dir: theme.direction
  }, /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Horizontal Alignment',
    itemKey: 'horizontal_alignment',
    type: 'option',
    options: defaultHorizontalAlignment
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Vertical Alignment',
    itemKey: 'vertical_alignment',
    type: 'option',
    options: defaultVerticalAlignment
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Height',
    itemKey: 'section_height',
    type: 'slider'
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Width',
    itemKey: 'content_width',
    type: 'slider'
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Text Alignment',
    itemKey: 'text_alignment',
    type: 'option',
    options: defaultTextAlignment
  })), /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 1,
    dir: theme.direction
  }, /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Background Images',
    itemKey: 'background_images',
    type: 'images'
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Color',
    itemKey: 'color',
    type: 'dropdown',
    options: defaultColor
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Opacity',
    itemKey: 'overlay_opacity',
    type: 'slider'
  })), sectionData.component && (sectionData.component == 'ListSection' || sectionData.component.includes("ListSection")) && /*#__PURE__*/React.createElement(TabPanel, {
    value: value,
    index: 2,
    dir: theme.direction
  }, /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Variant',
    itemKey: 'variant',
    type: 'option',
    options: defaultVariant
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Item Variant',
    itemKey: 'item_variant',
    type: 'option',
    options: defaultListVariant
  }), formValue('item_variant') !== 'Collage' && /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Item Size',
    itemKey: 'item_size',
    type: 'option',
    options: defaulItemSize
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Image Width',
    itemKey: 'item_image_width',
    type: 'slider'
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Image Position',
    itemKey: 'item_image_position',
    type: 'option',
    options: defaulImagePosition
  }), /*#__PURE__*/React.createElement(SectionPropertyField, {
    name: 'Text Alignment',
    itemKey: 'item_text_alignment',
    type: 'option',
    options: defaultTextAlignment
  })))))), openUploader && /*#__PURE__*/React.createElement(ImageUpload$1, {
    sectionData: sectionData,
    onUpdate: onUpdate,
    onCompleted: () => setOpenUploader(false),
    uploadMediaContent: uploadMediaContent
  }));
};

var SectionPropertyForm$1 = withStyles(styles$B, {
  withTheme: true
})(SectionPropertyForm);

const styles$C = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  boxModel: {
    width: '800px',
    padding: theme.spacing(3)
  },
  boxSelect: {
    border: '1px solid black',
    background: '#eee',
    padding: theme.spacing(1),
    cursor: 'pointer'
  },
  boxSelected: {
    border: '1px solid black',
    background: theme.palette.primary.main,
    padding: theme.spacing(1),
    cursor: 'pointer',
    color: 'white'
  }
});

const SelectNewSection = ({
  classes,
  onAddSection,
  selectedIndex,
  onCompleted
}) => {
  const [sectionSelect, setSectionSelect] = useState(null);
  const defaultTitle = {
    component: 'TitleSection'
  };
  const defaultListCard = {
    component: 'ListSection',
    variant: 'Grid',
    item_variant: 'Card',
    items: []
  };
  const defaultListCollage = {
    component: 'ListSection',
    variant: 'Grid',
    item_variant: 'Collage',
    items: []
  };
  const defaultListTab = {
    component: 'ListSection',
    variant: 'Tab',
    items: []
  };
  const defaultListExpansion = {
    component: 'ListSection',
    variant: 'Expansion',
    items: []
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          onCompleted();
        }
      } // Bind the event listener


      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const defaultSection = [{
    name: 'TitleSection',
    image: null,
    value: defaultTitle
  }, {
    name: 'ListSection - Card',
    image: null,
    value: defaultListCard
  }, {
    name: 'ListSection - Collage',
    image: null,
    value: defaultListCollage
  }, {
    name: 'ListSection - Expansion',
    image: null,
    value: defaultListExpansion
  }, {
    name: 'ListSection - Tab',
    image: null,
    value: defaultListTab
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 8
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.boxModel
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Select Section Model")), /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 3
  }, defaultSection.map(item => /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 4
  }, item.name !== (sectionSelect && sectionSelect.name) ? /*#__PURE__*/React.createElement(Box, {
    className: classes.boxSelect,
    onClick: () => setSectionSelect(item)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, item.name)) : /*#__PURE__*/React.createElement(Box, {
    className: classes.boxSelected,
    onClick: () => setSectionSelect(item)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, item.name)))))), /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: () => {
      if (sectionSelect !== null) {
        onAddSection(selectedIndex, sectionSelect.value);
        onCompleted();
      } else {
        alert("Please Select Section!");
      }
    }
  }, "Insert Section")))));
};

var SelectNewSection$1 = withStyles(styles$C, {
  withTheme: true
})(SelectNewSection);

const styles$D = theme => ({
  root: {
    width: '100%',
    padding: '10px'
  },
  toolbar: {},
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  menuButton: {
    marginLeft: theme.spacing(2)
  },
  menuTopAdd: {
    position: 'absolute',
    top: '-15px',
    // background:'white',
    color: theme.sectionPalette.accent.background,
    height: '50px',
    width: '50px',
    left: '50%',
    marginLeft: '-50px'
  },
  menuBottomAdd: {
    position: 'absolute',
    bottom: '-15px',
    // background:'white',
    color: theme.sectionPalette.accent.background,
    height: '50px',
    width: '50px',
    left: '50%',
    marginLeft: '-50px'
  }
});

const SectionEditControl = ({
  classes,
  theme,
  sectionData,
  onMoveUp,
  onMoveDown,
  onDelete,
  onEdit,
  onCancel,
  uploadMediaContent,
  onAddSection,
  onBeginEditItem,
  onEndEditItem
}) => {
  let sectionControl = [];
  sectionControl['width'] = '100%';
  const [showProperty, setShowProperty] = useState(false);
  const pageEditContext = useContext(PageEditContext);

  const showPropertyForm = show => {
    if (show) onBeginEdit();else onEndEdit();
    setShowProperty(show);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: sectionControl
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      width: '100%'
    }
  }, onAddSection && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuTopAdd,
    color: "primary",
    onClick: () => {
      pageEditContext.onBeginEditItem( /*#__PURE__*/React.createElement(SelectNewSection$1, {
        sectionData: sectionData,
        onAddSection: onAddSection,
        selectedIndex: pageEditContext.selectedIndex,
        onCompleted: pageEditContext.onEndEditItem
      }));
    }
  }, /*#__PURE__*/React.createElement(AddCircleIcon, null)), /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuBottomAdd,
    color: "primary",
    onClick: () => {
      pageEditContext.onBeginEditItem( /*#__PURE__*/React.createElement(SelectNewSection$1, {
        sectionData: sectionData,
        onAddSection: onAddSection,
        selectedIndex: pageEditContext.selectedIndex + 1,
        onCompleted: pageEditContext.onEndEditItem
      }));
    }
  }, /*#__PURE__*/React.createElement(AddCircleIcon, null)))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 8
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title,
    variant: "h6",
    noWrap: true
  }, sectionData.component), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), onCancel && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(DoneIcon, null)), onEdit && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: () => {
      pageEditContext.onBeginEditItem( /*#__PURE__*/React.createElement(SectionPropertyForm$1, {
        sectionData: sectionData,
        onUpdate: () => onEdit({ ...sectionData
        }),
        onCompleted: pageEditContext.onEndEditItem,
        uploadMediaContent: uploadMediaContent
      })); // onEdit({...sectionData}); 
      // showPropertyForm(true);
    }
  }, /*#__PURE__*/React.createElement(EditIcon, null)), onDelete && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: onDelete
  }, /*#__PURE__*/React.createElement(DeleteIcon, null)), onMoveUp && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: onMoveUp
  }, /*#__PURE__*/React.createElement(ArrowUpwardIcon, null)), onMoveDown && /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    className: classes.menuButton,
    color: "inherit",
    onClick: onMoveDown
  }, /*#__PURE__*/React.createElement(ArrowDownwardIcon, null)))), showProperty && /*#__PURE__*/React.createElement(SectionPropertyForm$1, {
    sectionData: sectionData,
    onUpdate: () => onEdit({ ...sectionData
    }),
    onCompleted: () => showPropertyForm(false),
    uploadMediaContent: uploadMediaContent
  }));
};

var SectionEditControl$1 = withStyles(styles$D, {
  withTheme: true
})(SectionEditControl);

const styles$E = theme => ({
  root: {
    //    maxWidth: 480,
    //    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  content: {},
  divider: {
    width: '100%',
    height: theme.spacing.unit,
    //    backgroundColor: theme.palette.common.white,
    backgroundColor: '#eee'
  },
  headerEdit: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 1100,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    // height: '60px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px'
  },
  editPanel: {
    position: 'fixed',
    top: 80,
    width: '100%',
    zIndex: 1250
  }
});

const PageEditContext = React.createContext({});

const Page = props => {
  const {
    classes,
    theme,
    history,
    location
  } = props;
  const {
    isFetching,
    lastFetched,
    data,
    fetchPageRecord,
    pageKey,
    logEvent
  } = props;
  const {
    shouldLogEvent = true
  } = props;
  const [currentLocationHash, setCurrentLocationHash] = useState(null); // Custom page content and rendering

  const {
    newSectionMaps,
    newContentBlockMaps,
    openLink,
    renderHelmet,
    renderSections,
    onLoading
  } = props; // For editing

  const {
    editMode = false,
    onDataChanged
  } = props;
  const navigationContext = useContext(NavigationContext); // Keep selected item path here. It contains selected section and
  // child items. Ex: "0/title" mean section 0, title block
  // "1/0/title" mean section 1, item 0, title block

  const [selectedItemPath, setSelectedItemPath] = useState(null); // We will show edit form on Page, otherwise it will cause zIndex issue
  // such as when showing property form for section, the form can overlap
  // child item or another section

  const [selectedItemEditForm, setSelectedItemEditForm] = useState(null); // Split to selected section index and child path

  let editSectionIndex = -1;
  let selectedChildItemPath = null;

  if (selectedItemPath) {
    let pos = selectedItemPath.indexOf("/");
    if (pos == -1) editSectionIndex = parseInt(selectedItemPath);else {
      editSectionIndex = parseInt(selectedItemPath.substring(0, pos));
      selectedChildItemPath = selectedItemPath.substring(pos + 1);
    }
  }

  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const topElement = useRef();
  let sectionsData = null;
  if (lastFetched && data.sections) sectionsData = data.sections;
  if (!sectionsData) sectionsData = [];
  useEffect(() => {
    if (!editMode && navigationContext.showAppBar) {
      fetchPageRecord();

      if (lastFetched) {
        if (shouldLogEvent) logEvent('view', {
          type: 'content',
          model: data.model,
          uid: data.uid,
          url: window.location.href,
          title: data.title || data.name
        });
        if (sectionsData.length && sectionsData[0].section_height == 100) navigationContext.showAppBar(false);else navigationContext.showAppBar(true);
      }

      return () => {
        navigationContext.showAppBar(false);
      };
    }
  }, [pageKey, lastFetched]);
  useEffect(() => {
    if (!editMode && navigationContext.setLoading) {
      // OnLoading is used for parent to manage loading progress
      // See BlogPage for sample
      if (onLoading) onLoading(isFetching);else navigationContext.setLoading(isFetching);
      return () => {
        if (onLoading) onLoading(false);else navigationContext.setLoading(false);
      };
    }
  }, [isFetching]);
  useEffect(() => {
    let hash = location.hash;
    if (hash && hash.indexOf("?") != -1) hash = hash.substring(0, hash.indexOf("?"));

    if (hash && hash.startsWith("#")) {
      if (hash != currentLocationHash && lastFetched && !isFetching) {
        setCurrentLocationHash(hash);
        setTimeout(() => {
          scrollToSection(hash.substring(1));
        }, 50);
      }
    } else {
      if (currentLocationHash) setCurrentLocationHash(null);
    }
  }, [pageKey, lastFetched, isFetching, location.hash]);

  const scrollToSection = id => {
    //      alert(linkTo)
    //      window.location = linkTo
    //      window.location.hash = linkTo //linkTo.substring(1)
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };

  const internalOpenLink = linkTo => {
    let link = "";

    if (linkTo.startsWith("#")) {
      // Scroll to section.
      const id = linkTo.substring(1);
      scrollToSection(id);
      return;
    }

    if (linkTo.startsWith("mailto:") || linkTo.startsWith("tel:") || linkTo.startsWith("http:") || linkTo.startsWith("https:")) {
      window.open(linkTo, "_blank");
      return;
    }

    if (openLink) {
      openLink(linkTo);
      return;
    }

    if (linkTo.startsWith("/")) link = linkTo;else link = "/" + linkTo;
    if (link === "/home") link = "/";
    history.push(link);
  };

  const updateNewValue = (oldValue, newValue) => {
    let newValueKeys = Object.keys(newValue);

    for (let i = 0; i < newValueKeys.length; i++) {
      oldValue[newValueKeys[i]] = newValue[newValueKeys[i]];

      if (newValueKeys[i] === 'selectedItemPath') {
        oldValue[newValueKeys[i]] = null;
      }
    }

    return oldValue;
  };

  const uploadMediaContent = data => {
    let url = process.env.REACT_APP_GOAPP_API_URL + "/content/api/content/" + pageKey + "/upload_media/";
    let api_key = process.env.REACT_APP_GOAPP_API_KEY;
    let formData = new FormData();
    formData.append('title', data.title);
    formData.append('media', data.media[0]);
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'X-API-Key': api_key
      },
      body: formData
    }).then(response => response.json()).then(json => json).catch(error => console.log(error));
  };

  const insertNewSection = (selectedIndex, newSectionData) => {
    let newSectionsData = sectionsData;
    newSectionsData.splice(selectedIndex, 0, newSectionData);
    onDataChanged({ ...data,
      sections: newSectionsData
    });
  };

  const pageEditContext = {
    editMode,
    selectedItemPath,
    uploadMediaContent,
    onBeginEditItem: form => setSelectedItemEditForm(form),
    onEndEditItem: () => setSelectedItemEditForm(null),
    onSelectItem: path => {
      console.log("PATH", path);
      setSelectedItemPath(path), setSelectedItemEditForm(null);
    }
  };

  const createContentBlock = (componentName, contentData, index, params = {}) => {
    let comp; // Don't know why this doesn't return 'function' for component
    // if (typeof componentName === 'function')

    if (componentName && typeof componentName != 'string') comp = componentName;else if (newContentBlockMaps && componentName in newContentBlockMaps) comp = newContentBlockMaps[componentName];else if (componentName in contentBlockMaps) comp = contentBlockMaps[componentName];else comp = contentBlockMaps['TitleContentBlock']; // default:

    return React.createElement(comp, { ...contentData,
      itemKey: contentData.key,
      openLink: internalOpenLink,
      contentIndex: index,
      ...params
    });
  };

  const createSection = (sectionData, index, params = {}) => {
    let comp; // Don't know why this doesn't return 'function' for component
    // if (typeof sectionData.component === 'function')

    if (sectionData.component && typeof sectionData.component != 'string') comp = sectionData.component;else if (newSectionMaps && sectionData.component in newSectionMaps) comp = newSectionMaps[sectionData.component];else if (sectionData.component in sectionMaps) comp = sectionMaps[sectionData.component];else comp = sectionMaps['TitleSection']; // default:

    let spacing;

    if (smUp) {
      spacing = 1;
    } else {
      spacing = 2;
    }

    let section = React.createElement(comp, { ...sectionData,
      item_spacing: 'item_spacing' in sectionData ? sectionData.item_spacing : spacing,
      horizontal_alignment: 'horizontal_alignment' in sectionData ? sectionData.horizontal_alignment.value : 'center',
      vertical_alignment: 'vertical_alignment' in sectionData ? sectionData.vertical_alignment.value : 'center',
      overlay_opacity: 'overlay_opacity' in sectionData ? sectionData.overlay_opacity : 50,
      color_mode: 'color_mode' in sectionData ? sectionData.color_mode.value : 'light',
      color: 'color' in sectionData ? sectionData.color.value : 'white',
      item_size: 'item_size' in sectionData ? sectionData.item_size.value : 'medium',
      item_justify: 'item_justify' in sectionData ? sectionData.item_justify.value : 'center',
      text_alignment: 'text_alignment' in sectionData ? sectionData.text_alignment.value : 'center',
      item_text_alignment: 'item_text_alignment' in sectionData ? sectionData.item_text_alignment.value : 'center',
      item_image_position: 'item_image_position' in sectionData ? sectionData.item_image_position.value : undefined,
      item_image_alternate_position: 'item_image_alternate_position' in sectionData ? sectionData.item_image_alternate_position.value : undefined,
      item_button_style: 'item_button_style' in sectionData ? sectionData.item_button_style.value != null ? sectionData.item_button_style.value : 'medium' : 'medium',
      button_style: 'button_style' in sectionData ? sectionData.button_style.value != null ? sectionData.button_style.value : 'medium' : 'medium',
      section_width: 'section_width' in sectionData ? sectionData.section_width.value != null ? sectionData.section_width.value : 'full' : 'full',
      section_height: 'section_height' in sectionData ? sectionData.section_height != null ? sectionData.section_height : 66 : 66,
      hashKey: sectionData.key,
      openLink: internalOpenLink,
      sectionIndex: index,
      key: index.toString(),
      createContentBlock: createContentBlock,
      ...params
    });

    if (editMode) {
      let sectionEditContext = { ...pageEditContext,
        selectedIndex: editSectionIndex,
        selectedItemPath: selectedChildItemPath,
        canEdit: editSectionIndex == index ? true : false,
        selectionLevel: 1,
        onUpdateSection: newSectionData => {
          let updateValueData = updateNewValue(sectionData, newSectionData);
          onDataChanged({ ...data,
            sections: sectionsData.map(s => {
              return s.uid == sectionData.uid ? updateValueData : s;
            })
          });
        },
        onUpdateItems: newSectionData => {
          updateNewValue(sectionData.items, newSectionData);
        },
        onUpdateItemValue: (newSectionData, itemIndex) => {
          if (sectionData.variant !== undefined) {
            updateNewValue(sectionData.items[itemIndex], newSectionData);
          } // setNewSectionsData(sectionsData.map((s,index) => {              
          //   return s.uid == sectionData.uid ? updateValueData : s
          // }))

        },
        onSelectItem: path => pageEditContext.onSelectItem(path ? editSectionIndex.toString() + "/" + path : editSectionIndex.toString())
      };
      let editControl = null;

      if (index == editSectionIndex && !selectedChildItemPath) {
        editControl = /*#__PURE__*/React.createElement(SectionEditControl$1, {
          sectionData: sectionData,
          onMoveUp: () => {
            if (index > 0) {
              let newSectionsData = sectionsData.filter(s => {
                return s.uid == sectionData.uid ? false : true;
              });
              newSectionsData.splice(index - 1, 0, sectionData);
              onDataChanged({ ...data,
                sections: newSectionsData
              });
              setSelectedItemPath((editSectionIndex - 1).toString());
            }
          },
          onMoveDown: () => {
            if (index < sectionsData.length - 1) {
              let newSectionsData = sectionsData.filter(s => {
                return s.uid == sectionData.uid ? false : true;
              });
              newSectionsData.splice(index + 1, 0, sectionData);
              onDataChanged({ ...data,
                sections: newSectionsData
              });
              setSelectedItemPath((editSectionIndex + 1).toString());
            }
          },
          onDelete: () => {
            onDataChanged({ ...data,
              sections: sectionsData.filter(s => {
                return s.uid == sectionData.uid ? false : true;
              })
            });
            setSelectedItemPath(null);
          },
          onEdit: newSectionData => {
            // setNewSectionsData(sectionsData.map(s => {              
            //   return s.uid == sectionData.uid ? newSectionData : s
            // }))
            let updateValueData = updateNewValue(sectionData, newSectionData);
            onDataChanged({ ...data,
              sections: sectionsData.map(s => {
                return s.uid == sectionData.uid ? updateValueData : s;
              })
            });
          },
          onCancel: () => {
            setSelectedItemPath(null);
            setSelectedItemEditForm(null);
          },
          onCompleted: () => {
            setSelectedItemPath(null);
            setSelectedItemEditForm(null);
          },
          uploadMediaContent: uploadMediaContent,
          onAddSection: insertNewSection
        });
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageEditContext.Provider, {
          value: sectionEditContext
        }, /*#__PURE__*/React.createElement(SelectionBox$1, {
          selected: true,
          control: editControl
        }, section)));
      } else {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageEditContext.Provider, {
          value: sectionEditContext
        }, /*#__PURE__*/React.createElement(SelectionBox$1, {
          selected: false,
          onSelect: () => {
            setSelectedItemPath(index.toString());
            setSelectedItemEditForm(null);
          }
        }, section)));
      }
    } else return section;
  };

  let sectionList = [];

  if (lastFetched) {
    const divider = /*#__PURE__*/React.createElement("div", {
      className: classes.divider
    });
    if (renderSections) sectionList = renderSections({
      createSection,
      createContentBlock,
      openLink: internalOpenLink,
      pageData: data,
      divider: divider
    });else if (sectionsData !== undefined && sectionsData.length > 0) {
      let carouselSectionsData = sectionsData.filter(sectionData => sectionData.is_carousel_section ? true : false);
      if (carouselSectionsData.length > 0) sectionList = [/*#__PURE__*/React.createElement(CarouselSectionList$1, {
        sectionList: carouselSectionsData,
        createSection: createSection,
        editMode: editMode,
        openLink: internalOpenLink
      })];
      sectionList = [...sectionList, ...sectionsData.filter(sectionData => sectionData.is_carousel_section ? false : true).map((sectionData, index) => createSection(sectionData, index + (carouselSectionsData ? carouselSectionsData.length : 0)))].reduce((prev, next) => [prev, divider, next]);
    }
  }

  let helmet = null;
  if (lastFetched) if (renderHelmet) {
    helmet = renderHelmet({
      pageData: data
    });
  } else helmet = /*#__PURE__*/React.createElement("title", null, data.title || data.name, " - ", process.env.REACT_APP_TITLE_SUFFIX);
  return /*#__PURE__*/React.createElement("div", null, helmet && !editMode && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, helmet.props.children.join(' '))), /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: topElement
  }, /*#__PURE__*/React.createElement(PageEditContext.Provider, {
    value: pageEditContext
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, sectionList), selectedItemEditForm && /*#__PURE__*/React.createElement("div", {
    className: classes.editPanel
  }, selectedItemEditForm))));
};

function pageKeyFromProps(props) {
  let key = null;
  if (props.slug && props.slug !== undefined) key = props.slug;else if (props.pageKey && props.pageKey !== undefined) key = props.pageKey;else key = props.match.params.pageKey;
  if (!key || key == undefined) key = 'home';
  return key;
}

const mapStateToProps$9 = (state, ownProps) => {
  let key = pageKeyFromProps(ownProps);
  if ('data' in ownProps) return {};else return { ...getContentRecord(state, "page", key),
    pageKey: key
  };
};

const mapDispatchToProps$9 = (dispatch, ownProps) => {
  let key = pageKeyFromProps(ownProps);
  return {
    fetchPageRecord: () => {
      if ('data' in ownProps) return;
      dispatch(fetchContentRecord('page', key));
    },
    logEvent: (eventName, data) => {
      if ('data' in ownProps) return;
      dispatch(logEvent(eventName, data));
    }
  };
};

var Page$1 = withRouter(withStyles(styles$E, {
  withTheme: true
})(connect(mapStateToProps$9, mapDispatchToProps$9)(Page)));

const styles$F = theme => ({
  container: {
    /*  
        marginLeft: -theme.spacing.unit * 2,
        width: `calc(100% + ${theme.spacing.unit*4}px)`,
        paddingLeft: theme.spacing.unit * 2,
    */
    overflow: 'scroll',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit * 2
  },
  row: {
    width: 1000
  },
  item: {
    marginRight: theme.spacing.unit
  }
});

const FilterItem = ({
  theme,
  classes,
  title,
  selected,
  onClick
}) => {
  return /*#__PURE__*/React.createElement(Button$2, {
    variant: "contained",
    size: "medium",
    color: "primary",
    className: classes.item,
    "aria-label": "",
    onClick: onClick
  }, " ", title);
};

const TitleFilterSection = props => {
  const {
    theme,
    classes,
    openLink,
    selected_index,
    onClick,
    variant,
    color,
    item_size,
    item_variant,
    item_count,
    items
  } = props;
  let textColor;

  if (color === 'dark') {
    textColor = theme.sectionPalette.dark.contrastText;
  } else if (color === 'accent') {
    textColor = theme.sectionPalette.accent.contrastText;
  } else if (color === 'light') {
    textColor = theme.sectionPalette.light.contrastText;
  } else if (color === 'white') {
    textColor = theme.sectionPalette.white.contrastText;
  } else {
    textColor = theme.sectionPalette.black.contrastText;
  }

  return /*#__PURE__*/React.createElement(Section$1, props, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, items.map((item, index) => /*#__PURE__*/React.createElement(FilterItem, {
    theme: theme,
    classes: classes,
    title: item.title,
    selected: index == selected_index ? true : false,
    onClick: () => onClick(item)
  })))));
};

TitleFilterSection.propTypes = {
  classes: PropTypes.object.isRequired
};
var TitleFilterSection$1 = withStyles(styles$F, {
  withTheme: true
})(TitleFilterSection);

const styles$G = theme => ({
  root: {
    //    maxWidth: 480,
    //    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  content: {},
  divider: {
    width: '100%',
    height: theme.spacing.unit,
    //    backgroundColor: theme.palette.common.white,
    backgroundColor: '#eee'
  }
});

const BlogPage = ({
  theme,
  classes,
  history,
  openLink,
  business,
  blogList,
  categoryKey,
  categoryList,
  fetchBlogList,
  pageKey,
  fetchCategoryList
}) => {
  const navigationContext = useContext(NavigationContext);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const topElement = useRef();
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  useEffect(() => {
    fetchBlogList();
    fetchCategoryList(); // if (lastFetched)
    //   logEvent('view', { type: 'content', uid: data.uid })
  }, [categoryKey]);
  useEffect(() => {
    navigationContext.setLoading(blogList.isFetching || categoryList.isFetching || isPageLoading);
    return () => {
      navigationContext.setLoading(false);
    };
  }, [blogList.isFetching, categoryList.isFetching, isPageLoading]);

  const renderSections = props => {
    const {
      createSection,
      createContentBlock,
      divider,
      pageData
    } = props;
    let sections = null;
    //      title = "All Posts in " + categoryKey.charAt(0).toUpperCase() + categoryKey.replace("-", " ").slice(1)    

    let filterItems = [{
      title: "All Posts",
      key: "all"
    }, ...(categoryList.lastFetched ? categoryList.data.records.map(cat => ({
      title: cat.title,
      key: cat.key
    })) : [])];
    let selectedIndex = filterItems.findIndex(item => item.key == categoryKey || item.key == "all" && !categoryKey);
    const titleSection = {
      component: TitleFilterSection$1,
      // title: smUp ? "## Blog" : null,
      // title: "#### " + title,
      section_height: 1,
      color: {
        value: 'white'
      },
      selected_index: selectedIndex,
      items: filterItems,
      onClick: item => {
        if (item.key == "all") openLink("/blog");else openLink("/blog/" + item.key);
      }
    };
    const postItems = blogList.lastFetched ? blogList.data.records : [];
    const postSection = {
      section_height: 1,
      component: 'ListSection',
      variant: 'Grid',
      text_alignment: {
        value: 'center'
      },
      item_size: {
        value: 'l'
      },
      item_component_type: 'BlogItem',
      item_justify: {
        value: 'left'
      },
      items: postItems,
      onItemClick: item => {
        openLink("/blog/post/" + item.key);
      }
    };
    const sectionsData = [titleSection, postSection, // other defined sections
    ...(pageData.sections ? pageData.sections : [])];
    sections = sectionsData.map((sectionData, index) => createSection(sectionData, index)); // No Divider
    //.reduce((prev, next) => [prev, divider, next])

    return sections;
  };

  const renderHelmet = ({
    pageData
  }) => {
    let title = "Blog"; //    if (blogList.lastFetched && categoryKey)
    //      title = "All Posts in " + categoryKey.charAt(0).toUpperCase() + categoryKey.replace("-", " ").slice(1)

    return /*#__PURE__*/React.createElement("title", null, title, " - ", process.env.REACT_APP_TITLE_SUFFIX);
  };

  return /*#__PURE__*/React.createElement(Page$1, {
    pageKey: "blog",
    renderSections: renderSections,
    renderHelmet: renderHelmet,
    onLoading: setIsPageLoading
  });
};

function categoryKeyFromProps(props) {
  let key = null;
  if (props.match && props.match.params.categoryKey !== undefined) key = props.match.params.categoryKey;
  return key;
}

const mapStateToProps$a = (state, ownProps) => {
  let categoryKey = categoryKeyFromProps(ownProps);
  let indexKey = categoryKey ? categoryKey : 'default';
  return {
    user: state.user,
    business: getBusinessInfo(state, '0').data,
    blogList: getContentIndex(state, 'blog', indexKey),
    categoryKey: categoryKey,
    categoryList: getContentIndex(state, 'blog-category', 'default'),
    pageKey: 'blog'
  };
};

const mapDispatchToProps$a = (dispatch, ownProps) => {
  let categoryKey = categoryKeyFromProps(ownProps);
  let indexKey = categoryKey ? categoryKey : 'default';
  return {
    login: () => {
      dispatch(login());
    },
    fetchBlogList: (refresh = false) => {
      let params = categoryKey ? {
        category_f: categoryKey
      } : null;
      dispatch(fetchContentIndex('blog', indexKey, params, refresh));
    },
    fetchCategoryList: (refresh = false) => {
      dispatch(fetchContentIndex('blog-category', 'default', null, refresh));
    },
    logEvent: (eventName, data) => {
      dispatch(logEvent(eventName, data));
    }
  };
};

var BlogPage$1 = withRouter(withStyles(styles$G, {
  withTheme: true
})(connect(mapStateToProps$a, mapDispatchToProps$a)(BlogPage)));

const styles$H = theme => ({
  root: {
    //    maxWidth: 480,
    //    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  content: {},
  divider: {
    width: '100%',
    height: theme.spacing.unit,
    //    backgroundColor: theme.palette.common.white,
    backgroundColor: '#eee'
  }
});

const BlogPostPage = ({
  classes,
  history,
  openLink,
  business,
  blogPostKey,
  logEvent,
  fetchBlogPost,
  fetchCategoryList,
  categoryList,
  lastFetched,
  isFetching,
  data
}) => {
  const navigationContext = useContext(NavigationContext);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const topElement = useRef();
  useEffect(() => {
    fetchBlogPost();
    fetchCategoryList();

    if (lastFetched) {
      logEvent('view', {
        type: 'content',
        model: data.model,
        uid: data.uid,
        url: window.location.href,
        title: data.title || data.name
      });
    }
  }, [blogPostKey, lastFetched]);
  useEffect(() => {
    navigationContext.setLoading(isFetching || isPageLoading);
    return () => {
      navigationContext.setLoading(false);
    };
  }, [isFetching, isPageLoading]);

  const renderSections = props => {
    const {
      createSection,
      createContentBlock,
      divider,
      pageData
    } = props;
    if (!lastFetched) return null;
    let sections = null;
    let categoryItems = [{
      title: "All Posts",
      key: "all"
    }, ...(categoryList.lastFetched ? categoryList.data.records.map(cat => ({
      title: cat.title,
      key: cat.key
    })) : [])];
    const categorySection = {
      component: TitleFilterSection$1,
      section_height: 1,
      color: {
        value: 'white'
      },
      items: categoryItems,
      onClick: item => {
        if (item.key == "all") openLink("/blog");else openLink("/blog/" + item.key);
      }
    };
    const postSection = {
      component: 'ListSection',
      variant: 'Grid',
      title: "#### " + data.title,
      text_alignment: {
        value: 'center'
      },
      section_height: 10,
      section_width: {
        value: 'full_text'
      },
      item_size: {
        value: 'xl'
      },
      item_text_alignment: {
        value: 'left'
      },
      item_component_type: 'Card',
      item_image_position: {
        value: 'top'
      },
      items: [{
        body: data.body,
        images: data.images
      }]
    };
    const sectionsData = [categorySection, postSection, // other defined sections
    ...(pageData.sections ? pageData.sections : [])];
    sections = sectionsData.map((sectionData, index) => createSection(sectionData, index)); // No Divider
    //.reduce((prev, next) => [prev, divider, next])

    return sections;
  };

  const renderHelmet = ({
    pageData
  }) => {
    let title = lastFetched ? data.title : "Blog Post";
    return /*#__PURE__*/React.createElement("title", null, title, " - ", process.env.REACT_APP_TITLE_SUFFIX);
  };

  return /*#__PURE__*/React.createElement(Page$1, {
    pageKey: "blog-post",
    renderSections: renderSections,
    renderHelmet: renderHelmet,
    onLoading: setIsPageLoading,
    shouldLogEvent: false
  });
};

function blogPostKeyFromProps(props) {
  let key = null;
  if (props.match && props.match.params.blogPostKey !== undefined) key = props.match.params.blogPostKey;
  return key;
}

const mapStateToProps$b = (state, ownProps) => {
  let blogPostKey = blogPostKeyFromProps(ownProps);
  return {
    user: state.user,
    business: getBusinessInfo(state, '0').data,
    categoryList: getContentIndex(state, 'blog-category', 'default'),
    ...getContentRecord(state, 'blog', blogPostKey)
  };
};

const mapDispatchToProps$b = (dispatch, ownProps) => {
  let blogPostKey = blogPostKeyFromProps(ownProps);
  return {
    fetchBlogPost: (refresh = false) => {
      dispatch(fetchContentRecord('blog', blogPostKey, refresh));
    },
    fetchCategoryList: (refresh = false) => {
      dispatch(fetchContentIndex('blog-category', 'default', null, refresh));
    },
    logEvent: (eventName, data) => {
      dispatch(logEvent(eventName, data));
    }
  };
};

var BlogPostPage$1 = withRouter(withStyles(styles$H, {
  withTheme: true
})(connect(mapStateToProps$b, mapDispatchToProps$b)(BlogPostPage)));

const NotFound = () => /*#__PURE__*/React.createElement("h1", null, "Not found");

const styles$I = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    paddinTop: theme.spacing.unit * 4,
    minWidth: 300
  },
  logo: {
    maxHeight: 32,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 40
    }
  },
  subMenuContainer: {
    padding: theme.spacing.unit * 2,
    backgroundColor: '#eee'
  },
  linkText: {},
  cardImage: {
    width: '100%'
  },
  closeButton: {
    position: 'fixed',
    top: theme.spacing.unit,
    right: theme.spacing.unit,
    'z-index': 1350
  }
});

const PageMenuItemCard = ({
  classes,
  theme,
  body,
  images
}) => {
  let imageUrl = null;

  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
    mb: 1
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: classes.cardImage
  })), body && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Markdown$1, {
    source: body
  })));
};

const PageMenu = ({
  classes,
  theme,
  history,
  business,
  hasCatalog,
  headerPage,
  fetchHeaderPage,
  pageList,
  fetchPageList,
  hideMenu
}) => {
  useEffect(() => {
    fetchHeaderPage();
    fetchPageList();
  }, []);
  let menuList = [];

  if (headerPage.lastFetched && headerPage.data.sections !== undefined) {
    menuList = [{
      'link_title': 'Home',
      'link_to': '/'
    }, ...headerPage.data.sections.filter(s => s.component == 'HeaderMenu')];
  } else if (pageList.lastFetched) {
    // let allPages = pageList.data.records.reduce((p, n) => {
    //   if (n.key == 'home' || n.component != 'Page')
    //     return p
    //   return [...p, {
    //     link_title: n.title,
    //     link_to: 'page/' + n.key
    //   }]
    // }, [])
    let allPages = pageList.data.records.filter(item => item.menu_index).map(item => ({
      'link_title': item.menu_label || item.title,
      'link_to': item.key !== 'home' ? '/' + item.key : '/',
      index: item.menu_index
    })).sort((a, b) => a.index > b.index ? 1 : b.index > a.index ? -1 : 0); // menuList.push({
    //   'link_title': 'Home',
    //   'link_to': '/'
    // })

    /*    
        if (hasCatalog)
          menuList.push({
            'link_title': 'Belanja',
            'link_to': '/catalog'
          })
    */
    // menuList.push({
    //   'link_title': 'Blog',
    //   'link_to': '/blog'
    // })

    menuList.push(...allPages);
  }

  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1);

  const openMenuItem = item => {
    setSelectedMenuIndex(-1);

    if (item.link_to) {
      if (item.link_to.startsWith("/")) history.push(item.link_to);else history.push("/" + item.link_to);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.closeButton
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "medium",
    className: classes.closeButton,
    onClick: hideMenu
  }, /*#__PURE__*/React.createElement(CancelIcon, null))), /*#__PURE__*/React.createElement(List, null, menuList.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, {
    onClick: () => openMenuItem(item)
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: classes.linkText
    }, item.link_title)
  })), item.items && item.items.length > 0 && /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    className: classes.subMenuContainer
  }, item.items.map(subItem => /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    onClick: () => openMenuItem(subItem)
  }, /*#__PURE__*/React.createElement(PageMenuItemCard, _extends({
    classes: classes,
    theme: theme
  }, subItem))))))))));
};

const mapStateToProps$c = (state, ownProps) => {
  return {
    headerPage: getContentRecord(state, "page", "header"),
    pageList: getContentIndex(state, 'page', 'default'),
    business: getBusinessInfo(state, '0').data
  };
};

const mapDispatchToProps$c = (dispatch, ownProps) => {
  return {
    fetchHeaderPage: () => {
      dispatch(fetchContentRecord('page', 'header'));
    },
    fetchPageList: (refresh = false) => {
      dispatch(fetchContentIndex('page', 'default', null, refresh));
    }
  };
};

var PageMenu$1 = withRouter(withStyles(styles$I, {
  withTheme: true
})(connect(mapStateToProps$c, mapDispatchToProps$c)(PageMenu)));

const styles$J = theme => ({
  root: {
    position: 'fixed',
    zIndex: 100
  },
  title: {
    fontSize: 24
  },
  placeholder: {
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 70
    }
  },
  appbar: {
    //    color: theme.palette.common.black,
    //    backgroundColor: theme.palette.common.white,
    background: 'transparent'
  },
  appbarBackground: {
    position: 'fixed',
    width: '100%',
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 70
    }
  },
  appbarPlaceholder: {
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 74
    }
  },
  toolbar: {
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    [theme.breakpoints.up('sm')]: {
      height: 70
    }
  },
  logoBox: {
    paddingTop: theme.spacing.unit / 2
  },
  logo: {
    maxHeight: 36,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 40
    }
  },
  left: {
    flex: 1
  },
  leftGrow: {},
  leftLinkActive: {//    color: theme.palette.common.white,
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  rightLink: {
    fontSize: 16,
    //    color: theme.palette.common.white,
    marginLeft: theme.spacing(3)
  },
  linkSecondary: {
    color: theme.palette.secondary.main
  },
  menuButton: {//    marginLeft: 12,
    //    marginRight: 12,
  },
  menuButtonHidden: {
    display: 'none'
  },
  desktopHidden: {
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  mobileHidden: {
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  cardImage: {
    width: '100%'
  },
  linkText: {
    color: 'black',
    textDecoration: 'none'
  },
  listItems: {
    '&:hover': {
      backgroundColor: '#eee'
    }
  }
});

const HeaderMenuCard = ({
  classes,
  theme,
  body,
  images
}) => {
  let imageUrl = null;

  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
    mb: 1
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: classes.cardImage
  })), body && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Markdown$1, {
    source: body
  })));
};

const HeaderMenu = ({
  classes,
  history,
  theme,
  items,
  variant = 'List',
  onClick
}) => {
  if (variant == 'Card') {
    let itemsPerRow = 4;
    let spacing = 4;
    return /*#__PURE__*/React.createElement(Grid$2, {
      container: true,
      spacing: spacing
    }, items.map(item => /*#__PURE__*/React.createElement(Grid$2, {
      item: true,
      xs: 12 / itemsPerRow
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      onClick: () => onClick(item)
    }, /*#__PURE__*/React.createElement(HeaderMenuCard, _extends({
      classes: classes,
      theme: theme
    }, item))))));
  } else if (!variant || variant == 'List') return /*#__PURE__*/React.createElement(Box, {
    style: {
      width: 400,
      backgroundColor: 'white'
    }
  }, /*#__PURE__*/React.createElement(List, {
    style: {
      padding: 0
    }
  }, items.map(item => /*#__PURE__*/React.createElement(Link$1, {
    to: item.link_to,
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    className: classes.listItems,
    onClick: () => onClick(item)
  }, item.images && item.images.length > 0 && /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
    src: item.images[0].image_url,
    className: classes.large
  })), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.linkText
    }, item.button_title)
  })), /*#__PURE__*/React.createElement(Divider, null)))));
};

const Header = ({
  classes,
  path,
  history,
  theme,
  business,
  rightMenuItems,
  inboxStats,
  headerPage,
  fetchHeaderPage,
  pageList,
  fetchPageList,
  dark = false,
  openLink
}) => {
  const navigationContext = useContext(NavigationContext);
  const [isDrawerOpen, showDrawer] = useState(false);
  const [transparentBar, setTransparentBar] = useState(true);

  const updateStyleOnScroll = () => {
    if (window.pageYOffset > 0) {
      if (transparentBar) setTransparentBar(false);
    } else if (!transparentBar) setTransparentBar(true);
  };

  useEffect(() => {
    fetchPageList();
    fetchHeaderPage();
  }, []);
  useEffect(() => {
    // This must be called on every render, otherwise updateStyleOnScroll won't be called
    window.addEventListener("scroll", updateStyleOnScroll);
  });

  const internalOpenLink = linkTo => {
    let link = "";

    if (linkTo.startsWith("mailto:")) {
      window.location.href = linkTo;
      return;
    }

    if (openLink) {
      openLink(linkTo);
      return;
    }

    if (linkTo.startsWith("/")) link = linkTo;else link = "/" + linkTo;
    if (link === "/home") link = "/";
    history.push(link);
  };

  let menuList = [];

  if (headerPage.lastFetched && headerPage.data.sections !== undefined) {
    menuList = [
    /*
          {
            'button_title': 'Home',
            'link_to': '/'
          },
    */
    ...headerPage.data.sections.filter(s => s.model == 'page-section')];
  } else if (pageList.lastFetched) {
    let allPages = pageList.data.records.reduce((p, n) => {
      if (n.component == 'Header' || n.component == 'Footer') return p;
      if ('menu_index' in n && n['menu_index'] != "" && parseInt(n['menu_index']) >= 0) return [...p, {
        button_title: n.menu_label || n.title,
        link_to: n.key == 'home' ? '/' : '/' + n.key,
        menu_index: parseInt(n['menu_index'])
      }];else return p;
    }, []);
    let sortedPages = allPages.sort((a, b) => {
      if (a['menu_index'] > b['menu_index']) return 1;
      if (a['menu_index'] < b['menu_index']) return -1;
      return 0;
    });
    /*
        menuList.push({
          'button_title': 'Home',
          'link_to': '/'
        })
    
        menuList.push({
          'button_title': 'Blog',
          'link_to': '/blog'
        })
    */

    /*
        
        if (allPages.length > 3)
          menuList.push({
            'button_title': 'Pages',
            'items': allPages
            })
        else
          menuList.push(...allPages)            
    */

    menuList.push(...sortedPages);
  }

  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1);

  const openMenuItem = item => {
    setSelectedMenuIndex(-1);

    if (item.link_to) {
      internalOpenLink(item.link_to);
    }
  };

  let activeMenuIndex = -1;

  for (var menuIndex = 0; menuIndex < menuList.length; menuIndex++) {
    let menu = menuList[menuIndex];

    if ('link_to' in menu) {
      if (path == '/') {
        if (menu.link_to == '/') {
          activeMenuIndex = menuIndex;
          break;
        }
      } else if (menu.link_to != '/') {
        if (path.startsWith(menu.link_to)) {
          activeMenuIndex = menuIndex;
          break;
        }
      }
    }
  }

  let appbarStyle = {};
  let appbarBackgroundStyle = {}; // TODO: use background color from section color and overlay attribute

  appbarStyle['backgroundColor'] = 'rgba(255, 255, 255, 1.0)';

  if (transparentBar && selectedMenuIndex == -1) {
    if (dark) appbarStyle['color'] = theme.palette.common.white;else appbarStyle['color'] = '#555';
    appbarBackgroundStyle = {
      background: 'transparent'
    };
  } else {
    appbarStyle['color'] = theme.palette.primary.main;
    appbarBackgroundStyle = {
      backgroundColor: theme.palette.common.white
    };
  }
  /*
  let cartIcon = (
    <ShoppingCartIcon />
    )
  if (cart && cart.lastUpdate && cart.data.lines.length)
    cartIcon = (
      <Badge badgeContent={ cart.data.lines.length } color="secondary">
        { cartIcon }
      </Badge>
    )
  */


  let inboxIcon = /*#__PURE__*/React.createElement(QuestionAnswerIcon$1, null);
  if (inboxStats && inboxStats !== undefined && inboxStats.new_count !== undefined && inboxStats.new_count > 0) inboxIcon = /*#__PURE__*/React.createElement(Badge, {
    badgeContent: inboxStats.new_count,
    color: "secondary"
  }, inboxIcon);
  /*
  let userIcon = (
    <AccountCircleIcon />
    )
  if (orderList && orderList.lastFetched && orderList.data.count)
    userIcon = (
      <Badge badgeContent={ orderList.data.count } color="secondary">
        { userIcon }
      </Badge>
    )
  */

  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let defaultRightMenuItems = rightMenuItems;

  if (!defaultRightMenuItems) {
    if (smUp) {
      defaultRightMenuItems = /*#__PURE__*/React.createElement(Button$2, {
        variant: "contained",
        color: "default",
        onClick: () => internalOpenLink('chat'),
        startIcon: /*#__PURE__*/React.createElement(QuestionAnswerIcon$1, null)
      }, "Contact Us");
    }
  }

  if (headerPage.isFetching) return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "fixed",
    className: classes.appbar,
    style: appbarStyle,
    elevation: 0
  }));
  let variant = headerPage.lastFetched ? headerPage.data.variant : 'Center';
  if (variant == "Hidden") return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  });
  let isInboxPage = path.startsWith("/inbox");
  let notificationIcons = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    onClick: () => openChat(-1)
  }, inboxIcon));
  notificationIcons = /*#__PURE__*/React.createElement(React.Fragment, null);

  if (smUp) {
    // Note: If I use borderBottom style, it work on first load, but on navigate
    // to other page, border color will back to standard black color. But if I add it
    // to borderBottom style, it works well.
    let activeBorderStyle = "3px solid " + theme.palette.primary.main;
    let menuItems = /*#__PURE__*/React.createElement(React.Fragment, null, menuList.length > 0 && menuList.map((m, index) => /*#__PURE__*/React.createElement(Box, {
      style: {
        display: 'inline',
        paddingTop: '6px',
        paddingBottom: '6px',
        borderBottom: activeMenuIndex == index ? activeBorderStyle : "none"
      }
    }, /*#__PURE__*/React.createElement(Button$2, {
      className: classes.mobileHidden,
      style: {
        fontWeight: activeMenuIndex == index ? 800 : 500
      },
      onClick: () => {
        if (selectedMenuIndex == index) setSelectedMenuIndex(-1);else if (m.items && m.items !== undefined && m.items.length) setSelectedMenuIndex(index);else if (m.link_to && m.link_to !== undefined) openMenuItem(m);
      },
      endIcon: m.items && m.items !== undefined ? /*#__PURE__*/React.createElement(ExpandMoreIcon, null) : ''
    }, m.button_title))).reduce((prev, next) => [prev, /*#__PURE__*/React.createElement(Typography, {
      style: {
        fontSize: "0.9em",
        opacity: "0.5"
      },
      component: "span"
    }, "\xA0"), next]));
    let toolbar = null;
    if (variant == 'Left') // Left logo and menu, right notification bar
      toolbar = /*#__PURE__*/React.createElement(Toolbar, {
        className: classes.toolbar
      }, /*#__PURE__*/React.createElement(Box, {
        className: classes.logoBox,
        mr: 4
      }, /*#__PURE__*/React.createElement("a", {
        onClick: () => internalOpenLink("/")
      }, 'logo' in business && /*#__PURE__*/React.createElement("img", {
        src: business.logo.image_url,
        className: classes.logo
      }))), /*#__PURE__*/React.createElement("div", {
        className: classes.leftGrow
      }, menuItems), /*#__PURE__*/React.createElement("div", {
        className: clsx(classes.right)
      }, defaultRightMenuItems && defaultRightMenuItems, notificationIcons));else // Center logo, left menu, right notification bar
      toolbar = /*#__PURE__*/React.createElement(Toolbar, {
        className: classes.toolbar
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.left
      }, menuItems), /*#__PURE__*/React.createElement(Box, {
        className: classes.logoBox
      }, /*#__PURE__*/React.createElement("a", {
        onClick: () => internalOpenLink("/")
      }, 'logo' in business && /*#__PURE__*/React.createElement("img", {
        src: business.logo.image_url,
        className: classes.logo
      }))), /*#__PURE__*/React.createElement("div", {
        className: clsx(classes.right)
      }, defaultRightMenuItems && defaultRightMenuItems, notificationIcons));
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement(AppBar, {
      position: "fixed",
      className: classes.appbar,
      style: appbarStyle,
      elevation: 0
    }, /*#__PURE__*/React.createElement(Fade$1, {
      in: !transparentBar || selectedMenuIndex >= 0
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.appbarBackground,
      style: appbarBackgroundStyle
    }, selectedMenuIndex >= 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      className: classes.appbarPlaceholder
    }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(HeaderMenu, _extends({
      classes: classes,
      theme: theme,
      onClick: item => openMenuItem(item)
    }, menuList[selectedMenuIndex])))))), /*#__PURE__*/React.createElement(Container, {
      style: {
        padding: 0
      }
    }, toolbar)), /*#__PURE__*/React.createElement("div", {
      className: classes.placeholder
    }));
  } else {
    let toolbar = null;
    if (variant == 'Left') toolbar = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      className: classes.logoBox,
      mr: 4
    }, /*#__PURE__*/React.createElement("a", {
      onClick: () => internalOpenLink("/")
    }, 'logo' in business && /*#__PURE__*/React.createElement("img", {
      src: business.logo.image_url,
      className: classes.logo
    }))), /*#__PURE__*/React.createElement("div", {
      className: clsx(classes.right)
    }, notificationIcons, /*#__PURE__*/React.createElement(IconButton, {
      color: "inherit",
      "aria-label": "Open drawer",
      onClick: () => showDrawer(!isDrawerOpen),
      className: clsx(classes.menuButton, isDrawerOpen && classes.menuButtonHidden, classes.desktopHidden)
    }, /*#__PURE__*/React.createElement(MenuIcon, null))));else toolbar = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.left
    }, /*#__PURE__*/React.createElement(IconButton, {
      color: "inherit",
      "aria-label": "Open drawer",
      onClick: () => showDrawer(!isDrawerOpen),
      className: clsx(classes.menuButton, isDrawerOpen && classes.menuButtonHidden, classes.desktopHidden)
    }, /*#__PURE__*/React.createElement(MenuIcon, null))), /*#__PURE__*/React.createElement(Box, {
      className: classes.logoBox
    }, /*#__PURE__*/React.createElement("a", {
      onClick: () => internalOpenLink("/")
    }, 'logo' in business && /*#__PURE__*/React.createElement("img", {
      src: business.logo.image_url,
      className: classes.logo
    }))), /*#__PURE__*/React.createElement("div", {
      className: clsx(classes.right)
    }, defaultRightMenuItems && defaultRightMenuItems, notificationIcons)); // Mobile view.

    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement(AppBar, {
      position: "fixed",
      className: classes.appbar,
      style: appbarStyle,
      elevation: 0
    }, /*#__PURE__*/React.createElement(Fade$1, {
      in: !transparentBar
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.appbarBackground,
      style: appbarBackgroundStyle
    })), /*#__PURE__*/React.createElement(Container, {
      style: {
        padding: 0
      }
    }, /*#__PURE__*/React.createElement(Toolbar, {
      className: classes.toolbar
    }, toolbar))), /*#__PURE__*/React.createElement("div", {
      className: classes.placeholder
    }), /*#__PURE__*/React.createElement(Drawer, {
      open: isDrawerOpen,
      onClose: () => showDrawer(false)
    }, /*#__PURE__*/React.createElement("div", {
      onClick: () => showDrawer(false),
      onKeyDown: () => showDrawer(false)
    }, /*#__PURE__*/React.createElement(PageMenu$1, {
      hideMenu: () => showDrawer(false)
    }))));
  }
};

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps$d = (state, ownProps) => {
  return {
    headerPage: getContentRecord(state, "page", "header"),
    pageList: getContentIndex(state, 'page', 'default'),
    path: ownProps.location.pathname,
    inboxStats: state.alpha.conversationList.stats
  };
};

const mapDispatchToProps$d = (dispatch, ownProps) => {
  return {
    fetchHeaderPage: () => {
      dispatch(fetchContentRecord('page', 'header'));
    },
    fetchPageList: (refresh = false) => {
      dispatch(fetchContentIndex('page', 'default', null, refresh));
    }
  };
};

var Header$1 = withRouter(withStyles(styles$J, {
  withTheme: true
})(connect(mapStateToProps$d, mapDispatchToProps$d)(Header)));

const styles$K = theme => ({
  root: {//    backgroundColor: '#eee'
  },
  linkText: {},
  container: {
    //    padding: theme.spacing.unit * 4,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6)
  },
  textBox: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left'
    }
  },
  imageCenter: {
    display: 'flex',
    alignItems: 'center' // justifyContent: 'center'

  }
});

const FooterSection = ({
  classes,
  theme,
  history,
  business,
  component,
  body,
  images,
  title,
  subtitle,
  items,
  item_size,
  item_component_type,
  text_alignment
}) => {
  let imageUrl = null;

  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url;
    if (imageUrl.startsWith("/")) imageUrl = "http://178.128.86.10:8000" + imageUrl;
  }

  let itemSize = item_size ? item_size.value : 'm';
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  let mdUp = useMediaQuery(theme.breakpoints.up('md'));
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'));
  let itemsPerRow;

  if (itemSize == 'xs') {
    if (xlUp) {
      itemsPerRow = 4;
    } else if (lgUp) {
      itemsPerRow = 4;
    } else if (mdUp) {
      itemsPerRow = 4;
    } else if (smUp) {
      itemsPerRow = 4;
    } else {
      itemsPerRow = 4;
    }
  } else if (itemSize == 's') {
    if (xlUp) {
      itemsPerRow = 4;
    } else if (lgUp) {
      itemsPerRow = 4;
    } else if (mdUp) {
      itemsPerRow = 4;
    } else if (smUp) {
      itemsPerRow = 4;
    } else {
      itemsPerRow = 4;
    }
  } else if (itemSize == 'l') {
    if (xlUp) {
      itemsPerRow = 2;
    } else if (lgUp) {
      itemsPerRow = 2;
    } else if (mdUp) {
      itemsPerRow = 2;
    } else if (smUp) {
      itemsPerRow = 2;
    } else {
      itemsPerRow = 1;
    }
  } else if (itemSize == 'xl') {
    if (xlUp) {
      itemsPerRow = 1;
    } else if (lgUp) {
      itemsPerRow = 1;
    } else if (mdUp) {
      itemsPerRow = 1;
    } else if (smUp) {
      itemsPerRow = 1;
    } else {
      itemsPerRow = 1;
    }
  } else {
    if (xlUp) {
      itemsPerRow = 2;
    } else if (lgUp) {
      itemsPerRow = 2;
    } else if (mdUp) {
      itemsPerRow = 2;
    } else if (smUp) {
      itemsPerRow = 2;
    } else {
      itemsPerRow = 2;
    }
  }

  let imageStyle = [];

  if (text_alignment === 'right') {
    imageStyle['justifyContent'] = 'flex-end';
  } else if (text_alignment === 'left') {
    imageStyle['justifyContent'] = 'flex-start';
  } else {
    imageStyle['justifyContent'] = 'center';
  }

  const onClickItem = link_to => {
    if (link_to.includes('/')) {
      history.push(link_to);
    } else {
      window.location.href = link_to;
      return;
    }
  };

  return /*#__PURE__*/React.createElement(Box, null, imageUrl && /*#__PURE__*/React.createElement(Box, {
    mb: 3,
    className: classes.imageCenter,
    style: imageStyle
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl
  })), title && /*#__PURE__*/React.createElement(Box, {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: title,
    variant: "hero"
  })), subtitle && /*#__PURE__*/React.createElement(Box, {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: subtitle
  }))), body && /*#__PURE__*/React.createElement(Box, {
    className: classes.textBox
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Markdown$1, {
    source: body
  }))), items && items.length > 0 && /*#__PURE__*/React.createElement(Grid$2, {
    container: true
  }, items.map(item => /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12 / itemsPerRow
  }, item_component_type !== 'SocialMediaContentBlock' ? /*#__PURE__*/React.createElement(React.Fragment, null, item.link_to !== undefined ? /*#__PURE__*/React.createElement(Typography, {
    onClick: () => onClickItem(item.link_to),
    style: {
      cursor: 'pointer'
    },
    variant: "body2"
  }, item.title) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, item.title)) : /*#__PURE__*/React.createElement(SocialMediaContentBlock$1, item)))));
};

const Footer = ({
  classes,
  theme,
  history,
  business,
  footerPage,
  fetchFooterPage,
  pageList,
  fetchPageList
}) => {
  useEffect(() => {
    fetchFooterPage();
    fetchPageList();
  }, []);
  let sections = [];
  if (footerPage.lastFetched && footerPage.data.sections !== undefined) sections = footerPage.data.sections;
  if (sections.length <= 0) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Container, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 4
  }, sections.map(section => /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 4,
    lg: 3
  }, /*#__PURE__*/React.createElement(FooterSection, _extends({
    classes: classes,
    theme: theme,
    history: history,
    business: business
  }, section)))))));
};

const mapStateToProps$e = (state, ownProps) => {
  return {
    footerPage: getContentRecord(state, "page", "footer"),
    pageList: getContentIndex(state, 'page', 'default'),
    business: getBusinessInfo(state, '0').data
  };
};

const mapDispatchToProps$e = (dispatch, ownProps) => {
  return {
    fetchFooterPage: () => {
      dispatch(fetchContentRecord('page', 'footer'));
    },
    fetchPageList: (refresh = false) => {
      dispatch(fetchContentIndex('page', 'default', null, refresh));
    }
  };
};

var Footer$1 = withRouter(withStyles(styles$K, {
  withTheme: true
})(connect(mapStateToProps$e, mapDispatchToProps$e)(Footer)));

export { BlogPage$1 as BlogPage, BlogPostPage$1 as BlogPostPage, Carousel$2 as Carousel, CarouselSectionList$1 as CarouselSectionList, Footer$1 as Footer, Gallery$1 as Gallery, Header$1 as Header, ImagesSlider$1 as ImagesSlider, ListSection$1 as ListSection, Markdown$1 as Markdown, NavigationContext, NavigationController$1 as NavigationController, NextArrow$1 as NextArrow, NotFound, Page$1 as Page, PrevArrow$1 as PrevArrow, Section$1 as Section, TitleFilterSection$1 as TitleFilterSection };
//# sourceMappingURL=index.es.js.map
